webpackJsonp([12],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getMainPageMeta = exports.getHotelMeta = exports.getAllHotelData = exports.getHotelList = exports.hotelPathRedirect = exports.changeHotel = undefined;

var _reduxActions = __webpack_require__(6);

var _reactRouterRedux = __webpack_require__(51);

var _hotel = __webpack_require__(157);

var _i18n = __webpack_require__(22);

var _endpoint = __webpack_require__(35);

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var changeHotel = exports.changeHotel = (0, _reduxActions.createAction)('CHANGE_HOTEL', function (hotel) {
	return { hotel: hotel };
});

var hotelPathRedirect = exports.hotelPathRedirect = (0, _reduxActions.createAction)('HOTEL_PATH_REDIRECT', function (hotel) {
	return function () {
		var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(dispatch) {
			return regeneratorRuntime.wrap(function _callee$(_context) {
				while (1) {
					switch (_context.prev = _context.next) {
						case 0:
							_context.next = 2;
							return dispatch((0, _reactRouterRedux.push)({ pathname: '/' + hotel }));

						case 2:
							_context.next = 4;
							return dispatch(changeHotel(hotel));

						case 4:
						case 'end':
							return _context.stop();
					}
				}
			}, _callee, undefined);
		}));

		return function (_x) {
			return _ref.apply(this, arguments);
		};
	}();
});

var getHotelList = exports.getHotelList = (0, _reduxActions.createAction)('FETCH_HOTEL_LIST', function () {
	return function () {
		var _ref2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(_, getState) {
			var _getState, lan, _ref3, status, message, data, translation, translatedHotelData, validHotelList, hotelList;

			return regeneratorRuntime.wrap(function _callee2$(_context2) {
				while (1) {
					switch (_context2.prev = _context2.next) {
						case 0:
							_getState = getState(), lan = _getState.global.lan;
							_context2.next = 3;
							return (0, _endpoint.wrapFetch)('api/v1/web/store', {
								method: 'GET'
							});

						case 3:
							_ref3 = _context2.sent;
							status = _ref3.status;
							message = _ref3.message;
							data = _ref3.data.data;

							if (!(status !== 200)) {
								_context2.next = 9;
								break;
							}

							throw new Error(message);

						case 9:
							translation = (0, _i18n.translate)(lan);
							translatedHotelData = (0, _hotel.hotelData)(translation);
							validHotelList = Object.keys(translatedHotelData);

							/* filter out the hotels which are not fully updated yet */

							hotelList = ['main'].concat(data.map(function (hotel) {
								return hotel.name;
							})).filter(function (hotel) {
								return validHotelList.includes(hotel);
							});
							return _context2.abrupt('return', {
								hotelList: hotelList
							});

						case 14:
						case 'end':
							return _context2.stop();
					}
				}
			}, _callee2, undefined);
		}));

		return function (_x2, _x3) {
			return _ref2.apply(this, arguments);
		};
	}();
});

var getAllHotelData = exports.getAllHotelData = (0, _reduxActions.createAction)('GET_ALL_HOTEL_DATA', function () {
	return function () {
		var _ref4 = _asyncToGenerator(regeneratorRuntime.mark(function _callee3(dispatch, getState) {
			var _getState2, lan, hotelList, translation, translatedHotelData, hotelData;

			return regeneratorRuntime.wrap(function _callee3$(_context3) {
				while (1) {
					switch (_context3.prev = _context3.next) {
						case 0:
							_context3.next = 2;
							return dispatch(getHotelList());

						case 2:
							_getState2 = getState(), lan = _getState2.global.lan, hotelList = _getState2.hotel.hotelList;
							translation = (0, _i18n.translate)(lan);
							translatedHotelData = (0, _hotel.hotelData)(translation);
							hotelData = {};


							hotelList.forEach(function (hotel) {
								hotelData[hotel] = translatedHotelData[hotel];
							});

							return _context3.abrupt('return', {
								hotelData: hotelData
							});

						case 8:
						case 'end':
							return _context3.stop();
					}
				}
			}, _callee3, undefined);
		}));

		return function (_x4, _x5) {
			return _ref4.apply(this, arguments);
		};
	}();
});

var getHotelMeta = exports.getHotelMeta = (0, _reduxActions.createAction)('GET_HOTEL_META', function () {
	var _ref5 = _asyncToGenerator(regeneratorRuntime.mark(function _callee4(lan, hotel, page) {
		var _ref6, status, message, data;

		return regeneratorRuntime.wrap(function _callee4$(_context4) {
			while (1) {
				switch (_context4.prev = _context4.next) {
					case 0:
						_context4.next = 2;
						return (0, _endpoint.wrapFetch)('api/v1/web/' + lan + '/' + hotel + '/meta?page=' + page, {
							method: 'GET'
						});

					case 2:
						_ref6 = _context4.sent;
						status = _ref6.status;
						message = _ref6.message;
						data = _ref6.data;

						if (!(status !== 200)) {
							_context4.next = 8;
							break;
						}

						throw new Error(message);

					case 8:
						return _context4.abrupt('return', { data: data });

					case 9:
					case 'end':
						return _context4.stop();
				}
			}
		}, _callee4, undefined);
	}));

	return function (_x6, _x7, _x8) {
		return _ref5.apply(this, arguments);
	};
}());

var getMainPageMeta = exports.getMainPageMeta = (0, _reduxActions.createAction)('GET_MAIN_PAGE_META', function () {
	var _ref7 = _asyncToGenerator(regeneratorRuntime.mark(function _callee5(lan) {
		var _ref8, status, message, data;

		return regeneratorRuntime.wrap(function _callee5$(_context5) {
			while (1) {
				switch (_context5.prev = _context5.next) {
					case 0:
						_context5.next = 2;
						return (0, _endpoint.wrapFetch)('api/v1/web/' + lan + '/brandMeta', {
							method: 'GET'
						});

					case 2:
						_ref8 = _context5.sent;
						status = _ref8.status;
						message = _ref8.message;
						data = _ref8.data;

						if (!(status !== 200)) {
							_context5.next = 8;
							break;
						}

						throw new Error(message);

					case 8:
						return _context5.abrupt('return', { data: data });

					case 9:
					case 'end':
						return _context5.stop();
				}
			}
		}, _callee5, undefined);
	}));

	return function (_x9) {
		return _ref7.apply(this, arguments);
	};
}());

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.translate = exports.changeLng = exports.lanMapRoute = exports.initi18next = exports.lanData = exports.LANG_MAP = exports.lanList = undefined;

var _i18next = __webpack_require__(518);

var _i18next2 = _interopRequireDefault(_i18next);

var _i18nextBrowserLanguagedetector = __webpack_require__(528);

var _i18nextBrowserLanguagedetector2 = _interopRequireDefault(_i18nextBrowserLanguagedetector);

var _reactI18next = __webpack_require__(42);

var _i18n = __webpack_require__(212);

var _resources = __webpack_require__(257);

var _resources2 = _interopRequireDefault(_resources);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import Backend from 'i18next-xhr-backend';
var lanList = exports.lanList = ['zh-TW', 'zh-CN', 'en', 'ja', 'ko'];

var LANG_MAP = exports.LANG_MAP = {
	tw: 'zh-TW',
	cn: 'zh-CN',
	en: 'en',
	jp: 'ja',
	kr: 'ko'
};

var lanData = exports.lanData = {
	'zh-TW': {
		id: 0,
		label: '繁',
		value: 'tw',
		bookingCode: '',
		locale: 'zh-TW'
	},
	ja: {
		id: 1,
		label: '日',
		value: 'jp',
		bookingCode: 2,
		locale: 'ja-JP'
	},
	ko: {
		id: 2,
		label: '한',
		value: 'kr',
		bookingCode: 12,
		locale: 'ko-KR'
	},
	en: {
		id: 3,
		label: 'EN',
		value: 'en',
		bookingCode: 1,
		locale: 'en-US'
	},
	'zh-CN': {
		id: 4,
		label: '简',
		value: 'cn',
		bookingCode: 11,
		locale: 'zh-CN'
	}
};

var languageDetect = {
	name: 'urlDetect',

	lookup: function lookup() {
		var found = void 0;

		if (typeof window !== 'undefined') {
			var pathnames = window.location.pathname.split('/');

			if (pathnames.length >= 3 && pathnames[2] !== 'main') {
				if (pathnames[2] in LANG_MAP) {
					found = LANG_MAP[pathnames[2]];
				} else {
					found = 'zh-TW';
				}
			}
		}

		return found;
	}
};

var initi18next = exports.initi18next = function initi18next(store) {
	var lngDetector = new _i18nextBrowserLanguagedetector2.default();
	// Setup Custom detector;
	lngDetector.addDetector(languageDetect);

	_i18next2.default
	// .use(Backend)
	.use(lngDetector).use(_reactI18next.reactI18nextModule).init({
		fallbackLng: 'zh-TW',

		whitelist: lanList,

		// have a common namespace used around the full app
		ns: ['navigators', 'translations'],
		defaultNS: 'translations',

		debug: "production" !== 'production',

		interpolation: {
			escapeValue: false // not needed for react!!
		},

		// Open when use backend
		// saveMissing: true,

		react: {
			wait: true
		},

		detection: {
			order: ['urlDetect', 'cookie', 'localStorage', 'navigator', 'htmlTag']
		},

		// Fakes translations resources. If you want to use backend, turn off this.
		resources: _resources2.default
	}, function () {
		store.dispatch((0, _i18n.changeLanguage)(_i18next2.default.language));
	});

	_i18next2.default.on('languageChanged', function () {
		store.dispatch((0, _i18n.changeLanguage)(_i18next2.default.language));
	});

	return _i18next2.default;
};

var lanMapRoute = exports.lanMapRoute = function lanMapRoute(lan) {
	var language = lan.split('-');
	if (language[0] === 'ja' || lan === 'jp') {
		return 'jp';
	}

	if (language[0] === 'ko' || lan === 'kr') {
		return 'kr';
	}

	if (lan === 'zh-CN' || lan === 'cn') {
		return 'cn';
	}

	if (lan === 'zh-TW' || lan === 'tw') {
		return 'tw';
	}

	if (['en'].includes(language[0]) || lan === 'en') {
		return language[0];
	}

	// Default router;
	return 'tw';
};

var routeMapLan = function routeMapLan(route) {
	if (route in LANG_MAP) {
		return LANG_MAP[route];
	}

	// Default router;
	return 'zh-TW';
};

var changeLng = exports.changeLng = function changeLng(lng) {
	return _i18next2.default.changeLanguage(routeMapLan(lng));
};

var translate = exports.translate = function translate(lan) {
	return function (translateGroup) {
		return function (key) {
			return _resources2.default[lan][translateGroup][key] || key;
		};
	};
};

/***/ }),
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.wrapFetchFormData = exports.wrapFetch = exports.SELF_HOST_ENDPOINT = exports.API_ENDPOINT = exports.HOST_MAP = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _queryString = __webpack_require__(204);

var _queryString2 = _interopRequireDefault(_queryString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var HOST_MAP = exports.HOST_MAP = {
	dev: 'https://justsleepbs.25demo.com',
	develop: 'https://justsleepbs.25demo.com',
	production: 'https://bs.justsleephotels.com'
};

var SELF_HOST_MAP = {
	dev: 'http://localhost:3000',
	develop: 'https://justsleep.25demo.com',
	production: 'https://www.justsleephotels.com'
};

var API_ENDPOINT = exports.API_ENDPOINT = HOST_MAP["production"];
var SELF_HOST_ENDPOINT = exports.SELF_HOST_ENDPOINT = SELF_HOST_MAP["production"];

var wrapFetch = exports.wrapFetch = function () {
	var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(url) {
		var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { headers: {} };
		var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
		var paramsString, URL, headers, result;
		return regeneratorRuntime.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						paramsString = _queryString2.default.stringify(params, { arrayFormat: 'bracket' });
						URL = paramsString !== '' ? API_ENDPOINT + '/' + url + '?' + paramsString : API_ENDPOINT + '/' + url;
						headers = new Headers(_extends({
							'Content-Type': 'application/json',
							Accept: 'application/json'
						}, options.headers));
						_context.next = 5;
						return fetch(URL, _extends({}, options, { headers: headers }));

					case 5:
						result = _context.sent;
						return _context.abrupt('return', result.json());

					case 7:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, undefined);
	}));

	return function wrapFetch(_x) {
		return _ref.apply(this, arguments);
	};
}();

var wrapFetchFormData = exports.wrapFetchFormData = function () {
	var _ref2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(url, options) {
		var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
		var paramsString, URL, result;
		return regeneratorRuntime.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						paramsString = _queryString2.default.stringify(params);
						URL = paramsString !== '' ? API_ENDPOINT + '/' + url + '?' + paramsString : API_ENDPOINT + '/' + url;
						_context2.next = 4;
						return fetch(URL, options);

					case 4:
						result = _context2.sent;
						return _context2.abrupt('return', result.json());

					case 6:
					case 'end':
						return _context2.stop();
				}
			}
		}, _callee2, undefined);
	}));

	return function wrapFetchFormData(_x4, _x5) {
		return _ref2.apply(this, arguments);
	};
}();

/***/ }),
/* 36 */,
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 3);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var UAParser = __webpack_require__(6);

var UA = exports.UA = new UAParser();

var browser = exports.browser = UA.getBrowser();
var cpu = exports.cpu = UA.getCPU();
var device = exports.device = UA.getDevice();
var engine = exports.engine = UA.getEngine();
var os = exports.os = UA.getOS();
var ua = exports.ua = UA.getUA();
var setUA = exports.setUA = function setUA(uaStr) {
  return UA.setUA(uaStr);
};

var mockUserAgent = exports.mockUserAgent = function mockUserAgent(userAgent) {
  window.navigator.__defineGetter__("userAgent", function () {
    return userAgent;
  });
};

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isYandex = exports.isEdge = exports.getUA = exports.engineVersion = exports.engineName = exports.mobileModel = exports.mobileVendor = exports.browserName = exports.browserVersion = exports.fullBrowserVersion = exports.osName = exports.osVersion = exports.isIE = exports.isOpera = exports.isSafari = exports.isFirefox = exports.isChrome = exports.isIOS = exports.isWinPhone = exports.isAndroid = exports.isBrowser = exports.isTablet = exports.isMobileOnly = exports.isMobile = exports.isChromium = exports.isMobileSafari = exports.isWearable = exports.isConsole = exports.isSmartTV = undefined;

var _getUaData = __webpack_require__(0);

var _types = __webpack_require__(2);

var CHROME = _types.BROWSER_TYPES.CHROME,
    CHROMIUM = _types.BROWSER_TYPES.CHROMIUM,
    IE = _types.BROWSER_TYPES.IE,
    INTERNET_EXPLORER = _types.BROWSER_TYPES.INTERNET_EXPLORER,
    OPERA = _types.BROWSER_TYPES.OPERA,
    FIREFOX = _types.BROWSER_TYPES.FIREFOX,
    SAFARI = _types.BROWSER_TYPES.SAFARI,
    MOBILE_SAFARI = _types.BROWSER_TYPES.MOBILE_SAFARI,
    EDGE = _types.BROWSER_TYPES.EDGE,
    YANDEX = _types.BROWSER_TYPES.YANDEX;
var MOBILE = _types.DEVICE_TYPES.MOBILE,
    TABLET = _types.DEVICE_TYPES.TABLET,
    SMART_TV = _types.DEVICE_TYPES.SMART_TV,
    BROWSER = _types.DEVICE_TYPES.BROWSER,
    WEARABLE = _types.DEVICE_TYPES.WEARABLE,
    CONSOLE = _types.DEVICE_TYPES.CONSOLE;
var ANDROID = _types.OS_TYPES.ANDROID,
    WINDOWS_PHONE = _types.OS_TYPES.WINDOWS_PHONE,
    IOS = _types.OS_TYPES.IOS;


var isMobileType = function isMobileType() {
  return _getUaData.device.type === MOBILE;
};
var isTabletType = function isTabletType() {
  return _getUaData.device.type === TABLET;
};

var isMobileAndTabletType = function isMobileAndTabletType() {
  switch (_getUaData.device.type) {
    case MOBILE:
    case TABLET:
      return true;
    default:
      return false;
  }
};

var isSmartTVType = function isSmartTVType() {
  return _getUaData.device.type === SMART_TV;
};
var isBrowserType = function isBrowserType() {
  return _getUaData.device.type === BROWSER;
};
var isWearableType = function isWearableType() {
  return _getUaData.device.type === WEARABLE;
};
var isConsoleType = function isConsoleType() {
  return _getUaData.device.type === CONSOLE;
};
var isAndroidType = function isAndroidType() {
  return _getUaData.os.name === ANDROID;
};
var isWinPhoneType = function isWinPhoneType() {
  return _getUaData.os.name === WINDOWS_PHONE;
};
var isIOSType = function isIOSType() {
  return _getUaData.os.name === IOS;
};
var isChromeType = function isChromeType() {
  return _getUaData.browser.name === CHROME;
};
var isFirefoxType = function isFirefoxType() {
  return _getUaData.browser.name === FIREFOX;
};
var isChromiumType = function isChromiumType() {
  return _getUaData.browser.name === CHROMIUM;
};
var isEdgeType = function isEdgeType() {
  return _getUaData.browser.name === EDGE;
};
var isYandexType = function isYandexType() {
  return _getUaData.browser.name === YANDEX;
};
var isSafariType = function isSafariType() {
  return _getUaData.browser.name === SAFARI || _getUaData.browser.name === MOBILE_SAFARI;
};
var isMobileSafariType = function isMobileSafariType() {
  return _getUaData.browser.name === MOBILE_SAFARI;
};
var isOperaType = function isOperaType() {
  return _getUaData.browser.name === OPERA;
};
var isIEType = function isIEType() {
  return _getUaData.browser.name === INTERNET_EXPLORER || _getUaData.browser.name === IE;
};

var getBrowserFullVersion = function getBrowserFullVersion() {
  return _getUaData.browser.major;
};
var getBrowserVersion = function getBrowserVersion() {
  return _getUaData.browser.version;
};
var getOsVersion = function getOsVersion() {
  return _getUaData.os.version ? _getUaData.os.version : "none";
};
var getOsName = function getOsName() {
  return _getUaData.os.name ? _getUaData.os.name : "none";
};
var getBrowserName = function getBrowserName() {
  return _getUaData.browser.name;
};
var getMobileVendor = function getMobileVendor() {
  return _getUaData.device.vendor ? _getUaData.device.vendor : "none";
};
var getMobileModel = function getMobileModel() {
  return _getUaData.device.model ? _getUaData.device.model : "none";
};
var getEngineName = function getEngineName() {
  return _getUaData.engine.name;
};
var getEngineVersion = function getEngineVersion() {
  return _getUaData.engine.version;
};
var getUseragent = function getUseragent() {
  return _getUaData.ua;
};

var isSmartTV = exports.isSmartTV = isSmartTVType();
var isConsole = exports.isConsole = isConsoleType();
var isWearable = exports.isWearable = isWearableType();
var isMobileSafari = exports.isMobileSafari = isMobileSafariType();
var isChromium = exports.isChromium = isChromiumType();
var isMobile = exports.isMobile = isMobileAndTabletType();
var isMobileOnly = exports.isMobileOnly = isMobileType();
var isTablet = exports.isTablet = isTabletType();
var isBrowser = exports.isBrowser = isBrowserType();
var isAndroid = exports.isAndroid = isAndroidType();
var isWinPhone = exports.isWinPhone = isWinPhoneType();
var isIOS = exports.isIOS = isIOSType();
var isChrome = exports.isChrome = isChromeType();
var isFirefox = exports.isFirefox = isFirefoxType();
var isSafari = exports.isSafari = isSafariType();
var isOpera = exports.isOpera = isOperaType();
var isIE = exports.isIE = isIEType();
var osVersion = exports.osVersion = getOsVersion();
var osName = exports.osName = getOsName();
var fullBrowserVersion = exports.fullBrowserVersion = getBrowserFullVersion();
var browserVersion = exports.browserVersion = getBrowserVersion();
var browserName = exports.browserName = getBrowserName();
var mobileVendor = exports.mobileVendor = getMobileVendor();
var mobileModel = exports.mobileModel = getMobileModel();
var engineName = exports.engineName = getEngineName();
var engineVersion = exports.engineVersion = getEngineVersion();
var getUA = exports.getUA = getUseragent();
var isEdge = exports.isEdge = isEdgeType();
var isYandex = exports.isYandex = isYandexType();

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wearPayload = exports.consolePayload = exports.stvPayload = exports.mobilePayload = exports.broPayload = exports.getCurrentBrowser = exports.checkType = exports.OS_TYPES = exports.BROWSER_TYPES = exports.DEVICE_TYPES = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _getUaData = __webpack_require__(0);

var DEVICE_TYPES = exports.DEVICE_TYPES = {
  MOBILE: 'mobile',
  TABLET: 'tablet',
  SMART_TV: 'smarttv',
  CONSOLE: 'console',
  WEARABLE: 'wearable',
  BROWSER: undefined
};

var BROWSER_TYPES = exports.BROWSER_TYPES = {
  CHROME: 'Chrome',
  FIREFOX: "Firefox",
  OPERA: "Opera",
  YANDEX: "Yandex",
  SAFARI: "Safari",
  INTERNET_EXPLORER: "Internet Explorer",
  EDGE: "Edge",
  CHROMIUM: "Chromium",
  IE: 'IE',
  MOBILE_SAFARI: "Mobile Safari"
};

var OS_TYPES = exports.OS_TYPES = {
  IOS: 'iOS',
  ANDROID: "Android",
  WINDOWS_PHONE: "Windows Phone"
};

var initialData = {
  isMobile: false,
  isTablet: false,
  isBrowser: false,
  isSmartTV: false,
  isConsole: false,
  isWearable: false
};

var checkType = exports.checkType = function checkType(type) {
  switch (type) {
    case DEVICE_TYPES.MOBILE:
      return { isMobile: true };
    case DEVICE_TYPES.TABLET:
      return { isTablet: true };
    case DEVICE_TYPES.SMART_TV:
      return { isSmartTV: true };
    case DEVICE_TYPES.CONSOLE:
      return { isConsole: true };
    case DEVICE_TYPES.WEARABLE:
      return { isWearable: true };
    case DEVICE_TYPES.BROWSER:
      return { isBrowser: true };
    default:
      return initialData;
  }
};

var getCurrentBrowser = exports.getCurrentBrowser = function getCurrentBrowser(name) {
  switch (name) {
    case BROWSER_TYPES.CHROME:
    case BROWSER_TYPES.FIREFOX:
    case BROWSER_TYPES.OPERA:
    case BROWSER_TYPES.YANDEX:
    case BROWSER_TYPES.SAFARI:
    case BROWSER_TYPES.IE:
    case BROWSER_TYPES.EDGE:
    case BROWSER_TYPES.CHROMIUM:
      return true;
    default:
      return false;
  }
};

var broPayload = exports.broPayload = function broPayload(isBrowser, browser, engine, os, ua) {
  return {
    isBrowser: isBrowser,
    browserMajorVersion: browser.major,
    browserFullVersion: browser.version,
    browserName: browser.name,
    engineName: engine.name || false,
    engineVersion: engine.version,
    osName: os.name,
    osVersion: os.version,
    userAgent: ua
  };
};

var mobilePayload = exports.mobilePayload = function mobilePayload(type, device, os, ua) {
  return _extends({}, type, {
    vendor: device.vendor || "none",
    model: device.model || "none",
    os: os.name || "none",
    osVersion: os.version || "none",
    ua: ua || "none"
  });
};

var stvPayload = exports.stvPayload = function stvPayload(isSmartTV, engine, os, ua) {
  return {
    isSmartTV: isSmartTV,
    engineName: engine.name || false,
    engineVersion: engine.version,
    osName: os.name,
    osVersion: os.version,
    userAgent: ua
  };
};

var consolePayload = exports.consolePayload = function consolePayload(isConsole, engine, os, ua) {
  return {
    isConsole: isConsole,
    engineName: engine.name || false,
    engineVersion: engine.version,
    osName: os.name,
    osVersion: os.version,
    userAgent: ua
  };
};

var wearPayload = exports.wearPayload = function wearPayload(isWearable, engine, os, ua) {
  return {
    isWearable: isWearable,
    engineName: engine.name || false,
    engineVersion: engine.version,
    osName: os.name,
    osVersion: os.version,
    userAgent: ua
  };
};

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deviceDetect = undefined;

var _views = __webpack_require__(4);

Object.keys(_views).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _views[key];
    }
  });
});

var _selectors = __webpack_require__(1);

Object.keys(_selectors).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _selectors[key];
    }
  });
});

var _detect = __webpack_require__(8);

var _detect2 = _interopRequireDefault(_detect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.deviceDetect = _detect2.default;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomView = exports.WearableView = exports.ConsoleView = exports.SmartTVView = exports.MobileOnlyView = exports.WinPhoneView = exports.TabletView = exports.MobileView = exports.IOSView = exports.IEView = exports.BrowserView = exports.AndroidView = undefined;

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _selectors = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AndroidView = exports.AndroidView = function AndroidView(_ref) {
  var renderWithFragment = _ref.renderWithFragment,
      children = _ref.children,
      viewClassName = _ref.viewClassName,
      style = _ref.style;

  return _selectors.isAndroid ? renderWithFragment ? _react2.default.createElement(
    _react.Fragment,
    null,
    children
  ) : _react2.default.createElement(
    'div',
    { className: viewClassName, style: style },
    children
  ) : null;
};

var BrowserView = exports.BrowserView = function BrowserView(_ref2) {
  var renderWithFragment = _ref2.renderWithFragment,
      children = _ref2.children,
      viewClassName = _ref2.viewClassName,
      style = _ref2.style;

  return _selectors.isBrowser ? renderWithFragment ? _react2.default.createElement(
    _react.Fragment,
    null,
    children
  ) : _react2.default.createElement(
    'div',
    { className: viewClassName, style: style },
    children
  ) : null;
};

var IEView = exports.IEView = function IEView(_ref3) {
  var renderWithFragment = _ref3.renderWithFragment,
      children = _ref3.children,
      viewClassName = _ref3.viewClassName,
      style = _ref3.style;

  return _selectors.isIE ? renderWithFragment ? _react2.default.createElement(
    _react.Fragment,
    null,
    children
  ) : _react2.default.createElement(
    'div',
    { className: viewClassName, style: style },
    children
  ) : null;
};

var IOSView = exports.IOSView = function IOSView(_ref4) {
  var renderWithFragment = _ref4.renderWithFragment,
      children = _ref4.children,
      viewClassName = _ref4.viewClassName,
      style = _ref4.style;

  return _selectors.isIOS ? renderWithFragment ? _react2.default.createElement(
    _react.Fragment,
    null,
    children
  ) : _react2.default.createElement(
    'div',
    { className: viewClassName, style: style },
    children
  ) : null;
};

var MobileView = exports.MobileView = function MobileView(_ref5) {
  var renderWithFragment = _ref5.renderWithFragment,
      children = _ref5.children,
      viewClassName = _ref5.viewClassName,
      style = _ref5.style;

  return _selectors.isMobile ? renderWithFragment ? _react2.default.createElement(
    _react.Fragment,
    null,
    children
  ) : _react2.default.createElement(
    'div',
    { className: viewClassName, style: style },
    children
  ) : null;
};

var TabletView = exports.TabletView = function TabletView(_ref6) {
  var renderWithFragment = _ref6.renderWithFragment,
      children = _ref6.children,
      viewClassName = _ref6.viewClassName,
      style = _ref6.style;

  return _selectors.isTablet ? renderWithFragment ? _react2.default.createElement(
    _react.Fragment,
    null,
    children
  ) : _react2.default.createElement(
    'div',
    { className: viewClassName, style: style },
    children
  ) : null;
};

var WinPhoneView = exports.WinPhoneView = function WinPhoneView(_ref7) {
  var renderWithFragment = _ref7.renderWithFragment,
      children = _ref7.children,
      viewClassName = _ref7.viewClassName,
      style = _ref7.style;

  return _selectors.isWinPhone ? renderWithFragment ? _react2.default.createElement(
    _react.Fragment,
    null,
    children
  ) : _react2.default.createElement(
    'div',
    { className: viewClassName, style: style },
    children
  ) : null;
};

var MobileOnlyView = exports.MobileOnlyView = function MobileOnlyView(_ref8) {
  var renderWithFragment = _ref8.renderWithFragment,
      children = _ref8.children,
      viewClassName = _ref8.viewClassName,
      style = _ref8.style;

  return _selectors.isMobileOnly ? renderWithFragment ? _react2.default.createElement(
    _react.Fragment,
    null,
    children
  ) : _react2.default.createElement(
    'div',
    { className: viewClassName, style: style },
    children
  ) : null;
};

var SmartTVView = exports.SmartTVView = function SmartTVView(_ref9) {
  var renderWithFragment = _ref9.renderWithFragment,
      children = _ref9.children,
      viewClassName = _ref9.viewClassName,
      style = _ref9.style;

  return _selectors.isSmartTV ? renderWithFragment ? _react2.default.createElement(
    _react.Fragment,
    null,
    children
  ) : _react2.default.createElement(
    'div',
    { className: viewClassName, style: style },
    children
  ) : null;
};

var ConsoleView = exports.ConsoleView = function ConsoleView(_ref10) {
  var renderWithFragment = _ref10.renderWithFragment,
      children = _ref10.children,
      viewClassName = _ref10.viewClassName,
      style = _ref10.style;

  return _selectors.isConsole ? renderWithFragment ? _react2.default.createElement(
    _react.Fragment,
    null,
    children
  ) : _react2.default.createElement(
    'div',
    { className: viewClassName, style: style },
    children
  ) : null;
};

var WearableView = exports.WearableView = function WearableView(_ref11) {
  var renderWithFragment = _ref11.renderWithFragment,
      children = _ref11.children,
      viewClassName = _ref11.viewClassName,
      style = _ref11.style;

  return _selectors.isWearable ? renderWithFragment ? _react2.default.createElement(
    _react.Fragment,
    null,
    children
  ) : _react2.default.createElement(
    'div',
    { className: viewClassName, style: style },
    children
  ) : null;
};

var CustomView = exports.CustomView = function CustomView(_ref12) {
  var renderWithFragment = _ref12.renderWithFragment,
      children = _ref12.children,
      viewClassName = _ref12.viewClassName,
      style = _ref12.style,
      condition = _ref12.condition;

  return condition ? renderWithFragment ? _react2.default.createElement(
    _react.Fragment,
    null,
    children
  ) : _react2.default.createElement(
    'div',
    { className: viewClassName, style: style },
    children
  ) : null;
};

/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(1);

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * UAParser.js v0.7.18
 * Lightweight JavaScript-based User-Agent string parser
 * https://github.com/faisalman/ua-parser-js
 *
 * Copyright © 2012-2016 Faisal Salman <fyzlman@gmail.com>
 * Dual licensed under GPLv2 or MIT
 */
(function(window,undefined){"use strict";var LIBVERSION="0.7.18",EMPTY="",UNKNOWN="?",FUNC_TYPE="function",UNDEF_TYPE="undefined",OBJ_TYPE="object",STR_TYPE="string",MAJOR="major",MODEL="model",NAME="name",TYPE="type",VENDOR="vendor",VERSION="version",ARCHITECTURE="architecture",CONSOLE="console",MOBILE="mobile",TABLET="tablet",SMARTTV="smarttv",WEARABLE="wearable",EMBEDDED="embedded";var util={extend:function(regexes,extensions){var margedRegexes={};for(var i in regexes){if(extensions[i]&&extensions[i].length%2===0){margedRegexes[i]=extensions[i].concat(regexes[i])}else{margedRegexes[i]=regexes[i]}}return margedRegexes},has:function(str1,str2){if(typeof str1==="string"){return str2.toLowerCase().indexOf(str1.toLowerCase())!==-1}else{return false}},lowerize:function(str){return str.toLowerCase()},major:function(version){return typeof version===STR_TYPE?version.replace(/[^\d\.]/g,"").split(".")[0]:undefined},trim:function(str){return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,"")}};var mapper={rgx:function(ua,arrays){var i=0,j,k,p,q,matches,match;while(i<arrays.length&&!matches){var regex=arrays[i],props=arrays[i+1];j=k=0;while(j<regex.length&&!matches){matches=regex[j++].exec(ua);if(!!matches){for(p=0;p<props.length;p++){match=matches[++k];q=props[p];if(typeof q===OBJ_TYPE&&q.length>0){if(q.length==2){if(typeof q[1]==FUNC_TYPE){this[q[0]]=q[1].call(this,match)}else{this[q[0]]=q[1]}}else if(q.length==3){if(typeof q[1]===FUNC_TYPE&&!(q[1].exec&&q[1].test)){this[q[0]]=match?q[1].call(this,match,q[2]):undefined}else{this[q[0]]=match?match.replace(q[1],q[2]):undefined}}else if(q.length==4){this[q[0]]=match?q[3].call(this,match.replace(q[1],q[2])):undefined}}else{this[q]=match?match:undefined}}}}i+=2}},str:function(str,map){for(var i in map){if(typeof map[i]===OBJ_TYPE&&map[i].length>0){for(var j=0;j<map[i].length;j++){if(util.has(map[i][j],str)){return i===UNKNOWN?undefined:i}}}else if(util.has(map[i],str)){return i===UNKNOWN?undefined:i}}return str}};var maps={browser:{oldsafari:{version:{"1.0":"/8",1.2:"/1",1.3:"/3","2.0":"/412","2.0.2":"/416","2.0.3":"/417","2.0.4":"/419","?":"/"}}},device:{amazon:{model:{"Fire Phone":["SD","KF"]}},sprint:{model:{"Evo Shift 4G":"7373KT"},vendor:{HTC:"APA",Sprint:"Sprint"}}},os:{windows:{version:{ME:"4.90","NT 3.11":"NT3.51","NT 4.0":"NT4.0",2000:"NT 5.0",XP:["NT 5.1","NT 5.2"],Vista:"NT 6.0",7:"NT 6.1",8:"NT 6.2",8.1:"NT 6.3",10:["NT 6.4","NT 10.0"],RT:"ARM"}}}};var regexes={browser:[[/(opera\smini)\/([\w\.-]+)/i,/(opera\s[mobiletab]+).+version\/([\w\.-]+)/i,/(opera).+version\/([\w\.]+)/i,/(opera)[\/\s]+([\w\.]+)/i],[NAME,VERSION],[/(opios)[\/\s]+([\w\.]+)/i],[[NAME,"Opera Mini"],VERSION],[/\s(opr)\/([\w\.]+)/i],[[NAME,"Opera"],VERSION],[/(kindle)\/([\w\.]+)/i,/(lunascape|maxthon|netfront|jasmine|blazer)[\/\s]?([\w\.]*)/i,/(avant\s|iemobile|slim|baidu)(?:browser)?[\/\s]?([\w\.]*)/i,/(?:ms|\()(ie)\s([\w\.]+)/i,/(rekonq)\/([\w\.]*)/i,/(chromium|flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark)\/([\w\.-]+)/i],[NAME,VERSION],[/(trident).+rv[:\s]([\w\.]+).+like\sgecko/i],[[NAME,"IE"],VERSION],[/(edge|edgios|edgea)\/((\d+)?[\w\.]+)/i],[[NAME,"Edge"],VERSION],[/(yabrowser)\/([\w\.]+)/i],[[NAME,"Yandex"],VERSION],[/(puffin)\/([\w\.]+)/i],[[NAME,"Puffin"],VERSION],[/((?:[\s\/])uc?\s?browser|(?:juc.+)ucweb)[\/\s]?([\w\.]+)/i],[[NAME,"UCBrowser"],VERSION],[/(comodo_dragon)\/([\w\.]+)/i],[[NAME,/_/g," "],VERSION],[/(micromessenger)\/([\w\.]+)/i],[[NAME,"WeChat"],VERSION],[/(qqbrowserlite)\/([\w\.]+)/i],[NAME,VERSION],[/(QQ)\/([\d\.]+)/i],[NAME,VERSION],[/m?(qqbrowser)[\/\s]?([\w\.]+)/i],[NAME,VERSION],[/(BIDUBrowser)[\/\s]?([\w\.]+)/i],[NAME,VERSION],[/(2345Explorer)[\/\s]?([\w\.]+)/i],[NAME,VERSION],[/(MetaSr)[\/\s]?([\w\.]+)/i],[NAME],[/(LBBROWSER)/i],[NAME],[/xiaomi\/miuibrowser\/([\w\.]+)/i],[VERSION,[NAME,"MIUI Browser"]],[/;fbav\/([\w\.]+);/i],[VERSION,[NAME,"Facebook"]],[/headlesschrome(?:\/([\w\.]+)|\s)/i],[VERSION,[NAME,"Chrome Headless"]],[/\swv\).+(chrome)\/([\w\.]+)/i],[[NAME,/(.+)/,"$1 WebView"],VERSION],[/((?:oculus|samsung)browser)\/([\w\.]+)/i],[[NAME,/(.+(?:g|us))(.+)/,"$1 $2"],VERSION],[/android.+version\/([\w\.]+)\s+(?:mobile\s?safari|safari)*/i],[VERSION,[NAME,"Android Browser"]],[/(chrome|omniweb|arora|[tizenoka]{5}\s?browser)\/v?([\w\.]+)/i],[NAME,VERSION],[/(dolfin)\/([\w\.]+)/i],[[NAME,"Dolphin"],VERSION],[/((?:android.+)crmo|crios)\/([\w\.]+)/i],[[NAME,"Chrome"],VERSION],[/(coast)\/([\w\.]+)/i],[[NAME,"Opera Coast"],VERSION],[/fxios\/([\w\.-]+)/i],[VERSION,[NAME,"Firefox"]],[/version\/([\w\.]+).+?mobile\/\w+\s(safari)/i],[VERSION,[NAME,"Mobile Safari"]],[/version\/([\w\.]+).+?(mobile\s?safari|safari)/i],[VERSION,NAME],[/webkit.+?(gsa)\/([\w\.]+).+?(mobile\s?safari|safari)(\/[\w\.]+)/i],[[NAME,"GSA"],VERSION],[/webkit.+?(mobile\s?safari|safari)(\/[\w\.]+)/i],[NAME,[VERSION,mapper.str,maps.browser.oldsafari.version]],[/(konqueror)\/([\w\.]+)/i,/(webkit|khtml)\/([\w\.]+)/i],[NAME,VERSION],[/(navigator|netscape)\/([\w\.-]+)/i],[[NAME,"Netscape"],VERSION],[/(swiftfox)/i,/(icedragon|iceweasel|camino|chimera|fennec|maemo\sbrowser|minimo|conkeror)[\/\s]?([\w\.\+]+)/i,/(firefox|seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([\w\.-]+)$/i,/(mozilla)\/([\w\.]+).+rv\:.+gecko\/\d+/i,/(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir)[\/\s]?([\w\.]+)/i,/(links)\s\(([\w\.]+)/i,/(gobrowser)\/?([\w\.]*)/i,/(ice\s?browser)\/v?([\w\._]+)/i,/(mosaic)[\/\s]([\w\.]+)/i],[NAME,VERSION]],cpu:[[/(?:(amd|x(?:(?:86|64)[_-])?|wow|win)64)[;\)]/i],[[ARCHITECTURE,"amd64"]],[/(ia32(?=;))/i],[[ARCHITECTURE,util.lowerize]],[/((?:i[346]|x)86)[;\)]/i],[[ARCHITECTURE,"ia32"]],[/windows\s(ce|mobile);\sppc;/i],[[ARCHITECTURE,"arm"]],[/((?:ppc|powerpc)(?:64)?)(?:\smac|;|\))/i],[[ARCHITECTURE,/ower/,"",util.lowerize]],[/(sun4\w)[;\)]/i],[[ARCHITECTURE,"sparc"]],[/((?:avr32|ia64(?=;))|68k(?=\))|arm(?:64|(?=v\d+;))|(?=atmel\s)avr|(?:irix|mips|sparc)(?:64)?(?=;)|pa-risc)/i],[[ARCHITECTURE,util.lowerize]]],device:[[/\((ipad|playbook);[\w\s\);-]+(rim|apple)/i],[MODEL,VENDOR,[TYPE,TABLET]],[/applecoremedia\/[\w\.]+ \((ipad)/],[MODEL,[VENDOR,"Apple"],[TYPE,TABLET]],[/(apple\s{0,1}tv)/i],[[MODEL,"Apple TV"],[VENDOR,"Apple"]],[/(archos)\s(gamepad2?)/i,/(hp).+(touchpad)/i,/(hp).+(tablet)/i,/(kindle)\/([\w\.]+)/i,/\s(nook)[\w\s]+build\/(\w+)/i,/(dell)\s(strea[kpr\s\d]*[\dko])/i],[VENDOR,MODEL,[TYPE,TABLET]],[/(kf[A-z]+)\sbuild\/.+silk\//i],[MODEL,[VENDOR,"Amazon"],[TYPE,TABLET]],[/(sd|kf)[0349hijorstuw]+\sbuild\/.+silk\//i],[[MODEL,mapper.str,maps.device.amazon.model],[VENDOR,"Amazon"],[TYPE,MOBILE]],[/\((ip[honed|\s\w*]+);.+(apple)/i],[MODEL,VENDOR,[TYPE,MOBILE]],[/\((ip[honed|\s\w*]+);/i],[MODEL,[VENDOR,"Apple"],[TYPE,MOBILE]],[/(blackberry)[\s-]?(\w+)/i,/(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[\s_-]?([\w-]*)/i,/(hp)\s([\w\s]+\w)/i,/(asus)-?(\w+)/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/\(bb10;\s(\w+)/i],[MODEL,[VENDOR,"BlackBerry"],[TYPE,MOBILE]],[/android.+(transfo[prime\s]{4,10}\s\w+|eeepc|slider\s\w+|nexus 7|padfone)/i],[MODEL,[VENDOR,"Asus"],[TYPE,TABLET]],[/(sony)\s(tablet\s[ps])\sbuild\//i,/(sony)?(?:sgp.+)\sbuild\//i],[[VENDOR,"Sony"],[MODEL,"Xperia Tablet"],[TYPE,TABLET]],[/android.+\s([c-g]\d{4}|so[-l]\w+)\sbuild\//i],[MODEL,[VENDOR,"Sony"],[TYPE,MOBILE]],[/\s(ouya)\s/i,/(nintendo)\s([wids3u]+)/i],[VENDOR,MODEL,[TYPE,CONSOLE]],[/android.+;\s(shield)\sbuild/i],[MODEL,[VENDOR,"Nvidia"],[TYPE,CONSOLE]],[/(playstation\s[34portablevi]+)/i],[MODEL,[VENDOR,"Sony"],[TYPE,CONSOLE]],[/(sprint\s(\w+))/i],[[VENDOR,mapper.str,maps.device.sprint.vendor],[MODEL,mapper.str,maps.device.sprint.model],[TYPE,MOBILE]],[/(lenovo)\s?(S(?:5000|6000)+(?:[-][\w+]))/i],[VENDOR,MODEL,[TYPE,TABLET]],[/(htc)[;_\s-]+([\w\s]+(?=\))|\w+)*/i,/(zte)-(\w*)/i,/(alcatel|geeksphone|lenovo|nexian|panasonic|(?=;\s)sony)[_\s-]?([\w-]*)/i],[VENDOR,[MODEL,/_/g," "],[TYPE,MOBILE]],[/(nexus\s9)/i],[MODEL,[VENDOR,"HTC"],[TYPE,TABLET]],[/d\/huawei([\w\s-]+)[;\)]/i,/(nexus\s6p)/i],[MODEL,[VENDOR,"Huawei"],[TYPE,MOBILE]],[/(microsoft);\s(lumia[\s\w]+)/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/[\s\(;](xbox(?:\sone)?)[\s\);]/i],[MODEL,[VENDOR,"Microsoft"],[TYPE,CONSOLE]],[/(kin\.[onetw]{3})/i],[[MODEL,/\./g," "],[VENDOR,"Microsoft"],[TYPE,MOBILE]],[/\s(milestone|droid(?:[2-4x]|\s(?:bionic|x2|pro|razr))?:?(\s4g)?)[\w\s]+build\//i,/mot[\s-]?(\w*)/i,/(XT\d{3,4}) build\//i,/(nexus\s6)/i],[MODEL,[VENDOR,"Motorola"],[TYPE,MOBILE]],[/android.+\s(mz60\d|xoom[\s2]{0,2})\sbuild\//i],[MODEL,[VENDOR,"Motorola"],[TYPE,TABLET]],[/hbbtv\/\d+\.\d+\.\d+\s+\([\w\s]*;\s*(\w[^;]*);([^;]*)/i],[[VENDOR,util.trim],[MODEL,util.trim],[TYPE,SMARTTV]],[/hbbtv.+maple;(\d+)/i],[[MODEL,/^/,"SmartTV"],[VENDOR,"Samsung"],[TYPE,SMARTTV]],[/\(dtv[\);].+(aquos)/i],[MODEL,[VENDOR,"Sharp"],[TYPE,SMARTTV]],[/android.+((sch-i[89]0\d|shw-m380s|gt-p\d{4}|gt-n\d+|sgh-t8[56]9|nexus 10))/i,/((SM-T\w+))/i],[[VENDOR,"Samsung"],MODEL,[TYPE,TABLET]],[/smart-tv.+(samsung)/i],[VENDOR,[TYPE,SMARTTV],MODEL],[/((s[cgp]h-\w+|gt-\w+|galaxy\snexus|sm-\w[\w\d]+))/i,/(sam[sung]*)[\s-]*(\w+-?[\w-]*)/i,/sec-((sgh\w+))/i],[[VENDOR,"Samsung"],MODEL,[TYPE,MOBILE]],[/sie-(\w*)/i],[MODEL,[VENDOR,"Siemens"],[TYPE,MOBILE]],[/(maemo|nokia).*(n900|lumia\s\d+)/i,/(nokia)[\s_-]?([\w-]*)/i],[[VENDOR,"Nokia"],MODEL,[TYPE,MOBILE]],[/android\s3\.[\s\w;-]{10}(a\d{3})/i],[MODEL,[VENDOR,"Acer"],[TYPE,TABLET]],[/android.+([vl]k\-?\d{3})\s+build/i],[MODEL,[VENDOR,"LG"],[TYPE,TABLET]],[/android\s3\.[\s\w;-]{10}(lg?)-([06cv9]{3,4})/i],[[VENDOR,"LG"],MODEL,[TYPE,TABLET]],[/(lg) netcast\.tv/i],[VENDOR,MODEL,[TYPE,SMARTTV]],[/(nexus\s[45])/i,/lg[e;\s\/-]+(\w*)/i,/android.+lg(\-?[\d\w]+)\s+build/i],[MODEL,[VENDOR,"LG"],[TYPE,MOBILE]],[/android.+(ideatab[a-z0-9\-\s]+)/i],[MODEL,[VENDOR,"Lenovo"],[TYPE,TABLET]],[/linux;.+((jolla));/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/((pebble))app\/[\d\.]+\s/i],[VENDOR,MODEL,[TYPE,WEARABLE]],[/android.+;\s(oppo)\s?([\w\s]+)\sbuild/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/crkey/i],[[MODEL,"Chromecast"],[VENDOR,"Google"]],[/android.+;\s(glass)\s\d/i],[MODEL,[VENDOR,"Google"],[TYPE,WEARABLE]],[/android.+;\s(pixel c)\s/i],[MODEL,[VENDOR,"Google"],[TYPE,TABLET]],[/android.+;\s(pixel xl|pixel)\s/i],[MODEL,[VENDOR,"Google"],[TYPE,MOBILE]],[/android.+;\s(\w+)\s+build\/hm\1/i,/android.+(hm[\s\-_]*note?[\s_]*(?:\d\w)?)\s+build/i,/android.+(mi[\s\-_]*(?:one|one[\s_]plus|note lte)?[\s_]*(?:\d?\w?)[\s_]*(?:plus)?)\s+build/i,/android.+(redmi[\s\-_]*(?:note)?(?:[\s_]*[\w\s]+))\s+build/i],[[MODEL,/_/g," "],[VENDOR,"Xiaomi"],[TYPE,MOBILE]],[/android.+(mi[\s\-_]*(?:pad)(?:[\s_]*[\w\s]+))\s+build/i],[[MODEL,/_/g," "],[VENDOR,"Xiaomi"],[TYPE,TABLET]],[/android.+;\s(m[1-5]\snote)\sbuild/i],[MODEL,[VENDOR,"Meizu"],[TYPE,TABLET]],[/android.+a000(1)\s+build/i,/android.+oneplus\s(a\d{4})\s+build/i],[MODEL,[VENDOR,"OnePlus"],[TYPE,MOBILE]],[/android.+[;\/]\s*(RCT[\d\w]+)\s+build/i],[MODEL,[VENDOR,"RCA"],[TYPE,TABLET]],[/android.+[;\/\s]+(Venue[\d\s]{2,7})\s+build/i],[MODEL,[VENDOR,"Dell"],[TYPE,TABLET]],[/android.+[;\/]\s*(Q[T|M][\d\w]+)\s+build/i],[MODEL,[VENDOR,"Verizon"],[TYPE,TABLET]],[/android.+[;\/]\s+(Barnes[&\s]+Noble\s+|BN[RT])(V?.*)\s+build/i],[[VENDOR,"Barnes & Noble"],MODEL,[TYPE,TABLET]],[/android.+[;\/]\s+(TM\d{3}.*\b)\s+build/i],[MODEL,[VENDOR,"NuVision"],[TYPE,TABLET]],[/android.+;\s(k88)\sbuild/i],[MODEL,[VENDOR,"ZTE"],[TYPE,TABLET]],[/android.+[;\/]\s*(gen\d{3})\s+build.*49h/i],[MODEL,[VENDOR,"Swiss"],[TYPE,MOBILE]],[/android.+[;\/]\s*(zur\d{3})\s+build/i],[MODEL,[VENDOR,"Swiss"],[TYPE,TABLET]],[/android.+[;\/]\s*((Zeki)?TB.*\b)\s+build/i],[MODEL,[VENDOR,"Zeki"],[TYPE,TABLET]],[/(android).+[;\/]\s+([YR]\d{2})\s+build/i,/android.+[;\/]\s+(Dragon[\-\s]+Touch\s+|DT)(\w{5})\sbuild/i],[[VENDOR,"Dragon Touch"],MODEL,[TYPE,TABLET]],[/android.+[;\/]\s*(NS-?\w{0,9})\sbuild/i],[MODEL,[VENDOR,"Insignia"],[TYPE,TABLET]],[/android.+[;\/]\s*((NX|Next)-?\w{0,9})\s+build/i],[MODEL,[VENDOR,"NextBook"],[TYPE,TABLET]],[/android.+[;\/]\s*(Xtreme\_)?(V(1[045]|2[015]|30|40|60|7[05]|90))\s+build/i],[[VENDOR,"Voice"],MODEL,[TYPE,MOBILE]],[/android.+[;\/]\s*(LVTEL\-)?(V1[12])\s+build/i],[[VENDOR,"LvTel"],MODEL,[TYPE,MOBILE]],[/android.+[;\/]\s*(V(100MD|700NA|7011|917G).*\b)\s+build/i],[MODEL,[VENDOR,"Envizen"],[TYPE,TABLET]],[/android.+[;\/]\s*(Le[\s\-]+Pan)[\s\-]+(\w{1,9})\s+build/i],[VENDOR,MODEL,[TYPE,TABLET]],[/android.+[;\/]\s*(Trio[\s\-]*.*)\s+build/i],[MODEL,[VENDOR,"MachSpeed"],[TYPE,TABLET]],[/android.+[;\/]\s*(Trinity)[\-\s]*(T\d{3})\s+build/i],[VENDOR,MODEL,[TYPE,TABLET]],[/android.+[;\/]\s*TU_(1491)\s+build/i],[MODEL,[VENDOR,"Rotor"],[TYPE,TABLET]],[/android.+(KS(.+))\s+build/i],[MODEL,[VENDOR,"Amazon"],[TYPE,TABLET]],[/android.+(Gigaset)[\s\-]+(Q\w{1,9})\s+build/i],[VENDOR,MODEL,[TYPE,TABLET]],[/\s(tablet|tab)[;\/]/i,/\s(mobile)(?:[;\/]|\ssafari)/i],[[TYPE,util.lowerize],VENDOR,MODEL],[/(android[\w\.\s\-]{0,9});.+build/i],[MODEL,[VENDOR,"Generic"]]],engine:[[/windows.+\sedge\/([\w\.]+)/i],[VERSION,[NAME,"EdgeHTML"]],[/(presto)\/([\w\.]+)/i,/(webkit|trident|netfront|netsurf|amaya|lynx|w3m)\/([\w\.]+)/i,/(khtml|tasman|links)[\/\s]\(?([\w\.]+)/i,/(icab)[\/\s]([23]\.[\d\.]+)/i],[NAME,VERSION],[/rv\:([\w\.]{1,9}).+(gecko)/i],[VERSION,NAME]],os:[[/microsoft\s(windows)\s(vista|xp)/i],[NAME,VERSION],[/(windows)\snt\s6\.2;\s(arm)/i,/(windows\sphone(?:\sos)*)[\s\/]?([\d\.\s\w]*)/i,/(windows\smobile|windows)[\s\/]?([ntce\d\.\s]+\w)/i],[NAME,[VERSION,mapper.str,maps.os.windows.version]],[/(win(?=3|9|n)|win\s9x\s)([nt\d\.]+)/i],[[NAME,"Windows"],[VERSION,mapper.str,maps.os.windows.version]],[/\((bb)(10);/i],[[NAME,"BlackBerry"],VERSION],[/(blackberry)\w*\/?([\w\.]*)/i,/(tizen)[\/\s]([\w\.]+)/i,/(android|webos|palm\sos|qnx|bada|rim\stablet\sos|meego|contiki)[\/\s-]?([\w\.]*)/i,/linux;.+(sailfish);/i],[NAME,VERSION],[/(symbian\s?os|symbos|s60(?=;))[\/\s-]?([\w\.]*)/i],[[NAME,"Symbian"],VERSION],[/\((series40);/i],[NAME],[/mozilla.+\(mobile;.+gecko.+firefox/i],[[NAME,"Firefox OS"],VERSION],[/(nintendo|playstation)\s([wids34portablevu]+)/i,/(mint)[\/\s\(]?(\w*)/i,/(mageia|vectorlinux)[;\s]/i,/(joli|[kxln]?ubuntu|debian|suse|opensuse|gentoo|(?=\s)arch|slackware|fedora|mandriva|centos|pclinuxos|redhat|zenwalk|linpus)[\/\s-]?(?!chrom)([\w\.-]*)/i,/(hurd|linux)\s?([\w\.]*)/i,/(gnu)\s?([\w\.]*)/i],[NAME,VERSION],[/(cros)\s[\w]+\s([\w\.]+\w)/i],[[NAME,"Chromium OS"],VERSION],[/(sunos)\s?([\w\.\d]*)/i],[[NAME,"Solaris"],VERSION],[/\s([frentopc-]{0,4}bsd|dragonfly)\s?([\w\.]*)/i],[NAME,VERSION],[/(haiku)\s(\w+)/i],[NAME,VERSION],[/cfnetwork\/.+darwin/i,/ip[honead]{2,4}(?:.*os\s([\w]+)\slike\smac|;\sopera)/i],[[VERSION,/_/g,"."],[NAME,"iOS"]],[/(mac\sos\sx)\s?([\w\s\.]*)/i,/(macintosh|mac(?=_powerpc)\s)/i],[[NAME,"Mac OS"],[VERSION,/_/g,"."]],[/((?:open)?solaris)[\/\s-]?([\w\.]*)/i,/(aix)\s((\d)(?=\.|\)|\s)[\w\.])*/i,/(plan\s9|minix|beos|os\/2|amigaos|morphos|risc\sos|openvms)/i,/(unix)\s?([\w\.]*)/i],[NAME,VERSION]]};var UAParser=function(uastring,extensions){if(typeof uastring==="object"){extensions=uastring;uastring=undefined}if(!(this instanceof UAParser)){return new UAParser(uastring,extensions).getResult()}var ua=uastring||(window&&window.navigator&&window.navigator.userAgent?window.navigator.userAgent:EMPTY);var rgxmap=extensions?util.extend(regexes,extensions):regexes;this.getBrowser=function(){var browser={name:undefined,version:undefined};mapper.rgx.call(browser,ua,rgxmap.browser);browser.major=util.major(browser.version);return browser};this.getCPU=function(){var cpu={architecture:undefined};mapper.rgx.call(cpu,ua,rgxmap.cpu);return cpu};this.getDevice=function(){var device={vendor:undefined,model:undefined,type:undefined};mapper.rgx.call(device,ua,rgxmap.device);return device};this.getEngine=function(){var engine={name:undefined,version:undefined};mapper.rgx.call(engine,ua,rgxmap.engine);return engine};this.getOS=function(){var os={name:undefined,version:undefined};mapper.rgx.call(os,ua,rgxmap.os);return os};this.getResult=function(){return{ua:this.getUA(),browser:this.getBrowser(),engine:this.getEngine(),os:this.getOS(),device:this.getDevice(),cpu:this.getCPU()}};this.getUA=function(){return ua};this.setUA=function(uastring){ua=uastring;return this};return this};UAParser.VERSION=LIBVERSION;UAParser.BROWSER={NAME:NAME,MAJOR:MAJOR,VERSION:VERSION};UAParser.CPU={ARCHITECTURE:ARCHITECTURE};UAParser.DEVICE={MODEL:MODEL,VENDOR:VENDOR,TYPE:TYPE,CONSOLE:CONSOLE,MOBILE:MOBILE,SMARTTV:SMARTTV,TABLET:TABLET,WEARABLE:WEARABLE,EMBEDDED:EMBEDDED};UAParser.ENGINE={NAME:NAME,VERSION:VERSION};UAParser.OS={NAME:NAME,VERSION:VERSION};if(typeof exports!==UNDEF_TYPE){if(typeof module!==UNDEF_TYPE&&module.exports){exports=module.exports=UAParser}exports.UAParser=UAParser}else{if("function"===FUNC_TYPE&&__webpack_require__(7)){!(__WEBPACK_AMD_DEFINE_RESULT__ = (function(){return UAParser}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))}else if(window){window.UAParser=UAParser}}var $=window&&(window.jQuery||window.Zepto);if(typeof $!==UNDEF_TYPE){var parser=new UAParser;$.ua=parser.getResult();$.ua.get=function(){return parser.getUA()};$.ua.set=function(uastring){parser.setUA(uastring);var result=parser.getResult();for(var prop in result){$.ua[prop]=result[prop]}}}})(typeof window==="object"?window:this);

/***/ }),
/* 7 */
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getUaData = __webpack_require__(0);

var _types = __webpack_require__(2);

var create = _interopRequireWildcard(_types);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var type = create.checkType(_getUaData.device.type);

exports.default = function () {
  var isBrowser = type.isBrowser,
      isMobile = type.isMobile,
      isTablet = type.isTablet,
      isSmartTV = type.isSmartTV,
      isConsole = type.isConsole,
      isWearable = type.isWearable;

  if (isBrowser) {
    return create.broPayload(isBrowser, _getUaData.browser, _getUaData.engine, _getUaData.os, _getUaData.ua);
  }

  if (isSmartTV) {
    return create.stvPayload(isSmartTV, _getUaData.engine, _getUaData.os, _getUaData.ua);
  }

  if (isConsole) {
    return create.consolePayload(isConsole, _getUaData.engine, _getUaData.os, _getUaData.ua);
  }

  if (isMobile) {
    return create.mobilePayload(type, _getUaData.device, _getUaData.os, _getUaData.ua);
  }

  if (isTablet) {
    return create.mobilePayload(type, _getUaData.device, _getUaData.os, _getUaData.ua);
  }

  if (isWearable) {
    return create.wearPayload(isWearable, _getUaData.engine, _getUaData.os, _getUaData.ua);
  }
};

/***/ })
/******/ ]);

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.closePopup = exports.getPopupIndex = exports.getPopups = undefined;

var _reduxActions = __webpack_require__(6);

var _endpoint = __webpack_require__(35);

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var getPopups = exports.getPopups = (0, _reduxActions.createAction)('FETCH_POPUPS', function () {
	var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(lan, hotel) {
		var _ref2, status, message, data, popups;

		return regeneratorRuntime.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						_context.next = 2;
						return (0, _endpoint.wrapFetch)('api/v1/web/' + lan + '/' + hotel + '/popup', {
							method: 'GET'
						});

					case 2:
						_ref2 = _context.sent;
						status = _ref2.status;
						message = _ref2.message;
						data = _ref2.data;

						if (!(status !== 200)) {
							_context.next = 8;
							break;
						}

						throw new Error(message);

					case 8:
						popups = data.map(function (popup) {
							return {
								title: popup.title,
								subtitle: popup.subtitle,
								buttonText: popup.btn_text,
								link: popup.link,
								pages: popup.pages,
								image: popup.thumb
							};
						});
						return _context.abrupt('return', {
							popups: popups
						});

					case 10:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, undefined);
	}));

	return function (_x, _x2) {
		return _ref.apply(this, arguments);
	};
}());

var getPopupIndex = exports.getPopupIndex = (0, _reduxActions.createAction)('FETCH_POPUP_INDEX', function () {
	var _ref3 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(lan) {
		var _ref4, status, message, data, popupIndex;

		return regeneratorRuntime.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						_context2.next = 2;
						return (0, _endpoint.wrapFetch)('api/v1/web/' + lan + '/popupIndex', {
							method: 'GET'
						});

					case 2:
						_ref4 = _context2.sent;
						status = _ref4.status;
						message = _ref4.message;
						data = _ref4.data;

						if (!(status !== 200)) {
							_context2.next = 8;
							break;
						}

						throw new Error(message);

					case 8:
						popupIndex = data.map(function (popup) {
							return {
								title: popup.title,
								subtitle: popup.subtitle,
								buttonText: popup.btn_text,
								link: popup.link,
								image: popup.thumb
							};
						});
						return _context2.abrupt('return', { popupIndex: popupIndex });

					case 10:
					case 'end':
						return _context2.stop();
				}
			}
		}, _callee2, undefined);
	}));

	return function (_x3) {
		return _ref3.apply(this, arguments);
	};
}());

var closePopup = exports.closePopup = (0, _reduxActions.createAction)('CLOSE_POPUP', function (popupHome) {
	return function () {
		var _ref5 = _asyncToGenerator(regeneratorRuntime.mark(function _callee3(dispatch, getState) {
			var _getState, _getState$popup, popups, popupIndex;

			return regeneratorRuntime.wrap(function _callee3$(_context3) {
				while (1) {
					switch (_context3.prev = _context3.next) {
						case 0:
							_context3.next = 2;
							return dispatch(getPopups);

						case 2:
							_context3.next = 4;
							return dispatch(getPopupIndex);

						case 4:
							_getState = getState(), _getState$popup = _getState.popup, popups = _getState$popup.popups, popupIndex = _getState$popup.popupIndex;

							if (!(popupHome === true)) {
								_context3.next = 8;
								break;
							}

							if (popupIndex.length > 0) {
								popupIndex.splice(0, 1);
							}
							return _context3.abrupt('return', { popupIndex: popupIndex });

						case 8:

							if (popups.length > 0) {
								popups.splice(0, 1);
							}

							return _context3.abrupt('return', { popups: popups });

						case 10:
						case 'end':
							return _context3.stop();
					}
				}
			}, _callee3, undefined);
		}));

		return function (_x4, _x5) {
			return _ref5.apply(this, arguments);
		};
	}();
});

/***/ }),
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__translate__ = __webpack_require__(469);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "translate", function() { return __WEBPACK_IMPORTED_MODULE_0__translate__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__I18n__ = __webpack_require__(196);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "I18n", function() { return __WEBPACK_IMPORTED_MODULE_1__I18n__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Interpolate__ = __webpack_require__(474);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Interpolate", function() { return __WEBPACK_IMPORTED_MODULE_2__Interpolate__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Trans__ = __webpack_require__(475);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Trans", function() { return __WEBPACK_IMPORTED_MODULE_3__Trans__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__I18nextProvider__ = __webpack_require__(481);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "I18nextProvider", function() { return __WEBPACK_IMPORTED_MODULE_4__I18nextProvider__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__loadNamespaces__ = __webpack_require__(482);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "loadNamespaces", function() { return __WEBPACK_IMPORTED_MODULE_5__loadNamespaces__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__context__ = __webpack_require__(135);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "reactI18nextModule", function() { return __WEBPACK_IMPORTED_MODULE_6__context__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "setDefaults", function() { return __WEBPACK_IMPORTED_MODULE_6__context__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getDefaults", function() { return __WEBPACK_IMPORTED_MODULE_6__context__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "setI18n", function() { return __WEBPACK_IMPORTED_MODULE_6__context__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getI18n", function() { return __WEBPACK_IMPORTED_MODULE_6__context__["b"]; });








/***/ }),
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getHomeNews = exports.getHotelNews = exports.getMoreHomeNewsList = exports.getHomeNewsList = exports.getMoreHotelNewsList = exports.getHotelNewsList = exports.getHotelNewsCategory = undefined;

var _reduxActions = __webpack_require__(6);

var _lodash = __webpack_require__(85);

var _reactRouterRedux = __webpack_require__(51);

var _endpoint = __webpack_require__(35);

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

// import { keyTransform } from 'util/helper';

var getHotelNewsCategory = exports.getHotelNewsCategory = (0, _reduxActions.createAction)('FETCH_HOTEL_NEWS_CATEGORY', function () {
	var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(lan, hotel) {
		var _ref2, status, message, data, categoryData, categoryList;

		return regeneratorRuntime.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						_context.next = 2;
						return (0, _endpoint.wrapFetch)('api/v1/web/' + lan + '/' + hotel + '/newsCategory', {
							method: 'GET'
						});

					case 2:
						_ref2 = _context.sent;
						status = _ref2.status;
						message = _ref2.message;
						data = _ref2.data;

						if (!(status !== 200)) {
							_context.next = 8;
							break;
						}

						throw new Error(message);

					case 8:
						categoryData = {};
						categoryList = data.map(function (d) {
							categoryData[d.id] = {
								id: d.id,
								label: d.name,
								value: d.id
							};

							return d.id;
						});
						return _context.abrupt('return', { categoryList: categoryList, categoryData: categoryData });

					case 11:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, undefined);
	}));

	return function (_x, _x2) {
		return _ref.apply(this, arguments);
	};
}());

var getHotelNewsList = exports.getHotelNewsList = (0, _reduxActions.createAction)('FETCH_HOTEL_NEWS_LIST', function () {
	var _ref3 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(lan, hotel, _ref4) {
		var _ref4$category = _ref4.category,
		    category = _ref4$category === undefined ? -1 : _ref4$category,
		    _ref4$page = _ref4.page,
		    page = _ref4$page === undefined ? 1 : _ref4$page;

		var params, _ref5, status, message, data, meta, newsList;

		return regeneratorRuntime.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						params = {
							category: parseInt(category, 10) === -1 ? undefined : category,
							page: page
						};
						_context2.next = 3;
						return (0, _endpoint.wrapFetch)('api/v1/web/' + lan + '/' + hotel + '/news', {
							method: 'GET'
						}, params);

					case 3:
						_ref5 = _context2.sent;
						status = _ref5.status;
						message = _ref5.message;
						data = _ref5.data;
						meta = _ref5.meta;

						if (!(status !== 200)) {
							_context2.next = 10;
							break;
						}

						throw new Error(message);

					case 10:
						newsList = data.map(function (news) {
							return {
								id: news.id,
								date: news.start_at,
								endDate: news.end_at,
								title: news.title,
								intro: news.intro,
								content: news.content,
								image: news.list_banner,
								thumbnail: news.list_banner_thumbnail,
								tags: news.category
							};
						});
						return _context2.abrupt('return', {
							newsList: newsList,
							totalPage: parseInt(meta.last_page, 10),
							currentPage: parseInt(meta.current_page, 10)
						});

					case 12:
					case 'end':
						return _context2.stop();
				}
			}
		}, _callee2, undefined);
	}));

	return function (_x3, _x4, _x5) {
		return _ref3.apply(this, arguments);
	};
}());

var getMoreHotelNewsList = exports.getMoreHotelNewsList = (0, _reduxActions.createAction)('FETCH_MORE_HOTEL_NEWS_LIST', function () {
	var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	return function () {
		var _ref6 = _asyncToGenerator(regeneratorRuntime.mark(function _callee3(_, getState) {
			var _getState, _getState$routing$loc, pathname, _getState$routing$loc2, category, oldList, hotel, lang, params, _ref7, status, message, _ref7$data, data, meta, newsList;

			return regeneratorRuntime.wrap(function _callee3$(_context3) {
				while (1) {
					switch (_context3.prev = _context3.next) {
						case 0:
							_getState = getState(), _getState$routing$loc = _getState.routing.locationBeforeTransitions, pathname = _getState$routing$loc.pathname, _getState$routing$loc2 = _getState$routing$loc.query.category, category = _getState$routing$loc2 === undefined ? -1 : _getState$routing$loc2, oldList = _getState.news.newsList;
							hotel = pathname.split('/')[1];
							lang = pathname.split('/')[2];
							params = {
								category: parseInt(category, 10) === -1 ? undefined : category,
								page: page
							};
							_context3.next = 6;
							return (0, _endpoint.wrapFetch)('api/v1/web/' + lang + '/' + hotel + '/news', {
								method: 'GET'
							}, params);

						case 6:
							_ref7 = _context3.sent;
							status = _ref7.status;
							message = _ref7.message;
							_ref7$data = _ref7.data;
							data = _ref7$data === undefined ? [] : _ref7$data;
							meta = _ref7.meta;

							if (!(status !== 200)) {
								_context3.next = 14;
								break;
							}

							throw new Error(message);

						case 14:
							newsList = data.map(function (news) {
								return {
									id: news.id,
									date: news.start_at,
									endDate: news.end_at,
									title: news.title,
									intro: news.intro,
									content: news.content,
									image: news.list_banner,
									thumbnail: news.list_banner_thumbnail,
									tags: news.category
								};
							});

							if (!(params.category && page === 1)) {
								_context3.next = 18;
								break;
							}

							console.log(newsList);
							return _context3.abrupt('return', newsList);

						case 18:
							return _context3.abrupt('return', {
								newsList: [].concat(oldList, newsList),
								totalPage: parseInt(meta.last_page, 10),
								currentPage: parseInt(meta.current_page, 10)
							});

						case 19:
						case 'end':
							return _context3.stop();
					}
				}
			}, _callee3, undefined);
		}));

		return function (_x7, _x8) {
			return _ref6.apply(this, arguments);
		};
	}();
});

var getHomeNewsList = exports.getHomeNewsList = (0, _reduxActions.createAction)('FETCH_HOME_NEWS_LIST', function () {
	var _ref8 = _asyncToGenerator(regeneratorRuntime.mark(function _callee4(lan, _ref9) {
		var _ref9$page = _ref9.page,
		    page = _ref9$page === undefined ? 1 : _ref9$page;

		var params, _ref10, status, message, data, meta, newsList;

		return regeneratorRuntime.wrap(function _callee4$(_context4) {
			while (1) {
				switch (_context4.prev = _context4.next) {
					case 0:
						params = {
							page: page
						};
						_context4.next = 3;
						return (0, _endpoint.wrapFetch)('api/v1/web/' + lan + '/news', {
							method: 'GET'
						}, params);

					case 3:
						_ref10 = _context4.sent;
						status = _ref10.status;
						message = _ref10.message;
						data = _ref10.data;
						meta = _ref10.meta;

						if (!(status !== 200)) {
							_context4.next = 10;
							break;
						}

						throw new Error(message);

					case 10:
						newsList = data.map(function (news) {
							return {
								id: news.id,
								date: news.start_at,
								endDate: news.end_at,
								title: news.title,
								intro: news.intro,
								content: news.content,
								image: news.list_banner,
								thumbnail: news.list_banner_thumbnail,
								tags: news.category
							};
						});
						return _context4.abrupt('return', {
							newsList: newsList,
							totalPage: parseInt(meta.last_page, 10),
							currentPage: parseInt(meta.current_page, 10)
						});

					case 12:
					case 'end':
						return _context4.stop();
				}
			}
		}, _callee4, undefined);
	}));

	return function (_x9, _x10) {
		return _ref8.apply(this, arguments);
	};
}());
var getMoreHomeNewsList = exports.getMoreHomeNewsList = (0, _reduxActions.createAction)('FETCH_MORE_HOME_NEWS_LIST', function (page) {
	return function () {
		var _ref11 = _asyncToGenerator(regeneratorRuntime.mark(function _callee5(_, getState) {
			var _getState2, pathname, oldList, params, lan, _ref12, status, message, data, meta, newsList;

			return regeneratorRuntime.wrap(function _callee5$(_context5) {
				while (1) {
					switch (_context5.prev = _context5.next) {
						case 0:
							_getState2 = getState(), pathname = _getState2.routing.locationBeforeTransitions.pathname, oldList = _getState2.news.newsList;
							params = {
								page: page
							};
							lan = pathname.split('/')[2] || 'tw';
							_context5.next = 5;
							return (0, _endpoint.wrapFetch)('api/v1/web/' + lan + '/news', {
								method: 'GET'
							}, params);

						case 5:
							_ref12 = _context5.sent;
							status = _ref12.status;
							message = _ref12.message;
							data = _ref12.data;
							meta = _ref12.meta;

							if (!(status !== 200)) {
								_context5.next = 12;
								break;
							}

							throw new Error(message);

						case 12:
							newsList = data.map(function (news) {
								return {
									id: news.id,
									date: news.start_at,
									endDate: news.end_at,
									title: news.title,
									intro: news.intro,
									content: news.content,
									image: news.list_banner,
									thumbnail: news.list_banner_thumbnail,
									tags: news.category
								};
							});
							return _context5.abrupt('return', {
								newsList: [].concat(oldList, newsList),
								totalPage: parseInt(meta.last_page, 10),
								currentPage: parseInt(meta.current_page, 10)
							});

						case 14:
						case 'end':
							return _context5.stop();
					}
				}
			}, _callee5, undefined);
		}));

		return function (_x11, _x12) {
			return _ref11.apply(this, arguments);
		};
	}();
});

var getHotelNews = exports.getHotelNews = (0, _reduxActions.createAction)('FETCH_HOTEL_NEWS', function (lan, hotel, newsId) {
	return function () {
		var _ref13 = _asyncToGenerator(regeneratorRuntime.mark(function _callee6(dispatch) {
			var response, data;
			return regeneratorRuntime.wrap(function _callee6$(_context6) {
				while (1) {
					switch (_context6.prev = _context6.next) {
						case 0:
							_context6.next = 2;
							return (0, _endpoint.wrapFetch)('api/v1/web/' + lan + '/' + hotel + '/news/' + newsId, {
								method: 'GET'
							});

						case 2:
							response = _context6.sent;

							if (!(response.status !== 200)) {
								_context6.next = 5;
								break;
							}

							throw new Error(response.message);

						case 5:
							data = (0, _lodash.get)(response, 'data.data');

							if (!(0, _lodash.isNil)(data)) {
								_context6.next = 10;
								break;
							}

							_context6.next = 9;
							return dispatch((0, _reactRouterRedux.push)({ pathname: '/' + hotel + '/' + lan }));

						case 9:
							return _context6.abrupt('return', null);

						case 10:
							return _context6.abrupt('return', {
								news: {
									id: data.id,
									title: data.title,
									subtitle: data.subtitle,
									content: data.content,
									date: data.start_at,
									endDate: data.end_at,
									bannerImage: data.banner,
									bannerThumbnail: data.banner_thumbnail,
									tag: (0, _lodash.get)(data, 'content.category', '').length > 0 ? data.category[0].name : '',
									prevId: (0, _lodash.get)(response, 'data.prev_id'),
									nextId: (0, _lodash.get)(response, 'data.next_id')
								}
							});

						case 11:
						case 'end':
							return _context6.stop();
					}
				}
			}, _callee6, undefined);
		}));

		return function (_x13) {
			return _ref13.apply(this, arguments);
		};
	}();
});

var getHomeNews = exports.getHomeNews = (0, _reduxActions.createAction)('FETCH_HOME_NEWS', function (lan, newsId) {
	return function () {
		var _ref14 = _asyncToGenerator(regeneratorRuntime.mark(function _callee7(dispatch) {
			var response, data;
			return regeneratorRuntime.wrap(function _callee7$(_context7) {
				while (1) {
					switch (_context7.prev = _context7.next) {
						case 0:
							_context7.next = 2;
							return (0, _endpoint.wrapFetch)('api/v1/web/' + lan + '/news/' + newsId, {
								method: 'GET'
							});

						case 2:
							response = _context7.sent;

							if (!(response.status !== 200)) {
								_context7.next = 5;
								break;
							}

							throw new Error(response.message);

						case 5:
							data = (0, _lodash.get)(response, 'data.data');

							if (!(0, _lodash.isNil)(data)) {
								_context7.next = 10;
								break;
							}

							_context7.next = 9;
							return dispatch((0, _reactRouterRedux.push)({ pathname: '/main/' + lan }));

						case 9:
							return _context7.abrupt('return', null);

						case 10:
							return _context7.abrupt('return', {
								news: {
									id: data.id,
									title: data.title,
									subtitle: data.subtitle,
									content: data.content,
									date: data.start_at,
									endDate: data.end_at,
									bannerImage: data.banner,
									bannerThumbnail: data.banner_thumbnail,
									tag: (0, _lodash.get)(data, 'content.category', '').length > 0 ? data.category[0].name : '',
									prevId: (0, _lodash.get)(response, 'data.prev_id'),
									nextId: (0, _lodash.get)(response, 'data.next_id')
								}
							});

						case 11:
						case 'end':
							return _context7.stop();
					}
				}
			}, _callee7, undefined);
		}));

		return function (_x14) {
			return _ref14.apply(this, arguments);
		};
	}();
});

/***/ }),
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var consoleLogger = {
  type: 'logger',

  log: function log(args) {
    this.output('log', args);
  },
  warn: function warn(args) {
    this.output('warn', args);
  },
  error: function error(args) {
    this.output('error', args);
  },
  output: function output(type, args) {
    var _console;

    /* eslint no-console: 0 */
    if (console && console[type]) (_console = console)[type].apply(_console, _toConsumableArray(args));
  }
};

var Logger = function () {
  function Logger(concreteLogger) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Logger);

    this.init(concreteLogger, options);
  }

  Logger.prototype.init = function init(concreteLogger) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    this.prefix = options.prefix || 'i18next:';
    this.logger = concreteLogger || consoleLogger;
    this.options = options;
    this.debug = options.debug;
  };

  Logger.prototype.setDebug = function setDebug(bool) {
    this.debug = bool;
  };

  Logger.prototype.log = function log() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return this.forward(args, 'log', '', true);
  };

  Logger.prototype.warn = function warn() {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return this.forward(args, 'warn', '', true);
  };

  Logger.prototype.error = function error() {
    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    return this.forward(args, 'error', '');
  };

  Logger.prototype.deprecate = function deprecate() {
    for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
  };

  Logger.prototype.forward = function forward(args, lvl, prefix, debugOnly) {
    if (debugOnly && !this.debug) return null;
    if (typeof args[0] === 'string') args[0] = '' + prefix + this.prefix + ' ' + args[0];
    return this.logger[lvl](args);
  };

  Logger.prototype.create = function create(moduleName) {
    return new Logger(this.logger, _extends({ prefix: this.prefix + ':' + moduleName + ':' }, this.options));
  };

  return Logger;
}();

/* harmony default export */ __webpack_exports__["a"] = (new Logger());

/***/ }),
/* 65 */,
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getBanner = undefined;

var _reduxActions = __webpack_require__(6);

var _endpoint = __webpack_require__(35);

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var getBanner = exports.getBanner = (0, _reduxActions.createAction)('FETCH_BANNER', function () {
	var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(lan, hotel, page) {
		var _ref2, status, message, _ref2$data, pic, pic_thumbnail;

		return regeneratorRuntime.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						_context.next = 2;
						return (0, _endpoint.wrapFetch)('api/v1/web/' + lan + '/' + hotel + '/banner/' + page, {
							method: 'GET'
						});

					case 2:
						_ref2 = _context.sent;
						status = _ref2.status;
						message = _ref2.message;
						_ref2$data = _ref2.data;
						pic = _ref2$data.pic;
						pic_thumbnail = _ref2$data.pic_thumbnail;

						if (!(status !== 200)) {
							_context.next = 10;
							break;
						}

						throw new Error(message);

					case 10:
						return _context.abrupt('return', { image: pic, thumbnail: pic_thumbnail });

					case 11:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, undefined);
	}));

	return function (_x, _x2, _x3) {
		return _ref.apply(this, arguments);
	};
}());

/***/ }),
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EventEmitter = function () {
  function EventEmitter() {
    _classCallCheck(this, EventEmitter);

    this.observers = {};
  }

  EventEmitter.prototype.on = function on(events, listener) {
    var _this = this;

    events.split(' ').forEach(function (event) {
      _this.observers[event] = _this.observers[event] || [];
      _this.observers[event].push(listener);
    });
  };

  EventEmitter.prototype.off = function off(event, listener) {
    var _this2 = this;

    if (!this.observers[event]) {
      return;
    }

    this.observers[event].forEach(function () {
      if (!listener) {
        delete _this2.observers[event];
      } else {
        var index = _this2.observers[event].indexOf(listener);
        if (index > -1) {
          _this2.observers[event].splice(index, 1);
        }
      }
    });
  };

  EventEmitter.prototype.emit = function emit(event) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    if (this.observers[event]) {
      var cloned = [].concat(this.observers[event]);
      cloned.forEach(function (observer) {
        observer.apply(undefined, args);
      });
    }

    if (this.observers['*']) {
      var _cloned = [].concat(this.observers['*']);
      _cloned.forEach(function (observer) {
        var _ref;

        observer.apply(observer, (_ref = [event]).concat.apply(_ref, args));
      });
    }
  };

  return EventEmitter;
}();

/* harmony default export */ __webpack_exports__["a"] = (EventEmitter);

/***/ }),
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.21';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function',
      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading whitespace. */
  var reTrimStart = /^\s+/;

  /** Used to match a single whitespace character. */
  var reWhitespace = /\s/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */
  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */
  function baseTrim(string) {
    return string
      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
      : string;
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedEndIndex(string) {
    var index = string.length;

    while (index-- && reWhitespace.test(string.charAt(index))) {}
    return index;
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      if (iteratees.length) {
        iteratees = arrayMap(iteratees, function(iteratee) {
          if (isArray(iteratee)) {
            return function(value) {
              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
            }
          }
          return iteratee;
        });
      } else {
        iteratees = [identity];
      }

      var index = -1;
      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
          return object;
        }

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      var low = 0,
          high = array == null ? 0 : array.length;
      if (high === 0) {
        return 0;
      }

      value = iteratee(value);
      var valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Check that cyclic values are equal.
      var arrStacked = stack.get(array);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Check that cyclic values are equal.
      var objStacked = stack.get(object);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = baseTrim(value);
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
      // and escape the comment, thus injecting code that gets evaled.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/\s/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Throw an error if a forbidden character was found in `variable`, to prevent
      // potential command injection attacks.
      else if (reForbiddenIdentifierChars.test(variable)) {
        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
      }

      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return baseTrim(string);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.slice(0, trimmedEndIndex(string) + 1);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return _;
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(50), __webpack_require__(156)(module)))

/***/ }),
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = makeString;
/* harmony export (immutable) */ __webpack_exports__["a"] = copy;
/* harmony export (immutable) */ __webpack_exports__["h"] = setPath;
/* harmony export (immutable) */ __webpack_exports__["f"] = pushPath;
/* harmony export (immutable) */ __webpack_exports__["d"] = getPath;
/* harmony export (immutable) */ __webpack_exports__["b"] = deepExtend;
/* harmony export (immutable) */ __webpack_exports__["g"] = regexEscape;
/* harmony export (immutable) */ __webpack_exports__["c"] = escape;
function makeString(object) {
  if (object == null) return '';
  /* eslint prefer-template: 0 */
  return '' + object;
}

function copy(a, s, t) {
  a.forEach(function (m) {
    if (s[m]) t[m] = s[m];
  });
}

function getLastOfPath(object, path, Empty) {
  function cleanKey(key) {
    return key && key.indexOf('###') > -1 ? key.replace(/###/g, '.') : key;
  }

  function canNotTraverseDeeper() {
    return !object || typeof object === 'string';
  }

  var stack = typeof path !== 'string' ? [].concat(path) : path.split('.');
  while (stack.length > 1) {
    if (canNotTraverseDeeper()) return {};

    var key = cleanKey(stack.shift());
    if (!object[key] && Empty) object[key] = new Empty();
    object = object[key];
  }

  if (canNotTraverseDeeper()) return {};
  return {
    obj: object,
    k: cleanKey(stack.shift())
  };
}

function setPath(object, path, newValue) {
  var _getLastOfPath = getLastOfPath(object, path, Object),
      obj = _getLastOfPath.obj,
      k = _getLastOfPath.k;

  obj[k] = newValue;
}

function pushPath(object, path, newValue, concat) {
  var _getLastOfPath2 = getLastOfPath(object, path, Object),
      obj = _getLastOfPath2.obj,
      k = _getLastOfPath2.k;

  obj[k] = obj[k] || [];
  if (concat) obj[k] = obj[k].concat(newValue);
  if (!concat) obj[k].push(newValue);
}

function getPath(object, path) {
  var _getLastOfPath3 = getLastOfPath(object, path),
      obj = _getLastOfPath3.obj,
      k = _getLastOfPath3.k;

  if (!obj) return undefined;
  return obj[k];
}

function deepExtend(target, source, overwrite) {
  /* eslint no-restricted-syntax: 0 */
  for (var prop in source) {
    if (prop in target) {
      // If we reached a leaf string in target or source then replace with source or skip depending on the 'overwrite' switch
      if (typeof target[prop] === 'string' || target[prop] instanceof String || typeof source[prop] === 'string' || source[prop] instanceof String) {
        if (overwrite) target[prop] = source[prop];
      } else {
        deepExtend(target[prop], source[prop], overwrite);
      }
    } else {
      target[prop] = source[prop];
    }
  }
  return target;
}

function regexEscape(str) {
  /* eslint no-useless-escape: 0 */
  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
}

/* eslint-disable */
var _entityMap = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': '&quot;',
  "'": '&#39;',
  "/": '&#x2F;'
};
/* eslint-enable */

function escape(data) {
  if (typeof data === 'string') {
    return data.replace(/[&<>"'\/]/g, function (s) {
      return _entityMap[s];
    });
  }

  return data;
}

/***/ }),
/* 103 */,
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getEachHotelAttractions = exports.getAttractions = undefined;

var _reduxActions = __webpack_require__(6);

var _endpoint = __webpack_require__(35);

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var getAttractions = exports.getAttractions = (0, _reduxActions.createAction)('FETCH_ATTRACTIONS', function () {
	var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(lan, hotel) {
		var _ref2, status, message, data, attractionList, attractionData;

		return regeneratorRuntime.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						_context.next = 2;
						return (0, _endpoint.wrapFetch)('api/v1/web/' + lan + '/' + hotel + '/attraction', {
							method: 'GET'
						});

					case 2:
						_ref2 = _context.sent;
						status = _ref2.status;
						message = _ref2.message;
						data = _ref2.data;

						if (!(status !== 200)) {
							_context.next = 8;
							break;
						}

						throw new Error(message);

					case 8:
						attractionList = [];
						attractionData = {};


						data.forEach(function (d) {
							attractionList.push(d.id);
							attractionData[d.id] = {
								id: d.id,
								type: d.category,
								title: d.title,
								address: d.address,
								image: d.pic,
								thumbnail: d.pic_thumbnail,
								content: d.info,
								lat: parseFloat(d.latitude) || 0,
								lng: parseFloat(d.longitude) || 0,
								info: {
									locationName: d.title,
									address: d.address
								}
							};
						});

						return _context.abrupt('return', {
							attractionList: attractionList,
							attractionData: attractionData
						});

					case 12:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, undefined);
	}));

	return function (_x, _x2) {
		return _ref.apply(this, arguments);
	};
}());

var getEachHotelAttractions = exports.getEachHotelAttractions = (0, _reduxActions.createAction)('FETCH_EACH_HOTEL_ATTRACTIONS', function () {
	var _ref3 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(lan) {
		var _ref4, status, message, data;

		return regeneratorRuntime.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						_context2.next = 2;
						return (0, _endpoint.wrapFetch)('api/v1/web/' + lan + '/attraction', {
							method: 'GET'
						});

					case 2:
						_ref4 = _context2.sent;
						status = _ref4.status;
						message = _ref4.message;
						data = _ref4.data;

						if (!(status !== 200)) {
							_context2.next = 8;
							break;
						}

						throw new Error(message);

					case 8:
						return _context2.abrupt('return', { hotelAttraction: data });

					case 9:
					case 'end':
						return _context2.stop();
				}
			}
		}, _callee2, undefined);
	}));

	return function (_x3) {
		return _ref3.apply(this, arguments);
	};
}());

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var normalizePathname = exports.normalizePathname = function normalizePathname(pathname) {
	var pathnames = pathname.split('/');

	if (pathnames[0] !== '') {
		pathnames = [''].concat(pathnames);
	}

	return pathnames;
};

/***/ }),
/* 106 */,
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var hoistNonReactStatic = __webpack_require__(134);
var React = __webpack_require__(1);
var ReactDOM = __webpack_require__(106);

module.exports = function enhanceWithClickOutside(WrappedComponent) {
  var componentName = WrappedComponent.displayName || WrappedComponent.name;

  var EnhancedComponent = function (_React$Component) {
    _inherits(EnhancedComponent, _React$Component);

    function EnhancedComponent(props) {
      _classCallCheck(this, EnhancedComponent);

      var _this = _possibleConstructorReturn(this, (EnhancedComponent.__proto__ || Object.getPrototypeOf(EnhancedComponent)).call(this, props));

      _this.handleClickOutside = _this.handleClickOutside.bind(_this);
      return _this;
    }

    _createClass(EnhancedComponent, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        document.addEventListener('click', this.handleClickOutside, true);
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        document.removeEventListener('click', this.handleClickOutside, true);
      }
    }, {
      key: 'handleClickOutside',
      value: function handleClickOutside(e) {
        var domNode = this.__domNode;
        if ((!domNode || !domNode.contains(e.target)) && typeof this.__wrappedComponent.handleClickOutside === 'function') {
          this.__wrappedComponent.handleClickOutside(e);
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var _this2 = this;

        var _props = this.props,
            wrappedRef = _props.wrappedRef,
            rest = _objectWithoutProperties(_props, ['wrappedRef']);

        return React.createElement(WrappedComponent, _extends({}, rest, {
          ref: function ref(c) {
            _this2.__wrappedComponent = c;
            _this2.__domNode = ReactDOM.findDOMNode(c);
            wrappedRef && wrappedRef(c);
          }
        }));
      }
    }]);

    return EnhancedComponent;
  }(React.Component);

  EnhancedComponent.displayName = 'clickOutside(' + componentName + ')';

  return hoistNonReactStatic(EnhancedComponent, WrappedComponent);
};

/***/ }),
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = setDefaults;
/* harmony export (immutable) */ __webpack_exports__["a"] = getDefaults;
/* harmony export (immutable) */ __webpack_exports__["e"] = setI18n;
/* harmony export (immutable) */ __webpack_exports__["b"] = getI18n;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return reactI18nextModule; });
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var defaultOptions = {
  wait: false,
  withRef: false,
  bindI18n: 'languageChanged loaded',
  bindStore: 'added removed',
  translateFuncName: 't',
  nsMode: 'default'
};

var i18n = void 0;

function setDefaults(options) {
  defaultOptions = _extends({}, defaultOptions, options);
}

function getDefaults() {
  return defaultOptions;
}

function setI18n(instance) {
  i18n = instance;
}

function getI18n() {
  return i18n;
}

var reactI18nextModule = {
  type: '3rdParty',

  init: function init(instance) {
    setDefaults(instance.options.react);
    setI18n(instance);
  }
};

/***/ }),
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.acceptCookies = exports.getCookies = exports.storePage = exports.scrollWindow = exports.matchMedia = undefined;

var _reduxActions = __webpack_require__(6);

var matchMedia = exports.matchMedia = (0, _reduxActions.createAction)('MATCH_MEDIA', function (media) {
	return { media: media };
});

var scrollWindow = exports.scrollWindow = (0, _reduxActions.createAction)('SCROLL_WINDOW', function (pageYOffset) {
	return { pageYOffset: pageYOffset };
});

var storePage = exports.storePage = (0, _reduxActions.createAction)('STORE_PAGE', function (page) {
	return { page: page };
});

var getCookies = exports.getCookies = (0, _reduxActions.createAction)('GET_COOKIES', function () {
	var decodedCookie = decodeURIComponent(document.cookie);
	var cookieStrList = decodedCookie.split(';');

	var cookies = {};
	cookieStrList.forEach(function (cookieStr) {
		var _cookieStr$trim$split = cookieStr.trim().split('='),
		    name = _cookieStr$trim$split[0],
		    value = _cookieStr$trim$split[1];

		cookies[name] = value;
	});

	return { cookies: cookies };
});

var acceptCookies = exports.acceptCookies = (0, _reduxActions.createAction)('ACCEPT_COOKIES', function () {
	document.cookie = 'acceptCookies=y';
	return {
		cookies: {
			acceptCookies: 'y'
		}
	};
});

/***/ }),
/* 152 */,
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warn;
function warn(s) {
  console.warn('[react-ga]', s);
}

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var keyTransform = exports.keyTransform = function keyTransform(data) {
	var newData = {};

	Object.keys(data).forEach(function (key) {
		var keyArray = key.split('_');

		var newKey = keyArray.reduce(function (prev, cur) {
			if (prev === '') {
				return cur;
			}

			if (cur.length > 0) {
				return '' + prev + cur[0].toUpperCase() + cur.slice(1);
			}

			return prev;
		}, '');

		newData[newKey] = data[key];
	});

	return newData;
};

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames2 = __webpack_require__(16);

var _classnames3 = _interopRequireDefault(_classnames2);

var _index = __webpack_require__(717);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getTransformValue = function getTransformValue(direction, size) {
	var translateX = 0;
	var translateY = 0;
	var rotate = 0;

	if (direction === 'left') {
		translateX = size / 6;
		rotate = 225;
	} else if (direction === 'right') {
		translateX = size / 6 * -1;
		rotate = 45;
	} else if (direction === 'up') {
		translateY = size / 6;
		rotate = 315;
	} else {
		translateY = size / 6 * -1;
		rotate = 135;
	}

	return 'translate(' + translateX + 'px, ' + translateY + 'px) rotate(' + rotate + 'deg)';
};

var Triangle = function Triangle(_ref) {
	var _classnames;

	var _ref$direction = _ref.direction,
	    direction = _ref$direction === undefined ? 'right' : _ref$direction,
	    color = _ref.color,
	    _ref$size = _ref.size,
	    size = _ref$size === undefined ? 10 : _ref$size,
	    borderWidth = _ref.borderWidth,
	    className = _ref.className;
	return _react2.default.createElement('span', {
		className: (0, _classnames3.default)(_index2.default.triangle, className, (_classnames = {}, _classnames[_index2.default.left] = direction === 'left', _classnames[_index2.default.right] = direction === 'right', _classnames[_index2.default.up] = direction === 'up', _classnames[_index2.default.down] = direction === 'down', _classnames)),
		style: {
			width: size + 'px',
			height: size + 'px',
			borderColor: color || '#2D2926',
			borderWidth: borderWidth ? borderWidth + 'px ' + borderWidth + 'px 0 0' : '2px 2px 0 0',
			transformOrigin: 'center',
			transform: getTransformValue(direction, size)
		}
	});
};

exports.default = Triangle;

/***/ }),
/* 156 */,
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.hotelAttractionMock = exports.defaultHotelMeta = exports.defaultHotelData = exports.hotelData = exports.fakeHotel = exports.defaultHotelList = undefined;

var _hualien = __webpack_require__(580);

var _hualien2 = _interopRequireDefault(_hualien);

var _jiaoxi = __webpack_require__(581);

var _jiaoxi2 = _interopRequireDefault(_jiaoxi);

var _kaohsiung = __webpack_require__(582);

var _kaohsiung2 = _interopRequireDefault(_kaohsiung);

var _kaohsiungStation = __webpack_require__(583);

var _kaohsiungStation2 = _interopRequireDefault(_kaohsiungStation);

var _main = __webpack_require__(584);

var _main2 = _interopRequireDefault(_main);

var _NTU = __webpack_require__(585);

var _NTU2 = _interopRequireDefault(_NTU);

var _sanchong = __webpack_require__(586);

var _sanchong2 = _interopRequireDefault(_sanchong);

var _ximending = __webpack_require__(587);

var _ximending2 = _interopRequireDefault(_ximending);

var _hushan = __webpack_require__(588);

var _hushan2 = _interopRequireDefault(_hushan);

var _zhongshan = __webpack_require__(589);

var _zhongshan2 = _interopRequireDefault(_zhongshan);

var _img_ximen_grey = __webpack_require__(590);

var _img_ximen_grey2 = _interopRequireDefault(_img_ximen_grey);

var _img_ximen_color = __webpack_require__(591);

var _img_ximen_color2 = _interopRequireDefault(_img_ximen_color);

var _img_ximen_grey2x = __webpack_require__(592);

var _img_ximen_grey2x2 = _interopRequireDefault(_img_ximen_grey2x);

var _img_ntu_grey = __webpack_require__(593);

var _img_ntu_grey2 = _interopRequireDefault(_img_ntu_grey);

var _img_ntu_color = __webpack_require__(594);

var _img_ntu_color2 = _interopRequireDefault(_img_ntu_color);

var _img_ntu_grey2x = __webpack_require__(595);

var _img_ntu_grey2x2 = _interopRequireDefault(_img_ntu_grey2x);

var _img_kao_grey = __webpack_require__(596);

var _img_kao_grey2 = _interopRequireDefault(_img_kao_grey);

var _img_kao_color = __webpack_require__(597);

var _img_kao_color2 = _interopRequireDefault(_img_kao_color);

var _img_kao_grey2x = __webpack_require__(598);

var _img_kao_grey2x2 = _interopRequireDefault(_img_kao_grey2x);

var _img_kaostation_grey = __webpack_require__(599);

var _img_kaostation_grey2 = _interopRequireDefault(_img_kaostation_grey);

var _img_kaostation_color = __webpack_require__(600);

var _img_kaostation_color2 = _interopRequireDefault(_img_kaostation_color);

var _img_kaostation_grey2x = __webpack_require__(601);

var _img_kaostation_grey2x2 = _interopRequireDefault(_img_kaostation_grey2x);

var _img_hualien_grey = __webpack_require__(602);

var _img_hualien_grey2 = _interopRequireDefault(_img_hualien_grey);

var _img_hualien_color = __webpack_require__(603);

var _img_hualien_color2 = _interopRequireDefault(_img_hualien_color);

var _img_hualien_grey2x = __webpack_require__(604);

var _img_hualien_grey2x2 = _interopRequireDefault(_img_hualien_grey2x);

var _img_jiaoxi_grey = __webpack_require__(605);

var _img_jiaoxi_grey2 = _interopRequireDefault(_img_jiaoxi_grey);

var _img_jiaoxi_color = __webpack_require__(606);

var _img_jiaoxi_color2 = _interopRequireDefault(_img_jiaoxi_color);

var _img_jiaoxi_grey2x = __webpack_require__(607);

var _img_jiaoxi_grey2x2 = _interopRequireDefault(_img_jiaoxi_grey2x);

var _img_ximen_grey2x3 = __webpack_require__(608);

var _img_ximen_grey2x4 = _interopRequireDefault(_img_ximen_grey2x3);

var _img_ximen_color2x = __webpack_require__(609);

var _img_ximen_color2x2 = _interopRequireDefault(_img_ximen_color2x);

var _img_ntu_grey2x3 = __webpack_require__(610);

var _img_ntu_grey2x4 = _interopRequireDefault(_img_ntu_grey2x3);

var _img_ntu_color2x = __webpack_require__(611);

var _img_ntu_color2x2 = _interopRequireDefault(_img_ntu_color2x);

var _img_kao_grey2x3 = __webpack_require__(612);

var _img_kao_grey2x4 = _interopRequireDefault(_img_kao_grey2x3);

var _img_kao_color2x = __webpack_require__(613);

var _img_kao_color2x2 = _interopRequireDefault(_img_kao_color2x);

var _img_kaostation_grey2x3 = __webpack_require__(614);

var _img_kaostation_grey2x4 = _interopRequireDefault(_img_kaostation_grey2x3);

var _img_kaostation_color2x = __webpack_require__(615);

var _img_kaostation_color2x2 = _interopRequireDefault(_img_kaostation_color2x);

var _img_hualien_grey2x3 = __webpack_require__(616);

var _img_hualien_grey2x4 = _interopRequireDefault(_img_hualien_grey2x3);

var _img_hualien_color2x = __webpack_require__(617);

var _img_hualien_color2x2 = _interopRequireDefault(_img_hualien_color2x);

var _img_jiaoxi_grey2x3 = __webpack_require__(618);

var _img_jiaoxi_grey2x4 = _interopRequireDefault(_img_jiaoxi_grey2x3);

var _img_jiaoxi_color2x = __webpack_require__(619);

var _img_jiaoxi_color2x2 = _interopRequireDefault(_img_jiaoxi_color2x);

var _img_sanchong_color = __webpack_require__(620);

var _img_sanchong_color2 = _interopRequireDefault(_img_sanchong_color);

var _img_sanchong_color2x = __webpack_require__(621);

var _img_sanchong_color2x2 = _interopRequireDefault(_img_sanchong_color2x);

var _img_sanchong_grey = __webpack_require__(622);

var _img_sanchong_grey2 = _interopRequireDefault(_img_sanchong_grey);

var _img_sanchong_grey2x = __webpack_require__(623);

var _img_sanchong_grey2x2 = _interopRequireDefault(_img_sanchong_grey2x);

var _img_sanchong_grey2x3 = __webpack_require__(624);

var _img_sanchong_grey2x4 = _interopRequireDefault(_img_sanchong_grey2x3);

var _img_hushan_color = __webpack_require__(625);

var _img_hushan_color2 = _interopRequireDefault(_img_hushan_color);

var _img_hushan_color2x = __webpack_require__(626);

var _img_hushan_color2x2 = _interopRequireDefault(_img_hushan_color2x);

var _img_hushan_grey = __webpack_require__(627);

var _img_hushan_grey2 = _interopRequireDefault(_img_hushan_grey);

var _img_hushan_grey2x = __webpack_require__(628);

var _img_hushan_grey2x2 = _interopRequireDefault(_img_hushan_grey2x);

var _img_hushan_grey2x3 = __webpack_require__(629);

var _img_hushan_grey2x4 = _interopRequireDefault(_img_hushan_grey2x3);

var _img_osakaShinsaibashi_color = __webpack_require__(630);

var _img_osakaShinsaibashi_color2 = _interopRequireDefault(_img_osakaShinsaibashi_color);

var _img_osakaShinsaibashi_color2x = __webpack_require__(631);

var _img_osakaShinsaibashi_color2x2 = _interopRequireDefault(_img_osakaShinsaibashi_color2x);

var _img_osakaShinsaibashi_grey = __webpack_require__(632);

var _img_osakaShinsaibashi_grey2 = _interopRequireDefault(_img_osakaShinsaibashi_grey);

var _img_osakaShinsaibashi_grey2x = __webpack_require__(633);

var _img_osakaShinsaibashi_grey2x2 = _interopRequireDefault(_img_osakaShinsaibashi_grey2x);

var _img_osakaShinsaibashi_grey2x3 = __webpack_require__(634);

var _img_osakaShinsaibashi_grey2x4 = _interopRequireDefault(_img_osakaShinsaibashi_grey2x3);

var _img_zhongshan_color = __webpack_require__(635);

var _img_zhongshan_color2 = _interopRequireDefault(_img_zhongshan_color);

var _img_zhongshan_color2x = __webpack_require__(636);

var _img_zhongshan_color2x2 = _interopRequireDefault(_img_zhongshan_color2x);

var _img_zhongshan_grey = __webpack_require__(637);

var _img_zhongshan_grey2 = _interopRequireDefault(_img_zhongshan_grey);

var _img_zhongshan_grey2x = __webpack_require__(638);

var _img_zhongshan_grey2x2 = _interopRequireDefault(_img_zhongshan_grey2x);

var _img_zhongshan_grey2x3 = __webpack_require__(639);

var _img_zhongshan_grey2x4 = _interopRequireDefault(_img_zhongshan_grey2x3);

var _responsiveImage = __webpack_require__(258);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ximen = {
	gray: (0, _responsiveImage.responsiveImage)(_img_ximen_grey2.default, _img_ximen_grey2x4.default),
	color: (0, _responsiveImage.responsiveImage)(_img_ximen_color2.default, _img_ximen_color2x2.default),
	thumbnail: _img_ximen_grey2x2.default
};
// import osakaShinsaibashiMeta from 'meta/osaka-shinsaibashi.json';

var ntu = {
	gray: (0, _responsiveImage.responsiveImage)(_img_ntu_grey2.default, _img_ntu_grey2x4.default),
	color: (0, _responsiveImage.responsiveImage)(_img_ntu_color2.default, _img_ntu_color2x2.default),
	thumbnail: _img_ntu_grey2x2.default
};

var zhongshan = {
	gray: (0, _responsiveImage.responsiveImage)(_img_zhongshan_grey2.default, _img_zhongshan_grey2x2.default),
	color: (0, _responsiveImage.responsiveImage)(_img_zhongshan_color2.default, _img_zhongshan_color2x2.default),
	thumbnail: _img_zhongshan_grey2x4.default
};

var kaohsiung = {
	gray: (0, _responsiveImage.responsiveImage)(_img_kao_grey2.default, _img_kao_grey2x4.default),
	color: (0, _responsiveImage.responsiveImage)(_img_kao_color2.default, _img_kao_color2x2.default),
	thumbnail: _img_kao_grey2x2.default
};

var kaohsiungStation = {
	gray: (0, _responsiveImage.responsiveImage)(_img_kaostation_grey2.default, _img_kaostation_grey2x4.default),
	color: (0, _responsiveImage.responsiveImage)(_img_kaostation_color2.default, _img_kaostation_color2x2.default),
	thumbnail: _img_kaostation_grey2x2.default
};

var hualien = {
	gray: (0, _responsiveImage.responsiveImage)(_img_hualien_grey2.default, _img_hualien_grey2x4.default),
	color: (0, _responsiveImage.responsiveImage)(_img_hualien_color2.default, _img_hualien_color2x2.default),
	thumbnail: _img_hualien_grey2x2.default
};

var jiaoxi = {
	gray: (0, _responsiveImage.responsiveImage)(_img_jiaoxi_grey2.default, _img_jiaoxi_grey2x4.default),
	color: (0, _responsiveImage.responsiveImage)(_img_jiaoxi_color2.default, _img_jiaoxi_color2x2.default),
	thumbnail: _img_jiaoxi_grey2x2.default
};

var sanchong = {
	gray: (0, _responsiveImage.responsiveImage)(_img_sanchong_grey2.default, _img_sanchong_grey2x2.default),
	color: (0, _responsiveImage.responsiveImage)(_img_sanchong_color2.default, _img_sanchong_color2x2.default),
	thumbnail: _img_sanchong_grey2x4.default
};

var hushan = {
	gray: (0, _responsiveImage.responsiveImage)(_img_hushan_grey2.default, _img_hushan_grey2x2.default),
	color: (0, _responsiveImage.responsiveImage)(_img_hushan_color2.default, _img_hushan_color2x2.default),
	thumbnail: _img_hushan_grey2x4.default
};

var osakaShinsaibashi = {
	gray: (0, _responsiveImage.responsiveImage)(_img_osakaShinsaibashi_grey2.default, _img_osakaShinsaibashi_grey2x2.default),
	color: (0, _responsiveImage.responsiveImage)(_img_osakaShinsaibashi_color2.default, _img_osakaShinsaibashi_color2x2.default),
	thumbnail: _img_osakaShinsaibashi_grey2x4.default
};

var defaultHotelList = exports.defaultHotelList = ['main', 'ximending', 'NTU', 'zhongshan', 'kaohsiung', 'kaohsiungStation', 'hualien', 'jiaoxi', 'sanchong', 'hushan', 'osakaShinsaibashi'];

var officialLinks = {
	// line: 'https://page.line.me/justsleep?openQrModal=true',
	// tripAdvisor: '',
	fb: 'https://www.facebook.com/JustSleepJS',
	ig: 'https://www.instagram.com/justsleep_js/',
	weibo: 'http://weibo.com/u/3030763041',
	youtube: 'https://www.youtube.com/user/JustSleepChannel?feature=watch'

	// export const hotelWithEvent = ['kaohsiung', 'kaohsiungStation', 'hualien'];

};var fakeHotel = exports.fakeHotel = {
	id: -99,
	key: 'fake',
	bookingCode: '',
	foreignBookingCode: '',
	name: 'name',
	enName: 'FAKE',
	intro: 'intro',
	address: 'address',
	tel: '+886 2-7735-5000000',
	mainImage: jiaoxi.color,
	grayImage: jiaoxi.gray,
	colorImage: jiaoxi.color,
	thumbnail: jiaoxi.thumbnail,
	location: {
		lat: 24.830266,
		lng: 121.773063
	},
	socialLinks: {
		line: '',
		tripAdvisor: ''
	}
};

var hotelData = exports.hotelData = function hotelData(t) {
	return {
		main: {
			id: -1,
			key: 'main',
			bookingCode: '',
			foreignBookingCode: '',
			hotelHomeTitle: t('hotelMain')('title'),
			name: t('hotelMain')('name'),
			enName: 'MAIN',
			intro: t('hotelMain')('intro'),
			intro2: t('hotelMain')('intro2'),
			address: t('hotelMain')('address'),
			tel: '+886 2 7735 5088',
			// contactUs: t('hotelMain')('contactUs'),
			// mainImage: ximen.color,
			// grayImage: ximen.gray,
			// colorImage: ximen.color,
			location: { lat: 25.045244, lng: 121.509994 },
			mapLink: 'https://goo.gl/maps/PL61XqLFvQP2',
			socialLinks: {
				line: ' https://lin.ee/6pifgqN',
				tripAdvisor: '',
				fb: officialLinks.fb,
				ig: officialLinks.ig,
				weibo: officialLinks.weibo,
				youtube: officialLinks.youtube
			},
			meta: _main2.default,
			registrationNumber: ''
		},
		ximending: {
			id: 0,
			key: 'ximending',
			bookingCode: 'JSXMD',
			foreignBookingCode: '25352',
			hotelHomeTitle: t('hotelXimen')('title'),
			name: t('hotelXimen')('name'),
			enName: 'XIMENDING',
			intro: t('hotelXimen')('intro'),
			address: t('hotelXimen')('address'),
			tel: '+886 2 2370 9000',
			contactUs: t('hotelXimen')('contactUs'),
			mainImage: ximen.color,
			grayImage: ximen.gray,
			colorImage: ximen.color,
			thumbnail: ximen.thumbnail,
			location: { lat: 25.045244, lng: 121.509994 },
			mapLink: 'https://goo.gl/maps/yQmoZsgvJZL2',
			socialLinks: {
				line: 'https://lin.ee/6pifgqN',
				tripAdvisor: 'https://www.tripadvisor.com.tw/Hotel_Review-g13808853',
				fb: officialLinks.fb,
				ig: officialLinks.ig,
				weibo: officialLinks.weibo,
				youtube: officialLinks.youtube
			},
			meta: _ximending2.default,
			registrationNumber: 348
		},
		NTU: {
			id: 2,
			key: 'NTU',
			bookingCode: 'JSNTU',
			foreignBookingCode: '59416',
			hotelHomeTitle: t('hotelNTU')('title'),
			name: t('hotelNTU')('name'),
			enName: 'NTU',
			intro: t('hotelNTU')('intro'),
			address: t('hotelNTU')('address'),
			tel: '+886 2 7735 5088',
			contactUs: t('hotelNTU')('contactUs'),
			mainImage: ntu.color,
			grayImage: ntu.gray,
			colorImage: ntu.color,
			thumbnail: ntu.thumbnail,
			location: { lat: 25.013504, lng: 121.536306 },
			mapLink: 'https://goo.gl/maps/PL61XqLFvQP2',
			socialLinks: {
				line: ' https://lin.ee/6pifgqN',
				tripAdvisor: 'http://www.tripadvisor.com.tw/Hotel_Review-g293913-d4023325-Reviews-Just_Sleep_NTU-Taipei.html',
				fb: officialLinks.fb,
				ig: officialLinks.ig,
				weibo: officialLinks.weibo,
				youtube: officialLinks.youtube
			},
			meta: _NTU2.default,
			registrationNumber: 802
		},
		zhongshan: {
			id: 0,
			key: 'zhongshan',
			bookingCode: 'JSZS',
			foreignBookingCode: '',
			hotelHomeTitle: t('hotelZhongshan')('title'),
			name: t('hotelZhongshan')('name'),
			enName: 'Taipei Zhongshan',
			intro: t('hotelZhongshan')('intro'),
			address: t('hotelZhongshan')('address'),
			contactUs: t('hotelZhongshan')('contactUs'),
			tel: '+886 2 7725 0088',
			mainImage: zhongshan.color,
			grayImage: zhongshan.gray,
			colorImage: zhongshan.color,
			thumbnail: zhongshan.thumbnail,
			location: { lat: 25.051311, lng: 121.5248328 },
			mapLink: 'https://maps.app.goo.gl/8qcga6Em5jeLpQRu8',
			socialLinks: {
				line: 'https://lin.ee/6pifgqN',
				tripAdvisor: 'https://lihi1.me/29JeZ',
				fb: officialLinks.fb,
				ig: officialLinks.ig,
				weibo: officialLinks.weibo,
				youtube: officialLinks.youtube
			},
			meta: _zhongshan2.default,
			registrationNumber: '819-1'
		},
		kaohsiung: {
			id: 3,
			key: 'kaohsiung',
			bookingCode: 'JSKZZ',
			foreignBookingCode: '60289',
			hotelHomeTitle: t('hotelKaohsiung')('title'),
			name: t('hotelKaohsiung')('name'),
			enName: 'KAOHSIUNG',
			intro: t('hotelKaohsiung')('intro'),
			address: t('hotelKaohsiung')('address'),
			tel: '+886 7 972 3568',
			contactUs: t('hotelKaohsiung')('contactUs'),
			mainImage: kaohsiung.color,
			grayImage: kaohsiung.gray,
			colorImage: kaohsiung.color,
			thumbnail: kaohsiung.thumbnail,
			location: { lat: 22.628662, lng: 120.331923 },
			mapLink: 'https://goo.gl/maps/E1iP9mBy5fv',
			socialLinks: {
				line: 'https://lin.ee/6pifgqN',
				tripAdvisor: 'http://www.tripadvisor.com.tw/Hotel_Review-g297908-d5288137-Reviews-Just_Sleep_Kaohsiung_Zhongzheng-Kaohsiung.html',
				fb: officialLinks.fb,
				ig: officialLinks.ig,
				weibo: officialLinks.weibo,
				youtube: officialLinks.youtube
			},
			meta: _kaohsiung2.default,
			registrationNumber: 450
		},
		kaohsiungStation: {
			id: 4,
			key: 'kaohsiungStation',
			bookingCode: 'JSKKS',
			foreignBookingCode: '66462',
			hotelHomeTitle: t('hotelKaohsiungStation')('title'),
			name: t('hotelKaohsiungStation')('name'),
			enName: 'KAOHSIUNG STATION',
			intro: t('hotelKaohsiungStation')('intro'),
			address: t('hotelKaohsiungStation')('address'),
			tel: '+886 7 973 3588',
			contactUs: t('hotelKaohsiungStation')('contactUs'),
			mainImage: kaohsiungStation.color,
			grayImage: kaohsiungStation.gray,
			colorImage: kaohsiungStation.color,
			thumbnail: kaohsiungStation.thumbnail,
			location: { lat: 22.635753, lng: 120.302508 },
			mapLink: 'https://goo.gl/maps/NzVcBZBpaMq',
			socialLinks: {
				line: 'https://lin.ee/6pifgqN',
				tripAdvisor: 'https://www.tripadvisor.com.tw/Hotel_Review-g13808513-d8598482-Reviews-Just_Sleep_Kaohsiung_Station-Xinxing_Kaohsiung.html',
				fb: officialLinks.fb,
				ig: officialLinks.ig,
				weibo: officialLinks.weibo,
				youtube: officialLinks.youtube
			},
			meta: _kaohsiungStation2.default,
			registrationNumber: 481
		},
		hualien: {
			id: 5,
			key: 'hualien',
			bookingCode: 'JSHZZ',
			foreignBookingCode: '60288',
			hotelHomeTitle: t('hotelHualien')('title'),
			name: t('hotelHualien')('name'),
			enName: 'HUALIEN',
			intro: t('hotelHualien')('intro'),
			address: t('hotelHualien')('address'),
			tel: '+886 3 890 0069',
			contactUs: t('hotelHualien')('contactUs'),
			mainImage: hualien.color,
			grayImage: hualien.gray,
			colorImage: hualien.color,
			thumbnail: hualien.thumbnail,
			location: { lat: 23.975141, lng: 121.603726 },
			mapLink: 'https://goo.gl/maps/4vTW7LeeyLS2',
			socialLinks: {
				line: 'https://lin.ee/6pifgqN',
				tripAdvisor: 'http://www.tripadvisor.com.tw/Hotel_Review-g297907-d5288138-Reviews-Just_Sleep_Hualien_Zhongzheng-Hualien.html',
				fb: officialLinks.fb,
				ig: officialLinks.ig,
				weibo: officialLinks.weibo,
				youtube: officialLinks.youtube
			},
			meta: _hualien2.default,
			registrationNumber: 141
		},
		jiaoxi: {
			id: 6,
			key: 'jiaoxi',
			bookingCode: 'JSJX',
			foreignBookingCode: '64173',
			hotelHomeTitle: t('hotelJiaoxi')('title'),
			name: t('hotelJiaoxi')('name'),
			enName: 'JIAOXI',
			intro: t('hotelJiaoxi')('intro'),
			address: t('hotelJiaoxi')('address'),
			tel: '+886 3 910 2000',
			contactUs: t('hotelJiaoxi')('contactUs'),
			mainImage: jiaoxi.color,
			grayImage: jiaoxi.gray,
			colorImage: jiaoxi.color,
			thumbnail: jiaoxi.thumbnail,
			location: { lat: 24.828856, lng: 121.772483 },
			mapLink: 'https://goo.gl/maps/SHhPLEGy1Zn',
			socialLinks: {
				line: 'https://lin.ee/6pifgqN',
				tripAdvisor: 'https://www.tripadvisor.com.tw/Hotel_Review-g13806648-d7230669-Reviews-Just_Sleep_Jiao_Xi_Hotel-Jiaoxi_Yilan.html',
				fb: officialLinks.fb,
				ig: officialLinks.ig,
				weibo: officialLinks.weibo,
				youtube: officialLinks.youtube
			},
			meta: _jiaoxi2.default,
			registrationNumber: 220
		},
		sanchong: {
			id: 7,
			key: 'sanchong',
			bookingCode: 'JSSC',
			foreignBookingCode: '',
			hotelHomeTitle: t('hotelSanchong')('title'),
			name: t('hotelSanchong')('name'),
			enName: 'SANCHONG',
			intro: t('hotelSanchong')('intro'),
			address: t('hotelSanchong')('address'),
			tel: '+886 2 2280 6111',
			contactUs: t('hotelSanchong')('contactUs'),
			mainImage: sanchong.color,
			grayImage: sanchong.gray,
			colorImage: sanchong.color,
			thumbnail: sanchong.thumbnail,
			location: { lat: 25.077427, lng: 121.487482 },
			mapLink: 'https://www.google.com.tw/maps/place/%E6%8D%B7%E7%B5%B2%E6%97%85%E5%8F%B0%E5%8C%97%E4%B8%89%E9%87%8D%E9%A4%A8/@25.077349,121.4869415,19z/data=!3m1!4b1!4m13!1m7!3m6!1s0x3442a8d76c3e5a67:0xce925ec0fbc71bc2!2zMjQx5paw5YyX5biC5LiJ6YeN5Y2A5LiJ5ZKM6Lev5Zub5q61MTA3LTHomZ8!3b1!8m2!3d25.077349!4d121.48749!3m4!1s0x3442a95aa166790d:0xca70944b2cf7a152!8m2!3d25.077349!4d121.48749?hl=zh-TW&authuser=0',
			socialLinks: {
				line: 'https://lin.ee/6pifgqN',
				tripAdvisor: 'https://www.tripadvisor.com.tw/Hotel_Review-g13808853',
				fb: officialLinks.fb,
				ig: officialLinks.ig,
				weibo: officialLinks.weibo,
				youtube: officialLinks.youtube
			},
			meta: _sanchong2.default,
			registrationNumber: '316-1'
		},
		'hushan': {
			id: 8,
			key: 'hushan',
			bookingCode: 'JSTD',
			foreignBookingCode: '',
			hotelHomeTitle: t('hotelHushan')('title'),
			name: t('hotelHushan')('name'),
			enName: 'TAINAN HUSHAN',
			intro: t('hotelHushan')('intro'),
			address: t('hotelHushan')('address'),
			tel: '+886 6 266 0568',
			contactUs: t('hotelHushan')('contactUs'),
			mainImage: hushan.color,
			grayImage: hushan.gray,
			colorImage: hushan.color,
			thumbnail: hushan.thumbnail,
			location: { lat: 22.939149, lng: 120.2267631 },
			mapLink: 'https://goo.gl/maps/A4VEnaFmEgcMD9g36',
			socialLinks: {
				line: 'https://page.line.me/justsleep?openQrModal=true',
				tripAdvisor: 'https://www.tripadvisor.com/Hotel_Review-g13806829-d23385372-Reviews-Just_Sleep_Tainan_Ten_Drum_Silks_Hotel_Group-Rende_Tainan.html',
				fb: officialLinks.fb,
				ig: officialLinks.ig,
				weibo: officialLinks.weibo,
				youtube: officialLinks.youtube
			},
			meta: _hushan2.default,
			registrationNumber: 347
		},
		osakaShinsaibashi: {
			id: 9,
			key: 'osakaShinsaibashi',
			bookingCode: 'JSOS',
			foreignBookingCode: '',
			hotelHomeTitle: t('hotelOsakaShinsaibashi')('title'),
			name: t('hotelOsakaShinsaibashi')('name'),
			enName: 'Osaka Shinsaibashi',
			intro: t('hotelOsakaShinsaibashi')('intro'),
			address: t('hotelOsakaShinsaibashi')('address'),
			tel: t('hotelOsakaShinsaibashi')('tel'),
			contactUs: t('hotelOsakaShinsaibashi')('contactUs'),
			fax: t('hotelOsakaShinsaibashi')('fax'),
			mainImage: osakaShinsaibashi.color,
			grayImage: osakaShinsaibashi.gray,
			colorImage: osakaShinsaibashi.color,
			thumbnail: osakaShinsaibashi.thumbnail,
			// location: { lat: 25.077427, lng: 121.487482 },
			// mapLink: 'https://goo.gl/maps/A4VEnaFmEgcMD9g36', //footer地址的連結
			socialLinks: {
				ig: 'https://www.instagram.com/justsleep_os',
				fb: 'https://www.facebook.com/profile.php?id=100089151938255'
			}
			// meta: osakaShinsaibashiMeta,
			// registrationNumber: 347,
		}
	};
};

var fakeTranslation = function fakeTranslation() {
	return function (key) {
		return key;
	};
};
var defaultHotelData = exports.defaultHotelData = hotelData(fakeTranslation);

var defaultHotelMeta = exports.defaultHotelMeta = {
	id: 1,
	title: '官網訂房最低價，另享高鐵訂票75折優惠',
	description: '鄰近西門町商圈、捷運西門站、西門町商圈，全新時尚大方空間設計，是旅人最佳選擇。捷絲旅台北西門館官網訂房最低價，並享高鐵訂票75折優惠！',
	keywords: '捷絲旅台北西門館, 西門町, 西門町飯店, 西門町住宿, 西門住宿推薦, 捷運西門站, 台北車站, 台北車站住宿, 西門町商圈, 台北旅遊, 台北旅行, 台北景點, 台北美食, 台北自由行'
};

var hotelAttractionMock = exports.hotelAttractionMock = {
	ximending: [{
		address: '臺北市萬華區中華路一段',
		category: { id: 1, name: '熱門景點' },
		id: 7,
		info: '為台北市西區最重要且國際化程度最高的消費商圈',
		latitude: '',
		longitude: '',
		order: 0,
		pic: 'https://fakeimg.pl/350x200/?text=ximending',
		shop: { id: 1, title: '台北西門' },
		title: '西門町'
	}],
	NTU: [{
		address: '臺北市萬華區中華路一段',
		category: { id: 1, name: '熱門景點' },
		id: 7,
		info: '為台北市西區最重要且國際化程度最高的消費商圈',
		latitude: '',
		longitude: '',
		order: 0,
		pic: 'https://fakeimg.pl/350x200/?text=NTU',
		shop: { id: 1, title: 'NTU' },
		title: 'NTU'
	}],
	zhongshan: [{
		address: '"臺北市中山區中山北路一段135巷39號',
		category: { id: 1, name: '熱門景點' },
		id: 7,
		info: '為台北市西區最重要且國際化程度最高的消費商圈',
		latitude: '',
		longitude: '',
		order: 0,
		pic: '',
		shop: { id: 1, title: '台北中山' },
		title: '台北中山'
	}],
	kaohsiung: [{
		address: '臺北市萬華區中華路一段',
		category: { id: 1, name: '熱門景點' },
		id: 7,
		info: '為台北市西區最重要且國際化程度最高的消費商圈',
		latitude: '',
		longitude: '',
		order: 0,
		pic: 'https://fakeimg.pl/350x200/?text=kaohsiung',
		shop: { id: 1, title: 'kaohsiung' },
		title: 'kaohsiung'
	}],
	kaohsiungStation: [{
		address: '臺北市萬華區中華路一段',
		category: { id: 1, name: '熱門景點' },
		id: 7,
		info: '為台北市西區最重要且國際化程度最高的消費商圈',
		latitude: '',
		longitude: '',
		order: 0,
		pic: 'https://fakeimg.pl/350x200/?text=kaohsiungStation',
		shop: { id: 1, title: 'kaohsiungStation' },
		title: 'kaohsiungStation'
	}],
	hualien: [{
		address: '臺北市萬華區中華路一段',
		category: { id: 1, name: '熱門景點' },
		id: 7,
		info: '為台北市西區最重要且國際化程度最高的消費商圈',
		latitude: '',
		longitude: '',
		order: 0,
		pic: 'https://fakeimg.pl/350x200/?text=hualien',
		shop: { id: 1, title: 'hualien' },
		title: 'hualien'
	}],
	jiaoxi: [{
		address: '臺北市萬華區中華路一段',
		category: { id: 1, name: '熱門景點' },
		id: 7,
		info: '為台北市西區最重要且國際化程度最高的消費商圈',
		latitude: '',
		longitude: '',
		order: 0,
		pic: 'https://fakeimg.pl/350x200/?text=jiaoxi',
		shop: { id: 1, title: 'jiaoxi' },
		title: 'jiaoxi'
	}],
	sanchong: [{
		address: '臺北市萬華區中華路一段',
		category: { id: 1, name: '熱門景點' },
		id: 7,
		info: '為台北市西區最重要且國際化程度最高的消費商圈',
		latitude: '',
		longitude: '',
		order: 0,
		pic: 'https://fakeimg.pl/350x200/?text=sanchong',
		shop: { id: 1, title: 'sanchong' },
		title: 'sanchong'
	}],
	hushan: [{
		address: '臺北市萬華區中華路一段',
		category: { id: 1, name: '熱門景點' },
		id: 7,
		info: '為台北市西區最重要且國際化程度最高的消費商圈',
		latitude: '',
		longitude: '',
		order: 0,
		pic: 'https://fakeimg.pl/350x200/?text=hushan',
		shop: { id: 1, title: 'hushan' },
		title: 'hushan'
	}],
	osakaShinsaibashi: [{
		address: '542-0081大阪市中央區南船場二丁目9-15',
		category: { id: 1, name: '熱門景點' },
		id: 7,
		info: '為台北市西區最重要且國際化程度最高的消費商圈',
		latitude: '',
		longitude: '',
		order: 0,
		pic: 'https://fakeimg.pl/350x200/?text=osakaShinsaibashi',
		shop: { id: 1, title: 'osakaShinsaibashi' },
		title: 'osakaShinsaibashi'
	}]
};

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames3 = __webpack_require__(16);

var _classnames4 = _interopRequireDefault(_classnames3);

var _reactClickOutside = __webpack_require__(107);

var _reactClickOutside2 = _interopRequireDefault(_reactClickOutside);

var _reactDeviceDetect = __webpack_require__(37);

var _Options = __webpack_require__(245);

var _Options2 = _interopRequireDefault(_Options);

var _Triangle = __webpack_require__(155);

var _Triangle2 = _interopRequireDefault(_Triangle);

var _index = __webpack_require__(718);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Select = function (_React$Component) {
	_inherits(Select, _React$Component);

	function Select(props) {
		_classCallCheck(this, Select);

		var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

		_this.state = {
			optionsOpen: false
		};
		_this.handleClickOutside = _this.handleClickOutside.bind(_this);
		_this.onSelect = _this.onSelect.bind(_this);
		_this.toggleSelectBox = _this.toggleSelectBox.bind(_this);
		return _this;
	}

	Select.prototype.onSelect = function onSelect(option) {
		this.setState({ optionsOpen: false });
		this.props.onSelect(option);
	};

	Select.prototype.handleClickOutside = function handleClickOutside() {
		this.setState({ optionsOpen: false });
	};

	Select.prototype.toggleSelectBox = function toggleSelectBox() {
		if (!this.props.disabled) {
			this.setState({ optionsOpen: !this.state.optionsOpen });
		}
	};

	Select.prototype.render = function render() {
		var _classnames, _classnames2;

		var _props = this.props,
		    className = _props.className,
		    options = _props.options,
		    _props$placeholder = _props.placeholder,
		    placeholder = _props$placeholder === undefined ? 'select...' : _props$placeholder,
		    PlaceholderIcon = _props.PlaceholderIcon,
		    _props$selected = _props.selected,
		    selected = _props$selected === undefined ? {
			id: -1,
			label: '',
			value: ''
		} : _props$selected,
		    disabled = _props.disabled,
		    selectBoxConfigProp = _props.selectBoxConfig,
		    optionConfigProp = _props.optionConfig,
		    moreWeight = _props.moreWeight;


		var selectBoxConfig = _extends({
			class: _index2.default.defaultSelectBox,
			activeClass: _index2.default.activeSelectBox,
			triangle: true,
			triangleDown: false,
			triangleSize: 10,
			triangleColor: '#2D2926',
			triangleBorderWidth: 1,
			animation: false
		}, selectBoxConfigProp);

		var optionConfig = _extends({ border: true }, optionConfigProp);

		var optionsOpen = this.state.optionsOpen;


		return _react2.default.createElement(
			'div',
			{
				className: (0, _classnames4.default)(_index2.default.select, className, (_classnames = {}, _classnames[_index2.default.disabled] = disabled, _classnames))
			},
			_react2.default.createElement(
				'div',
				{
					className: (0, _classnames4.default)(_index2.default.selectBox, selectBoxConfig.class, (_classnames2 = {}, _classnames2[_index2.default.active] = optionsOpen, _classnames2[selectBoxConfig.activeClass] = optionsOpen, _classnames2[_index2.default.animation] = selectBoxConfig.animation, _classnames2[_index2.default.isBrowser] = _reactDeviceDetect.isBrowser, _classnames2)),
					role: 'button',
					tabIndex: '0',
					onClick: this.toggleSelectBox,
					onKeyPress: function onKeyPress() {}
				},
				_react2.default.createElement('div', { className: _index2.default.mask }),
				_react2.default.createElement(
					'div',
					{ className: _index2.default.container },
					selected.id === -1 ? _react2.default.createElement(
						'div',
						{ className: _index2.default.placeholder },
						PlaceholderIcon && _react2.default.createElement(
							'div',
							{ className: _index2.default.icon },
							_react2.default.createElement(PlaceholderIcon, null)
						),
						_react2.default.createElement(
							'div',
							{ className: _index2.default.text },
							placeholder
						)
					) : selected.label,
					selectBoxConfig.triangle && _react2.default.createElement(_Triangle2.default, {
						direction: selectBoxConfig.triangleDown || optionsOpen ? 'down' : 'right',
						className: _index2.default.triangle,
						size: selectBoxConfig.triangleSize,
						color: selectBoxConfig.triangleColor,
						borderWidth: selectBoxConfig.triangleBorderWidth
					})
				)
			),
			_react2.default.createElement(
				'div',
				{
					className: (0, _classnames4.default)(_index2.default.options),
					style: { height: optionsOpen ? options.length * 60 + 'px' : 0 }
				},
				_react2.default.createElement(_Options2.default, _extends({
					options: options,
					selected: selected,
					onSelect: this.onSelect,
					moreWeight: moreWeight
				}, optionConfig))
			)
		);
	};

	return Select;
}(_react2.default.Component);

exports.default = (0, _reactClickOutside2.default)(Select);

/***/ }),
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__context__ = __webpack_require__(135);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var removedIsInitialSSR = false;

var I18n = function (_Component) {
  _inherits(I18n, _Component);

  function I18n(props, context) {
    _classCallCheck(this, I18n);

    var _this = _possibleConstructorReturn(this, (I18n.__proto__ || Object.getPrototypeOf(I18n)).call(this, props, context));

    _this.i18n = context.i18n || props.i18n || Object(__WEBPACK_IMPORTED_MODULE_2__context__["b" /* getI18n */])();
    _this.namespaces = _this.props.ns || _this.i18n.options.defaultNS;
    if (typeof _this.namespaces === 'string') _this.namespaces = [_this.namespaces];

    var i18nOptions = _this.i18n && _this.i18n.options.react || {};
    _this.options = _extends({}, Object(__WEBPACK_IMPORTED_MODULE_2__context__["a" /* getDefaults */])(), i18nOptions, props);

    // nextjs SSR: getting data from next.js or other ssr stack
    if (props.initialI18nStore) {
      _this.i18n.services.resourceStore.data = props.initialI18nStore;
      _this.options.wait = false; // we got all passed down already
    }
    if (props.initialLanguage) {
      _this.i18n.changeLanguage(props.initialLanguage);
    }

    // provider SSR: data was set in provider and ssr flag was set
    if (_this.i18n.options.isInitialSSR) {
      _this.options.wait = false;
    }

    var language = _this.i18n.languages && _this.i18n.languages[0];
    var ready = !!language && _this.namespaces.every(function (ns) {
      return _this.i18n.hasResourceBundle(language, ns);
    });

    _this.state = {
      i18nLoadedAt: null,
      ready: ready
    };

    _this.onI18nChanged = _this.onI18nChanged.bind(_this);
    _this.getI18nTranslate = _this.getI18nTranslate.bind(_this);
    return _this;
  }

  _createClass(I18n, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        t: this.t,
        i18n: this.i18n
      };
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.t = this.getI18nTranslate();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var bind = function bind() {
        if (_this2.options.bindI18n && _this2.i18n) _this2.i18n.on(_this2.options.bindI18n, _this2.onI18nChanged);
        if (_this2.options.bindStore && _this2.i18n.store) _this2.i18n.store.on(_this2.options.bindStore, _this2.onI18nChanged);
      };

      this.mounted = true;
      this.i18n.loadNamespaces(this.namespaces, function () {
        var ready = function ready() {
          if (_this2.mounted && !_this2.state.ready) _this2.setState({ ready: true });
          if (_this2.options.wait && _this2.mounted) bind();
        };

        if (_this2.i18n.isInitialized) {
          ready();
        } else {
          var initialized = function initialized() {
            // due to emitter removing issue in i18next we need to delay remove
            setTimeout(function () {
              _this2.i18n.off('initialized', initialized);
            }, 1000);
            ready();
          };

          _this2.i18n.on('initialized', initialized);
        }
      });

      if (!this.options.wait) bind();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var _this3 = this;

      this.mounted = false;
      if (this.onI18nChanged) {
        if (this.options.bindI18n) {
          var p = this.options.bindI18n.split(' ');
          p.forEach(function (f) {
            return _this3.i18n.off(f, _this3.onI18nChanged);
          });
        }
        if (this.options.bindStore) {
          var _p = this.options.bindStore.split(' ');
          _p.forEach(function (f) {
            return _this3.i18n.store && _this3.i18n.store.off(f, _this3.onI18nChanged);
          });
        }
      }
    }
  }, {
    key: 'onI18nChanged',
    value: function onI18nChanged() {
      if (!this.mounted) return;

      this.t = this.getI18nTranslate();
      this.setState({ i18nLoadedAt: new Date() });
    }
  }, {
    key: 'getI18nTranslate',
    value: function getI18nTranslate() {
      return this.i18n.getFixedT(null, this.options.nsMode === 'fallback' ? this.namespaces : this.namespaces[0]);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var children = this.props.children;
      var ready = this.state.ready;


      if (!ready && this.options.wait) return null;

      // remove ssr flag set by provider - first render was done from now on wait if set to wait
      if (this.i18n.options.isInitialSSR && !removedIsInitialSSR) {
        removedIsInitialSSR = true;
        setTimeout(function () {
          delete _this4.i18n.options.isInitialSSR;
        }, 100);
      }

      return children(this.t, { i18n: this.i18n, t: this.t });
    }
  }]);

  return I18n;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (I18n);


I18n.contextTypes = {
  i18n: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

I18n.childContextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  i18n: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

/***/ }),
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({

  processors: {},

  addPostProcessor: function addPostProcessor(module) {
    this.processors[module.name] = module;
  },
  handle: function handle(processors, value, key, options, translator) {
    var _this = this;

    processors.forEach(function (processor) {
      if (_this.processors[processor]) value = _this.processors[processor].process(value, key, options, translator);
    });

    return value;
  }
});

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.languagePathRedirect = exports.changeLanguage = undefined;

var _reduxActions = __webpack_require__(6);

var _reactRouterRedux = __webpack_require__(51);

var _hotel = __webpack_require__(15);

var changeLanguage = exports.changeLanguage = (0, _reduxActions.createAction)('CHANGE_LANGUAGE', function (lan) {
	return function (dispatch) {
		dispatch((0, _hotel.getAllHotelData)());
		return { lan: lan };
	};
});

var languagePathRedirect = exports.languagePathRedirect = (0, _reduxActions.createAction)('LANGUAGE_PATH_REDIRECT', function (lan) {
	return function (dispatch, getState) {
		var _getState = getState(),
		    pathname = _getState.routing.locationBeforeTransitions.pathname;

		var newPathname = '';

		// For smart language direct.
		if (pathname !== '/') {
			var pathnames = pathname.split('/');

			// Normalize pathname
			if (pathnames[0] !== '') {
				pathnames = [''].concat(pathnames);
			}

			// home page language redirect
			if (pathnames.length === 2) {
				pathnames.push(lan);
				newPathname = pathnames.join('/');
			}

			// hotel page language redirect
			if (pathnames.length >= 3) {
				pathnames[2] = lan;
				newPathname = pathnames.join('/');
			}
		} else {
			// If user is at homepage or illegal path,
			// just redirect to main page with language
			newPathname = '/main/' + lan;
		}

		dispatch((0, _reactRouterRedux.push)({ pathname: newPathname }));
	};
});

/***/ }),
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.createScroller = exports.addMatchMediaListener = undefined;

var _global = __webpack_require__(151);

var addMatchMediaListener = exports.addMatchMediaListener = function addMatchMediaListener(store) {
	var phoneMedia = window.matchMedia('(max-width: 719px)');
	var tabletMedia = window.matchMedia('(max-width: 1199px) and (min-width: 720px)');
	var desktopMedia = window.matchMedia('(min-width: 1200px)');

	var handleMediaChange = function handleMediaChange(callback) {
		return function (media) {
			if (media.matches) {
				callback();
			}
		};
	};

	phoneMedia.addListener(handleMediaChange(function () {
		return store.dispatch((0, _global.matchMedia)('phone'));
	}));
	tabletMedia.addListener(handleMediaChange(function () {
		return store.dispatch((0, _global.matchMedia)('tablet'));
	}));
	desktopMedia.addListener(handleMediaChange(function () {
		return store.dispatch((0, _global.matchMedia)('desktop'));
	}));

	// Initalize
	handleMediaChange(function () {
		return store.dispatch((0, _global.matchMedia)('phone'));
	})(phoneMedia);
	handleMediaChange(function () {
		return store.dispatch((0, _global.matchMedia)('tablet'));
	})(tabletMedia);
	handleMediaChange(function () {
		return store.dispatch((0, _global.matchMedia)('desktop'));
	})(desktopMedia);
};

var createScroller = exports.createScroller = function createScroller(store) {
	var ticking = false;

	var scrollEvent = function scrollEvent() {
		var _window = window,
		    scrollY = _window.scrollY;


		if (!ticking) {
			window.requestAnimationFrame(function () {
				store.dispatch((0, _global.scrollWindow)(scrollY));
				ticking = false;
			});
		}
		ticking = true;
	};

	var addListener = function addListener() {
		window.addEventListener('scroll', scrollEvent, false);
		// Initalize the scroll value
		store.dispatch((0, _global.scrollWindow)(window.scrollY));
	};

	var removeListener = function removeListener() {
		window.removeEventListener('scroll', scrollEvent);
	};

	return {
		addListener: addListener,
		removeListener: removeListener
	};
};

/***/ }),
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = trim;
// GA strings need to have leading/trailing whitespace trimmed, and not all
// browsers have String.prototoype.trim().
function trim(s) {
  return s && s.toString().replace(/^\s+|\s+$/g, '');
}

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reactContainerHelper = __webpack_require__(49);

var _reactRedux = __webpack_require__(17);

var _i18n = __webpack_require__(212);

var _hotel = __webpack_require__(15);

var _i18n2 = __webpack_require__(22);

var _component = __webpack_require__(711);

var _component2 = _interopRequireDefault(_component);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var mapSetStateToProps = function mapSetStateToProps(_, _ref) {
	var lanRoute = _ref.lanRoute,
	    changeLanguage = _ref.changeLanguage,
	    changeHotel = _ref.changeHotel,
	    props = _objectWithoutProperties(_ref, ['lanRoute', 'changeLanguage', 'changeHotel']);

	return _extends({
		lanRoute: lanRoute

	}, props, {
		onLangSelect: function onLangSelect(option) {
			changeLanguage(option.value);
		},
		onHotelSelect: function onHotelSelect(option) {
			changeHotel(option.value);
		}
	});
};

var componentContainer = (0, _reactContainerHelper.contain)(undefined, mapSetStateToProps)(_component2.default);

var mapStateToProps = function mapStateToProps(_ref2) {
	var lan = _ref2.global.lan,
	    hotel = _ref2.hotel.hotel;
	return {
		language: lan,
		lanRoute: (0, _i18n2.lanMapRoute)(lan),
		hotel: hotel
	};
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	return {
		changeLanguage: function changeLanguage(language) {
			return dispatch((0, _i18n.languagePathRedirect)(language));
		},
		changeHotel: function changeHotel(hotel) {
			return dispatch((0, _hotel.hotelPathRedirect)(hotel));
		}
	};
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(componentContainer);

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reactContainerHelper = __webpack_require__(49);

var _component = __webpack_require__(713);

var _component2 = _interopRequireDefault(_component);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var defaultSelected = {
	id: -1,
	label: '',
	value: ''
};

var initState = function initState(_ref) {
	var _ref$selected = _ref.selected,
	    selected = _ref$selected === undefined ? defaultSelected : _ref$selected;
	return {
		selected: selected
	};
};

var mapSetStateToProps = function mapSetStateToProps(_ref3, _ref2, setState) {
	var selected = _ref3.selected;

	var props = _objectWithoutProperties(_ref2, []),
	    onSelect = _ref2.onSelect;

	return _extends({
		selected: selected

	}, props, {
		select: function select(option) {
			setState({ selected: option });
			onSelect(option);
		}
	});
};

exports.default = (0, _reactContainerHelper.contain)(initState, mapSetStateToProps)(_component2.default);

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(1);

function LogoJustsleepShort(props) {
    return React.createElement("svg", props, React.createElement("g", { "fill": "none", "fillRule": "evenodd" }, React.createElement("g", { "fill": "#FFF" }, React.createElement("path", { "d": "M25.553 33.936c0 2.191-.068 5.009-1.24 7.639-.757 1.44-1.79 2.88-3.512 4.069-2.48 1.691-5.441 2.38-8.127 2.38-5.166 0-10.47-2.755-12.26-8.14-.207-.438-.275-1.002-.414-1.502h2.274c.068.25.137.438.207.688 2.066 6.512 8.195 7.263 10.33 7.263 5.305-.125 8.54-2.88 9.574-5.447.896-2.066 1.102-4.195 1.102-6.95V.876h2.066v33.06zM58.01 47.21h-1.578c0-2.254 0-4.445.057-7.201-2.03 5.761-7.213 8.14-12.51 8.015-8.905-.251-13.356-6.199-13.356-16.154V14.025H32.2V31.87c0 8.953 3.945 14.652 12.116 14.526 7.1-.124 12.115-4.571 12.115-13.274V14.025h1.578V47.21zM82.042 21.852c0-5.01-3.788-7.075-7.714-7.012-4.89 0-8.196 3.005-7.99 6.95.207 4.007 2.824 5.51 7.99 6.825 4.82 1.189 10.262 2.379 10.676 9.454.344 5.447-4.408 9.955-10.676 9.955-6.06 0-11.64-3.944-11.226-10.018h1.927c0 5.323 3.995 8.39 9.299 8.39 5.442 0 8.885-3.756 8.746-8.077-.136-4.571-2.892-6.762-8.815-7.951-5.51-1.44-9.642-2.881-9.849-8.578 0-5.51 4.477-8.578 9.918-8.578 5.303.062 9.643 2.943 9.643 8.64h-1.929zM98.15 15.653h-8.06v-1.628h8.06V.876h1.928v13.15h9.367v1.627h-9.367V47.21H98.15zM128.585 32.809c.329 6.262 4.733 7.45 6.837 7.45 3.748 0 6.641-2.88 6.641-6.135 0-3.944-3.485-4.946-10.256-7.513-3.682-1.252-12.163-4.133-12.163-12.898C119.644 4.822 127.861 0 135.751 0c6.442 0 14.989 3.256 15.384 13.525h-9.664c-.395-2.13-1.249-5.698-6.049-5.698-3.221 0-5.983 2.129-5.983 5.259-.066 3.445 2.565 4.32 10.783 7.577 7.428 3.068 11.571 6.449 11.571 13.023 0 7.45-4.8 14.4-16.239 14.4-11.045 0-16.765-6.323-16.699-15.277h9.73zM155.208 47.209h8.612V.876h-8.612zM196.492 26.485c-.329-3.256-3.945-7.827-10.256-7.764-6.378 0-9.862 4.383-10.19 7.764h20.446zm-20.578 6.262c.394 5.51 5.522 8.577 10.453 8.514 4.207 0 7.035-1.815 8.678-4.633h8.876c-1.71 3.82-4.274 6.7-7.298 8.641-3.024 2.003-6.574 3.005-10.322 3.005-11.11 0-19.066-8.578-19.066-18.158 0-9.767 8.021-18.345 18.935-18.345 5.39 0 10.125 1.941 13.477 5.26 4.406 4.32 6.048 9.704 5.325 15.716h-29.058zM237.809 26.485c-.328-3.256-3.944-7.827-10.256-7.764-6.377 0-9.861 4.383-10.19 7.764h20.446zm-20.578 6.262c.394 5.51 5.523 8.577 10.454 8.514 4.207 0 7.034-1.815 8.678-4.633h8.876c-1.71 3.82-4.274 6.7-7.298 8.641-3.025 2.003-6.574 3.005-10.322 3.005-11.111 0-19.066-8.578-19.066-18.158 0-9.767 8.02-18.345 18.935-18.345 5.39 0 10.124 1.941 13.477 5.26 4.405 4.32 6.048 9.704 5.325 15.716h-29.06zM280.047 29.992c0-4.947-3.748-10.582-11.046-10.582-3.155 0-5.85 1.19-7.823 3.13-1.906 1.879-3.09 4.572-3.09 7.577 0 2.943 1.184 5.573 3.155 7.45 1.973 1.88 4.734 3.069 7.824 3.069 6.575 0 10.98-4.946 10.98-10.581v-.063zm-30.178-17.156h8.087v5.009c2.564-3.444 6.773-6.073 12.755-6.073 12.623 0 17.947 10.205 17.947 18.533 0 9.768-7.297 17.97-17.882 17.97-7.034 0-10.848-3.444-12.293-5.636v16.593h-8.614V12.836z" }))));
}

LogoJustsleepShort.displayName = "LogoJustsleepShort";

LogoJustsleepShort.defaultProps = { "width": "289", "height": "60" };

module.exports = LogoJustsleepShort;

LogoJustsleepShort.default = LogoJustsleepShort;

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// 只有部分飯店的部分語言有愛旅行回饋計劃
var TW_REWARD_LINK = {
	'jiaoxi': 'https://member.silkshotelgroup.com/Campaign/Index/JSJX',
	'ximending': 'https://member.silkshotelgroup.com/Campaign/Index/JSXMD',
	'sanchong': 'https://member.silkshotelgroup.com/Campaign/Index/JSSC',
	'NTU': 'https://member.silkshotelgroup.com/Campaign/Index/JSNTU',
	'zhongshan': 'https://member.silkshotelgroup.com/Campaign/Index/JSZS'
}; /* eslint-disable indent */


var EN_REWARD_LINK = {
	'jiaoxi': 'https://member.silkshotelgroup.com/en/Campaign/Index/JSJX',
	'ximending': 'https://member.silkshotelgroup.com/en/Campaign/Index/JSXMD',
	'sanchong': 'https://member.silkshotelgroup.com/en/Campaign/Index/JSSC',
	'NTU': 'https://member.silkshotelgroup.com/en/Campaign/Index/JSNTU',
	'zhongshan': 'https://member.silkshotelgroup.com/en/Campaign/Index/JSZS'
};

var NavExtraItem = function NavExtraItem(_ref) {
	var className = _ref.className,
	    hotel = _ref.hotel,
	    lan = _ref.lan;

	if (hotel === 'hualien' && lan === 'zh-TW' || hotel === 'kaohsiung' && lan === 'zh-TW' || hotel === 'kaohsiungStation' && lan === 'zh-TW') {
		return _react2.default.createElement(
			'a',
			{
				className: className,
				href: 'https://member.silkshotelgroup.com/Campaign/Index/JS',
				target: '_blank',
				rel: 'noopener noreferrer'
			},
			'\u96C6\u9EDE\u4EAB\u6A02\u56DE\u994B\u8A08\u5283'
		);
	}

	if (lan === 'zh-TW' && hotel in TW_REWARD_LINK) {
		var hotelLink = TW_REWARD_LINK[hotel];

		return _react2.default.createElement(
			'a',
			{ className: className, href: hotelLink, target: '_blank', rel: 'noopener noreferrer' },
			'\u611B\u65C5\u884C\u56DE\u994B\u8A08\u5283'
		);
	}

	if (lan === 'en' && hotel in EN_REWARD_LINK) {
		var _hotelLink = EN_REWARD_LINK[hotel];

		return _react2.default.createElement(
			'a',
			{ className: className, href: _hotelLink, target: '_blank', rel: 'noopener noreferrer' },
			'REWARDS'
		);
	}

	if (hotel === 'osakaShinsaibashi') {
		var _hotelLink2 = '';
		var wording = '';
		switch (lan) {
			case 'zh-TW':
				_hotelLink2 = 'https://member.silkshotelgroup.com/Campaign/Index/JSOKS';
				wording = '愛旅行回饋計畫';
				break;
			case 'zh-CN':
				_hotelLink2 = 'https://member.silkshotelgroup.com/zh-CN/Campaign/Index/JSOKS';
				wording = '爱旅行回馈计画';
				break;
			case 'en':
				_hotelLink2 = 'https://member.silkshotelgroup.com/en/Campaign/Index/JSOKS';
				wording = 'REWARDS';
				break;
			case 'ja':
				_hotelLink2 = 'https://member.silkshotelgroup.com/ja/Campaign/Index/JSOKS';
				wording = 'リワード';
				break;
			case 'ko':
				_hotelLink2 = 'https://member.silkshotelgroup.com/en/Campaign/Index/JSOKS';
				wording = '보상';
				break;
			default:
				_hotelLink2 = '';
				wording = '';
		}
		return _react2.default.createElement(
			'a',
			{ className: className, href: _hotelLink2, target: '_blank', rel: 'noopener noreferrer' },
			wording
		);
	}

	return '';
};

exports.default = NavExtraItem;

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// 因為這五館 navbar 過長會跑版，所以用 ESG 代替，其他館正常顯示 SUSTAINABLE
var useEGSHotels = ['jiaoxi', 'ximending', 'sanchong', 'osakaShinsaibashi', 'NTU'];

var NavSustainabilityItem = function NavSustainabilityItem(_ref) {
	var className = _ref.className,
	    lan = _ref.lan,
	    hotel = _ref.hotel;

	var showNavButton = lan === 'zh-TW' || lan === 'zh-CN' || lan === 'en';
	var link = lan === 'en' ? 'https://esg.silkshotelgroup.com/en' : 'https://esg.silkshotelgroup.com';

	var context = void 0;
	if (lan === 'zh-TW') {
		context = '永續發展';
	} else if (lan === 'zh-CN') {
		context = '永续发展';
	} else if (lan === 'en') {
		if (useEGSHotels.includes(hotel)) {
			context = 'ESG';
		} else {
			context = 'SUSTAINABLE';
		}
	}

	if (showNavButton) {
		return _react2.default.createElement(
			'a',
			{
				className: className,
				href: link,
				target: '_blank',
				rel: 'noopener noreferrer'
			},
			context
		);
	}

	return '';
};

exports.default = NavSustainabilityItem;

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var hotelPages = exports.hotelPages = [{
	id: 0,
	label: 'index',
	route: ''
}, {
	id: 1,
	label: 'accommodation',
	route: 'rooms'
}, {
	id: 2,
	label: 'restaurant',
	route: 'diningsandmeetings'
}, {
	id: 3,
	label: 'facility',
	route: 'amenities'
}, {
	id: 4,
	label: 'activity',
	route: 'activities'
}, {
	id: 5,
	label: 'location',
	route: 'directions'
}, {
	id: 6,
	label: 'news',
	route: 'promotions'
}];

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getActivities = undefined;

var _reduxActions = __webpack_require__(6);

var _endpoint = __webpack_require__(35);

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var getActivities = exports.getActivities = (0, _reduxActions.createAction)('FETCH_ACTIVITIES', function () {
	var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(lan, hotel) {
		var _ref2, status, message, data, activities;

		return regeneratorRuntime.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						_context.next = 2;
						return (0, _endpoint.wrapFetch)('api/v1/web/' + lan + '/' + hotel + '/activity', {
							method: 'GET'
						});

					case 2:
						_ref2 = _context.sent;
						status = _ref2.status;
						message = _ref2.message;
						data = _ref2.data;

						if (!(status !== 200)) {
							_context.next = 8;
							break;
						}

						throw new Error(message);

					case 8:
						activities = data.map(function (activity) {
							return {
								id: activity.id,
								title: activity.title,
								label: activity.type,
								content: activity.intro,
								image: activity.pic,
								thumbnail: activity.pic_thumbnail,
								relationLink: activity.relation_link,
								joinLink: activity.join_link
							};
						});
						return _context.abrupt('return', { activities: activities });

					case 10:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, undefined);
	}));

	return function (_x, _x2) {
		return _ref.apply(this, arguments);
	};
}());

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getLocationData = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(6);

var _helper = __webpack_require__(154);

var _endpoint = __webpack_require__(35);

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var getLocationData = exports.getLocationData = (0, _reduxActions.createAction)('FETCH_LOCATION_DATA', function () {
	var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(lan, hotel) {
		var _ref2, status, message, data;

		return regeneratorRuntime.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						_context.next = 2;
						return (0, _endpoint.wrapFetch)('api/v1/web/' + lan + '/' + hotel + '/transportation', {
							method: 'GET'
						});

					case 2:
						_ref2 = _context.sent;
						status = _ref2.status;
						message = _ref2.message;
						data = _ref2.data.data;

						if (!(status !== 200)) {
							_context.next = 8;
							break;
						}

						throw new Error(message);

					case 8:
						return _context.abrupt('return', _extends({}, (0, _helper.keyTransform)(data)));

					case 9:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, undefined);
	}));

	return function (_x, _x2) {
		return _ref.apply(this, arguments);
	};
}());

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getFacilities = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(6);

var _helper = __webpack_require__(154);

var _endpoint = __webpack_require__(35);

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var getFacilities = exports.getFacilities = (0, _reduxActions.createAction)('FETCH_FACILITIES', function () {
	var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(lan, hotel) {
		var _ref2, status, message, data, facilityList, facilityData;

		return regeneratorRuntime.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						_context.next = 2;
						return (0, _endpoint.wrapFetch)('api/v1/web/' + lan + '/' + hotel + '/facility', {
							method: 'GET'
						});

					case 2:
						_ref2 = _context.sent;
						status = _ref2.status;
						message = _ref2.message;
						data = _ref2.data;

						if (!(status !== 200)) {
							_context.next = 8;
							break;
						}

						throw new Error(message);

					case 8:
						facilityList = [];
						facilityData = {};


						data.forEach(function (d) {
							facilityList.push(d.id);
							facilityData[d.id] = _extends({}, (0, _helper.keyTransform)(d), {
								time: d.time.split('、'),
								photos: d.photos.map(function (photo) {
									return photo.url;
								}),
								thumbnail: d.photos.map(function (photo) {
									return photo.thumb_url;
								})
							});
						});

						return _context.abrupt('return', {
							facilityList: facilityList,
							facilityData: facilityData
						});

					case 12:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, undefined);
	}));

	return function (_x, _x2) {
		return _ref.apply(this, arguments);
	};
}());

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(__webpack_require__(1));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ProgressiveImage =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ProgressiveImage, _React$Component);

  function ProgressiveImage(props) {
    var _this;

    _classCallCheck(this, ProgressiveImage);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ProgressiveImage).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "image", void 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "loadImage", function (src, srcSetData) {
      // If there is already an image we nullify the onload
      // and onerror props so it does not incorrectly set state
      // when it resolves
      if (_this.image) {
        _this.image.onload = null;
        _this.image.onerror = null;
      }

      var image = new Image();
      _this.image = image;
      image.onload = _this.onLoad;
      image.onerror = _this.onError;
      image.src = src;

      if (srcSetData) {
        image.srcset = srcSetData.srcSet;
        image.sizes = srcSetData.sizes;
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onLoad", function () {
      // use this.image.src instead of this.props.src to
      // avoid the possibility of props being updated and the
      // new image loading before the new props are available as
      // this.props.
      if (_this.props.delay) {
        _this.setImageWithDelay();
      } else {
        _this.setImage();
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "setImageWithDelay", function () {
      setTimeout(function () {
        _this.setImage();
      }, _this.props.delay);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "setImage", function () {
      _this.setState({
        image: _this.image.src,
        loading: false,
        srcSetData: {
          srcSet: _this.image.srcset || '',
          sizes: _this.image.sizes || ''
        }
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onError", function (errorEvent) {
      var onError = _this.props.onError;

      if (onError) {
        onError(errorEvent);
      }
    });

    _this.state = {
      image: props.placeholder,
      loading: true,
      srcSetData: {
        srcSet: '',
        sizes: ''
      }
    };
    return _this;
  }

  _createClass(ProgressiveImage, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          src = _this$props.src,
          srcSetData = _this$props.srcSetData;
      this.loadImage(src, srcSetData);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;

      var _this$props2 = this.props,
          src = _this$props2.src,
          placeholder = _this$props2.placeholder,
          srcSetData = _this$props2.srcSetData; // We only invalidate the current image if the src has changed.

      if (src !== prevProps.src) {
        this.setState({
          image: placeholder,
          loading: true
        }, function () {
          _this2.loadImage(src, srcSetData);
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.image) {
        this.image.onload = null;
        this.image.onerror = null;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          image = _this$state.image,
          loading = _this$state.loading,
          srcSetData = _this$state.srcSetData;
      var children = this.props.children;

      if (!children || typeof children !== 'function') {
        throw new Error("ProgressiveImage requires a function as its only child");
      }

      return children(image, loading, srcSetData);
    }
  }]);

  return ProgressiveImage;
}(React.Component);

exports.default = ProgressiveImage;


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(1);

function ArrowLong(props) {
    return React.createElement("svg", props, React.createElement("path", { "fill": "#8DC8E8", "fillRule": "evenodd", "d": "M47.45 12H.5c-.275 0-.5-.427-.5-.95 0-.521.225-.948.5-.948h47.062l-8.731-7.859c-.991-.892.347-2.378 1.338-1.486l10 9c.427.384.422.878.198 1.245a1 1 0 0 1-.198 1.241l-10 9a1 1 0 1 1-1.338-1.486L47.45 12z" }));
}

ArrowLong.displayName = "ArrowLong";

ArrowLong.defaultProps = { "width": "51", "height": "22" };

module.exports = ArrowLong;

ArrowLong.default = ArrowLong;

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames3 = __webpack_require__(16);

var _classnames4 = _interopRequireDefault(_classnames3);

var _reactDeviceDetect = __webpack_require__(37);

var _arrowLong = __webpack_require__(254);

var _arrowLong2 = _interopRequireDefault(_arrowLong);

var _index = __webpack_require__(748);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Button = function Button(_ref) {
	var _classnames, _classnames2;

	var className = _ref.className,
	    contentClassName = _ref.contentClassName,
	    arrow = _ref.arrow,
	    children = _ref.children,
	    _ref$animation = _ref.animation,
	    animation = _ref$animation === undefined ? true : _ref$animation,
	    reverse = _ref.reverse,
	    maskColor = _ref.maskColor,
	    _ref$onClick = _ref.onClick,
	    onClick = _ref$onClick === undefined ? function () {} : _ref$onClick;
	return _react2.default.createElement(
		'div',
		{
			className: (0, _classnames4.default)(_index2.default.button, className, (_classnames = {}, _classnames[_index2.default.reverse] = reverse, _classnames[_index2.default.isBrowser] = _reactDeviceDetect.isBrowser, _classnames)),
			role: 'button',
			tabIndex: '0',
			onClick: onClick,
			onKeyPress: function onKeyPress() {}
		},
		animation && _react2.default.createElement('div', {
			className: _index2.default.animationMask,
			style: {
				backgroundColor: maskColor || ''
			}
		}),
		_react2.default.createElement(
			'div',
			{
				className: (0, _classnames4.default)(_index2.default.content, contentClassName, (_classnames2 = {}, _classnames2[_index2.default.animation] = animation, _classnames2))
			},
			children,
			arrow && _react2.default.createElement(
				'div',
				{ className: _index2.default.arrow },
				_react2.default.createElement(_arrowLong2.default, null)
			)
		)
	);
};

exports.default = Button;

/***/ }),
/* 256 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"popup":"index__popup___3RuE6","popup-box":"index__popup-box___1DHkI","popupBox":"index__popup-box___1DHkI","image":"index__image___13heK","introduction":"index__introduction___3xJUK","title":"index__title___1iU5S","subtitle":"index__subtitle___2CINK","link":"index__link___1xFPW","triangle":"index__triangle___pZNqB","close-button":"index__close-button___3JY3a","closeButton":"index__close-button___3JY3a","popup-close":"index__popup-close___2Tmk_","popupClose":"index__popup-close___2Tmk_","fadeOut":"index__fadeOut___3_wL6","fadeIn":"index__fadeIn___3Ye_j"};

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _en = __webpack_require__(640);

var _en2 = _interopRequireDefault(_en);

var _ja = __webpack_require__(641);

var _ja2 = _interopRequireDefault(_ja);

var _ko = __webpack_require__(642);

var _ko2 = _interopRequireDefault(_ko);

var _zhCN = __webpack_require__(643);

var _zhCN2 = _interopRequireDefault(_zhCN);

var _zhTW = __webpack_require__(644);

var _zhTW2 = _interopRequireDefault(_zhTW);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
	en: _en2.default,
	ja: _ja2.default,
	ko: _ko2.default,
	'zh-CN': _zhCN2.default,
	'zh-TW': _zhTW2.default
};

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var responsiveImage = exports.responsiveImage = function responsiveImage(largeImg, smallImage) {
	if (window.innerWidth < 1200) {
		return smallImage;
	}
	return largeImg;
};

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reactContainerHelper = __webpack_require__(49);

var _reactRedux = __webpack_require__(17);

var _component = __webpack_require__(712);

var _component2 = _interopRequireDefault(_component);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var initState = function initState(_ref) {
	var hotel = _ref.hotel;
	return {
		selectedHotel: hotel
	};
};

var mapSetStateToProps = function mapSetStateToProps(_ref3, _ref2, setState) {
	var selectedHotel = _ref3.selectedHotel;

	var props = _objectWithoutProperties(_ref2, []),
	    _onSelect = _ref2.onSelect;

	return _extends({
		selectedHotel: selectedHotel

	}, props, {
		onSelect: function onSelect(option) {
			setState({ selectedHotel: option.value });
			_onSelect(option);
		}
	});
};

var componentContainer = (0, _reactContainerHelper.contain)(initState, mapSetStateToProps)(_component2.default);

var mapStateToProps = function mapStateToProps(_ref4, _ref5) {
	var _ref4$hotel = _ref4.hotel,
	    hotel = _ref4$hotel.hotel,
	    hotelData = _ref4$hotel.hotelData,
	    hotelList = _ref4$hotel.hotelList;
	var withHomeSelection = _ref5.withHomeSelection;
	return {
		hotel: {
			id: hotelData[hotel].id,
			label: hotelData[hotel].name,
			value: hotel
		},
		hotelList: withHomeSelection ? hotelList : hotelList.filter(function (hotelName) {
			return hotelName !== 'main';
		}),
		hotelData: hotelData
	};
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(componentContainer);

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(1);

function Train(props) {
    return React.createElement("svg", props, React.createElement("g", { "fill": "none", "fillRule": "evenodd" }, [React.createElement("path", { "d": "M0 0h24v24H0z", "key": 0 }), React.createElement("path", { "fill": "#757575", "fillRule": "nonzero", "d": "M4 15.5C4 17.43 5.57 19 7.5 19L6 20.5v.5h12v-.5L16.5 19c1.93 0 3.5-1.57 3.5-3.5V5c0-3.5-3.58-4-8-4s-8 .5-8 4v10.5zm8 1.5c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm6-7H6V5h12v5z", "key": 1 })]));
}

Train.displayName = "Train";

Train.defaultProps = { "width": "24", "height": "24" };

module.exports = Train;

Train.default = Train;

/***/ }),
/* 261 */,
/* 262 */,
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(160);

__webpack_require__(195);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(106);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactI18next = __webpack_require__(42);

var _reactHotLoader = __webpack_require__(483);

var _reactRouter = __webpack_require__(36);

var _reactRouterRedux = __webpack_require__(51);

var _registerServiceWorker = __webpack_require__(517);

var _registerServiceWorker2 = _interopRequireDefault(_registerServiceWorker);

var _i18n = __webpack_require__(22);

var _event = __webpack_require__(230);

__webpack_require__(645);

__webpack_require__(646);

var _store = __webpack_require__(647);

var _store2 = _interopRequireDefault(_store);

var _routes = __webpack_require__(673);

var _routes2 = _interopRequireDefault(_routes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// A modern alternative to CSS resets
var store = (0, _store2.default)({});
// Global css setting

var history = (0, _reactRouterRedux.syncHistoryWithStore)(_reactRouter.browserHistory, store);

var i18n = (0, _i18n.initi18next)(store);

(0, _event.addMatchMediaListener)(store);

_reactDom2.default.render(_react2.default.createElement(
	_reactHotLoader.AppContainer,
	null,
	_react2.default.createElement(
		_reactI18next.I18nextProvider,
		{ i18n: i18n },
		_react2.default.createElement(_routes2.default, { store: store, history: history })
	)
), document.getElementById('content'));

if (false) {
	module.hot.accept('./routes', function () {
		var NewRoutes = require('./routes').default; // eslint-disable-line global-require
		_reactDom2.default.render(_react2.default.createElement(
			_reactHotLoader.AppContainer,
			null,
			_react2.default.createElement(
				_reactI18next.I18nextProvider,
				{ i18n: i18n },
				_react2.default.createElement(NewRoutes, { store: store, history: history })
			)
		), document.getElementById('content'));
	});
}

(0, _registerServiceWorker2.default)();

/***/ }),
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = translate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__context__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__I18n__ = __webpack_require__(196);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







function getDisplayName(component) {
  return component.displayName || component.name || 'Component';
}

function translate(namespaces) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};


  return function Wrapper(WrappedComponent) {
    var Translate = function (_Component) {
      _inherits(Translate, _Component);

      function Translate(props, context) {
        _classCallCheck(this, Translate);

        var _this = _possibleConstructorReturn(this, (Translate.__proto__ || Object.getPrototypeOf(Translate)).call(this, props, context));

        _this.i18n = context.i18n || props.i18n || options.i18n || Object(__WEBPACK_IMPORTED_MODULE_3__context__["b" /* getI18n */])();
        namespaces = namespaces || _this.i18n.options.defaultNS;
        if (typeof namespaces === 'string') namespaces = [namespaces];

        var i18nOptions = _this.i18n && _this.i18n.options.react || {};
        _this.options = _extends({}, Object(__WEBPACK_IMPORTED_MODULE_3__context__["a" /* getDefaults */])(), i18nOptions, options);

        _this.getWrappedInstance = _this.getWrappedInstance.bind(_this);
        return _this;
      }

      _createClass(Translate, [{
        key: 'getWrappedInstance',
        value: function getWrappedInstance() {
          if (!this.options.withRef) {
            // eslint-disable-next-line no-console
            console.error('To access the wrapped instance, you need to specify ' + '{ withRef: true } as the second argument of the translate() call.');
          }

          /* eslint react/no-string-refs: 1 */
          return this.wrappedInstance;
        }
      }, {
        key: 'render',
        value: function render() {
          var _this2 = this;

          var extraProps = {};

          if (this.options.withRef) {
            extraProps.ref = function (c) {
              _this2.wrappedInstance = c;
            };
          }

          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__I18n__["a" /* default */], _extends({ ns: namespaces }, this.options, this.props, { i18n: this.i18n }), function (t, context) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, _extends({}, _this2.props, extraProps, context));
          });
        }
      }]);

      return Translate;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    Translate.WrappedComponent = WrappedComponent;

    Translate.contextTypes = {
      i18n: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
    };

    Translate.displayName = 'Translate(' + getDisplayName(WrappedComponent) + ')';

    Translate.namespaces = namespaces;

    return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(Translate, WrappedComponent);
  };
}

translate.setDefaults = __WEBPACK_IMPORTED_MODULE_3__context__["d" /* setDefaults */];

translate.setI18n = __WEBPACK_IMPORTED_MODULE_3__context__["e" /* setI18n */];

/***/ }),
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var Interpolate = function (_PureComponent) {
  _inherits(Interpolate, _PureComponent);

  function Interpolate(props, context) {
    _classCallCheck(this, Interpolate);

    var _this = _possibleConstructorReturn(this, (Interpolate.__proto__ || Object.getPrototypeOf(Interpolate)).call(this, props, context));

    _this.i18n = props.i18n || context.i18n;
    _this.t = props.t || context.t;
    return _this;
  }

  _createClass(Interpolate, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var parent = this.props.parent || 'span';
      var REGEXP = this.props.regexp || this.i18n.services.interpolator.regexp;
      var _props = this.props,
          className = _props.className,
          style = _props.style;

      // Set to true if you want to use raw HTML in translation values
      // See https://github.com/i18next/react-i18next/issues/189

      var useDangerouslySetInnerHTML = this.props.useDangerouslySetInnerHTML || false;
      var dangerouslySetInnerHTMLPartElement = this.props.dangerouslySetInnerHTMLPartElement || 'span';

      var tOpts = _extends({}, this.props.options, { interpolation: { prefix: '#$?', suffix: '?$#' } });
      var format = this.t(this.props.i18nKey, tOpts);

      if (!format || typeof format !== 'string') return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('noscript', null);

      var children = [];

      var handleFormat = function handleFormat(key, props) {
        if (key.indexOf(_this2.i18n.options.interpolation.formatSeparator) < 0) {
          if (props[key] === undefined) _this2.i18n.services.logger.warn('interpolator: missed to pass in variable ' + key + ' for interpolating ' + format);
          return props[key];
        }

        var p = key.split(_this2.i18n.options.interpolation.formatSeparator);
        var k = p.shift().trim();
        var f = p.join(_this2.i18n.options.interpolation.formatSeparator).trim();

        if (props[k] === undefined) _this2.i18n.services.logger.warn('interpolator: missed to pass in variable ' + k + ' for interpolating ' + format);
        return _this2.i18n.options.interpolation.format(props[k], f, _this2.i18n.language);
      };

      format.split(REGEXP).reduce(function (memo, match, index) {
        var child = void 0;

        if (index % 2 === 0) {
          if (match.length === 0) return memo;
          if (useDangerouslySetInnerHTML) {
            child = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(dangerouslySetInnerHTMLPartElement, { dangerouslySetInnerHTML: { __html: match } });
          } else {
            child = match;
          }
        } else {
          child = handleFormat(match, _this2.props);
        }

        memo.push(child);
        return memo;
      }, children);

      var additionalProps = {};
      if (this.i18n.options.react && this.i18n.options.react.exposeNamespace) {
        var ns = typeof this.t.ns === 'string' ? this.t.ns : this.t.ns[0];
        if (this.props.i18nKey && this.i18n.options.nsSeparator && this.props.i18nKey.indexOf(this.i18n.options.nsSeparator) > -1) {
          var parts = this.props.i18nKey.split(this.i18n.options.nsSeparator);
          ns = parts[0];
        }
        if (this.t.ns) additionalProps['data-i18next-options'] = JSON.stringify({ ns: ns });
      }

      if (className) additionalProps.className = className;
      if (style) additionalProps.style = style;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement.apply(this, [parent, additionalProps].concat(children));
    }
  }]);

  return Interpolate;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

Interpolate.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

Interpolate.defaultProps = {
  className: ''
};

Interpolate.contextTypes = {
  i18n: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (Interpolate);

/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_html_parse_stringify2__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_html_parse_stringify2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_html_parse_stringify2__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





function hasChildren(node) {
  return node && (node.children || node.props && node.props.children);
}

function getChildren(node) {
  return node && node.children ? node.children : node.props && node.props.children;
}

function nodesToString(mem, children, index) {
  if (Object.prototype.toString.call(children) !== '[object Array]') children = [children];

  children.forEach(function (child, i) {
    // const isElement = React.isValidElement(child);
    // const elementKey = `${index !== 0 ? index + '-' : ''}${i}:${typeof child.type === 'function' ? child.type.name : child.type || 'var'}`;
    var elementKey = '' + i;

    if (typeof child === 'string') {
      mem = '' + mem + child;
    } else if (hasChildren(child)) {
      mem = mem + '<' + elementKey + '>' + nodesToString('', getChildren(child), i + 1) + '</' + elementKey + '>';
    } else if (__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child)) {
      mem = mem + '<' + elementKey + '></' + elementKey + '>';
    } else if ((typeof child === 'undefined' ? 'undefined' : _typeof(child)) === 'object') {
      var clone = _extends({}, child);
      var format = clone.format;
      delete clone.format;

      var keys = Object.keys(clone);
      if (format && keys.length === 1) {
        mem = mem + '<' + elementKey + '>{{' + keys[0] + ', ' + format + '}}</' + elementKey + '>';
      } else if (keys.length === 1) {
        mem = mem + '<' + elementKey + '>{{' + keys[0] + '}}</' + elementKey + '>';
      } else if (console && console.warn) {
        // not a valid interpolation object (can only contain one value plus format)
        console.warn('react-i18next: the passed in object contained more than one variable - the object should look like {{ value, format }} where format is optional.', child);
      }
    } else if (console && console.warn) {
      console.warn('react-i18next: the passed in value is invalid - seems you passed in a variable like {number} - please pass in variables for interpolation as full objects like {{number}}.', child);
    }
  });

  return mem;
}

function renderNodes(children, targetString, i18n) {

  // parse ast from string with additional wrapper tag
  // -> avoids issues in parser removing prepending text nodes
  var ast = __WEBPACK_IMPORTED_MODULE_2_html_parse_stringify2___default.a.parse('<0>' + targetString + '</0>');

  function mapAST(reactNodes, astNodes) {
    if (Object.prototype.toString.call(reactNodes) !== '[object Array]') reactNodes = [reactNodes];
    if (Object.prototype.toString.call(astNodes) !== '[object Array]') astNodes = [astNodes];

    return astNodes.reduce(function (mem, node, i) {
      if (node.type === 'tag') {
        var child = reactNodes[parseInt(node.name, 10)] || {};
        var isElement = __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child);

        if (typeof child === 'string') {
          mem.push(child);
        } else if (hasChildren(child)) {
          var inner = mapAST(getChildren(child), node.children);
          if (child.dummy) child.children = inner; // needed on preact!
          mem.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, _extends({}, child.props, { key: i }), inner));
        } else if ((typeof child === 'undefined' ? 'undefined' : _typeof(child)) === 'object' && !isElement) {
          var interpolated = i18n.services.interpolator.interpolate(node.children[0].content, child, i18n.language);
          mem.push(interpolated);
        } else {
          mem.push(child);
        }
      } else if (node.type === 'text') {
        mem.push(node.content);
      }
      return mem;
    }, []);
  }

  // call mapAST with having react nodes nested into additional node like
  // we did for the string ast from translation
  // return the children of that extra node to get expected result
  var result = mapAST([{ dummy: true, children: children }], ast);
  return getChildren(result[0]);
}

var Trans = function (_React$Component) {
  _inherits(Trans, _React$Component);

  function Trans() {
    _classCallCheck(this, Trans);

    return _possibleConstructorReturn(this, (Trans.__proto__ || Object.getPrototypeOf(Trans)).apply(this, arguments));
  }

  _createClass(Trans, [{
    key: 'render',
    value: function render() {
      var contextAndProps = _extends({ i18n: this.context.i18n, t: this.context.t }, this.props);

      var children = contextAndProps.children,
          count = contextAndProps.count,
          parent = contextAndProps.parent,
          i18nKey = contextAndProps.i18nKey,
          i18n = contextAndProps.i18n,
          t = contextAndProps.t,
          additionalProps = _objectWithoutProperties(contextAndProps, ['children', 'count', 'parent', 'i18nKey', 'i18n', 't']);

      var reactI18nextOptions = i18n.options && i18n.options.react || {};
      var useAsParent = parent !== undefined ? parent : reactI18nextOptions.defaultTransParent;

      var defaultValue = nodesToString('', children, 0);
      var hashTransKey = reactI18nextOptions.hashTransKey;
      var key = i18nKey || (hashTransKey ? hashTransKey(defaultValue) : defaultValue);
      var translation = key ? t(key, { interpolation: { prefix: '#$?', suffix: '?$#' }, defaultValue: defaultValue, count: count }) : defaultValue;

      if (reactI18nextOptions.exposeNamespace) {
        var ns = typeof t.ns === 'string' ? t.ns : t.ns[0];
        if (i18nKey && i18n.options.nsSeparator && i18nKey.indexOf(i18n.options.nsSeparator) > -1) {
          var parts = i18nKey.split(i18n.options.nsSeparator);
          ns = parts[0];
        }
        if (t.ns) additionalProps['data-i18next-options'] = JSON.stringify({ ns: ns });
      }

      if (!useAsParent) return renderNodes(children, translation, i18n);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(useAsParent, additionalProps, renderNodes(children, translation, i18n));
    }
  }]);

  return Trans;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Trans);


Trans.propTypes = {
  count: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  parent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  i18nKey: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  i18n: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

// Trans.defaultProps = {
//   parent: 'div'
// };

Trans.contextTypes = {
  i18n: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
    parse: __webpack_require__(477),
    stringify: __webpack_require__(480)
};


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

/*jshint -W030 */
var tagRE = /(?:<!--[\S\s]*?-->|<(?:"[^"]*"['"]*|'[^']*'['"]*|[^'">])+>)/g;
var parseTag = __webpack_require__(478);
// re-used obj for quick lookups of components
var empty = Object.create ? Object.create(null) : {};
// common logic for pushing a child node onto a list
function pushTextNode(list, html, level, start, ignoreWhitespace) {
    // calculate correct end of the content slice in case there's
    // no tag after the text node.
    var end = html.indexOf('<', start);
    var content = html.slice(start, end === -1 ? undefined : end);
    // if a node is nothing but whitespace, collapse it as the spec states:
    // https://www.w3.org/TR/html4/struct/text.html#h-9.1
    if (/^\s*$/.test(content)) {
        content = ' ';
    }
    // don't add whitespace-only text nodes if they would be trailing text nodes
    // or if they would be leading whitespace-only text nodes:
    //  * end > -1 indicates this is not a trailing text node
    //  * leading node is when level is -1 and list has length 0
    if ((!ignoreWhitespace && end > -1 && level + list.length >= 0) || content !== ' ') {
        list.push({
            type: 'text',
            content: content
        });
    }
}

module.exports = function parse(html, options) {
    options || (options = {});
    options.components || (options.components = empty);
    var result = [];
    var current;
    var level = -1;
    var arr = [];
    var byTag = {};
    var inComponent = false;

    html.replace(tagRE, function (tag, index) {
        if (inComponent) {
            if (tag !== ('</' + current.name + '>')) {
                return;
            } else {
                inComponent = false;
            }
        }

        var isOpen = tag.charAt(1) !== '/';
        var isComment = tag.indexOf('<!--') === 0;
        var start = index + tag.length;
        var nextChar = html.charAt(start);
        var parent;

        if (isOpen && !isComment) {
            level++;

            current = parseTag(tag);
            if (current.type === 'tag' && options.components[current.name]) {
                current.type = 'component';
                inComponent = true;
            }

            if (!current.voidElement && !inComponent && nextChar && nextChar !== '<') {
                pushTextNode(current.children, html, level, start, options.ignoreWhitespace);
            }

            byTag[current.tagName] = current;

            // if we're at root, push new base node
            if (level === 0) {
                result.push(current);
            }

            parent = arr[level - 1];

            if (parent) {
                parent.children.push(current);
            }

            arr[level] = current;
        }

        if (isComment || !isOpen || current.voidElement) {
            if (!isComment) {
                level--;
            }
            if (!inComponent && nextChar !== '<' && nextChar) {
                // trailing text node
                // if we're at the root, push a base text node. otherwise add as
                // a child to the current node.
                parent = level === -1 ? result : arr[level].children;
                pushTextNode(parent, html, level, start, options.ignoreWhitespace);
            }
        }
    });

    // If the "html" passed isn't actually html, add it as a text node.
    if (!result.length && html.length) {
        pushTextNode(result, html, 0, 0, options.ignoreWhitespace);
    }

    return result;
};


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

var attrRE = /([\w-]+)|=|(['"])([.\s\S]*?)\2/g;
var voidElements = __webpack_require__(479);

module.exports = function (tag) {
    var i = 0;
    var key;
    var expectingValueAfterEquals = true;
    var res = {
        type: 'tag',
        name: '',
        voidElement: false,
        attrs: {},
        children: []
    };

    tag.replace(attrRE, function (match) {
        if (match === '=') {
            expectingValueAfterEquals = true;
            i++;
            return;
        }

        if (!expectingValueAfterEquals) {
            if (key) {
                res.attrs[key] = key; // boolean attribute
            }
            key=match;
        } else {
            if (i === 0) {
                if (voidElements[match] || tag.charAt(tag.length - 2) === '/') {
                    res.voidElement = true;
                }
                res.name = match;
            } else {
                res.attrs[key] = match.replace(/^['"]|['"]$/g, '');
                key=undefined;
            }
        }
        i++;
        expectingValueAfterEquals = false;
    });

    return res;
};


/***/ }),
/* 479 */
/***/ (function(module, exports) {

/**
 * This file automatically generated from `pre-publish.js`.
 * Do not manually edit.
 */

module.exports = {
  "area": true,
  "base": true,
  "br": true,
  "col": true,
  "embed": true,
  "hr": true,
  "img": true,
  "input": true,
  "keygen": true,
  "link": true,
  "menuitem": true,
  "meta": true,
  "param": true,
  "source": true,
  "track": true,
  "wbr": true
};


/***/ }),
/* 480 */
/***/ (function(module, exports) {

function attrString(attrs) {
    var buff = [];
    for (var key in attrs) {
        buff.push(key + '="' + attrs[key] + '"');
    }
    if (!buff.length) {
        return '';
    }
    return ' ' + buff.join(' ');
}

function stringify(buff, doc) {
    switch (doc.type) {
    case 'text':
        return buff + doc.content;
    case 'tag':
        buff += '<' + doc.name + (doc.attrs ? attrString(doc.attrs) : '') + (doc.voidElement ? '/>' : '>');
        if (doc.voidElement) {
            return buff;
        }
        return buff + doc.children.reduce(stringify, '') + '</' + doc.name + '>';
    }
}

module.exports = function (doc) {
    return doc.reduce(function (token, rootEl) {
        return token + stringify('', rootEl);
    }, '');
};


/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var I18nextProvider = function (_Component) {
  _inherits(I18nextProvider, _Component);

  function I18nextProvider(props, context) {
    _classCallCheck(this, I18nextProvider);

    var _this = _possibleConstructorReturn(this, (I18nextProvider.__proto__ || Object.getPrototypeOf(I18nextProvider)).call(this, props, context));

    _this.i18n = props.i18n;
    if (props.initialI18nStore) {
      _this.i18n.services.resourceStore.data = props.initialI18nStore;
      _this.i18n.options.isInitialSSR = true; // if set will be deleted on first render in translate hoc
    }
    if (props.initialLanguage) {
      _this.i18n.changeLanguage(props.initialLanguage);
    }
    return _this;
  }

  _createClass(I18nextProvider, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return { i18n: this.i18n };
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.i18n !== nextProps.i18n) {
        throw new Error('[react-i18next][I18nextProvider]does not support changing the i18n object.');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;

      return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(children);
    }
  }]);

  return I18nextProvider;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

I18nextProvider.propTypes = {
  i18n: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element.isRequired
};

I18nextProvider.childContextTypes = {
  i18n: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (I18nextProvider);

/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = loadNamespaces;
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

// shim object entries
if (!Object.entries) Object.entries = function (obj) {
  var ownProps = Object.keys(obj),
      i = ownProps.length,
      resArray = new Array(i); // preallocate the Array
  while (i--) {
    resArray[i] = [ownProps[i], obj[ownProps[i]]];
  }return resArray;
};

// Borrowed from https://github.com/Rezonans/redux-async-connect/blob/master/modules/ReduxAsyncConnect.js#L16
function eachComponents(components, iterator) {
  for (var i = 0, l = components.length; i < l; i++) {
    // eslint-disable-line id-length
    if (_typeof(components[i]) === 'object') {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = Object.entries(components[i])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _step$value = _slicedToArray(_step.value, 2),
              key = _step$value[0],
              value = _step$value[1];

          iterator(value, i, key);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    } else {
      iterator(components[i], i);
    }
  }
}

function filterAndFlattenComponents(components) {
  var flattened = [];
  eachComponents(components, function (Component) {
    if (Component && Component.namespaces) {

      Component.namespaces.forEach(function (namespace) {
        if (flattened.indexOf(namespace) === -1) {
          flattened.push(namespace);
        }
      });
    }
  });
  return flattened;
}

function loadNamespaces(_ref) {
  var components = _ref.components,
      i18n = _ref.i18n;

  var allNamespaces = filterAndFlattenComponents(components);

  return new Promise(function (resolve) {
    i18n.loadNamespaces(allNamespaces, resolve);
  });
}

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(484)


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable global-require */

if (true) {
  module.exports = __webpack_require__(485);
} else {
  module.exports = require('./index.dev');
}

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports.AppContainer = __webpack_require__(486);

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable global-require */

if (true) {
  module.exports = __webpack_require__(487);
} else {
  module.exports = require('./AppContainer.dev');
}

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable react/prop-types */

var React = __webpack_require__(1);

var Component = React.Component;

var AppContainer = function (_Component) {
  _inherits(AppContainer, _Component);

  function AppContainer() {
    _classCallCheck(this, AppContainer);

    return _possibleConstructorReturn(this, (AppContainer.__proto__ || Object.getPrototypeOf(AppContainer)).apply(this, arguments));
  }

  _createClass(AppContainer, [{
    key: 'render',
    value: function render() {
      if (this.props.component) {
        return React.createElement(this.props.component, this.props.props);
      }

      return React.Children.only(this.props.children);
    }
  }]);

  return AppContainer;
}(Component);

module.exports = AppContainer;

/***/ }),
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = register;
exports.unregister = unregister;
// In production, we register a service worker to serve assets from local cache.

// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on the "N+1" visit to a page, since previously
// cached resources are updated in the background.

// To learn more about the benefits of this model, read https://goo.gl/KwvDNy.
// This link also includes instructions on opting out of this behavior.

function register() {
	// Register the service worker
	if ('serviceWorker' in navigator) {
		window.addEventListener('load', function () {
			var swUrl = 'service-worker.js';
			navigator.serviceWorker.register(swUrl).then(function (registration) {
				/* eslint-disable no-param-reassign */
				registration.onupdatefound = function () {
					var installingWorker = registration.installing;
					installingWorker.onstatechange = function () {
						if (installingWorker.state === 'installed') {
							if (navigator.serviceWorker.controller) {
								// At this point, the old content will have been purged and
								// the fresh content will have been added to the cache.
								// It's the perfect time to display a "New content is
								// available; please refresh." message in your web app.
								console.log('New content is available; please refresh.');
							} else {
								// At this point, everything has been precached.
								// It's the perfect time to display a
								// "Content is cached for offline use." message.
								console.log('Content is cached for offline use.');
							}
						}
					};
				};
			}).catch(function (error) {
				console.error('Error during service worker registration:', error);
			});
		});
	}
}

function unregister() {
	if ('serviceWorker' in navigator) {
		navigator.serviceWorker.ready.then(function (registration) {
			registration.unregister();
		});
	}
}

/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "changeLanguage", function() { return changeLanguage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cloneInstance", function() { return cloneInstance; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createInstance", function() { return createInstance; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "dir", function() { return dir; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exists", function() { return exists; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFixedT", function() { return getFixedT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "init", function() { return init; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadLanguages", function() { return loadLanguages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadNamespaces", function() { return loadNamespaces; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadResources", function() { return loadResources; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "off", function() { return off; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "on", function() { return on; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setDefaultNamespace", function() { return setDefaultNamespace; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return t; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "use", function() { return use; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__i18next_js__ = __webpack_require__(519);


/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);

var changeLanguage = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].changeLanguage.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var cloneInstance = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].cloneInstance.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var createInstance = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].createInstance.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var dir = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].dir.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var exists = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].exists.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var getFixedT = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].getFixedT.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var init = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].init.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var loadLanguages = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].loadLanguages.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var loadNamespaces = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].loadNamespaces.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var loadResources = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].loadResources.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var off = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].off.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var on = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].on.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var setDefaultNamespace = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].setDefaultNamespace.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var t = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].t.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var use = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].use.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);

/***/ }),
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__logger_js__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EventEmitter_js__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ResourceStore_js__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Translator_js__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LanguageUtils_js__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PluralResolver_js__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Interpolator_js__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__BackendConnector_js__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CacheConnector_js__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__defaults_js__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__postProcessor_js__ = __webpack_require__(211);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }













function noop() {}

var I18n = function (_EventEmitter) {
  _inherits(I18n, _EventEmitter);

  function I18n() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments[1];

    _classCallCheck(this, I18n);

    var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));

    _this.options = Object(__WEBPACK_IMPORTED_MODULE_9__defaults_js__["b" /* transformOptions */])(options);
    _this.services = {};
    _this.logger = __WEBPACK_IMPORTED_MODULE_0__logger_js__["a" /* default */];
    _this.modules = { external: [] };

    if (callback && !_this.isInitialized && !options.isClone) {
      var _ret;

      // https://github.com/i18next/i18next/issues/879
      if (!_this.options.initImmediate) return _ret = _this.init(options, callback), _possibleConstructorReturn(_this, _ret);
      setTimeout(function () {
        _this.init(options, callback);
      }, 0);
    }
    return _this;
  }

  I18n.prototype.init = function init() {
    var _this2 = this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments[1];

    if (typeof options === 'function') {
      callback = options;
      options = {};
    }
    this.options = _extends({}, Object(__WEBPACK_IMPORTED_MODULE_9__defaults_js__["a" /* get */])(), this.options, Object(__WEBPACK_IMPORTED_MODULE_9__defaults_js__["b" /* transformOptions */])(options));

    this.format = this.options.interpolation.format;
    if (!callback) callback = noop;

    function createClassOnDemand(ClassOrObject) {
      if (!ClassOrObject) return null;
      if (typeof ClassOrObject === 'function') return new ClassOrObject();
      return ClassOrObject;
    }

    // init services
    if (!this.options.isClone) {
      if (this.modules.logger) {
        __WEBPACK_IMPORTED_MODULE_0__logger_js__["a" /* default */].init(createClassOnDemand(this.modules.logger), this.options);
      } else {
        __WEBPACK_IMPORTED_MODULE_0__logger_js__["a" /* default */].init(null, this.options);
      }

      var lu = new __WEBPACK_IMPORTED_MODULE_4__LanguageUtils_js__["a" /* default */](this.options);
      this.store = new __WEBPACK_IMPORTED_MODULE_2__ResourceStore_js__["a" /* default */](this.options.resources, this.options);

      var s = this.services;
      s.logger = __WEBPACK_IMPORTED_MODULE_0__logger_js__["a" /* default */];
      s.resourceStore = this.store;
      s.resourceStore.on('added removed', function (lng, ns) {
        s.cacheConnector.save();
      });
      s.languageUtils = lu;
      s.pluralResolver = new __WEBPACK_IMPORTED_MODULE_5__PluralResolver_js__["a" /* default */](lu, { prepend: this.options.pluralSeparator, compatibilityJSON: this.options.compatibilityJSON, simplifyPluralSuffix: this.options.simplifyPluralSuffix });
      s.interpolator = new __WEBPACK_IMPORTED_MODULE_6__Interpolator_js__["a" /* default */](this.options);

      s.backendConnector = new __WEBPACK_IMPORTED_MODULE_7__BackendConnector_js__["a" /* default */](createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
      // pipe events from backendConnector
      s.backendConnector.on('*', function (event) {
        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        _this2.emit.apply(_this2, [event].concat(args));
      });

      s.backendConnector.on('loaded', function (loaded) {
        s.cacheConnector.save();
      });

      s.cacheConnector = new __WEBPACK_IMPORTED_MODULE_8__CacheConnector_js__["a" /* default */](createClassOnDemand(this.modules.cache), s.resourceStore, s, this.options);
      // pipe events from backendConnector
      s.cacheConnector.on('*', function (event) {
        for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          args[_key2 - 1] = arguments[_key2];
        }

        _this2.emit.apply(_this2, [event].concat(args));
      });

      if (this.modules.languageDetector) {
        s.languageDetector = createClassOnDemand(this.modules.languageDetector);
        s.languageDetector.init(s, this.options.detection, this.options);
      }

      this.translator = new __WEBPACK_IMPORTED_MODULE_3__Translator_js__["a" /* default */](this.services, this.options);
      // pipe events from translator
      this.translator.on('*', function (event) {
        for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
          args[_key3 - 1] = arguments[_key3];
        }

        _this2.emit.apply(_this2, [event].concat(args));
      });

      this.modules.external.forEach(function (m) {
        if (m.init) m.init(_this2);
      });
    }

    // append api
    var storeApi = ['getResource', 'addResource', 'addResources', 'addResourceBundle', 'removeResourceBundle', 'hasResourceBundle', 'getResourceBundle'];
    storeApi.forEach(function (fcName) {
      _this2[fcName] = function () {
        var _store;

        return (_store = _this2.store)[fcName].apply(_store, arguments);
      };
    });

    var load = function load() {
      _this2.changeLanguage(_this2.options.lng, function (err, t) {
        _this2.isInitialized = true;
        _this2.logger.log('initialized', _this2.options);
        _this2.emit('initialized', _this2.options);

        callback(err, t);
      });
    };

    if (this.options.resources || !this.options.initImmediate) {
      load();
    } else {
      setTimeout(load, 0);
    }

    return this;
  };

  /* eslint consistent-return: 0 */


  I18n.prototype.loadResources = function loadResources() {
    var _this3 = this;

    var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : noop;

    if (!this.options.resources) {
      if (this.language && this.language.toLowerCase() === 'cimode') return callback(); // avoid loading resources for cimode

      var toLoad = [];

      var append = function append(lng) {
        if (!lng) return;
        var lngs = _this3.services.languageUtils.toResolveHierarchy(lng);
        lngs.forEach(function (l) {
          if (toLoad.indexOf(l) < 0) toLoad.push(l);
        });
      };

      if (!this.language) {
        // at least load fallbacks in this case
        var fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
        fallbacks.forEach(function (l) {
          return append(l);
        });
      } else {
        append(this.language);
      }

      if (this.options.preload) {
        this.options.preload.forEach(function (l) {
          return append(l);
        });
      }

      this.services.cacheConnector.load(toLoad, this.options.ns, function () {
        _this3.services.backendConnector.load(toLoad, _this3.options.ns, callback);
      });
    } else {
      callback(null);
    }
  };

  I18n.prototype.reloadResources = function reloadResources(lngs, ns) {
    if (!lngs) lngs = this.languages;
    if (!ns) ns = this.options.ns;
    this.services.backendConnector.reload(lngs, ns);
  };

  I18n.prototype.use = function use(module) {
    if (module.type === 'backend') {
      this.modules.backend = module;
    }

    if (module.type === 'cache') {
      this.modules.cache = module;
    }

    if (module.type === 'logger' || module.log && module.warn && module.error) {
      this.modules.logger = module;
    }

    if (module.type === 'languageDetector') {
      this.modules.languageDetector = module;
    }

    if (module.type === 'postProcessor') {
      __WEBPACK_IMPORTED_MODULE_10__postProcessor_js__["a" /* default */].addPostProcessor(module);
    }

    if (module.type === '3rdParty') {
      this.modules.external.push(module);
    }

    return this;
  };

  I18n.prototype.changeLanguage = function changeLanguage(lng, callback) {
    var _this4 = this;

    var done = function done(err, l) {
      _this4.translator.changeLanguage(l);

      if (l) {
        _this4.emit('languageChanged', l);
        _this4.logger.log('languageChanged', l);
      }

      if (callback) callback(err, function () {
        return _this4.t.apply(_this4, arguments);
      });
    };

    var setLng = function setLng(l) {
      if (l) {
        _this4.language = l;
        _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);
        if (!_this4.translator.language) _this4.translator.changeLanguage(l);

        if (_this4.services.languageDetector) _this4.services.languageDetector.cacheUserLanguage(l);
      }

      _this4.loadResources(function (err) {
        done(err, l);
      });
    };

    if (!lng && this.services.languageDetector && !this.services.languageDetector.async) {
      setLng(this.services.languageDetector.detect());
    } else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
      this.services.languageDetector.detect(setLng);
    } else {
      setLng(lng);
    }
  };

  I18n.prototype.getFixedT = function getFixedT(lng, ns) {
    var _this5 = this;

    var fixedT = function fixedT(key, opts) {
      for (var _len4 = arguments.length, rest = Array(_len4 > 2 ? _len4 - 2 : 0), _key4 = 2; _key4 < _len4; _key4++) {
        rest[_key4 - 2] = arguments[_key4];
      }

      var options = _extends({}, opts);
      if ((typeof opts === 'undefined' ? 'undefined' : _typeof(opts)) !== 'object') {
        options = _this5.options.overloadTranslationOptionHandler([key, opts].concat(rest));
      }

      options.lng = options.lng || fixedT.lng;
      options.lngs = options.lngs || fixedT.lngs;
      options.ns = options.ns || fixedT.ns;
      return _this5.t(key, options);
    };
    if (typeof lng === 'string') {
      fixedT.lng = lng;
    } else {
      fixedT.lngs = lng;
    }
    fixedT.ns = ns;
    return fixedT;
  };

  I18n.prototype.t = function t() {
    var _translator;

    return this.translator && (_translator = this.translator).translate.apply(_translator, arguments);
  };

  I18n.prototype.exists = function exists() {
    var _translator2;

    return this.translator && (_translator2 = this.translator).exists.apply(_translator2, arguments);
  };

  I18n.prototype.setDefaultNamespace = function setDefaultNamespace(ns) {
    this.options.defaultNS = ns;
  };

  I18n.prototype.loadNamespaces = function loadNamespaces(ns, callback) {
    var _this6 = this;

    if (!this.options.ns) return callback && callback();
    if (typeof ns === 'string') ns = [ns];

    ns.forEach(function (n) {
      if (_this6.options.ns.indexOf(n) < 0) _this6.options.ns.push(n);
    });

    this.loadResources(callback);
  };

  I18n.prototype.loadLanguages = function loadLanguages(lngs, callback) {
    if (typeof lngs === 'string') lngs = [lngs];
    var preloaded = this.options.preload || [];

    var newLngs = lngs.filter(function (lng) {
      return preloaded.indexOf(lng) < 0;
    });
    // Exit early if all given languages are already preloaded
    if (!newLngs.length) return callback();

    this.options.preload = preloaded.concat(newLngs);
    this.loadResources(callback);
  };

  I18n.prototype.dir = function dir(lng) {
    if (!lng) lng = this.languages && this.languages.length > 0 ? this.languages[0] : this.language;
    if (!lng) return 'rtl';

    var rtlLngs = ['ar', 'shu', 'sqr', 'ssh', 'xaa', 'yhd', 'yud', 'aao', 'abh', 'abv', 'acm', 'acq', 'acw', 'acx', 'acy', 'adf', 'ads', 'aeb', 'aec', 'afb', 'ajp', 'apc', 'apd', 'arb', 'arq', 'ars', 'ary', 'arz', 'auz', 'avl', 'ayh', 'ayl', 'ayn', 'ayp', 'bbz', 'pga', 'he', 'iw', 'ps', 'pbt', 'pbu', 'pst', 'prp', 'prd', 'ur', 'ydd', 'yds', 'yih', 'ji', 'yi', 'hbo', 'men', 'xmn', 'fa', 'jpr', 'peo', 'pes', 'prs', 'dv', 'sam'];

    return rtlLngs.indexOf(this.services.languageUtils.getLanguagePartFromCode(lng)) >= 0 ? 'rtl' : 'ltr';
  };

  /* eslint class-methods-use-this: 0 */


  I18n.prototype.createInstance = function createInstance() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments[1];

    return new I18n(options, callback);
  };

  I18n.prototype.cloneInstance = function cloneInstance() {
    var _this7 = this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;

    var mergedOptions = _extends({}, this.options, options, { isClone: true });
    var clone = new I18n(mergedOptions);
    var membersToCopy = ['store', 'services', 'language'];
    membersToCopy.forEach(function (m) {
      clone[m] = _this7[m];
    });
    clone.translator = new __WEBPACK_IMPORTED_MODULE_3__Translator_js__["a" /* default */](clone.services, clone.options);
    clone.translator.on('*', function (event) {
      for (var _len5 = arguments.length, args = Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
        args[_key5 - 1] = arguments[_key5];
      }

      clone.emit.apply(clone, [event].concat(args));
    });
    clone.init(mergedOptions, callback);
    clone.translator.options = clone.options; // sync options

    return clone;
  };

  return I18n;
}(__WEBPACK_IMPORTED_MODULE_1__EventEmitter_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new I18n());

/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EventEmitter_js__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_js__ = __webpack_require__(102);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }




var ResourceStore = function (_EventEmitter) {
  _inherits(ResourceStore, _EventEmitter);

  function ResourceStore(data) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { ns: ['translation'], defaultNS: 'translation' };

    _classCallCheck(this, ResourceStore);

    var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));

    _this.data = data || {};
    _this.options = options;
    return _this;
  }

  ResourceStore.prototype.addNamespaces = function addNamespaces(ns) {
    if (this.options.ns.indexOf(ns) < 0) {
      this.options.ns.push(ns);
    }
  };

  ResourceStore.prototype.removeNamespaces = function removeNamespaces(ns) {
    var index = this.options.ns.indexOf(ns);
    if (index > -1) {
      this.options.ns.splice(index, 1);
    }
  };

  ResourceStore.prototype.getResource = function getResource(lng, ns, key) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    var keySeparator = options.keySeparator || this.options.keySeparator;
    if (keySeparator === undefined) keySeparator = '.';

    var path = [lng, ns];
    if (key && typeof key !== 'string') path = path.concat(key);
    if (key && typeof key === 'string') path = path.concat(keySeparator ? key.split(keySeparator) : key);

    if (lng.indexOf('.') > -1) {
      path = lng.split('.');
    }

    return __WEBPACK_IMPORTED_MODULE_1__utils_js__["d" /* getPath */](this.data, path);
  };

  ResourceStore.prototype.addResource = function addResource(lng, ns, key, value) {
    var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : { silent: false };

    var keySeparator = this.options.keySeparator;
    if (keySeparator === undefined) keySeparator = '.';

    var path = [lng, ns];
    if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);

    if (lng.indexOf('.') > -1) {
      path = lng.split('.');
      value = ns;
      ns = path[1];
    }

    this.addNamespaces(ns);

    __WEBPACK_IMPORTED_MODULE_1__utils_js__["h" /* setPath */](this.data, path, value);

    if (!options.silent) this.emit('added', lng, ns, key, value);
  };

  ResourceStore.prototype.addResources = function addResources(lng, ns, resources) {
    /* eslint no-restricted-syntax: 0 */
    for (var m in resources) {
      if (typeof resources[m] === 'string') this.addResource(lng, ns, m, resources[m], { silent: true });
    }
    this.emit('added', lng, ns, resources);
  };

  ResourceStore.prototype.addResourceBundle = function addResourceBundle(lng, ns, resources, deep, overwrite) {
    var path = [lng, ns];
    if (lng.indexOf('.') > -1) {
      path = lng.split('.');
      deep = resources;
      resources = ns;
      ns = path[1];
    }

    this.addNamespaces(ns);

    var pack = __WEBPACK_IMPORTED_MODULE_1__utils_js__["d" /* getPath */](this.data, path) || {};

    if (deep) {
      __WEBPACK_IMPORTED_MODULE_1__utils_js__["b" /* deepExtend */](pack, resources, overwrite);
    } else {
      pack = _extends({}, pack, resources);
    }

    __WEBPACK_IMPORTED_MODULE_1__utils_js__["h" /* setPath */](this.data, path, pack);

    this.emit('added', lng, ns, resources);
  };

  ResourceStore.prototype.removeResourceBundle = function removeResourceBundle(lng, ns) {
    if (this.hasResourceBundle(lng, ns)) {
      delete this.data[lng][ns];
    }
    this.removeNamespaces(ns);

    this.emit('removed', lng, ns);
  };

  ResourceStore.prototype.hasResourceBundle = function hasResourceBundle(lng, ns) {
    return this.getResource(lng, ns) !== undefined;
  };

  ResourceStore.prototype.getResourceBundle = function getResourceBundle(lng, ns) {
    if (!ns) ns = this.options.defaultNS;

    // COMPATIBILITY: remove extend in v2.1.0
    if (this.options.compatibilityAPI === 'v1') return _extends({}, this.getResource(lng, ns));

    return this.getResource(lng, ns);
  };

  ResourceStore.prototype.toJSON = function toJSON() {
    return this.data;
  };

  return ResourceStore;
}(__WEBPACK_IMPORTED_MODULE_0__EventEmitter_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (ResourceStore);

/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__logger_js__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EventEmitter_js__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__postProcessor_js__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_js__ = __webpack_require__(102);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }






var Translator = function (_EventEmitter) {
  _inherits(Translator, _EventEmitter);

  function Translator(services) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Translator);

    var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));

    __WEBPACK_IMPORTED_MODULE_3__utils_js__["a" /* copy */](['resourceStore', 'languageUtils', 'pluralResolver', 'interpolator', 'backendConnector'], services, _this);

    _this.options = options;
    _this.logger = __WEBPACK_IMPORTED_MODULE_0__logger_js__["a" /* default */].create('translator');
    return _this;
  }

  Translator.prototype.changeLanguage = function changeLanguage(lng) {
    if (lng) this.language = lng;
  };

  Translator.prototype.exists = function exists(key) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { interpolation: {} };

    var resolved = this.resolve(key, options);
    return resolved && resolved.res !== undefined;
  };

  Translator.prototype.extractFromKey = function extractFromKey(key, options) {
    var nsSeparator = options.nsSeparator || this.options.nsSeparator;
    if (nsSeparator === undefined) nsSeparator = ':';
    var keySeparator = options.keySeparator || this.options.keySeparator || '.';

    var namespaces = options.ns || this.options.defaultNS;
    if (nsSeparator && key.indexOf(nsSeparator) > -1) {
      var parts = key.split(nsSeparator);
      if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
      key = parts.join(keySeparator);
    }
    if (typeof namespaces === 'string') namespaces = [namespaces];

    return {
      key: key,
      namespaces: namespaces
    };
  };

  Translator.prototype.translate = function translate(keys) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) !== 'object') {
      /* eslint prefer-rest-params: 0 */
      options = this.options.overloadTranslationOptionHandler(arguments);
    }

    // non valid keys handling
    if (keys === undefined || keys === null || keys === '') return '';
    if (typeof keys === 'number') keys = String(keys);
    if (typeof keys === 'string') keys = [keys];

    // separators
    var keySeparator = options.keySeparator || this.options.keySeparator || '.';

    // get namespace(s)

    var _extractFromKey = this.extractFromKey(keys[keys.length - 1], options),
        key = _extractFromKey.key,
        namespaces = _extractFromKey.namespaces;

    var namespace = namespaces[namespaces.length - 1];

    // return key on CIMode
    var lng = options.lng || this.language;
    var appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
    if (lng && lng.toLowerCase() === 'cimode') {
      if (appendNamespaceToCIMode) {
        var nsSeparator = options.nsSeparator || this.options.nsSeparator;
        return namespace + nsSeparator + key;
      }

      return key;
    }

    // resolve from store
    var resolved = this.resolve(keys, options);
    var res = resolved && resolved.res;
    var usedKey = resolved && resolved.usedKey || key;

    var resType = Object.prototype.toString.apply(res);
    var noObject = ['[object Number]', '[object Function]', '[object RegExp]'];
    var joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;

    // object
    var handleAsObject = typeof res !== 'string' && typeof res !== 'boolean' && typeof res !== 'number';
    if (res && handleAsObject && noObject.indexOf(resType) < 0 && !(joinArrays && resType === '[object Array]')) {
      if (!options.returnObjects && !this.options.returnObjects) {
        this.logger.warn('accessing an object - but returnObjects options is not enabled!');
        return this.options.returnedObjectHandler ? this.options.returnedObjectHandler(usedKey, res, options) : 'key \'' + key + ' (' + this.language + ')\' returned an object instead of string.';
      }

      // if we got a separator we loop over children - else we just return object as is
      // as having it set to false means no hierarchy so no lookup for nested values
      if (options.keySeparator || this.options.keySeparator) {
        var copy = resType === '[object Array]' ? [] : {}; // apply child translation on a copy

        /* eslint no-restricted-syntax: 0 */
        for (var m in res) {
          if (Object.prototype.hasOwnProperty.call(res, m)) {
            copy[m] = this.translate('' + usedKey + keySeparator + m, _extends({}, options, { joinArrays: false, ns: namespaces }));
          }
        }
        res = copy;
      }
    } else if (joinArrays && resType === '[object Array]') {
      // array special treatment
      res = res.join(joinArrays);
      if (res) res = this.extendTranslation(res, keys, options);
    } else {
      // string, empty or null
      var usedDefault = false;
      var _usedKey = false;

      // fallback value
      if (!this.isValidLookup(res) && options.defaultValue !== undefined) {
        usedDefault = true;
        res = options.defaultValue;
      }
      if (!this.isValidLookup(res)) {
        _usedKey = true;
        res = key;
      }

      // save missing
      var updateMissing = options.defaultValue && options.defaultValue !== res && this.options.updateMissing;
      if (_usedKey || usedDefault || updateMissing) {
        this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? options.defaultValue : res);

        var lngs = [];
        var fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);
        if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) {
          for (var i = 0; i < fallbackLngs.length; i++) {
            lngs.push(fallbackLngs[i]);
          }
        } else if (this.options.saveMissingTo === 'all') {
          lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
        } else {
          lngs.push(options.lng || this.language);
        }

        if (this.options.saveMissing) {
          if (this.options.missingKeyHandler) {
            this.options.missingKeyHandler(lngs, namespace, key, updateMissing ? options.defaultValue : res, updateMissing);
          } else if (this.backendConnector && this.backendConnector.saveMissing) {
            this.backendConnector.saveMissing(lngs, namespace, key, updateMissing ? options.defaultValue : res, updateMissing);
          }
        }

        this.emit('missingKey', lngs, namespace, key, res);
      }

      // extend
      res = this.extendTranslation(res, keys, options);

      // append namespace if still key
      if (_usedKey && res === key && this.options.appendNamespaceToMissingKey) res = namespace + ':' + key;

      // parseMissingKeyHandler
      if (_usedKey && this.options.parseMissingKeyHandler) res = this.options.parseMissingKeyHandler(res);
    }

    // return
    return res;
  };

  Translator.prototype.extendTranslation = function extendTranslation(res, key, options) {
    var _this2 = this;

    if (options.interpolation) this.interpolator.init(_extends({}, options, { interpolation: _extends({}, this.options.interpolation, options.interpolation) }));

    // interpolate
    var data = options.replace && typeof options.replace !== 'string' ? options.replace : options;
    if (this.options.interpolation.defaultVariables) data = _extends({}, this.options.interpolation.defaultVariables, data);
    res = this.interpolator.interpolate(res, data, options.lng || this.language);

    // nesting
    if (options.nest !== false) res = this.interpolator.nest(res, function () {
      return _this2.translate.apply(_this2, arguments);
    }, options);

    if (options.interpolation) this.interpolator.reset();

    // post process
    var postProcess = options.postProcess || this.options.postProcess;
    var postProcessorNames = typeof postProcess === 'string' ? [postProcess] : postProcess;

    if (res !== undefined && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) {
      res = __WEBPACK_IMPORTED_MODULE_2__postProcessor_js__["a" /* default */].handle(postProcessorNames, res, key, options, this);
    }

    return res;
  };

  Translator.prototype.resolve = function resolve(keys) {
    var _this3 = this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var found = void 0;
    var usedKey = void 0;

    if (typeof keys === 'string') keys = [keys];

    // forEach possible key
    keys.forEach(function (k) {
      if (_this3.isValidLookup(found)) return;
      var extracted = _this3.extractFromKey(k, options);
      var key = extracted.key;
      usedKey = key;
      var namespaces = extracted.namespaces;
      if (_this3.options.fallbackNS) namespaces = namespaces.concat(_this3.options.fallbackNS);

      var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
      var needsContextHandling = options.context !== undefined && typeof options.context === 'string' && options.context !== '';

      var codes = options.lngs ? options.lngs : _this3.languageUtils.toResolveHierarchy(options.lng || _this3.language);

      namespaces.forEach(function (ns) {
        if (_this3.isValidLookup(found)) return;

        codes.forEach(function (code) {
          if (_this3.isValidLookup(found)) return;

          var finalKey = key;
          var finalKeys = [finalKey];

          var pluralSuffix = void 0;
          if (needsPluralHandling) pluralSuffix = _this3.pluralResolver.getSuffix(code, options.count);

          // fallback for plural if context not found
          if (needsPluralHandling && needsContextHandling) finalKeys.push(finalKey + pluralSuffix);

          // get key for context if needed
          if (needsContextHandling) finalKeys.push(finalKey += '' + _this3.options.contextSeparator + options.context);

          // get key for plural if needed
          if (needsPluralHandling) finalKeys.push(finalKey += pluralSuffix);

          // iterate over finalKeys starting with most specific pluralkey (-> contextkey only) -> singularkey only
          var possibleKey = void 0;
          /* eslint no-cond-assign: 0 */
          while (possibleKey = finalKeys.pop()) {
            if (!_this3.isValidLookup(found)) {
              found = _this3.getResource(code, ns, possibleKey, options);
            }
          }
        });
      });
    });

    return { res: found, usedKey: usedKey };
  };

  Translator.prototype.isValidLookup = function isValidLookup(res) {
    return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
  };

  Translator.prototype.getResource = function getResource(code, ns, key) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    return this.resourceStore.getResource(code, ns, key, options);
  };

  return Translator;
}(__WEBPACK_IMPORTED_MODULE_1__EventEmitter_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Translator);

/***/ }),
/* 522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__logger_js__ = __webpack_require__(64);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

var LanguageUtil = function () {
  function LanguageUtil(options) {
    _classCallCheck(this, LanguageUtil);

    this.options = options;

    this.whitelist = this.options.whitelist || false;
    this.logger = __WEBPACK_IMPORTED_MODULE_0__logger_js__["a" /* default */].create('languageUtils');
  }

  LanguageUtil.prototype.getScriptPartFromCode = function getScriptPartFromCode(code) {
    if (!code || code.indexOf('-') < 0) return null;

    var p = code.split('-');
    if (p.length === 2) return null;
    p.pop();
    return this.formatLanguageCode(p.join('-'));
  };

  LanguageUtil.prototype.getLanguagePartFromCode = function getLanguagePartFromCode(code) {
    if (!code || code.indexOf('-') < 0) return code;

    var p = code.split('-');
    return this.formatLanguageCode(p[0]);
  };

  LanguageUtil.prototype.formatLanguageCode = function formatLanguageCode(code) {
    // http://www.iana.org/assignments/language-tags/language-tags.xhtml
    if (typeof code === 'string' && code.indexOf('-') > -1) {
      var specialCases = ['hans', 'hant', 'latn', 'cyrl', 'cans', 'mong', 'arab'];
      var p = code.split('-');

      if (this.options.lowerCaseLng) {
        p = p.map(function (part) {
          return part.toLowerCase();
        });
      } else if (p.length === 2) {
        p[0] = p[0].toLowerCase();
        p[1] = p[1].toUpperCase();

        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
      } else if (p.length === 3) {
        p[0] = p[0].toLowerCase();

        // if lenght 2 guess it's a country
        if (p[1].length === 2) p[1] = p[1].toUpperCase();
        if (p[0] !== 'sgn' && p[2].length === 2) p[2] = p[2].toUpperCase();

        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
        if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = capitalize(p[2].toLowerCase());
      }

      return p.join('-');
    }

    return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
  };

  LanguageUtil.prototype.isWhitelisted = function isWhitelisted(code) {
    if (this.options.load === 'languageOnly' || this.options.nonExplicitWhitelist) {
      code = this.getLanguagePartFromCode(code);
    }
    return !this.whitelist || !this.whitelist.length || this.whitelist.indexOf(code) > -1;
  };

  LanguageUtil.prototype.getFallbackCodes = function getFallbackCodes(fallbacks, code) {
    if (!fallbacks) return [];
    if (typeof fallbacks === 'string') fallbacks = [fallbacks];
    if (Object.prototype.toString.apply(fallbacks) === '[object Array]') return fallbacks;

    if (!code) return fallbacks.default || [];

    // asume we have an object defining fallbacks
    var found = fallbacks[code];
    if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
    if (!found) found = fallbacks[this.formatLanguageCode(code)];
    if (!found) found = fallbacks.default;

    return found || [];
  };

  LanguageUtil.prototype.toResolveHierarchy = function toResolveHierarchy(code, fallbackCode) {
    var _this = this;

    var fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);

    var codes = [];
    var addCode = function addCode(c) {
      if (!c) return;
      if (_this.isWhitelisted(c)) {
        codes.push(c);
      } else {
        _this.logger.warn('rejecting non-whitelisted language code: ' + c);
      }
    };

    if (typeof code === 'string' && code.indexOf('-') > -1) {
      if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
      if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
      if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
    } else if (typeof code === 'string') {
      addCode(this.formatLanguageCode(code));
    }

    fallbackCodes.forEach(function (fc) {
      if (codes.indexOf(fc) < 0) addCode(_this.formatLanguageCode(fc));
    });

    return codes;
  };

  return LanguageUtil;
}();

/* harmony default export */ __webpack_exports__["a"] = (LanguageUtil);

/***/ }),
/* 523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__logger_js__ = __webpack_require__(64);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



// definition http://translate.sourceforge.net/wiki/l10n/pluralforms
/* eslint-disable */
var sets = [{ lngs: ['ach', 'ak', 'am', 'arn', 'br', 'fil', 'gun', 'ln', 'mfe', 'mg', 'mi', 'oc', 'pt', 'pt-BR', 'tg', 'ti', 'tr', 'uz', 'wa'], nr: [1, 2], fc: 1 }, { lngs: ['af', 'an', 'ast', 'az', 'bg', 'bn', 'ca', 'da', 'de', 'dev', 'el', 'en', 'eo', 'es', 'et', 'eu', 'fi', 'fo', 'fur', 'fy', 'gl', 'gu', 'ha', 'he', 'hi', 'hu', 'hy', 'ia', 'it', 'kn', 'ku', 'lb', 'mai', 'ml', 'mn', 'mr', 'nah', 'nap', 'nb', 'ne', 'nl', 'nn', 'no', 'nso', 'pa', 'pap', 'pms', 'ps', 'pt-PT', 'rm', 'sco', 'se', 'si', 'so', 'son', 'sq', 'sv', 'sw', 'ta', 'te', 'tk', 'ur', 'yo'], nr: [1, 2], fc: 2 }, { lngs: ['ay', 'bo', 'cgg', 'fa', 'id', 'ja', 'jbo', 'ka', 'kk', 'km', 'ko', 'ky', 'lo', 'ms', 'sah', 'su', 'th', 'tt', 'ug', 'vi', 'wo', 'zh'], nr: [1], fc: 3 }, { lngs: ['be', 'bs', 'dz', 'hr', 'ru', 'sr', 'uk'], nr: [1, 2, 5], fc: 4 }, { lngs: ['ar'], nr: [0, 1, 2, 3, 11, 100], fc: 5 }, { lngs: ['cs', 'sk'], nr: [1, 2, 5], fc: 6 }, { lngs: ['csb', 'pl'], nr: [1, 2, 5], fc: 7 }, { lngs: ['cy'], nr: [1, 2, 3, 8], fc: 8 }, { lngs: ['fr'], nr: [1, 2], fc: 9 }, { lngs: ['ga'], nr: [1, 2, 3, 7, 11], fc: 10 }, { lngs: ['gd'], nr: [1, 2, 3, 20], fc: 11 }, { lngs: ['is'], nr: [1, 2], fc: 12 }, { lngs: ['jv'], nr: [0, 1], fc: 13 }, { lngs: ['kw'], nr: [1, 2, 3, 4], fc: 14 }, { lngs: ['lt'], nr: [1, 2, 10], fc: 15 }, { lngs: ['lv'], nr: [1, 2, 0], fc: 16 }, { lngs: ['mk'], nr: [1, 2], fc: 17 }, { lngs: ['mnk'], nr: [0, 1, 2], fc: 18 }, { lngs: ['mt'], nr: [1, 2, 11, 20], fc: 19 }, { lngs: ['or'], nr: [2, 1], fc: 2 }, { lngs: ['ro'], nr: [1, 2, 20], fc: 20 }, { lngs: ['sl'], nr: [5, 1, 2, 3], fc: 21 }];

var _rulesPluralsTypes = {
  1: function _(n) {
    return Number(n > 1);
  },
  2: function _(n) {
    return Number(n != 1);
  },
  3: function _(n) {
    return 0;
  },
  4: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  5: function _(n) {
    return Number(n === 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
  },
  6: function _(n) {
    return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
  },
  7: function _(n) {
    return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  8: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
  },
  9: function _(n) {
    return Number(n >= 2);
  },
  10: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
  },
  11: function _(n) {
    return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
  },
  12: function _(n) {
    return Number(n % 10 != 1 || n % 100 == 11);
  },
  13: function _(n) {
    return Number(n !== 0);
  },
  14: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
  },
  15: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  16: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
  },
  17: function _(n) {
    return Number(n == 1 || n % 10 == 1 ? 0 : 1);
  },
  18: function _(n) {
    return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
  },
  19: function _(n) {
    return Number(n == 1 ? 0 : n === 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
  },
  20: function _(n) {
    return Number(n == 1 ? 0 : n === 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
  },
  21: function _(n) {
    return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
  }
};
/* eslint-enable */

function createRules() {
  var rules = {};
  sets.forEach(function (set) {
    set.lngs.forEach(function (l) {
      rules[l] = {
        numbers: set.nr,
        plurals: _rulesPluralsTypes[set.fc]
      };
    });
  });
  return rules;
}

var PluralResolver = function () {
  function PluralResolver(languageUtils) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, PluralResolver);

    this.languageUtils = languageUtils;
    this.options = options;

    this.logger = __WEBPACK_IMPORTED_MODULE_0__logger_js__["a" /* default */].create('pluralResolver');

    this.rules = createRules();
  }

  PluralResolver.prototype.addRule = function addRule(lng, obj) {
    this.rules[lng] = obj;
  };

  PluralResolver.prototype.getRule = function getRule(code) {
    return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
  };

  PluralResolver.prototype.needsPlural = function needsPlural(code) {
    var rule = this.getRule(code);

    return rule && rule.numbers.length > 1;
  };

  PluralResolver.prototype.getSuffix = function getSuffix(code, count) {
    var _this = this;

    var rule = this.getRule(code);

    if (rule) {
      //if (rule.numbers.length === 1) return ''; // only singular

      var idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
      var suffix = rule.numbers[idx];

      // special treatment for lngs only having singular and plural
      if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
        if (suffix === 2) {
          suffix = 'plural';
        } else if (suffix === 1) {
          suffix = '';
        }
      }

      var returnSuffix = function returnSuffix() {
        return _this.options.prepend && suffix.toString() ? _this.options.prepend + suffix.toString() : suffix.toString();
      };

      // COMPATIBILITY JSON
      // v1
      if (this.options.compatibilityJSON === 'v1') {
        if (suffix === 1) return '';
        if (typeof suffix === 'number') return '_plural_' + suffix.toString();
        return returnSuffix();
      } else if ( /* v2 */this.options.compatibilityJSON === 'v2' || rule.numbers.length === 2 && rule.numbers[0] === 1) {
        return returnSuffix();
      } else if ( /* v3 - gettext index */rule.numbers.length === 2 && rule.numbers[0] === 1) {
        return returnSuffix();
      }
      return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
    }

    this.logger.warn('no plural rule found for: ' + code);
    return '';
  };

  return PluralResolver;
}();

/* harmony default export */ __webpack_exports__["a"] = (PluralResolver);

/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_js__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__logger_js__ = __webpack_require__(64);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var Interpolator = function () {
  function Interpolator() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Interpolator);

    this.logger = __WEBPACK_IMPORTED_MODULE_1__logger_js__["a" /* default */].create('interpolator');

    this.init(options, true);
  }

  /* eslint no-param-reassign: 0 */


  Interpolator.prototype.init = function init() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var reset = arguments[1];

    if (reset) {
      this.options = options;
      this.format = options.interpolation && options.interpolation.format || function (value) {
        return value;
      };
      this.escape = options.interpolation && options.interpolation.escape || __WEBPACK_IMPORTED_MODULE_0__utils_js__["c" /* escape */];
    }
    if (!options.interpolation) options.interpolation = { escapeValue: true };

    var iOpts = options.interpolation;

    this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;

    this.prefix = iOpts.prefix ? __WEBPACK_IMPORTED_MODULE_0__utils_js__["g" /* regexEscape */](iOpts.prefix) : iOpts.prefixEscaped || '{{';
    this.suffix = iOpts.suffix ? __WEBPACK_IMPORTED_MODULE_0__utils_js__["g" /* regexEscape */](iOpts.suffix) : iOpts.suffixEscaped || '}}';

    this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';

    this.unescapePrefix = iOpts.unescapeSuffix ? '' : iOpts.unescapePrefix || '-';
    this.unescapeSuffix = this.unescapePrefix ? '' : iOpts.unescapeSuffix || '';

    this.nestingPrefix = iOpts.nestingPrefix ? __WEBPACK_IMPORTED_MODULE_0__utils_js__["g" /* regexEscape */](iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || __WEBPACK_IMPORTED_MODULE_0__utils_js__["g" /* regexEscape */]('$t(');
    this.nestingSuffix = iOpts.nestingSuffix ? __WEBPACK_IMPORTED_MODULE_0__utils_js__["g" /* regexEscape */](iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || __WEBPACK_IMPORTED_MODULE_0__utils_js__["g" /* regexEscape */](')');

    this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1000;

    // the regexp
    this.resetRegExp();
  };

  Interpolator.prototype.reset = function reset() {
    if (this.options) this.init(this.options);
  };

  Interpolator.prototype.resetRegExp = function resetRegExp() {
    // the regexp
    var regexpStr = this.prefix + '(.+?)' + this.suffix;
    this.regexp = new RegExp(regexpStr, 'g');

    var regexpUnescapeStr = '' + this.prefix + this.unescapePrefix + '(.+?)' + this.unescapeSuffix + this.suffix;
    this.regexpUnescape = new RegExp(regexpUnescapeStr, 'g');

    var nestingRegexpStr = this.nestingPrefix + '(.+?)' + this.nestingSuffix;
    this.nestingRegexp = new RegExp(nestingRegexpStr, 'g');
  };

  Interpolator.prototype.interpolate = function interpolate(str, data, lng) {
    var _this = this;

    var match = void 0;
    var value = void 0;
    var replaces = void 0;

    function regexSafe(val) {
      return val.replace(/\$/g, '$$$$');
    }

    var handleFormat = function handleFormat(key) {
      if (key.indexOf(_this.formatSeparator) < 0) return __WEBPACK_IMPORTED_MODULE_0__utils_js__["d" /* getPath */](data, key);

      var p = key.split(_this.formatSeparator);
      var k = p.shift().trim();
      var f = p.join(_this.formatSeparator).trim();

      return _this.format(__WEBPACK_IMPORTED_MODULE_0__utils_js__["d" /* getPath */](data, k), f, lng);
    };

    this.resetRegExp();

    replaces = 0;
    // unescape if has unescapePrefix/Suffix
    /* eslint no-cond-assign: 0 */
    while (match = this.regexpUnescape.exec(str)) {
      value = handleFormat(match[1].trim());
      str = str.replace(match[0], value);
      this.regexpUnescape.lastIndex = 0;
      replaces++;
      if (replaces >= this.maxReplaces) {
        break;
      }
    }

    replaces = 0;
    // regular escape on demand
    while (match = this.regexp.exec(str)) {
      value = handleFormat(match[1].trim());
      if (typeof value !== 'string') value = __WEBPACK_IMPORTED_MODULE_0__utils_js__["e" /* makeString */](value);
      if (!value) {
        this.logger.warn('missed to pass in variable ' + match[1] + ' for interpolating ' + str);
        value = '';
      }
      value = this.escapeValue ? regexSafe(this.escape(value)) : regexSafe(value);
      str = str.replace(match[0], value);
      this.regexp.lastIndex = 0;
      replaces++;
      if (replaces >= this.maxReplaces) {
        break;
      }
    }
    return str;
  };

  Interpolator.prototype.nest = function nest(str, fc) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    var match = void 0;
    var value = void 0;

    var clonedOptions = _extends({}, options);
    clonedOptions.applyPostProcessor = false; // avoid post processing on nested lookup

    // if value is something like "myKey": "lorem $(anotherKey, { "count": {{aValueInOptions}} })"
    function handleHasOptions(key) {
      if (key.indexOf(',') < 0) return key;

      var p = key.split(',');
      key = p.shift();
      var optionsString = p.join(',');
      optionsString = this.interpolate(optionsString, clonedOptions);
      optionsString = optionsString.replace(/'/g, '"');

      try {
        clonedOptions = JSON.parse(optionsString);
      } catch (e) {
        this.logger.error('failed parsing options string in nesting for key ' + key, e);
      }

      return key;
    }

    // regular escape on demand
    while (match = this.nestingRegexp.exec(str)) {
      value = fc(handleHasOptions.call(this, match[1].trim()), clonedOptions);

      // is only the nesting key (key1 = '$(key2)') return the value without stringify
      if (value && match[0] === str && typeof value !== 'string') return value;

      // no string to include or empty
      if (typeof value !== 'string') value = __WEBPACK_IMPORTED_MODULE_0__utils_js__["e" /* makeString */](value);
      if (!value) {
        this.logger.warn('missed to resolve ' + match[1] + ' for nesting ' + str);
        value = '';
      }
      // Nested keys should not be escaped by default #854
      // value = this.escapeValue ? regexSafe(utils.escape(value)) : regexSafe(value);
      str = str.replace(match[0], value);
      this.regexp.lastIndex = 0;
    }
    return str;
  };

  return Interpolator;
}();

/* harmony default export */ __webpack_exports__["a"] = (Interpolator);

/***/ }),
/* 525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_js__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__logger_js__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EventEmitter_js__ = __webpack_require__(81);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }





function remove(arr, what) {
  var found = arr.indexOf(what);

  while (found !== -1) {
    arr.splice(found, 1);
    found = arr.indexOf(what);
  }
}

var Connector = function (_EventEmitter) {
  _inherits(Connector, _EventEmitter);

  function Connector(backend, store, services) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    _classCallCheck(this, Connector);

    var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));

    _this.backend = backend;
    _this.store = store;
    _this.languageUtils = services.languageUtils;
    _this.options = options;
    _this.logger = __WEBPACK_IMPORTED_MODULE_1__logger_js__["a" /* default */].create('backendConnector');

    _this.state = {};
    _this.queue = [];

    if (_this.backend && _this.backend.init) {
      _this.backend.init(services, options.backend, options);
    }
    return _this;
  }

  Connector.prototype.queueLoad = function queueLoad(languages, namespaces, callback) {
    var _this2 = this;

    // find what needs to be loaded
    var toLoad = [];
    var pending = [];
    var toLoadLanguages = [];
    var toLoadNamespaces = [];

    languages.forEach(function (lng) {
      var hasAllNamespaces = true;

      namespaces.forEach(function (ns) {
        var name = lng + '|' + ns;

        if (_this2.store.hasResourceBundle(lng, ns)) {
          _this2.state[name] = 2; // loaded
        } else if (_this2.state[name] < 0) {
          // nothing to do for err
        } else if (_this2.state[name] === 1) {
          if (pending.indexOf(name) < 0) pending.push(name);
        } else {
          _this2.state[name] = 1; // pending

          hasAllNamespaces = false;

          if (pending.indexOf(name) < 0) pending.push(name);
          if (toLoad.indexOf(name) < 0) toLoad.push(name);
          if (toLoadNamespaces.indexOf(ns) < 0) toLoadNamespaces.push(ns);
        }
      });

      if (!hasAllNamespaces) toLoadLanguages.push(lng);
    });

    if (toLoad.length || pending.length) {
      this.queue.push({
        pending: pending,
        loaded: {},
        errors: [],
        callback: callback
      });
    }

    return {
      toLoad: toLoad,
      pending: pending,
      toLoadLanguages: toLoadLanguages,
      toLoadNamespaces: toLoadNamespaces
    };
  };

  Connector.prototype.loaded = function loaded(name, err, data) {
    var _this3 = this;

    var _name$split = name.split('|'),
        _name$split2 = _slicedToArray(_name$split, 2),
        lng = _name$split2[0],
        ns = _name$split2[1];

    if (err) this.emit('failedLoading', lng, ns, err);

    if (data) {
      this.store.addResourceBundle(lng, ns, data);
    }

    // set loaded
    this.state[name] = err ? -1 : 2;

    // callback if ready
    this.queue.forEach(function (q) {
      __WEBPACK_IMPORTED_MODULE_0__utils_js__["f" /* pushPath */](q.loaded, [lng], ns);
      remove(q.pending, name);

      if (err) q.errors.push(err);

      if (q.pending.length === 0 && !q.done) {
        _this3.emit('loaded', q.loaded);
        /* eslint no-param-reassign: 0 */
        q.done = true;
        if (q.errors.length) {
          q.callback(q.errors);
        } else {
          q.callback();
        }
      }
    });

    // remove done load requests
    this.queue = this.queue.filter(function (q) {
      return !q.done;
    });
  };

  Connector.prototype.read = function read(lng, ns, fcName) {
    var tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

    var _this4 = this;

    var wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 250;
    var callback = arguments[5];

    if (!lng.length) return callback(null, {}); // noting to load

    return this.backend[fcName](lng, ns, function (err, data) {
      if (err && data /* = retryFlag */ && tried < 5) {
        setTimeout(function () {
          _this4.read.call(_this4, lng, ns, fcName, tried + 1, wait * 2, callback);
        }, wait);
        return;
      }
      callback(err, data);
    });
  };

  /* eslint consistent-return: 0 */


  Connector.prototype.load = function load(languages, namespaces, callback) {
    var _this5 = this;

    if (!this.backend) {
      this.logger.warn('No backend was added via i18next.use. Will not load resources.');
      return callback && callback();
    }
    var options = _extends({}, this.backend.options, this.options.backend);

    if (typeof languages === 'string') languages = this.languageUtils.toResolveHierarchy(languages);
    if (typeof namespaces === 'string') namespaces = [namespaces];

    var toLoad = this.queueLoad(languages, namespaces, callback);
    if (!toLoad.toLoad.length) {
      if (!toLoad.pending.length) callback(); // nothing to load and no pendings...callback now
      return null; // pendings will trigger callback
    }

    // load with multi-load
    if (options.allowMultiLoading && this.backend.readMulti) {
      this.read(toLoad.toLoadLanguages, toLoad.toLoadNamespaces, 'readMulti', null, null, function (err, data) {
        if (err) _this5.logger.warn('loading namespaces ' + toLoad.toLoadNamespaces.join(', ') + ' for languages ' + toLoad.toLoadLanguages.join(', ') + ' via multiloading failed', err);
        if (!err && data) _this5.logger.log('successfully loaded namespaces ' + toLoad.toLoadNamespaces.join(', ') + ' for languages ' + toLoad.toLoadLanguages.join(', ') + ' via multiloading', data);

        toLoad.toLoad.forEach(function (name) {
          var _name$split3 = name.split('|'),
              _name$split4 = _slicedToArray(_name$split3, 2),
              l = _name$split4[0],
              n = _name$split4[1];

          var bundle = __WEBPACK_IMPORTED_MODULE_0__utils_js__["d" /* getPath */](data, [l, n]);
          if (bundle) {
            _this5.loaded(name, err, bundle);
          } else {
            var error = 'loading namespace ' + n + ' for language ' + l + ' via multiloading failed';
            _this5.loaded(name, error);
            _this5.logger.error(error);
          }
        });
      });
    } else {
      toLoad.toLoad.forEach(function (name) {
        _this5.loadOne(name);
      });
    }
  };

  Connector.prototype.reload = function reload(languages, namespaces) {
    var _this6 = this;

    if (!this.backend) {
      this.logger.warn('No backend was added via i18next.use. Will not load resources.');
    }
    var options = _extends({}, this.backend.options, this.options.backend);

    if (typeof languages === 'string') languages = this.languageUtils.toResolveHierarchy(languages);
    if (typeof namespaces === 'string') namespaces = [namespaces];

    // load with multi-load
    if (options.allowMultiLoading && this.backend.readMulti) {
      this.read(languages, namespaces, 'readMulti', null, null, function (err, data) {
        if (err) _this6.logger.warn('reloading namespaces ' + namespaces.join(', ') + ' for languages ' + languages.join(', ') + ' via multiloading failed', err);
        if (!err && data) _this6.logger.log('successfully reloaded namespaces ' + namespaces.join(', ') + ' for languages ' + languages.join(', ') + ' via multiloading', data);

        languages.forEach(function (l) {
          namespaces.forEach(function (n) {
            var bundle = __WEBPACK_IMPORTED_MODULE_0__utils_js__["d" /* getPath */](data, [l, n]);
            if (bundle) {
              _this6.loaded(l + '|' + n, err, bundle);
            } else {
              var error = 'reloading namespace ' + n + ' for language ' + l + ' via multiloading failed';
              _this6.loaded(l + '|' + n, error);
              _this6.logger.error(error);
            }
          });
        });
      });
    } else {
      languages.forEach(function (l) {
        namespaces.forEach(function (n) {
          _this6.loadOne(l + '|' + n, 're');
        });
      });
    }
  };

  Connector.prototype.loadOne = function loadOne(name) {
    var _this7 = this;

    var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    var _name$split5 = name.split('|'),
        _name$split6 = _slicedToArray(_name$split5, 2),
        lng = _name$split6[0],
        ns = _name$split6[1];

    this.read(lng, ns, 'read', null, null, function (err, data) {
      if (err) _this7.logger.warn(prefix + 'loading namespace ' + ns + ' for language ' + lng + ' failed', err);
      if (!err && data) _this7.logger.log(prefix + 'loaded namespace ' + ns + ' for language ' + lng, data);

      _this7.loaded(name, err, data);
    });
  };

  Connector.prototype.saveMissing = function saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
    if (this.backend && this.backend.create) this.backend.create(languages, namespace, key, fallbackValue, null /* unused callback */, { isUpdate: isUpdate });

    // write to store to avoid resending
    if (!languages || !languages[0]) return;
    this.store.addResource(languages[0], namespace, key, fallbackValue);
  };

  return Connector;
}(__WEBPACK_IMPORTED_MODULE_2__EventEmitter_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Connector);

/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__logger_js__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EventEmitter_js__ = __webpack_require__(81);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }




var Connector = function (_EventEmitter) {
  _inherits(Connector, _EventEmitter);

  function Connector(cache, store, services) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    _classCallCheck(this, Connector);

    var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));

    _this.cache = cache;
    _this.store = store;
    _this.services = services;
    _this.options = options;
    _this.logger = __WEBPACK_IMPORTED_MODULE_0__logger_js__["a" /* default */].create('cacheConnector');

    if (_this.cache && _this.cache.init) _this.cache.init(services, options.cache, options);
    return _this;
  }

  /* eslint consistent-return: 0 */


  Connector.prototype.load = function load(languages, namespaces, callback) {
    var _this2 = this;

    if (!this.cache) return callback && callback();
    var options = _extends({}, this.cache.options, this.options.cache);

    var loadLngs = typeof languages === 'string' ? this.services.languageUtils.toResolveHierarchy(languages) : languages;

    if (options.enabled) {
      this.cache.load(loadLngs, function (err, data) {
        if (err) _this2.logger.error('loading languages ' + loadLngs.join(', ') + ' from cache failed', err);
        if (data) {
          /* eslint no-restricted-syntax: 0 */
          for (var l in data) {
            if (Object.prototype.hasOwnProperty.call(data, l)) {
              for (var n in data[l]) {
                if (Object.prototype.hasOwnProperty.call(data[l], n)) {
                  if (n !== 'i18nStamp') {
                    var bundle = data[l][n];
                    if (bundle) _this2.store.addResourceBundle(l, n, bundle);
                  }
                }
              }
            }
          }
        }
        if (callback) callback();
      });
    } else if (callback) {
      callback();
    }
  };

  Connector.prototype.save = function save() {
    if (this.cache && this.options.cache && this.options.cache.enabled) this.cache.save(this.store.data);
  };

  return Connector;
}(__WEBPACK_IMPORTED_MODULE_1__EventEmitter_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Connector);

/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return get; });
/* harmony export (immutable) */ __webpack_exports__["b"] = transformOptions;

function get() {
  return {
    debug: false,
    initImmediate: true,

    ns: ['translation'],
    defaultNS: ['translation'],
    fallbackLng: ['dev'],
    fallbackNS: false, // string or array of namespaces

    whitelist: false, // array with whitelisted languages
    nonExplicitWhitelist: false,
    load: 'all', // | currentOnly | languageOnly
    preload: false, // array with preload languages

    simplifyPluralSuffix: true,
    keySeparator: '.',
    nsSeparator: ':',
    pluralSeparator: '_',
    contextSeparator: '_',

    saveMissing: false, // enable to send missing values
    updateMissing: false, // enable to update default values if different from translated value (only useful on initial development, or when keeping code as source of truth)
    saveMissingTo: 'fallback', // 'current' || 'all'
    missingKeyHandler: false, // function(lng, ns, key, fallbackValue) -> override if prefer on handling

    postProcess: false, // string or array of postProcessor names
    returnNull: true, // allows null value as valid translation
    returnEmptyString: true, // allows empty string value as valid translation
    returnObjects: false,
    joinArrays: false, // or string to join array
    returnedObjectHandler: function returnedObjectHandler() {}, // function(key, value, options) triggered if key returns object but returnObjects is set to false
    parseMissingKeyHandler: false, // function(key) parsed a key that was not found in t() before returning
    appendNamespaceToMissingKey: false,
    appendNamespaceToCIMode: false,
    overloadTranslationOptionHandler: function handle(args) {
      return { defaultValue: args[1] };
    },

    interpolation: {
      escapeValue: true,
      format: function format(value, _format, lng) {
        return value;
      },
      prefix: '{{',
      suffix: '}}',
      formatSeparator: ',',
      // prefixEscaped: '{{',
      // suffixEscaped: '}}',
      // unescapeSuffix: '',
      unescapePrefix: '-',

      nestingPrefix: '$t(',
      nestingSuffix: ')',
      // nestingPrefixEscaped: '$t(',
      // nestingSuffixEscaped: ')',
      // defaultVariables: undefined // object that can have values to interpolate on - extends passed in interpolation data
      maxReplaces: 1000 // max replaces to prevent endless loop
    }
  };
}

/* eslint no-param-reassign: 0 */
function transformOptions(options) {
  // create namespace object if namespace is passed in as string
  if (typeof options.ns === 'string') options.ns = [options.ns];
  if (typeof options.fallbackLng === 'string') options.fallbackLng = [options.fallbackLng];
  if (typeof options.fallbackNS === 'string') options.fallbackNS = [options.fallbackNS];

  // extend whitelist with cimode
  if (options.whitelist && options.whitelist.indexOf('cimode') < 0) options.whitelist.push('cimode');

  return options;
}

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(529).default;


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__(530);

var utils = _interopRequireWildcard(_utils);

var _cookie = __webpack_require__(531);

var _cookie2 = _interopRequireDefault(_cookie);

var _querystring = __webpack_require__(532);

var _querystring2 = _interopRequireDefault(_querystring);

var _localStorage = __webpack_require__(533);

var _localStorage2 = _interopRequireDefault(_localStorage);

var _navigator = __webpack_require__(534);

var _navigator2 = _interopRequireDefault(_navigator);

var _htmlTag = __webpack_require__(535);

var _htmlTag2 = _interopRequireDefault(_htmlTag);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function getDefaults() {
  return {
    order: ['querystring', 'cookie', 'localStorage', 'navigator', 'htmlTag'],
    lookupQuerystring: 'lng',
    lookupCookie: 'i18next',
    lookupLocalStorage: 'i18nextLng',

    // cache user language
    caches: ['localStorage'],
    excludeCacheFor: ['cimode']
    //cookieMinutes: 10,
    //cookieDomain: 'myDomain'
  };
}

var Browser = function () {
  function Browser(services) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Browser);

    this.type = 'languageDetector';
    this.detectors = {};

    this.init(services, options);
  }

  _createClass(Browser, [{
    key: 'init',
    value: function init(services) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var i18nOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      this.services = services;
      this.options = utils.defaults(options, this.options || {}, getDefaults());
      this.i18nOptions = i18nOptions;

      this.addDetector(_cookie2.default);
      this.addDetector(_querystring2.default);
      this.addDetector(_localStorage2.default);
      this.addDetector(_navigator2.default);
      this.addDetector(_htmlTag2.default);
    }
  }, {
    key: 'addDetector',
    value: function addDetector(detector) {
      this.detectors[detector.name] = detector;
    }
  }, {
    key: 'detect',
    value: function detect(detectionOrder) {
      var _this = this;

      if (!detectionOrder) detectionOrder = this.options.order;

      var detected = [];
      detectionOrder.forEach(function (detectorName) {
        if (_this.detectors[detectorName]) {
          var lookup = _this.detectors[detectorName].lookup(_this.options);
          if (lookup && typeof lookup === 'string') lookup = [lookup];
          if (lookup) detected = detected.concat(lookup);
        }
      });

      var found = void 0;
      detected.forEach(function (lng) {
        if (found) return;
        var cleanedLng = _this.services.languageUtils.formatLanguageCode(lng);
        if (_this.services.languageUtils.isWhitelisted(cleanedLng)) found = cleanedLng;
      });

      return found || this.i18nOptions.fallbackLng[0];
    }
  }, {
    key: 'cacheUserLanguage',
    value: function cacheUserLanguage(lng, caches) {
      var _this2 = this;

      if (!caches) caches = this.options.caches;
      if (!caches) return;
      if (this.options.excludeCacheFor && this.options.excludeCacheFor.indexOf(lng) > -1) return;
      caches.forEach(function (cacheName) {
        if (_this2.detectors[cacheName]) _this2.detectors[cacheName].cacheUserLanguage(lng, _this2.options);
      });
    }
  }]);

  return Browser;
}();

Browser.type = 'languageDetector';

exports.default = Browser;

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaults = defaults;
exports.extend = extend;
var arr = [];
var each = arr.forEach;
var slice = arr.slice;

function defaults(obj) {
  each.call(slice.call(arguments, 1), function (source) {
    if (source) {
      for (var prop in source) {
        if (obj[prop] === undefined) obj[prop] = source[prop];
      }
    }
  });
  return obj;
}

function extend(obj) {
  each.call(slice.call(arguments, 1), function (source) {
    if (source) {
      for (var prop in source) {
        obj[prop] = source[prop];
      }
    }
  });
  return obj;
}

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var cookie = {
  create: function create(name, value, minutes, domain) {
    var expires = void 0;
    if (minutes) {
      var date = new Date();
      date.setTime(date.getTime() + minutes * 60 * 1000);
      expires = '; expires=' + date.toGMTString();
    } else expires = '';
    domain = domain ? 'domain=' + domain + ';' : '';
    document.cookie = name + '=' + value + expires + ';' + domain + 'path=/';
  },

  read: function read(name) {
    var nameEQ = name + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1, c.length);
      }if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  },

  remove: function remove(name) {
    this.create(name, '', -1);
  }
};

exports.default = {
  name: 'cookie',

  lookup: function lookup(options) {
    var found = void 0;

    if (options.lookupCookie && typeof document !== 'undefined') {
      var c = cookie.read(options.lookupCookie);
      if (c) found = c;
    }

    return found;
  },
  cacheUserLanguage: function cacheUserLanguage(lng, options) {
    if (options.lookupCookie && typeof document !== 'undefined') {
      cookie.create(options.lookupCookie, lng, options.cookieMinutes, options.cookieDomain);
    }
  }
};

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'querystring',

  lookup: function lookup(options) {
    var found = void 0;

    if (typeof window !== 'undefined') {
      var query = window.location.search.substring(1);
      var params = query.split('&');
      for (var i = 0; i < params.length; i++) {
        var pos = params[i].indexOf('=');
        if (pos > 0) {
          var key = params[i].substring(0, pos);
          if (key === options.lookupQuerystring) {
            found = params[i].substring(pos + 1);
          }
        }
      }
    }

    return found;
  }
};

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var hasLocalStorageSupport = void 0;
try {
  hasLocalStorageSupport = window !== 'undefined' && window.localStorage !== null;
  var testKey = 'i18next.translate.boo';
  window.localStorage.setItem(testKey, 'foo');
  window.localStorage.removeItem(testKey);
} catch (e) {
  hasLocalStorageSupport = false;
}

exports.default = {
  name: 'localStorage',

  lookup: function lookup(options) {
    var found = void 0;

    if (options.lookupLocalStorage && hasLocalStorageSupport) {
      var lng = window.localStorage.getItem(options.lookupLocalStorage);
      if (lng) found = lng;
    }

    return found;
  },
  cacheUserLanguage: function cacheUserLanguage(lng, options) {
    if (options.lookupLocalStorage && hasLocalStorageSupport) {
      window.localStorage.setItem(options.lookupLocalStorage, lng);
    }
  }
};

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'navigator',

  lookup: function lookup(options) {
    var found = [];

    if (typeof navigator !== 'undefined') {
      if (navigator.languages) {
        // chrome only; not an array, so can't use .push.apply instead of iterating
        for (var i = 0; i < navigator.languages.length; i++) {
          found.push(navigator.languages[i]);
        }
      }
      if (navigator.userLanguage) {
        found.push(navigator.userLanguage);
      }
      if (navigator.language) {
        found.push(navigator.language);
      }
    }

    return found.length > 0 ? found : undefined;
  }
};

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'htmlTag',

  lookup: function lookup(options) {
    var found = void 0;
    var htmlTag = options.htmlTag || (typeof document !== 'undefined' ? document.documentElement : null);

    if (htmlTag && typeof htmlTag.getAttribute === 'function') {
      found = htmlTag.getAttribute('lang');
    }

    return found;
  }
};

/***/ }),
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */
/***/ (function(module, exports) {

module.exports = {"en":{"home":{"title":"Best Rate and Service Guarantee | Book Direct with Just Sleep Hualien Zhongzheng","description":"Enter and immediately feel lighthearted and relaxed. Just Sleep Hualien Zhongzheng is located in a quiet place amidst the bustling area in Hualien City.","keywords":"Just Sleep Hualien Zhongzheng, Just Sleep, hotels in Hualien, Hualien hotel recommendation, best hotel in Hualien, Hualien hotel recommodation, Hualien travel, Hualien tourism, Taiwan travel, Taiwan tourism, budget travelling Taiwan, budget travelling Hualien,  Hualien culture, Taiwan culture, Hualien attractions, Taiwan attractions, Hualien food, Taiwan food, Business Hotel Hualien, convenient hotel in Hualien, family trip, family holiday, family hotel, hotel in Hualien center"},"rooms":{"title":"Best Hotel Price Guarantee | Book Direct with Just Sleep Hualien Zhongzheng","description":"Each of Just Sleep Hualien Zhongzheng’s 94 modernly designed rooms contains a world-renowned body contouring Wellspring Bed to ensure a restful sleep. ","keywords":"Just Sleep Hualien Zhongzheng, Just Sleep, hotels in Hualien, Hualien hotel recommendation, best hotel in Hualien, Hualien hotel recommodation, Hualien travel, Hualien tourism, Taiwan travel, Taiwan tourism, budget travelling Taiwan, budget travelling Hualien,  Hualien culture, Taiwan culture, Hualien attractions, Taiwan attractions, Hualien food, Taiwan food, Business Hotel Hualien, convenient hotel in Hualien, family trip, family holiday, family hotel, hotel bed, Wellspring Bed"},"diningsandmeetings":{"title":"Dinings & Meetings | Just Sleep Hualien Zhongzheng","description":"Just Sleep Hualien Zhongzheng adheres to the principle of providing fresh and creative vegetarian fusion cuisines to our customers to ensure an ecstatic day.","keywords":"Just Sleep Hualien Zhongzheng, Just Sleep, hotels in Hualien, Hualien hotel recommendation, best hotel in Hualien, Hualien hotel recommodation, Hualien travel, Hualien tourism, Taiwan travel, Taiwan tourism, budget travelling Taiwan, budget travelling Hualien,  Hualien culture, Taiwan culture, Hualien attractions, Taiwan attractions, Hualien food, Taiwan food, Business Hotel Hualien, convenient hotel in Hualien, family trip, family holiday, family hotel, hotel vegetarian restaurant "},"amenities":{"title":"Amenities | Just Sleep Hualien Zhongzheng","description":"We provide a holistic experience for our guests by offering a children's playroom, a self-service laundry room, a library, and a gallery space.","keywords":"Just Sleep Hualien Zhongzheng, Just Sleep, hotels in Hualien, Hualien hotel recommendation, best hotel in Hualien, Hualien hotel recommodation, Hualien travel, Hualien tourism, Taiwan travel, Taiwan tourism, budget travelling Taiwan, budget travelling Hualien,  Hualien culture, Taiwan culture, Hualien attractions, Taiwan attractions, Hualien food, Taiwan food, Business Hotel Hualien, convenient hotel in Hualien, family trip, family holiday, family hotel, hotel gallery, Hualien gallery, hotel library, children-friendly hotel "},"activities":{"title":"Activities | Just Sleep Hualien Zhongzheng","description":"An opportunity to share your travel stories with others has been provided by Just Sleep Hualien Zhongzheng through exclusive seasonal events and activities.","keywords":"Just Sleep Hualien Zhongzheng, Just Sleep, hotels in Hualien, Hualien hotel recommendation, best hotel in Hualien, Hualien hotel recommodation, Hualien travel, Hualien tourism, Taiwan travel, Taiwan tourism, budget travelling Taiwan, budget travelling Hualien,  Hualien culture, Taiwan culture, Hualien attractions, Taiwan attractions, Hualien food, Taiwan food, Business Hotel Hualien, convenient hotel in Hualien, family trip, family holiday, family hotel"},"directions":{"title":"Directions | Just Sleep Hualien Zhongzheng","description":"With local food carts, restaurants, and gorgeous ocean and mountainside views close by, the innovative spirit of Hualien can be experienced at our hotel.","keywords":"Just Sleep Hualien Zhongzheng, Just Sleep, hotels in Hualien, Hualien hotel recommendation, best hotel in Hualien, Hualien hotel recommodation, Hualien travel, Hualien tourism, Taiwan travel, Taiwan tourism, budget travelling Taiwan, budget travelling Hualien,  Hualien culture, Taiwan culture, Hualien attractions, Taiwan attractions, Hualien food, Taiwan food, Business Hotel Hualien, convenient hotel in Hualien, family trip, family holiday, family hotel"},"promotions":{"title":"Saving Money with Best Rate Guarantee | Book Direct with Just Sleep Hualien Zhongzheng","description":"Just Sleep Hualien Zhongzheng offers various room packages and good deals if reservations happen on our official website. Stay tuned for the latest news!","keywords":"Just Sleep Hualien Zhongzheng, Just Sleep, hotels in Hualien, Hualien hotel recommendation, best hotel in Hualien, Hualien hotel recommodation, Hualien travel, Hualien tourism, Taiwan travel, Taiwan tourism, budget travelling Taiwan, budget travelling Hualien,  Hualien culture, Taiwan culture, Hualien attractions, Taiwan attractions, Hualien food, Taiwan food, Business Hotel Hualien, convenient hotel in Hualien, family trip, family holiday, family hotel"}},"zh-TW":{"home":{"title":"官網訂房最低價，另享高鐵訂票75折優惠 | 捷絲旅 花蓮中正館","description":"官網訂房最低價，另享高鐵訂票75折優惠！以文學為主軸，提供旅人與眾不同旅宿體驗，館內設挑高餐廳及圖書館，使旅人休憩時放鬆，享受優質與貼心服務。","keywords":"捷絲旅花蓮中正館, 花蓮酒店, 花蓮飯店, 花蓮商務飯店, 花蓮旅店, 花蓮住宿, 花蓮酒店推薦, 花蓮飯店推薦, 花蓮旅店推薦, 花蓮住宿推薦, 花蓮商務飯店推薦, 花蓮旅遊, 台灣旅遊, 台灣自由行, 花蓮自由行, 台灣自助旅行, 花蓮自助旅行, 花蓮景點, 花蓮美食, 花蓮旅遊, 台灣文化, 台灣休閒, 台灣景點, 花蓮交通便利飯店, 花蓮訂房, 花蓮親子飯店, 親子住宿"},"rooms":{"title":"官網訂房最低價，另享高鐵訂票75折優惠 | 捷絲旅 花蓮中正館","description":"官網訂房最低價，享高鐵訂票優惠！設計精巧客房，採國際級感溫、塑形Wellspring床墊，頂級淋浴設備、寬頻無線上網，帶給極佳舒適、便利性。","keywords":"捷絲旅花蓮中正館, 花蓮酒店, 花蓮飯店, 花蓮商務飯店, 花蓮旅店, 花蓮住宿, 花蓮酒店推薦, 花蓮飯店推薦, 花蓮旅店推薦, 花蓮住宿推薦, 花蓮商務飯店推薦, 花蓮旅遊, 台灣旅遊, 台灣自由行, 花蓮自由行, 台灣自助旅行, 花蓮自助旅行, 花蓮景點, 花蓮美食, 花蓮旅遊, 台灣文化, 台灣休閒, 台灣景點, 花蓮交通便利飯店, 花蓮訂房, 花蓮親子飯店, 親子住宿, 飯店床"},"diningsandmeetings":{"title":"餐廳會議 | 捷絲旅 花蓮中正館","description":"「捷絲旅花蓮中正館」為旅人送上輕鬆無負擔的時尚精緻蔬食。提供自助式早餐，結合在地當季蔬果，提供旅人豐富、多樣的朝食選擇， 有個“蔬”適的早晨。","keywords":"捷絲旅花蓮中正館, 花蓮酒店, 花蓮飯店, 花蓮商務飯店, 花蓮旅店, 花蓮住宿, 花蓮酒店推薦, 花蓮飯店推薦, 花蓮旅店推薦, 花蓮住宿推薦, 花蓮商務飯店推薦, 花蓮旅遊, 台灣旅遊, 台灣自由行, 花蓮自由行, 台灣自助旅行, 花蓮自助旅行, 花蓮景點, 花蓮美食, 花蓮旅遊, 台灣文化, 台灣休閒, 台灣景點, 花蓮交通便利飯店, 花蓮訂房, 花蓮親子飯店, 親子住宿, 蔬食飯店"},"amenities":{"title":"設施服務 | 捷絲旅 花蓮中正館","description":"無論親子族群或自助行旅客，都能感受悠閒放鬆並且充實的時光。「捷絲旅花蓮中正館」設有圖書館、兒童遊戲室、自助洗衣室和藝廊。","keywords":"捷絲旅花蓮中正館, 花蓮酒店, 花蓮飯店, 花蓮商務飯店, 花蓮旅店, 花蓮住宿, 花蓮酒店推薦, 花蓮飯店推薦, 花蓮旅店推薦, 花蓮住宿推薦, 花蓮商務飯店推薦, 花蓮旅遊, 台灣旅遊, 台灣自由行, 花蓮自由行, 台灣自助旅行, 花蓮自助旅行, 花蓮景點, 花蓮美食, 花蓮旅遊, 台灣文化, 台灣休閒, 台灣景點, 花蓮交通便利飯店, 花蓮訂房, 花蓮親子飯店, 親子住宿"},"activities":{"title":"館內活動 | 捷絲旅 花蓮中正館","description":"「捷絲旅花蓮中正館」不定期推出季節性活動，為你而量身打造出一生難忘的旅行歡樂時光。","keywords":"捷絲旅花蓮中正館, 花蓮酒店, 花蓮飯店, 花蓮商務飯店, 花蓮旅店, 花蓮住宿, 花蓮酒店推薦, 花蓮飯店推薦, 花蓮旅店推薦, 花蓮住宿推薦, 花蓮商務飯店推薦, 花蓮旅遊, 台灣旅遊, 台灣自由行, 花蓮自由行, 台灣自助旅行, 花蓮自助旅行, 花蓮景點, 花蓮美食, 花蓮旅遊, 台灣文化, 台灣休閒, 台灣景點, 花蓮交通便利飯店, 花蓮訂房, 花蓮親子飯店, 親子住宿"},"directions":{"title":"交通景點 | 捷絲旅 花蓮中正館","description":"我們坐落於繽紛熱鬧、匯聚在地美食小吃的花蓮市中心，鄰近風格鮮活的文化創意園區、東大門夜市，及景色遼闊的南濱海岸，可享受創新活力的度假愉悅感。","keywords":"捷絲旅花蓮中正館, 花蓮酒店, 花蓮飯店, 花蓮商務飯店, 花蓮旅店, 花蓮住宿, 花蓮酒店推薦, 花蓮飯店推薦, 花蓮旅店推薦, 花蓮住宿推薦, 花蓮商務飯店推薦, 花蓮旅遊, 台灣旅遊, 台灣自由行, 花蓮自由行, 台灣自助旅行, 花蓮自助旅行, 花蓮景點, 花蓮美食, 花蓮旅遊, 台灣文化, 台灣休閒, 台灣景點, 花蓮交通便利飯店, 花蓮訂房, 花蓮親子飯店, 親子住宿"},"promotions":{"title":"官網訂房最低價，另享高鐵訂票75折優惠 | 最新優惠 | 捷絲旅 花蓮中正館","description":"不要漏掉了！豐富住房優惠、高鐵訂票75折優惠，官網訂房最低價。「捷絲旅花蓮中正館」官網上鎖定最新消息優惠訊息不漏接！","keywords":"捷絲旅花蓮中正館, 花蓮酒店, 花蓮飯店, 花蓮商務飯店, 花蓮旅店, 花蓮住宿, 花蓮酒店推薦, 花蓮飯店推薦, 花蓮旅店推薦, 花蓮住宿推薦, 花蓮商務飯店推薦, 花蓮旅遊, 台灣旅遊, 台灣自由行, 花蓮自由行, 台灣自助旅行, 花蓮自助旅行, 花蓮景點, 花蓮美食, 花蓮旅遊, 台灣文化, 台灣休閒, 台灣景點, 花蓮交通便利飯店, 花蓮訂房, 花蓮親子飯店, 親子住宿"}},"zh-CN":{"home":{"title":"官网订房保证最低价 | 捷丝旅 花莲中正馆","description":"官网订房最低价，另享高铁订票75折优惠！以文学为主轴，提供旅人与众不同旅宿体验，馆内设挑高餐厅及图书馆，使旅人休憩时放松，享受优质与贴心服务。","keywords":"捷丝旅花莲中正馆, 花莲酒店, 花莲饭店, 花莲商务饭店, 花莲旅店, 花莲住宿, 花莲酒店推荐, 花莲饭店推荐, 花莲旅店推荐, 花莲住宿推荐, 花莲商务饭店推荐, 花莲旅游, 台湾旅游, 台湾自由行, 花莲自由行, 台湾自助旅行, 花莲自助旅行, 花莲景点, 花莲美食, 花莲旅游, 台湾文化, 台湾休閒, 台湾景点,  花莲交通便利饭店, 花莲订房, 花莲亲子饭店"},"rooms":{"title":"官网订房保证最低价 | 捷丝旅 花莲中正馆","description":"官网订房最低价，享高铁订票优惠！设计精巧客房，采国际级感温、塑形Wellspring床垫，顶级淋浴设备、宽频无线上网，带给极佳舒适、便利性。","keywords":"捷丝旅花莲中正馆, 花莲酒店, 花莲饭店, 花莲商务饭店, 花莲旅店, 花莲住宿, 花莲酒店推荐, 花莲饭店推荐, 花莲旅店推荐, 花莲住宿推荐, 花莲商务饭店推荐, 花莲旅游, 台湾旅游, 台湾自由行, 花莲自由行, 台湾自助旅行, 花莲自助旅行, 花莲景点, 花莲美食, 花莲旅游, 台湾文化, 台湾休閒, 台湾景点,  花莲交通便利饭店, 花莲订房, 花莲亲子饭店"},"diningsandmeetings":{"title":"餐厅会议 | 捷丝旅 花莲中正馆","description":"「捷丝旅花莲中正馆」为旅人送上轻松无负担的时尚精致蔬食。提供自助式早餐，结合在地当季蔬果，提供旅人丰富、多样的朝食选择， 有个“蔬”适的早晨。","keywords":"捷丝旅花莲中正馆, 花莲酒店, 花莲饭店, 花莲商务饭店, 花莲旅店, 花莲住宿, 花莲酒店推荐, 花莲饭店推荐, 花莲旅店推荐, 花莲住宿推荐, 花莲商务饭店推荐, 花莲旅游, 台湾旅游, 台湾自由行, 花莲自由行, 台湾自助旅行, 花莲自助旅行, 花莲景点, 花莲美食, 花莲旅游, 台湾文化, 台湾休閒, 台湾景点,  花莲交通便利饭店, 花莲订房, 花莲亲子饭店"},"amenities":{"title":"设施服务 | 捷丝旅 花莲中正馆","description":"无论亲子族群或自助行旅客，都能感受悠闲放松并且充实的时光。 「捷丝旅花莲中正馆」设有图书馆、儿童游戏室、自助洗衣室和艺廊。","keywords":"捷丝旅花莲中正馆, 花莲酒店, 花莲饭店, 花莲商务饭店, 花莲旅店, 花莲住宿, 花莲酒店推荐, 花莲饭店推荐, 花莲旅店推荐, 花莲住宿推荐, 花莲商务饭店推荐, 花莲旅游, 台湾旅游, 台湾自由行, 花莲自由行, 台湾自助旅行, 花莲自助旅行, 花莲景点, 花莲美食, 花莲旅游, 台湾文化, 台湾休閒, 台湾景点,  花莲交通便利饭店, 花莲订房, 花莲亲子饭店"},"activities":{"title":"馆内活动 | 捷丝旅 花莲中正馆","description":"「捷丝旅花莲中正馆」不定期推出季节性活动，为你而量身打造出一生难忘的旅行欢乐时光。","keywords":"捷丝旅花莲中正馆, 花莲酒店, 花莲饭店, 花莲商务饭店, 花莲旅店, 花莲住宿, 花莲酒店推荐, 花莲饭店推荐, 花莲旅店推荐, 花莲住宿推荐, 花莲商务饭店推荐, 花莲旅游, 台湾旅游, 台湾自由行, 花莲自由行, 台湾自助旅行, 花莲自助旅行, 花莲景点, 花莲美食, 花莲旅游, 台湾文化, 台湾休閒, 台湾景点,  花莲交通便利饭店, 花莲订房, 花莲亲子饭店"},"directions":{"title":"交通景点 | 捷丝旅 花莲中正馆","description":"我们坐落于缤纷热闹、汇聚在地美食小吃的花莲市中心，邻近风格鲜活的文化创意园区、东大门夜市，及景色辽阔的南滨海岸，可享受创新活力的度假愉悦感。","keywords":"捷丝旅花莲中正馆, 花莲酒店, 花莲饭店, 花莲商务饭店, 花莲旅店, 花莲住宿, 花莲酒店推荐, 花莲饭店推荐, 花莲旅店推荐, 花莲住宿推荐, 花莲商务饭店推荐, 花莲旅游, 台湾旅游, 台湾自由行, 花莲自由行, 台湾自助旅行, 花莲自助旅行, 花莲景点, 花莲美食, 花莲旅游, 台湾文化, 台湾休閒, 台湾景点,  花莲交通便利饭店, 花莲订房, 花莲亲子饭店"},"promotions":{"title":"官网订房保证最低价 | 最新优惠 | 捷丝旅 花莲中正馆","description":"不要漏掉了！豐富住房優惠、高鐵訂票75折優惠，官網訂房最低價。「捷絲旅花蓮中正館」官網上鎖定最新消息優惠訊息不漏接！","keywords":"捷丝旅花莲中正馆, 花莲酒店, 花莲饭店, 花莲商务饭店, 花莲旅店, 花莲住宿, 花莲酒店推荐, 花莲饭店推荐, 花莲旅店推荐, 花莲住宿推荐, 花莲商务饭店推荐, 花莲旅游, 台湾旅游, 台湾自由行, 花莲自由行, 台湾自助旅行, 花莲自助旅行, 花莲景点, 花莲美食, 花莲旅游, 台湾文化, 台湾休閒, 台湾景点,  花莲交通便利饭店, 花莲订房, 花莲亲子饭店"}},"ja":{"home":{"title":"ご予約は当サイトが最もお得です | ジャストスリープ花蓮中正館","description":"ジャストスリープ花蓮中正館は花蓮市内の中正路に位置して、鉄道花蓮駅、花蓮空港、太魯閣国立公園や七星潭といった観光スポットから近い、交通が大変便利なロケーションにあります。","keywords":"ジャストスリープ花蓮中正館、ジャストスリープ花蓮、花蓮ビスネスホテル、家族ホテル、ラグジュアリーホテル、ブティックホテル、デザイナーズホテル、ベストホテル、花蓮 宿泊、花蓮観光、花蓮旅行、台湾旅行、台湾おすすめホテル、花蓮おすすめホテル、花蓮文化、花蓮レジャー、花蓮観光スポット、花蓮の料理、台湾の文化、台湾レジャー、台湾観光スポット、台湾の料理、台湾観光、花蓮厳選ホテル、花蓮で泊まりたいホテル、花蓮の格安ホテル、花蓮の人気ホテル、花蓮観光に便利なホテル、花蓮で駅近のホテル、親子連れにおすすめのホテル"},"rooms":{"title":"ご予約は当サイトが最もお得です | ジャストスリープ花蓮中正館","description":"ジャストスリープ花蓮中正館は市内の風景を見渡せるバルコニーつきの客室が94室、国際的知名度を誇るWellspring社のマットレス、高級シャワー設備なども完備しています。","keywords":"ジャストスリープ花蓮中正館、ジャストスリープ花蓮、花蓮ビスネスホテル、家族ホテル、ラグジュアリーホテル、ブティックホテル、デザイナーズホテル、ベストホテル、花蓮 宿泊、花蓮観光、花蓮旅行、台湾旅行、台湾おすすめホテル、花蓮おすすめホテル、花蓮文化、花蓮レジャー、花蓮観光スポット、花蓮の料理、台湾の文化、台湾レジャー、台湾観光スポット、台湾の料理、台湾観光、花蓮厳選ホテル、花蓮で泊まりたいホテル、花蓮の格安ホテル、花蓮の人気ホテル、花蓮観光に便利なホテル、花蓮で駅近のホテル、親子連れにおすすめのホテル"},"diningsandmeetings":{"title":"レストラン、会議 | ジャストスリープ花蓮中正館","description":"ジャストスリープ花蓮中正館は自然、新鮮、健康、革新の経営理念を貫きます。お客様の健康のため、使っている食材は最も新鮮な果物や野菜とユニークな味のしいたけにこだわっています。","keywords":"ジャストスリープ花蓮中正館、ジャストスリープ花蓮、花蓮ビスネスホテル、家族ホテル、ラグジュアリーホテル、ブティックホテル、デザイナーズホテル、ベストホテル、花蓮 宿泊、花蓮観光、花蓮旅行、台湾旅行、台湾おすすめホテル、花蓮おすすめホテル、花蓮文化、花蓮レジャー、花蓮観光スポット、花蓮の料理、台湾の文化、台湾レジャー、台湾観光スポット、台湾の料理、台湾観光、花蓮厳選ホテル、花蓮で泊まりたいホテル、花蓮の格安ホテル、花蓮の人気ホテル、花蓮観光に便利なホテル、花蓮で駅近のホテル、親子連れにおすすめのホテル"},"amenities":{"title":"レジャー施設 | ジャストスリープ花蓮中正館","description":"ジャストスリープ花蓮中正館は図書館、子供用プレイルーム、洗濯室など、高い天井をデザインした図書館も完備しており、ほかでは味わえない快適な滞在をご体験していただけます。","keywords":"ジャストスリープ花蓮中正館、ジャストスリープ花蓮、花蓮ビスネスホテル、家族ホテル、ラグジュアリーホテル、ブティックホテル、デザイナーズホテル、ベストホテル、花蓮 宿泊、花蓮観光、花蓮旅行、台湾旅行、台湾おすすめホテル、花蓮おすすめホテル、花蓮文化、花蓮レジャー、花蓮観光スポット、花蓮の料理、台湾の文化、台湾レジャー、台湾観光スポット、台湾の料理、台湾観光、花蓮厳選ホテル、花蓮で泊まりたいホテル、花蓮の格安ホテル、花蓮の人気ホテル、花蓮観光に便利なホテル、花蓮で駅近のホテル、親子連れにおすすめのホテル"},"activities":{"title":"館内イベント | ジャストスリープ花蓮中正館","description":"ジャストスリープ花蓮中正館は客が楽しい旅にするために、不定期的にイベントを開催します。","keywords":"ジャストスリープ花蓮中正館、ジャストスリープ花蓮、花蓮ビスネスホテル、家族ホテル、ラグジュアリーホテル、ブティックホテル、デザイナーズホテル、ベストホテル、花蓮 宿泊、花蓮観光、花蓮旅行、台湾旅行、台湾おすすめホテル、花蓮おすすめホテル、花蓮文化、花蓮レジャー、花蓮観光スポット、花蓮の料理、台湾の文化、台湾レジャー、台湾観光スポット、台湾の料理、台湾観光、花蓮厳選ホテル、花蓮で泊まりたいホテル、花蓮の格安ホテル、花蓮の人気ホテル、花蓮観光に便利なホテル、花蓮で駅近のホテル、親子連れにおすすめのホテル"},"directions":{"title":"交通アクセス | ジャストスリープ花蓮中正館","description":"ジャストスリープ花蓮中正館はにぎやかな花蓮市の中心に位置します。近くには美しい風景が観賞できる南賓海岸やクリエイティブなアートに触れあえる文化創意園区などがあります。","keywords":"ジャストスリープ花蓮中正館、ジャストスリープ花蓮、花蓮ビスネスホテル、家族ホテル、ラグジュアリーホテル、ブティックホテル、デザイナーズホテル、ベストホテル、花蓮 宿泊、花蓮観光、花蓮旅行、台湾旅行、台湾おすすめホテル、花蓮おすすめホテル、花蓮文化、花蓮レジャー、花蓮観光スポット、花蓮の料理、台湾の文化、台湾レジャー、台湾観光スポット、台湾の料理、台湾観光、花蓮厳選ホテル、花蓮で泊まりたいホテル、花蓮の格安ホテル、花蓮の人気ホテル、花蓮観光に便利なホテル、花蓮で駅近のホテル、親子連れにおすすめのホテル"},"promotions":{"title":"ご予約は当サイトが最もお得です | 最新情報 | ジャストスリープ花蓮中正館","description":"ジャストスリープ花蓮中正館は季節のご案内やホテルプロモーション情報などを配信しております。ニュースレターにご登録ください。","keywords":"ジャストスリープ花蓮中正館、ジャストスリープ花蓮、花蓮ビスネスホテル、家族ホテル、ラグジュアリーホテル、ブティックホテル、デザイナーズホテル、ベストホテル、花蓮 宿泊、花蓮観光、花蓮旅行、台湾旅行、台湾おすすめホテル、花蓮おすすめホテル、花蓮文化、花蓮レジャー、花蓮観光スポット、花蓮の料理、台湾の文化、台湾レジャー、台湾観光スポット、台湾の料理、台湾観光、花蓮厳選ホテル、花蓮で泊まりたいホテル、花蓮の格安ホテル、花蓮の人気ホテル、花蓮観光に便利なホテル、花蓮で駅近のホテル、親子連れにおすすめのホテル"}},"ko":{"home":{"title":"공식 사이트에서 예약하는 것이 가장 저렴합니다 | 저스트슬립 이란 자오시점","description":"화롄 중정점 레스토랑은 넓고 감각적인 공간을 제공하며 호텔내부 도서관이용도 가능합니다. 호텔은 문화창작단지 부근에 위치해있으며, 인근의 다양한 현지음식을 체험할수있습니다. 본 호텔은 최상의 서비스와 다양한 시설을 제공하며 고객의 편안한 투숙을 위해 최선을 다하고있습니다.","keywords":"#이란온천호텔 #이란비즈니스호텔#이란숙박#이란여행#이란자유여행#이란호텔추천#대만동대문야시장#이란맛집#이란호텔예약#이란관광#이란호텔할인"},"rooms":{"title":"공식 사이트에서 예약하는 것이 가장 저렴합니다 | 저스트슬립 이란 자오시점","description":"화롄 중정점은 편안한 숙면을 보장할 글로벌 품질 Wellspring 매트리스 등을 갖춘 세련된 디자인의 94개 객실을 보유하고 있습니다. 일부 객실의 경우 경치를 감상할 수 있는 테라스가 있어 복잡한 도심 속에서 자신만의 공간을 누릴 수있습니다. 이밖에 최고급 욕실 설비 및 광대역 무선 인터넷, 위성TV 등을구비하여 쾌적하고 편리한 공간을 선사하고 있습니다.","keywords":"#이란온천호텔 #이란비즈니스호텔#이란숙박#이란여행#이란자유여행#이란호텔추천#대만동대문야시장#이란맛집#이란호텔예약#이란관광#이란호텔할인"},"diningsandmeetings":{"title":"다이닝 & 연회 회의 | 저스트슬립 이란 자오시점","description":"화롄 중정점은 채식주의 레스토랑은 아침식사(뷔페)를 제공합니다. 모든 음식과 과일은 제철에맞는 식자제를 사용하며, 쌀죽,빵,과일 등 다양한 음식을 제공합니다. 또한, 본 호텔 레스토랑은 채식주의자를 위한 건강한 식단을 제공합니다.","keywords":"#이란온천호텔 #이란비즈니스호텔#이란숙박#이란여행#이란자유여행#이란호텔추천#대만동대문야시장#이란맛집#이란호텔예약#이란관광#이란호텔할인"},"amenities":{"title":"테마 | 저스트슬립 이란 자오시점","description":"화롄 중정점은 도서관, 실내놀이터 ,셀프 세탁실이 갖추고 있으며 대만에 계시는 동안 편안하고 좋은 시간을 보낼 수 있습니다저스트슬립 가오슝 중정점","keywords":"#이란온천호텔 #이란비즈니스호텔#이란숙박#이란여행#이란자유여행#이란호텔추천#대만동대문야시장#이란맛집#이란호텔예약#이란관광#이란호텔할인"},"activities":{"title":"관내활동 | 저스트슬립 이란 자오시점","description":"더 알찬 여행을 위해 이벤트 확인하기","keywords":"#이란온천호텔 #이란비즈니스호텔#이란숙박#이란여행#이란자유여행#이란호텔추천#대만동대문야시장#이란맛집#이란호텔예약#이란관광#이란호텔할인"},"directions":{"title":"시설 | 저스트슬립 이란 자오시점","description":"저스트슬립 이란 자오시점은 화롄에서 가장 번화하고 먹거리가 가장 집중되어 있는 화롄시의 중심부에 위치에 있으면서, 각종 관광지와 인접해 있습니다. 인접해있는 관광지로는 광활한 난빈해안공원南濱海岸, 화려한 색채와 예술적인 감각을 선사하는 화롄원화창의원구文化創意園區가 있으며, 고객여러분들은 이곳에서 갖가지 아름다운 풍경들을 보며, 창의적인 감각과 휴가지의 전형적인 경관 모두를 즐기실 수 있을 것입니다.","keywords":"#이란온천호텔 #이란비즈니스호텔#이란숙박#이란여행#이란자유여행#이란호텔추천#대만동대문야시장#이란맛집#이란호텔예약#이란관광#이란호텔할인"},"promotions":{"title":"최신소식 | 저스트슬립 이란 자오시점","description":"팔로우해서 스페셜 오퍼 놓치지 않기","keywords":"#이란온천호텔 #이란비즈니스호텔#이란숙박#이란여행#이란자유여행#이란호텔추천#대만동대문야시장#이란맛집#이란호텔예약#이란관광#이란호텔할인"}}}

/***/ }),
/* 581 */
/***/ (function(module, exports) {

module.exports = {"en":{"home":{"title":"Best Rate and Service Guarantee | Book Direct with Just Sleep Yilan Jiaoxi","description":"Our hotel, with each guest room having its own hot spring bath and considerate service, and conveniently located downtown, is visitors' first choice. ","keywords":"Yilan Jiaoxi Hot Spring Hotel, Yilan Jiaoxi Hot Spring Accommodation, Recommended Yilan Jiaoxi Hot Spring, Recommend Hot Spring Accommodation, Recommend Jiaoxi Accommodation, Yilan travel, Yilan trip, Yilan scenic site, Yilan gourmet food, Yilan check-in place, Yilan Best Price Guarantee, Yilan Best Hotel Price Guarantee, Yilan private hot spring hotel, Yilan Jiaoxi hotel, Just Sleep Yilan Jiaoxi"},"rooms":{"title":"Best Hotel Price Guarantee | Book Direct with Just Sleep Yilan Jiaoxi","description":"All guest rooms have a private hot spring bath. Traditional and modern infused elements in our rooms provide you with an especially soothing environment.","keywords":"Yilan Jiaoxi Hot Spring Hotel, Yilan Jiaoxi Hot Spring Accommodation, Recommended Yilan Jiaoxi Hot Spring, Recommend Hot Spring Accommodation, Recommend Jiaoxi Accommodation, Just Sleep Yilan Jiaoxi, modern Jiaoxi hot spring hotel"},"diningsandmeetings":{"title":"Dinings & Meetings | Just Sleep Yilan Jiaoxi","description":"A scenic conference room is available for medium-sized activities, and a diverse spill of breakfast choices using local ingredients is served at Just Cafe.","keywords":"Yilan Jiaoxi Hot Spring Hotel, Yilan Jiaoxi Hot Spring Accommodation, Recommended Yilan Jiaoxi Hot Spring, Recommend Hot Spring Accommodation, Recommend Jiaoxi Accommodation, hotel conference room, Just Sleep Yilan Jiaoxi, Jiaoxi hotel"},"amenities":{"title":"Amenities | Just Sleep Yilan Jiaoxi","description":"Come see if your grandma has the same things as our “grandma” in her “Grandma’s Stationery Store”! We also have a game room, outdoor pool, and indoor hot spring.","keywords":"Yilan Jiaoxi Hot Spring Hotel, Yilan Jiaoxi Hot Spring Accommodation, Recommended Yilan Jiaoxi Hot Spring, Recommend Hot Spring Accommodation, Recommend Jiaoxi Accommodation, hotel's facilities, free hotel's facilities, hotel's Wi-Fi, Just Sleep Yilan Jiaoxi, Jiaoxi children-friendly hotel"},"activities":{"title":"Activities | Just Sleep Yilan Jiaoxi","description":"We believe a brilliant holiday can only be created by parent-child activities, like participating in our DIY sessions which changes each season.","keywords":"Yilan Jiaoxi Hot Spring Hotel, Yilan Jiaoxi Hot Spring Accommodation, Recommended Yilan Jiaoxi Hot Spring, Recommend Hot Spring Accommodation, Recommend Jiaoxi Accommodation, Hotel activities, Recommended Yilan scenic site, Yilan tourism, Jiaoxi hotel DIY"},"directions":{"title":"Directions | Just Sleep Yilan Jiaoxi","description":"Challenging local design hotels, we are in a convenient location with railway and bus stations, shopping district, and famous tourist attractions nearby.","keywords":"Yilan Jiaoxi Hot Spring Hotel, Yilan Jiaoxi Hot Spring Accommodation, Recommended Yilan Jiaoxi Hot Spring, Recommend Hot Spring Accommodation, Recommend Jiaoxi Accommodation, Hotel activities, Recommended Yilan scenic site, Yilan tourism, Jiaoxi shopping "},"promotions":{"title":"Saving Money with Best Rate Guarantee | Book Direct with Just Sleep Yilan Jiaoxi","description":"Start paying attention to the irregular special offers on our official website! Booking a reservation there will also get you the best price.","keywords":"Yilan Jiaoxi Hot Spring Hotel, Yilan Jiaoxi Hot Spring Accommodation, Recommended Yilan Jiaoxi Hot Spring, Recommend Hot Spring Accommodation, Recommend Jiaoxi Accommodation, Yilan Hotel offers, Yilan Jiaoxi accommodation offers, Yilan Best Price Guarantee, Yilan Best Hotel Price Guarantee"}},"zh-TW":{"home":{"title":"官網訂房最低價，另享高鐵訂票75折優惠 | 捷絲旅 宜蘭礁溪館","description":"礁溪度假住宿首選，捷絲旅宜蘭礁溪館官網訂房最低價，並享高鐵訂票75折優惠！坐落礁溪市區，步行可達礁溪商圈、礁溪火車站，全館客房皆設有獨立湯池。","keywords":"捷絲旅宜蘭礁溪館, 宜蘭礁溪溫泉飯店, 宜蘭礁溪溫泉住宿, 宜蘭礁溪溫泉推薦,  泡湯住宿推薦, 礁溪住宿推薦, 宜蘭旅遊, 宜蘭旅行, 宜蘭景點, 宜蘭美食, 宜蘭打卡景點, 礁溪溫泉飯店"},"rooms":{"title":"官網訂房最低價，另享高鐵訂票75折優惠 | 捷絲旅 宜蘭礁溪館","description":"快來！客房分為日式和洋式，每房擁有獨立湯池，旅人可盡情放鬆享受泡湯時光，適合情侶、好友及家庭旅遊。官網訂房最低價，並享高鐵訂票75折優惠！","keywords":"捷絲旅宜蘭礁溪館, 宜蘭礁溪溫泉飯店, 宜蘭礁溪溫泉住宿, 宜蘭礁溪溫泉推薦,  泡湯住宿推薦, 礁溪住宿推薦, 礁溪泡湯, 美人湯泉, 獨立湯池, 日式泡湯"},"diningsandmeetings":{"title":"餐廳會議 | 捷絲旅 宜蘭礁溪館","description":"景觀會議室是舉辦小型或中型會議與活動的最佳場所。Just Café提供多樣的朝食選擇，五星級主廚細心嚴選食材，讓旅客吃的健康開心並重複回來。","keywords":"捷絲旅宜蘭礁溪館, 宜蘭礁溪溫泉飯店, 宜蘭礁溪溫泉住宿, 宜蘭礁溪溫泉推薦,  泡湯住宿推薦, 礁溪住宿推薦, 獨立湯池, 礁溪會議場地, 礁溪在地美食, 飯店美食, 飯店會議室"},"amenities":{"title":"設施服務 | 捷絲旅 宜蘭礁溪館","description":"最佳體驗親子活動的地點。「奶奶的文具店」裡的物品，你的奶奶也有嗎?全館提供露天風呂、男女裸湯等設施，另設有親子遊戲空間「傳統遊藝間」。","keywords":"捷絲旅宜蘭礁溪館, 宜蘭礁溪溫泉飯店, 宜蘭礁溪溫泉住宿, 宜蘭礁溪溫泉推薦,  泡湯住宿推薦, 礁溪住宿推薦, 溫泉泡湯, 礁溪休閒設施, 礁溪親子設施, 礁溪溫泉裸湯, 飯店親子遊戲"},"activities":{"title":"館內活動 | 捷絲旅 宜蘭礁溪館","description":"小孩的天堂，把家長與小孩之間的距離拉得更近，一個充分了解小孩的機會。每季皆提供不同的DIY體驗，適合親子共同參與、共度歡樂的旅行時光。","keywords":"捷絲旅宜蘭礁溪館, 宜蘭礁溪溫泉飯店, 宜蘭礁溪溫泉住宿, 宜蘭礁溪溫泉推薦,  泡湯住宿推薦, 礁溪住宿推薦, 飯店活動, 宜蘭景點推薦, 宜蘭旅遊行程, 飯店親子遊戲, 飯店DIY"},"directions":{"title":"交通景點 | 捷絲旅 宜蘭礁溪館","description":"離熱鬧的礁溪商圈及著名觀光景點，如五峰旗風景區、湯圍溝公園等只有幾步路。全館鄰近礁溪火車站、礁溪轉運站、公車站等交通位置，交通位置便利快捷。","keywords":"捷絲旅宜蘭礁溪館, 宜蘭礁溪溫泉飯店, 宜蘭礁溪溫泉住宿, 宜蘭礁溪溫泉推薦,  泡湯住宿推薦, 礁溪住宿推薦, 宜蘭景點, 礁溪景點, 宜蘭礁溪交通, 宜蘭打卡景點, 湯圍溝溫泉, 五峰旗瀑布, 五峰旗風景區, 礁溪火車站, 礁溪轉運站"},"promotions":{"title":"官網訂房最低價，另享高鐵訂票75折優惠 | 最新優惠 | 捷絲旅 宜蘭礁溪館","description":"一定要注意！官網上不定期推出住房專案、最優惠住房價格、及入住季節專案可享限定好禮。官網上訂房最低價，可享高鐵訂票75折優惠！","keywords":"捷絲旅宜蘭礁溪館, 宜蘭礁溪溫泉飯店, 宜蘭礁溪溫泉住宿, 宜蘭礁溪溫泉推薦,  泡湯住宿推薦, 礁溪住宿推薦, 宜蘭飯店優惠, 早鳥住房, 季節限定, 宜蘭礁溪住房優惠"}},"zh-CN":{"home":{"title":"官网订房保证最低价 | 捷丝旅 宜兰礁溪馆","description":"礁溪度假住宿首选，捷丝旅宜兰礁溪馆官网订房最低价，并享高铁订票75折优惠！坐落礁溪市区，步行可达礁溪商圈、礁溪火车站，全馆客房皆设有独立汤池。","keywords":"捷丝旅宜兰礁溪馆, 宜兰礁溪温泉饭店, 宜兰礁溪温泉住宿, 宜兰礁溪温泉推荐, 泡汤住宿推荐, 礁溪住宿推荐, 宜兰旅游, 宜兰旅行, 宜兰景点, 宜兰美食, 宜兰打卡景点"},"rooms":{"title":"官网订房保证最低价 | 捷丝旅 宜兰礁溪馆","description":"快来！客房分为日式和洋式，每房拥有独立汤池，旅人可尽情放松享受泡汤时光，适合情侣、好友及家庭旅游。官网订房最低价，并享高铁订票75折优惠！","keywords":"捷丝旅宜兰礁溪馆, 宜兰礁溪温泉饭店, 宜兰礁溪温泉住宿, 宜兰礁溪温泉推荐, 泡汤住宿推荐, 礁溪住宿推荐, 礁溪泡汤, 美人汤泉, 独立汤池"},"diningsandmeetings":{"title":"餐厅会议 | 捷丝旅 宜兰礁溪馆","description":"景观会议室是举办小型或中型会议与活动的最佳场所。 Just Café提供多样的朝食选择，五星级主厨细心严选食材，让旅客吃的健康开心并重复回来。","keywords":"捷丝旅宜兰礁溪馆, 宜兰礁溪温泉饭店, 宜兰礁溪温泉住宿, 宜兰礁溪温泉推荐, 泡汤住宿推荐, 礁溪住宿推荐, 独立汤池, 礁溪会议场地, 礁溪在地美食"},"amenities":{"title":"设施服务 | 捷丝旅 宜兰礁溪馆","description":"最佳体验亲子活动的地点。 「奶奶的文具店」里的物品，你的奶奶也有吗?全馆提供露天风吕、男女裸汤等设施，另设有亲子游戏空间「传统游艺间」。","keywords":"捷丝旅宜兰礁溪馆, 宜兰礁溪温泉饭店, 宜兰礁溪温泉住宿, 宜兰礁溪温泉推荐, 泡汤住宿推荐, 礁溪住宿推荐, 温泉泡汤, 礁溪休闲设施, 礁溪亲子设施, 礁溪温泉裸汤"},"activities":{"title":"馆内活动 | 捷丝旅 宜兰礁溪馆","description":"小孩的天堂，把家长与小孩之间的距离拉得更近，一个充分了解小孩的机会。每季皆提供不同的DIY体验，适合亲子共同参与、共度欢乐的旅行时光。","keywords":"捷丝旅宜兰礁溪馆, 宜兰礁溪温泉饭店, 宜兰礁溪温泉住宿, 宜兰礁溪温泉推荐, 泡汤住宿推荐, 礁溪住宿推荐, 饭店活动, 宜兰景点推荐, 宜兰旅游行程"},"directions":{"title":"交通景点 | 捷丝旅 宜兰礁溪馆","description":"离热闹的礁溪商圈及著名观光景点，如五峰旗风景区、汤围沟公园等只有几步路。全馆邻近礁溪火车站、礁溪转运站、公车站等交通位置，交通位置便利快捷。","keywords":"捷丝旅宜兰礁溪馆, 宜兰礁溪温泉饭店, 宜兰礁溪温泉住宿, 宜兰礁溪温泉推荐, 泡汤住宿推荐, 礁溪住宿推荐, 宜兰景点, 礁溪景点, 宜兰礁溪交通, 宜兰打卡景点, 汤围沟温泉, 五峰旗瀑布"},"promotions":{"title":"官网订房保证最低价 | 最新优惠 | 捷丝旅 宜兰礁溪馆","description":"一定要注意！官网上不定期推出住房专案、最优惠住房价格、及入住季节专案可享限定好礼。官网上订房最低价，可享高铁订票75折优惠！","keywords":"捷丝旅宜兰礁溪馆, 宜兰礁溪温泉饭店, 宜兰礁溪温泉住宿, 宜兰礁溪温泉推荐, 泡汤住宿推荐, 礁溪住宿推荐, 宜兰饭店优惠, 早鸟住房, 季节限定, 宜兰礁溪住房优惠"}},"ja":{"home":{"title":"ご予約は当サイトが最もお得です | ジャストスリープ宜蘭礁溪館","description":"礁渓の市街地に位置し、徒歩2分で礁渓ショッピングエリア、5分で礁渓駅に向かうことができます。全館すべての客室に独立した浴槽が設けられています。お手頃な料金、親切なサービスは、礁渓でのリゾートへの宿泊先にまず選ぶべきホテルです。","keywords":"宜蘭礁渓温泉ホテル、宜蘭礁渓での温泉と宿泊、宜蘭礁渓温泉でおすすめの温泉、おすすめの温泉と宿泊、礁渓の宿泊のおすすめ、宜蘭の旅、宜蘭旅行、宜蘭の観光スポット、宜蘭の美食、宜蘭のチェックポイント"},"rooms":{"title":"ご予約は当サイトが最もお得です | ジャストスリープ宜蘭礁溪館","description":"7-12坪の快適な客室です。各部屋すべてに独立した浴槽が設けられています。お客様に心行くまでご入浴の時をお楽しみいただきます。客室は2-8名様でご宿泊いただけます。カップル、親しいご友人やご家族でのご旅行に適しています。","keywords":"宜蘭礁渓温泉ホテル、宜蘭礁渓での温泉と宿泊、宜蘭礁渓温泉でおすすめの温泉、おすすめの温泉と宿泊、礁渓の宿泊のおすすめ"},"diningsandmeetings":{"title":"レストラン、会議 | ジャストスリープ宜蘭礁溪館","description":"Just Café ジャストカフェではビュッフェスタイルの朝食をご提供しています。シェフ厳選の地元の新鮮な食材による豊富で多様な朝食の選択をお客様にご提供しています。このほか中小型の会議室のスペースが設けられています。60-150名様での会議とイベントの開催に適しています。","keywords":"宜蘭礁渓温泉ホテル、宜蘭礁渓での温泉と宿泊、宜蘭礁渓温泉でおすすめの温泉、おすすめの温泉と宿泊、礁渓の宿泊のおすすめ"},"amenities":{"title":"レストラン、会議 | ジャストスリープ宜蘭礁溪館","description":"当ホテルでは露天風呂、男女別での大浴場などの設備をご提供しています。このほか親子でのプレイスペース「伝統遊芸間」、「おばあちゃんの文具店」が設けられ、親子でのご旅行、温泉を楽しむ旅の宿に最良の選択です。","keywords":"宜蘭礁渓温泉ホテル、宜蘭礁渓での温泉と宿泊、宜蘭礁渓温泉でおすすめの温泉、おすすめの温泉と宿泊、礁渓の宿泊のおすすめ"},"activities":{"title":"館内イベント | ジャストスリープ宜蘭礁溪館","description":"季節ごとに異なるDIY体験をご提供しています。親子で一緒に参加するのに適しており、共に楽しい旅の時間をお過ごしいただくことで、お客様のリゾートでの旅のスケジュールとすばらしい休暇を豊かなものにします。","keywords":"宜蘭礁渓温泉ホテル、宜蘭礁渓での温泉と宿泊、宜蘭礁渓温泉でおすすめの温泉、おすすめの温泉と宿泊、礁渓の宿泊のおすすめ"},"directions":{"title":"交通アクセス | ジャストスリープ宜蘭礁溪館","description":"全館礁渓駅、礁渓転運駅(礁渓ターミナル駅)、バス停などの交通の要所に隣接しています。アクセスが便利ですばやく、徒歩で賑やかな礁渓ショッピングエリアと五峰風景区、湯圍溝温泉公園などの有名な観光スポットに向かうことができます。","keywords":"宜蘭礁渓温泉ホテル、宜蘭礁渓での温泉と宿泊、宜蘭礁渓温泉でおすすめの温泉、おすすめの温泉と宿泊、礁渓の宿泊のおすすめ、宜蘭のおすすめ観光スポット、宜蘭の旅行日程、礁渓の観光スポット、宜蘭礁渓へのアクセス、ホテルからの送迎、宜蘭のチェックポイント、湯圍溝温泉、五峰旗瀑布"},"promotions":{"title":"ご予約は当サイトが最もお得です | 最新情報 | ジャストスリープ宜蘭礁溪館","description":"当ホテルでは不定期にご宿泊プランと割引情報をリリースしています。公式ウェブサイトではお客様に最も優れた客室料金をご提供しております。お客様専用の割引情報を入手するためにも、最新情報にご注目ください。","keywords":"宜蘭礁渓温泉ホテル、宜蘭礁渓での温泉と宿泊、宜蘭礁渓温泉でおすすめの温泉、おすすめの温泉と宿泊、礁渓の宿泊のおすすめ、宜蘭のホテルの割引、宜蘭礁渓の宿泊割引"}},"ko":{"home":{"title":"공식 사이트에서 예약하는 것이 가장 저렴합니다 | 저스트슬립 이란 자오시점","description":"자오시 시내에 위치해 있으며, 자오시 상권까지 도보로 2분, 자오시 기차역까지 도보로 5분이면 이동이 가능하며, 전 호텔 객실에 온천탕을 구비하고 있습니다. 저렴한 가격과 따뜻한 서비스와 함께 자오시에서의 휴가를 위한 최고의 선택이 될것입니다.","keywords":"이란 자오시 온천호텔, 이란 자오시 온천 숙박, 이란 자오시 온천 추천, 온천호텔 추천, 자오시 숙박 추천, 넓은 온천탕, 이란여행, 이란여행, 이란명소, 이란의 맛있는 음식, 이란에서 가볼 만한 명소"},"rooms":{"title":"공식 사이트에서 예약하는 것이 가장 저렴합니다 | 저스트슬립 이란 자오시점","description":"7－12평의 편안한 객실, 모든 객실에 온천탕을 구비하고 있어 편안하게 온천을 즐기실 수 있습니다. 객실은 2-8인 입실이 가능하여 연인, 친구 및 가족여행에 안성맞춤입니다.","keywords":"이란 자오시 온천호텔, 이란 자오시 온천 숙박, 이란 자오시 온천 추천, 온천호텔 추천, 자오시 숙박 추천, 넓은 온천탕, 이란여행, 이란여행, 이란명소, 이란의 맛있는 음식, 이란에서 가볼 만한 명소"},"diningsandmeetings":{"title":"다이닝 & 연회 회의 | 저스트슬립 이란 자오시점","description":"Just Café에서는 뷔페식 조식을 제공해드리며, 메인 셰프가 엄선한 신선한 현지의 식재료로 샐러드, 과일, 베이커리, 죽 및 기타 요리 등 여행객에게 더욱 풍성하고 다양한 초이스와 제공해 드리며 아름답고 여유로운 아침시간을 선사해 드리며, 또한 중소형의 회의실 공간을 구비하고 있으며 60-150명 규모의 회의 및 행사에 안성맞춤입니다.","keywords":"이란 자오시 온천호텔, 이란 자오시 온천 숙박, 이란 자오시 온천 추천, 온천호텔 추천, 자오시 숙박 추천, 넓은 온천탕, 이란여행, 이란여행, 이란명소, 이란의 맛있는 음식, 이란에서 가볼 만한 명소"},"amenities":{"title":"테마 | 저스트슬립 이란 자오시점","description":"노천탕, 남녀탕등의 온천시설과 오락공간인「전통놀이 공간」, 「할머니의 문구점」은 여가 및 온천여행의 최고의 선택입니다.","keywords":"이란 자오시 온천호텔, 이란 자오시 온천 숙박, 이란 자오시 온천 추천, 온천호텔 추천, 자오시 숙박 추천, 넓은 온천탕, 이란여행, 이란여행, 이란명소, 이란의 맛있는 음식, 이란에서 가볼 만한 명소"},"activities":{"title":"관내활동 | 저스트슬립 이란 자오시점","description":"매 계절마다 제공되는 다양한 DIY체험은 내가 직접 참여하고 즐길 수 있는 여행에 안성맞춤이며 더욱 풍성하고 아름다운 여행의 시간을 선사해 드립니다.","keywords":"이란 자오시 온천호텔, 이란 자오시 온천 숙박, 이란 자오시 온천 추천, 온천호텔 추천, 자오시 숙박 추천, 넓은 온천탕, 이란여행, 이란여행, 이란명소, 이란의 맛있는 음식, 이란에서 가볼 만한 명소"},"directions":{"title":"시설 | 저스트슬립 이란 자오시점","description":"호텔이 위치한 곳은 자오시 열차역, 자오시 전철역, 버스터미널등과 인접한 교통의 허브이며, 교통이 편리하고 빠르며 도한 도보로 핫플레이스인 자오시 상권 및 우펑치풍경구(五峰旗风景区), 탕웨이꺼우 온천공원(汤围沟温泉公园)등의 유명한 관광지까지 바로 이동이 가능합니다.","keywords":"이란 자오시 온천호텔, 이란 자오시 온천 숙박, 이란 자오시 온천 추천, 온천호텔 추천, 자오시 숙박 추천, 넓은 온천탕, 이란여행, 이란여행, 이란명소, 이란의 맛있는 음식, 이란에서 가볼 만한 명소"},"promotions":{"title":"공식 사이트에서 예약하는 것이 가장 저렴합니다 | 최신소식 | 저스트슬립 이란 자오시점","description":"호텔에서는 깜짝 이벤트 및 할인혜택에 관한 정보를 제공해 드리며, 홈페이지에서 여행객을 위한 가장 저렴한 가격을 제공해 드립니다. 여행객을 위한 특별 할인에 관한 최신 정보를 놓치지 마세요.","keywords":"이란 자오시 온천호텔, 이란 자오시 온천 숙박, 이란 자오시 온천 추천, 온천호텔 추천, 자오시 숙박 추천, 넓은 온천탕, 이란 호텔 혜택, 이란 자오시 투숙 혜택"}}}

/***/ }),
/* 582 */
/***/ (function(module, exports) {

module.exports = {"en":{"home":{"title":"Best Rate and Service Guarantee | Book Direct with Just Sleep Kaohsiung Zhongzheng","description":"Being submerged in a fashionable musical atmosphere, Just Sleep Kaohsiung Zhongzheng is also surrounded by Taiwanese specialty snacks around the corner.","keywords":"Just Sleep Kaohsiung Zhongzheng, Just Sleep, hotels in Kaohsiung, Kaohsiung hotel recommendation, best hotel Kaohsiung, Kaohsiung hotel recommodation, Kaohsiung travel, Kaohsiung tourism, Taiwan travel, Taiwan tourism, budget travelling Taiwan, budget travelling Kaohsiung,  Kaohsiung culture, Taiwan culture, Kaohsiung attractions, Taiwan attractions, Kaohsiung food, Taiwan food,Business Hotel Kaohsiung,convenient hotel Kaohsiung, Kaohsiung hotel music"},"rooms":{"title":"Best Hotel Price Guarantee | Book Direct with Just Sleep Kaohsiung Zhongzheng","description":"Each of our rooms expresses modern chic in distinct ways and contains a world-renowned, body contouring Wellspring Bed to ensure a restful sleep.","keywords":"Just Sleep Kaohsiung Zhongzheng, Just Sleep, hotels in Kaohsiung, Kaohsiung hotel recommendation, best hotel Kaohsiung, Kaohsiung hotel recommodation, Kaohsiung travel, Kaohsiung tourism, Taiwan travel, Taiwan tourism, budget travelling Taiwan, budget travelling Kaohsiung,  Kaohsiung culture, Taiwan culture, Kaohsiung attractions, Taiwan attractions, Kaohsiung food, Taiwan food,Business Hotel Kaohsiung,convenient hotel Kaohsiung, Kaohsiung hotel bed"},"diningsandmeetings":{"title":"Dinings & Meetings | Just Sleep Kaohsiung Zhongzheng","description":"Filling you with positivity and energy, Just Sleep Kaohsiung Zhongzheng adheres to the principle of providing fresh, healthy, and creative fusion cuisines.","keywords":"Just Sleep Kaohsiung Zhongzheng, Just Sleep, hotels in Kaohsiung, Kaohsiung hotel recommendation, best hotel Kaohsiung, Kaohsiung hotel recommodation, Kaohsiung travel, Kaohsiung tourism, Taiwan travel, Taiwan tourism, budget travelling Taiwan, budget travelling Kaohsiung,  Kaohsiung culture, Taiwan culture, Kaohsiung attractions, Taiwan attractions, Kaohsiung food, Taiwan food,Business Hotel Kaohsiung,convenient hotel Kaohsiung"},"amenities":{"title":"Amenities | Just Sleep Kaohsiung Zhongzheng","description":"A friendly lounge, a professional meeting room, a nonjudgmental gym, a clean laundry room, and two computers are available to provide a freely creative space.","keywords":"Just Sleep Kaohsiung Zhongzheng, Just Sleep, hotels in Kaohsiung, Kaohsiung hotel recommendation, best hotel Kaohsiung, Kaohsiung hotel recommodation, Kaohsiung travel, Kaohsiung tourism, Taiwan travel, Taiwan tourism, budget travelling Taiwan, budget travelling Kaohsiung,  Kaohsiung culture, Taiwan culture, Kaohsiung attractions, Taiwan attractions, Kaohsiung food, Taiwan food,Business Hotel Kaohsiung,convenient hotel Kaohsiung"},"activities":{"title":"Activities | Just Sleep Kaohsiung Zhongzheng","description":"Just Sleep Kaohsiung Zhongzheng is the right place to go down memory lane with people you have made new connections with through different seasonal events.","keywords":"Just Sleep Kaohsiung Zhongzheng, Just Sleep, hotels in Kaohsiung, Kaohsiung hotel recommendation, best hotel Kaohsiung, Kaohsiung hotel recommodation, Kaohsiung travel, Kaohsiung tourism, Taiwan travel, Taiwan tourism, budget travelling Taiwan, budget travelling Kaohsiung,  Kaohsiung culture, Taiwan culture, Kaohsiung attractions, Taiwan attractions, Kaohsiung food, Taiwan food,Business Hotel Kaohsiung,convenient hotel Kaohsiung"},"directions":{"title":"Directions | Just Sleep Kaohsiung Zhongzheng","description":"Being planted on a historic area, we are in the heart of the city, a few minutes away from public transportations, major landmarks, and shopping centers.","keywords":"Just Sleep Kaohsiung Zhongzheng, Just Sleep, hotels in Kaohsiung, Kaohsiung hotel recommendation, best hotel Kaohsiung, Kaohsiung hotel recommodation, Kaohsiung travel, Kaohsiung tourism, Taiwan travel, Taiwan tourism, budget travelling Taiwan, budget travelling Kaohsiung,  Kaohsiung culture, Taiwan culture, Kaohsiung attractions, Taiwan attractions, Kaohsiung food, Taiwan food,Business Hotel Kaohsiung,convenient hotel Kaohsiung"},"promotions":{"title":"Saving Money with Best Rate Guarantee | Book Direct with Just Sleep Kaohsiung Zhongzheng","description":"Only here for a little bit! We’re offering various generous room packages and deals if you book a reservation on our official website!","keywords":"Just Sleep Kaohsiung Zhongzheng, Just Sleep, hotels in Kaohsiung, Kaohsiung hotel recommendation, best hotel Kaohsiung, Kaohsiung hotel recommodation, Kaohsiung travel, Kaohsiung tourism, Taiwan travel, Taiwan tourism, budget travelling Taiwan, budget travelling Kaohsiung,  Kaohsiung culture, Taiwan culture, Kaohsiung attractions, Taiwan attractions, Kaohsiung food, Taiwan food,Business Hotel Kaohsiung,convenient hotel Kaohsiung"}},"zh-TW":{"home":{"title":"官網訂房最低價，另享高鐵訂票75折優惠 | 捷絲旅 高雄中正館","description":"「捷絲旅高雄中正館」以音樂為設計主軸，內部設計具時尚音樂風格與實用功能。本館近捷運站、衛武營國家藝術文化中心及武廟夜市，提供不同凡響體驗。","keywords":"捷絲旅高雄中正館, 高雄酒店, 高雄飯店, 高雄商務飯店, 高雄旅店, 高雄住宿, 高雄酒店推薦, 高雄飯店推薦, 高雄旅店推薦, 高雄住宿推薦, 高雄商務飯店推薦,高雄旅遊, 台灣旅遊, 台灣自由行, 高雄自由行, 台灣自助旅行, 高雄自助旅行, 高雄景點, 高雄美食, 高雄旅遊, 台灣文化, 台灣休閒, 台灣景點, 高雄交通便利飯店,高雄訂房"},"rooms":{"title":"官網訂房最低價，另享高鐵訂票75折優惠 | 捷絲旅 高雄中正館","description":"設計精巧的客房採用國際級的感溫、塑形Wellspring床墊，提供絕對舒適的睡眠品質。頂級淋浴設備、寬頻無線上網等，給旅客最新科技的便利性。","keywords":"捷絲旅高雄中正館, 高雄酒店, 高雄飯店, 高雄商務飯店, 高雄旅店, 高雄住宿, 高雄酒店推薦, 高雄飯店推薦, 高雄旅店推薦, 高雄住宿推薦, 高雄商務飯店推薦,高雄旅遊, 台灣旅遊, 台灣自由行, 高雄自由行, 台灣自助旅行, 高雄自助旅行, 高雄景點, 高雄美食, 高雄旅遊, 台灣文化, 台灣休閒, 台灣景點, 高雄交通便利飯店,高雄訂房"},"diningsandmeetings":{"title":"餐廳會議 | 捷絲旅 高雄中正館","description":"捷絲旅高雄中正館提供旅人豐富、多樣的朝食選擇，從沙拉、水果、麵包、熱粥、小菜等，結合在地當季蔬果，為旅人送上輕鬆無負擔的時尚精緻蔬食。","keywords":"捷絲旅高雄中正館, 高雄酒店, 高雄飯店, 高雄商務飯店, 高雄旅店, 高雄住宿, 高雄酒店推薦, 高雄飯店推薦, 高雄旅店推薦, 高雄住宿推薦, 高雄商務飯店推薦,高雄旅遊, 台灣旅遊, 台灣自由行, 高雄自由行, 台灣自助旅行, 高雄自助旅行, 高雄景點, 高雄美食, 高雄旅遊, 台灣文化, 台灣休閒, 台灣景點, 高雄交通便利飯店,高雄訂房"},"amenities":{"title":"設施服務 | 捷絲旅 高雄中正館","description":"為了讓無論商務人士或是自助行旅客都能感受便利且舒適的時光，捷絲旅高雄中正館設有小型會議室、響樂交誼廳、健身室、免費上網區及自助洗衣室。","keywords":"捷絲旅高雄中正館, 高雄酒店, 高雄飯店, 高雄商務飯店, 高雄旅店, 高雄住宿, 高雄酒店推薦, 高雄飯店推薦, 高雄旅店推薦, 高雄住宿推薦, 高雄商務飯店推薦,高雄旅遊, 台灣旅遊, 台灣自由行, 高雄自由行, 台灣自助旅行, 高雄自助旅行, 高雄景點, 高雄美食, 高雄旅遊, 台灣文化, 台灣休閒, 台灣景點,  高雄交通便利飯店,高雄訂房"},"activities":{"title":"館內活動 | 捷絲旅 高雄中正館","description":"捷絲旅高雄中正館不定期推出季節性的活動，為旅人打造旅行歡樂時光並且在分享旅行經驗中創造出結交新朋友的機會。","keywords":"捷絲旅高雄中正館, 高雄酒店, 高雄飯店, 高雄商務飯店, 高雄旅店, 高雄住宿, 高雄酒店推薦, 高雄飯店推薦, 高雄旅店推薦, 高雄住宿推薦, 高雄商務飯店推薦,高雄旅遊, 台灣旅遊, 台灣自由行, 高雄自由行, 台灣自助旅行, 高雄自助旅行, 高雄景點, 高雄美食, 高雄旅遊, 台灣文化, 台灣休閒, 台灣景點, 高雄交通便利飯店,高雄訂房"},"directions":{"title":"交通景點 | 捷絲旅 高雄中正館","description":"提供旅人不同凡響的便利旅宿體驗，從捷絲旅高雄中正館可步行抵達高雄捷運技擊館站，衛武營國家藝術文化中心及武廟夜市。","keywords":"捷絲旅高雄中正館, 高雄酒店, 高雄飯店, 高雄商務飯店, 高雄旅店, 高雄住宿, 高雄酒店推薦, 高雄飯店推薦, 高雄旅店推薦, 高雄住宿推薦, 高雄商務飯店推薦,高雄旅遊, 台灣旅遊, 台灣自由行, 高雄自由行, 台灣自助旅行, 高雄自助旅行, 高雄景點, 高雄美食, 高雄旅遊, 台灣文化, 台灣休閒, 台灣景點, 高雄交通便利飯店,高雄訂房"},"promotions":{"title":"官網訂房最低價，另享高鐵訂票75折優惠 | 最新優惠 | 捷絲旅 高雄中正館","description":"不要錯過，官網訂房最低價！捷絲旅高雄中正館推出豐富住房優惠，鎖定最新消息優惠訊息，不漏接！","keywords":"捷絲旅高雄中正館, 高雄酒店, 高雄飯店, 高雄商務飯店, 高雄旅店, 高雄住宿, 高雄酒店推薦, 高雄飯店推薦, 高雄旅店推薦, 高雄住宿推薦, 高雄商務飯店推薦,高雄旅遊, 台灣旅遊, 台灣自由行, 高雄自由行, 台灣自助旅行, 高雄自助旅行, 高雄景點, 高雄美食, 高雄旅遊, 台灣文化, 台灣休閒, 台灣景點, 高雄交通便利飯店,高雄訂房"}},"zh-CN":{"home":{"title":"官网订房保证最低价 | 捷丝旅 高雄中正馆","description":"「捷丝旅高雄中正馆」以音乐为设计主轴，内部设计具时尚音乐风格与实用功能。本馆近捷运站、卫武营国家艺术文化中心及武庙夜市，提供不同凡响体验。","keywords":"捷丝旅高雄中正馆, 高雄酒店, 高雄饭店, 高雄商务饭店, 高雄旅店, 高雄住宿, 高雄酒店推荐, 高雄饭店推荐, 高雄旅店推荐, 高雄住宿推荐, 高雄商务饭店推荐,高雄旅游, 台湾旅游, 台湾自由行, 高雄自由行, 台湾自助旅行, 高雄自助旅行, 高雄景点, 高雄美食, 高雄旅游, 台湾文化, 台湾休閒, 台湾景点,  高雄交通便利饭店,高雄订房"},"rooms":{"title":"官网订房保证最低价 | 捷丝旅 高雄中正馆","description":"设计精巧的客房采用国际级的感温、塑形Wellspring床垫，提供绝对舒适的睡眠品质。顶级淋浴设备、宽频无线上网等，给旅客最新科技的便利性。","keywords":"捷丝旅高雄中正馆, 高雄酒店, 高雄饭店, 高雄商务饭店, 高雄旅店, 高雄住宿, 高雄酒店推荐, 高雄饭店推荐, 高雄旅店推荐, 高雄住宿推荐, 高雄商务饭店推荐,高雄旅游, 台湾旅游, 台湾自由行, 高雄自由行, 台湾自助旅行, 高雄自助旅行, 高雄景点, 高雄美食, 高雄旅游, 台湾文化, 台湾休閒, 台湾景点,  高雄交通便利饭店,高雄订房"},"diningsandmeetings":{"title":"餐厅会议 | 捷丝旅 高雄中正馆","description":"捷丝旅高雄中正馆提供旅人丰富、多样的朝食选择，从沙拉、水果、面包、热粥、小菜等，结合在地当季蔬果，为旅人送上轻松无负担的时尚精致蔬食。","keywords":"捷丝旅高雄中正馆, 高雄酒店, 高雄饭店, 高雄商务饭店, 高雄旅店, 高雄住宿, 高雄酒店推荐, 高雄饭店推荐, 高雄旅店推荐, 高雄住宿推荐, 高雄商务饭店推荐,高雄旅游, 台湾旅游, 台湾自由行, 高雄自由行, 台湾自助旅行, 高雄自助旅行, 高雄景点, 高雄美食, 高雄旅游, 台湾文化, 台湾休閒, 台湾景点,  高雄交通便利饭店,高雄订房"},"amenities":{"title":"设施服务 | 捷丝旅 高雄中正馆","description":"为了让无论商务人士或是自助行旅客都能感受便利且舒适的时光，捷丝旅高雄中正馆设有小型会议室、响乐交谊厅、健身室、免费上网区及自助洗衣室。","keywords":"捷丝旅高雄中正馆, 高雄酒店, 高雄饭店, 高雄商务饭店, 高雄旅店, 高雄住宿, 高雄酒店推荐, 高雄饭店推荐, 高雄旅店推荐, 高雄住宿推荐, 高雄商务饭店推荐,高雄旅游, 台湾旅游, 台湾自由行, 高雄自由行, 台湾自助旅行, 高雄自助旅行, 高雄景点, 高雄美食, 高雄旅游, 台湾文化, 台湾休閒, 台湾景点, 高雄交通便利饭店,高雄订房"},"activities":{"title":"馆内活动 | 捷丝旅 高雄中正馆","description":"捷丝旅高雄中正馆不定期推出季节性的活动，为旅人打造旅行欢乐时光并且在分享旅行经验中创造出结交新朋友的机会。","keywords":"捷丝旅高雄中正馆, 高雄酒店, 高雄饭店, 高雄商务饭店, 高雄旅店, 高雄住宿, 高雄酒店推荐, 高雄饭店推荐, 高雄旅店推荐, 高雄住宿推荐, 高雄商务饭店推荐,高雄旅游, 台湾旅游, 台湾自由行, 高雄自由行, 台湾自助旅行, 高雄自助旅行, 高雄景点, 高雄美食, 高雄旅游, 台湾文化, 台湾休閒, 台湾景点, 高雄交通便利饭店,高雄订房"},"directions":{"title":"交通景点 | 捷丝旅 高雄中正馆","description":"提供旅人不同凡响的便利旅宿体验，从捷丝旅高雄中正馆可步行抵达高雄捷运技击馆站，卫武营国家艺术文化中心及武庙夜市。","keywords":"捷丝旅高雄中正馆, 高雄酒店, 高雄饭店, 高雄商务饭店, 高雄旅店, 高雄住宿, 高雄酒店推荐, 高雄饭店推荐, 高雄旅店推荐, 高雄住宿推荐, 高雄商务饭店推荐,高雄旅游, 台湾旅游, 台湾自由行, 高雄自由行, 台湾自助旅行, 高雄自助旅行, 高雄景点, 高雄美食, 高雄旅游, 台湾文化, 台湾休閒, 台湾景点, 高雄交通便利饭店,高雄订房"},"promotions":{"title":"官网订房保证最低价 | 最新优惠 | 捷丝旅 高雄中正馆","description":"不要错过，官网订房最低价！捷丝旅高雄中正馆推出丰富住房优惠，锁定最新消息优惠讯息，不漏接！","keywords":"捷丝旅高雄中正馆, 高雄酒店, 高雄饭店, 高雄商务饭店, 高雄旅店, 高雄住宿, 高雄酒店推荐, 高雄饭店推荐, 高雄旅店推荐, 高雄住宿推荐, 高雄商务饭店推荐,高雄旅游, 台湾旅游, 台湾自由行, 高雄自由行, 台湾自助旅行, 高雄自助旅行, 高雄景点, 高雄美食, 高雄旅游, 台湾文化, 台湾休閒, 台湾景点, 高雄交通便利饭店,高雄订房"}},"ja":{"home":{"title":"ご予約は当サイトが最もお得です | ジャストスリープ高雄中正館","description":"ジャストスリープ高雄中正館は現代の建物、おしゃれで実用性を備えた内装デザインで、MRT技撃館駅の真向かいに位置して、大変便利なロケーションにあります。","keywords":"ジャストスリープ高雄中正館、ジャストスリープ高雄、高雄ビスネスホテル、家族ホテル、ラグジュアリーホテル、ブティックホテル、デザイナーズホテル、ベストホテル、高雄 宿泊、高雄観光、高雄旅行、台湾旅行、台湾おすすめホテル、高雄おすすめホテル、高雄文化、高雄レジャー、高雄観光スポット、高雄の料理、台湾の文化、台湾レジャー、台湾観光スポット、台湾の料理、台湾観光、高雄厳選ホテル、高雄で泊まりたいホテル高雄の格安ホテル、高雄の人気ホテル、高雄観光に便利なホテル、高雄で駅近のホテル"},"rooms":{"title":"ご予約は当サイトが最もお得です | ジャストスリープ高雄中正館","description":"ジャストスリープ高雄中正館はおしゃれなデザインの客室が158室、国際的知名度を誇るWellspring社のマットレス、高級シャワー設備なども完備しています。","keywords":"ジャストスリープ高雄中正館、ジャストスリープ高雄、高雄ビスネスホテル、家族ホテル、ラグジュアリーホテル、ブティックホテル、デザイナーズホテル、ベストホテル、高雄 宿泊、高雄観光、高雄旅行、台湾旅行、台湾おすすめホテル、高雄おすすめホテル、高雄文化、高雄レジャー、高雄観光スポット、高雄の料理、台湾の文化、台湾レジャー、台湾観光スポット、台湾の料理、台湾観光、高雄厳選ホテル、高雄で泊まりたいホテル高雄の格安ホテル、高雄の人気ホテル、高雄観光に便利なホテル、高雄で駅近のホテル"},"diningsandmeetings":{"title":"レストラン、会議 | ジャストスリープ高雄中正館","description":"ジャストスリープ高雄中正館は自然、新鮮、健康、革新の経営理念を貫きます。お客様の健康のため、使っている食材は最も新鮮な果物や野菜とユニークな味のしいたけにこだわっています。","keywords":"ジャストスリープ高雄中正館、ジャストスリープ高雄、高雄ビスネスホテル、家族ホテル、ラグジュアリーホテル、ブティックホテル、デザイナーズホテル、ベストホテル、高雄 宿泊、高雄観光、高雄旅行、台湾旅行、台湾おすすめホテル、高雄おすすめホテル、高雄文化、高雄レジャー、高雄観光スポット、高雄の料理、台湾の文化、台湾レジャー、台湾観光スポット、台湾の料理、台湾観光、高雄厳選ホテル、高雄で泊まりたいホテル高雄の格安ホテル、高雄の人気ホテル、高雄観光に便利なホテル、高雄で駅近のホテル"},"amenities":{"title":"レジャー施設 | ジャストスリープ高雄中正館","description":"ジャストスリープ高雄中正館には映画音楽とクラシック音楽など、いろいろなタイプがあります。また、ラウンジで本、雑誌、中国語と日本語の新聞、コンピュータは宿泊のお客様に無料で提供しています。","keywords":"ジャストスリープ高雄中正館、ジャストスリープ高雄、高雄ビスネスホテル、家族ホテル、ラグジュアリーホテル、ブティックホテル、デザイナーズホテル、ベストホテル、高雄 宿泊、高雄観光、高雄旅行、台湾旅行、台湾おすすめホテル、高雄おすすめホテル、高雄文化、高雄レジャー、高雄観光スポット、高雄の料理、台湾の文化、台湾レジャー、台湾観光スポット、台湾の料理、台湾観光、高雄厳選ホテル、高雄で泊まりたいホテル高雄の格安ホテル、高雄の人気ホテル、高雄観光に便利なホテル、高雄で駅近のホテル"},"activities":{"title":"館内イベント | ジャストスリープ高雄中正館","description":"ジャストスリープ高雄中正館は客が楽しい旅にするために、不定期的にイベントを開催します。","keywords":"ジャストスリープ高雄中正館、ジャストスリープ高雄、高雄ビスネスホテル、家族ホテル、ラグジュアリーホテル、ブティックホテル、デザイナーズホテル、ベストホテル、高雄 宿泊、高雄観光、高雄旅行、台湾旅行、台湾おすすめホテル、高雄おすすめホテル、高雄文化、高雄レジャー、高雄観光スポット、高雄の料理、台湾の文化、台湾レジャー、台湾観光スポット、台湾の料理、台湾観光、高雄厳選ホテル、高雄で泊まりたいホテル高雄の格安ホテル、高雄の人気ホテル、高雄観光に便利なホテル、高雄で駅近のホテル"},"directions":{"title":"交通アクセス | ジャストスリープ高雄中正館","description":"ジャストスリープ高雄の近くには衛武営都会公園、芸術文化センター、多くのレストランや商店が軒を連ねる武氏廟路などがあって、自然や芸術、高雄の郷土料理を存分にお楽しみいただけます。","keywords":"ジャストスリープ高雄中正館、ジャストスリープ高雄、高雄ビスネスホテル、家族ホテル、ラグジュアリーホテル、ブティックホテル、デザイナーズホテル、ベストホテル、高雄 宿泊、高雄観光、高雄旅行、台湾旅行、台湾おすすめホテル、高雄おすすめホテル、高雄文化、高雄レジャー、高雄観光スポット、高雄の料理、台湾の文化、台湾レジャー、台湾観光スポット、台湾の料理、台湾観光、高雄厳選ホテル、高雄で泊まりたいホテル高雄の格安ホテル、高雄の人気ホテル、高雄観光に便利なホテル、高雄で駅近のホテル"},"promotions":{"title":"ご予約は当サイトが最もお得です | 最新情報 | ジャストスリープ高雄中正館","description":"ジャストスリープ高雄中正館は季節のご案内やホテルプロモーション情報などを配信しております。ニュースレターにご登録ください。","keywords":"ジャストスリープ高雄中正館、ジャストスリープ高雄、高雄ビスネスホテル、家族ホテル、ラグジュアリーホテル、ブティックホテル、デザイナーズホテル、ベストホテル、高雄 宿泊、高雄観光、高雄旅行、台湾旅行、台湾おすすめホテル、高雄おすすめホテル、高雄文化、高雄レジャー、高雄観光スポット、高雄の料理、台湾の文化、台湾レジャー、台湾観光スポット、台湾の料理、台湾観光、高雄厳選ホテル、高雄で泊まりたいホテル高雄の格安ホテル、高雄の人気ホテル、高雄観光に便利なホテル、高雄で駅近のホテル"}},"ko":{"home":{"title":"공식 사이트에서 예약하는 것이 가장 저렴합니다 | 저스트슬립 가오슝 중정점","description":"저스트슬립 가오슝 중정점 은문화, 예술중심의 융합된 감각적 디자인으로 넓은 공간을 제공하며 부근에 우먀오 야시장, 웨이우잉 예술문화센터와 지하철역에 인접해있습니다. 투숙객은 다양한 현지 문화를 체험할 수 있습니다.","keywords":"#가오슝호텔 #가오슝비즈니스호텔#가오슝숙박#가오슝여행#가오슝자유여행#가오슝호텔추천#우먀오야시장근쳐호텔#가오슝맛집#가오슝호텔예약#가오슝관광#가오슝호텔할인"},"rooms":{"title":"공식 사이트에서 예약하는 것이 가장 저렴합니다 | 저스트슬립 가오슝 종정점","description":"저스트슬립 가오슝 종정점은 편안한 숙면을 보장할 글로벌 품질 Wellspring 매트리스 등을 갖춘 세련된디자인의 158개 객실을 보유하고 있습니다. 일부 객실의 경우 경치를감상할 수 있는 테라스가 있어 복잡한 도심 속에서 자신만의 공간을 누릴 수있습니다. 이밖에 최고급 욕실 설비 및 광대역 무선 인터넷, 위성TV 등을구비하여 쾌적하고 편리한 공간을 선사하고 있습니다.","keywords":"#가오슝호텔 #가오슝비즈니스호텔#가오슝숙박#가오슝여행#가오슝자유여행#가오슝호텔추천#우먀오야시장근쳐호텔#가오슝맛집#가오슝호텔예약#가오슝관광#가오슝호텔할인"},"diningsandmeetings":{"title":"다이닝 & 연회 회의 | 저스트슬립 가오슝 종정점","description":"저스트슬립 가오슝 종정점은 채식주의 레스토랑은 아침식사(뷔페)를 제공합니다. 모든 음식과 과일은 제철에맞는 식자제를 사용하며, 쌀죽,빵,과일 등 다양한 음식을 제공합니다. 또한, 본 호텔 레스토랑은 채식주의자를 위한 건강한 식단을 제공합니다.","keywords":"#가오슝호텔 #가오슝비즈니스호텔#가오슝숙박#가오슝여행#가오슝자유여행#가오슝호텔추천#우먀오야시장근쳐호텔#가오슝맛집#가오슝호텔예약#가오슝관광#가오슝호텔할인"},"amenities":{"title":"테마 | 저스트슬립 가오슝 종정점","description":"저스트슬립 가오슝 중정점은 라운지,헬스,비즈니스 서비스,셀프 세탁실이 갖추고 있으며 대만에 계시는 동안 편안하고 좋은 시간을 보낼 수 있습니다","keywords":"#가오슝호텔 #가오슝비즈니스호텔#가오슝숙박#가오슝여행#가오슝자유여행#가오슝호텔추천#우먀오야시장근쳐호텔#가오슝맛집#가오슝호텔예약#가오슝관광#가오슝호텔할인"},"activities":{"title":"관내활동 | 저스트슬립 가오슝 종정점","description":"더 알찬 여행을 위해 이벤트 확인하기","keywords":"#가오슝호텔 #가오슝비즈니스호텔#가오슝숙박#가오슝여행#가오슝자유여행#가오슝호텔추천#우먀오야시장근쳐호텔#가오슝맛집#가오슝호텔예약#가오슝관광#가오슝호텔할인"},"directions":{"title":"시설 | 저스트슬립 가오슝 종정점","description":"저스트슬립 가오슝 종정점은 문화,예술중심의 융합된 감각적 디자인으로 넓은 공간을 제공하며 부근에 우먀오[武廟]야시장, 웨이우잉[衛武營] 예술문화센터와 지하철역에 인접해있습니다. 투숙객은 다양한 현지 문화를 체험할수있습니다.","keywords":"#가오슝호텔 #가오슝비즈니스호텔#가오슝숙박#가오슝여행#가오슝자유여행#가오슝호텔추천#우먀오야시장근쳐호텔#가오슝맛집#가오슝호텔예약#가오슝관광#가오슝호텔할인"},"promotions":{"title":"공식 사이트에서 예약하는 것이 가장 저렴합니다 | 최신소식 | 저스트슬립 가오슝 종정점","description":"팔로우해서 스페셜 오퍼 놓치지 않기","keywords":"#가오슝호텔 #가오슝비즈니스호텔#가오슝숙박#가오슝여행#가오슝자유여행#가오슝호텔추천#우먀오야시장근쳐호텔#가오슝맛집#가오슝호텔예약#가오슝관광#가오슝호텔할인"}}}

/***/ }),
/* 583 */
/***/ (function(module, exports) {

module.exports = {"en":{"home":{"title":"Best Rate and Service Guarantee | Book Direct with Just Sleep Kaohsiung Station","description":"Exquisite original art works and custom-made designer furnishings can be seen at the conveniently located Just Sleep Kaohsiung Station.","keywords":"Just Sleep Kaohsiung Zhongzheng, Just Sleep, hotels in Kaohsiung, Kaohsiung hotel recommendation, best hotel Kaohsiung, Kaohsiung hotel recommodation, Kaohsiung travel, Kaohsiung tourism, Taiwan travel, Taiwan tourism, budget travelling Taiwan, budget travelling Kaohsiung,  Kaohsiung culture, Taiwan culture, Kaohsiung attractions, Taiwan attractions, Kaohsiung food, Taiwan food,Business Hotel Kaohsiung,convenient hotel Kaohsiung, hotel art"},"rooms":{"title":"Best Hotel Price Guarantee | Book Direct with Just Sleep Kaohsiung Station","description":"Eye-catching artistic floral designs, a world-renowned body contouring Wellspring bed, and a shower system ensures inspirations and comfort during your stay.","keywords":"Just Sleep Kaohsiung Zhongzheng, Just Sleep, hotels in Kaohsiung, Kaohsiung hotel recommendation, best hotel Kaohsiung, Kaohsiung hotel recommodation, Kaohsiung travel, Kaohsiung tourism, Taiwan travel, Taiwan tourism, budget travelling Taiwan, budget travelling Kaohsiung,  Kaohsiung culture, Taiwan culture, Kaohsiung attractions, Taiwan attractions, Kaohsiung food, Taiwan food,Business Hotel Kaohsiung,convenient hotel Kaohsiung, hotel designs"},"diningsandmeetings":{"title":"Dinings & Meetings | Just Sleep Kaohsiung Station","description":"Multicultural health and innovative dining builds up Double Veggie’s base, and freshly brewed coffee, tea, and delicate light meals make up Jessicafe’s core.","keywords":"Just Sleep Kaohsiung Zhongzheng, Just Sleep, hotels in Kaohsiung, Kaohsiung hotel recommendation, best hotel Kaohsiung, Kaohsiung hotel recommodation, Kaohsiung travel, Kaohsiung tourism, Taiwan travel, Taiwan tourism, budget travelling Taiwan, budget travelling Kaohsiung,  Kaohsiung culture, Taiwan culture, Kaohsiung attractions, Taiwan attractions, Kaohsiung food, Taiwan food,Business Hotel Kaohsiung,convenient hotel Kaohsiung, hotel vegetarian restaurant"},"amenities":{"title":"Amenities | Just Sleep Kaohsiung Station","description":"We are the friendliest place for family getaways. Modern sleek designs, children-friendly amenities, and multi-use facilities can be found with us. ","keywords":"Just Sleep Kaohsiung Zhongzheng, Just Sleep, hotels in Kaohsiung, Kaohsiung hotel recommendation, best hotel Kaohsiung, Kaohsiung hotel recommodation, Kaohsiung travel, Kaohsiung tourism, Taiwan travel, Taiwan tourism, budget travelling Taiwan, budget travelling Kaohsiung,  Kaohsiung culture, Taiwan culture, Kaohsiung attractions, Taiwan attractions, Kaohsiung food, Taiwan food,Business Hotel Kaohsiung,convenient hotel Kaohsiung, Kaohsiung family getaways"},"activities":{"title":"Activities | Just Sleep Kaohsiung Station","description":"Seasonal activities are offered to focus on different values in fastening the bonds between friends, family, and strangers through sharing travel adventures.","keywords":"Just Sleep Kaohsiung Zhongzheng, Just Sleep, hotels in Kaohsiung, Kaohsiung hotel recommendation, best hotel Kaohsiung, Kaohsiung hotel recommodation, Kaohsiung travel, Kaohsiung tourism, Taiwan travel, Taiwan tourism, budget travelling Taiwan, budget travelling Kaohsiung,  Kaohsiung culture, Taiwan culture, Kaohsiung attractions, Taiwan attractions, Kaohsiung food, Taiwan food,Business Hotel Kaohsiung,convenient hotel Kaohsiung, Kaohsiung travel adventures"},"directions":{"title":"Directions | Just Sleep Kaohsiung Station","description":"Being able to taste numerous local food carts and visit attractions in the center of the city while being close to “home” is only possible at ours.","keywords":"Just Sleep Kaohsiung Zhongzheng, Just Sleep, hotels in Kaohsiung, Kaohsiung hotel recommendation, best hotel Kaohsiung, Kaohsiung hotel recommodation, Kaohsiung travel, Kaohsiung tourism, Taiwan travel, Taiwan tourism, budget travelling Taiwan, budget travelling Kaohsiung,  Kaohsiung culture, Taiwan culture, Kaohsiung attractions, Taiwan attractions, Kaohsiung food, Taiwan food,Business Hotel Kaohsiung,convenient hotel Kaohsiung"},"promotions":{"title":"Saving Money with Best Rate Guarantee | Book Direct with Just Sleep Kaohsiung Station","description":"Watch out for exclusive and generous deals that are coming your way! Check out and reserve a room through our official website to get the absolute best deal.","keywords":"Just Sleep Kaohsiung Zhongzheng, Just Sleep, hotels in Kaohsiung, Kaohsiung hotel recommendation, best hotel Kaohsiung, Kaohsiung hotel recommodation, Kaohsiung travel, Kaohsiung tourism, Taiwan travel, Taiwan tourism, budget travelling Taiwan, budget travelling Kaohsiung,  Kaohsiung culture, Taiwan culture, Kaohsiung attractions, Taiwan attractions, Kaohsiung food, Taiwan food,Business Hotel Kaohsiung,convenient hotel Kaohsiung"}},"zh-TW":{"home":{"title":"官網訂房最低價，另享高鐵訂票75折優惠 | 捷絲旅 高雄站前館","description":"結合設計美學，具精品魅力及文創時尚氣息。近高雄火車站、捷運美麗島站及六合夜市，交通便利，為旅客休憩首選。官網訂房最低價，享高鐵訂票75折優惠！","keywords":"捷絲旅高雄站前館, 高雄酒店, 高雄飯店, 高雄商務飯店, 高雄旅店, 高雄住宿, 高雄酒店推薦, 高雄飯店推薦, 高雄旅店推薦, 高雄住宿推薦, 高雄商務飯店推薦,高雄旅遊, 台灣旅遊, 台灣自由行, 高雄自由行, 台灣自助旅行, 高雄自助旅行, 高雄景點, 高雄美食, 高雄旅遊, 台灣文化, 台灣休閒, 台灣景點, 高雄交通便利飯店,高雄訂房"},"rooms":{"title":"官網訂房最低價，另享高鐵訂票75折優惠 | 捷絲旅 高雄站前館","description":"時尚高雅的客房，將城市花園融入設計，精品魅力及文創的時尚氣息，採用國際級Wellspring床墊及頂級淋浴設備，帶給高質感住宿享受。","keywords":"捷絲旅高雄站前館, 高雄酒店, 高雄飯店, 高雄商務飯店, 高雄旅店, 高雄住宿, 高雄酒店推薦, 高雄飯店推薦, 高雄旅店推薦, 高雄住宿推薦, 高雄商務飯店推薦,高雄旅遊, 台灣旅遊, 台灣自由行, 高雄自由行, 台灣自助旅行, 高雄自助旅行, 高雄景點, 高雄美食, 高雄旅遊, 台灣文化, 台灣休閒, 台灣景點, 高雄交通便利飯店,高雄訂房"},"diningsandmeetings":{"title":"餐廳會議 | 捷絲旅 高雄站前館","description":"「蔬食百匯」 以異國料理烹調手法， 美味精緻; Jessicafe，推出輕食茶點，讓客人在挑高空間與寬敞座席中，感受美食與藝術交融的享受。","keywords":"捷絲旅高雄站前館, 高雄酒店, 高雄飯店, 高雄商務飯店, 高雄旅店, 高雄住宿, 高雄酒店推薦, 高雄飯店推薦, 高雄旅店推薦, 高雄住宿推薦, 高雄商務飯店推薦,高雄旅遊, 台灣旅遊, 台灣自由行, 高雄自由行, 台灣自助旅行, 高雄自助旅行, 高雄景點, 高雄美食, 高雄旅遊, 台灣文化, 台灣休閒, 台灣景點, 高雄交通便利飯店,高雄訂房"},"amenities":{"title":"設施服務 | 捷絲旅 高雄站前館","description":"無論商務人士或是自助行旅客，都能感受便利且舒適的時光。現代時尚設計的捷絲旅高雄站前館設交誼廳、健身室、免費上網區及自助洗衣室。","keywords":"捷絲旅高雄站前館, 高雄酒店, 高雄飯店, 高雄商務飯店, 高雄旅店, 高雄住宿, 高雄酒店推薦, 高雄飯店推薦, 高雄旅店推薦, 高雄住宿推薦, 高雄商務飯店推薦,高雄旅遊, 台灣旅遊, 台灣自由行, 高雄自由行, 台灣自助旅行, 高雄自助旅行, 高雄景點, 高雄美食, 高雄旅遊, 台灣文化, 台灣休閒, 台灣景點, 高雄交通便利飯店,高雄訂房"},"activities":{"title":"館內活動 | 捷絲旅 高雄站前館","description":"為旅人打造難以忘懷的旅行時光，捷絲旅高雄站前館不定期推出依照季節而改變的活動。「捷絲旅」與「新天鵝堡」之間的合作就是提供給旅客高人氣桌遊。","keywords":"捷絲旅高雄站前館, 高雄酒店, 高雄飯店, 高雄商務飯店, 高雄旅店, 高雄住宿, 高雄酒店推薦, 高雄飯店推薦, 高雄旅店推薦, 高雄住宿推薦, 高雄商務飯店推薦,高雄旅遊, 台灣旅遊, 台灣自由行, 高雄自由行, 台灣自助旅行, 高雄自助旅行, 高雄景點, 高雄美食, 高雄旅遊, 台灣文化, 台灣休閒, 台灣景點, 高雄交通便利飯店,高雄訂房"},"directions":{"title":"交通景點 | 捷捷絲旅 高雄站前館","description":"坐落於高雄市中心，可輕鬆享受購物樂趣及品嚐在地美食的好滋味，臨近高雄市熱鬧的六合夜市旁，著名觀光景點如光之穹頂及駁二藝術特區位於步行範圍內。","keywords":"捷絲旅高雄站前館, 高雄酒店, 高雄飯店, 高雄商務飯店, 高雄旅店, 高雄住宿, 高雄酒店推薦, 高雄飯店推薦, 高雄旅店推薦, 高雄住宿推薦, 高雄商務飯店推薦,高雄旅遊, 台灣旅遊, 台灣自由行, 高雄自由行, 台灣自助旅行, 高雄自助旅行, 高雄景點, 高雄美食, 高雄旅遊, 台灣文化, 台灣休閒, 台灣景點, 高雄交通便利飯店,高雄訂房"},"promotions":{"title":"官網訂房最低價，另享高鐵訂票75折優惠 | 最新優惠 | 捷絲旅 高雄站前館","description":"捷絲旅高雄站前館推出豐富住房優惠，鎖定最新消息優惠訊息不漏接！","keywords":"捷絲旅高雄站前館, 高雄酒店, 高雄飯店, 高雄商務飯店, 高雄旅店, 高雄住宿, 高雄酒店推薦, 高雄飯店推薦, 高雄旅店推薦, 高雄住宿推薦, 高雄商務飯店推薦,高雄旅遊, 台灣旅遊, 台灣自由行, 高雄自由行, 台灣自助旅行, 高雄自助旅行, 高雄景點, 高雄美食, 高雄旅遊, 台灣文化, 台灣休閒, 台灣景點, 高雄交通便利飯店,高雄訂房"}},"zh-CN":{"home":{"title":"官网订房保证最低价 | 捷丝旅 高雄站前馆","description":"结合设计美学，具精品魅力及文创时尚气息。近高雄火车站、捷运美丽岛站及六合夜市，交通便利，为旅客休憩首选。官网订房最低价，享高铁订票75折优惠！","keywords":"捷丝旅高雄站前馆, 高雄酒店, 高雄饭店, 高雄商务饭店, 高雄旅店, 高雄住宿, 高雄酒店推荐, 高雄饭店推荐, 高雄旅店推荐, 高雄住宿推荐, 高雄商务饭店推荐,高雄旅游, 台湾旅游, 台湾自由行, 高雄自由行, 台湾自助旅行, 高雄自助旅行, 高雄景点, 高雄美食, 高雄旅游, 台湾文化, 台湾休閒, 台湾景点,  高雄交通便利饭店,高雄订房"},"rooms":{"title":"官网订房保证最低价 | 捷丝旅 高雄站前馆","description":"时尚高雅的客房，将城市花园融入设计，精品魅力及文创的时尚气息，采用国际级Wellspring床垫及顶级淋浴设备，带给高质感住宿享受。","keywords":"捷丝旅高雄站前馆, 高雄酒店, 高雄饭店, 高雄商务饭店, 高雄旅店, 高雄住宿, 高雄酒店推荐, 高雄饭店推荐, 高雄旅店推荐, 高雄住宿推荐, 高雄商务饭店推荐,高雄旅游, 台湾旅游, 台湾自由行, 高雄自由行, 台湾自助旅行, 高雄自助旅行, 高雄景点, 高雄美食, 高雄旅游, 台湾文化, 台湾休閒, 台湾景点,  高雄交通便利饭店,高雄订房"},"diningsandmeetings":{"title":"餐厅会议 | 捷丝旅 高雄站前馆","description":"「蔬食百汇」 以异国料理烹调手法， 美味精致; Jessicafe，推出轻食茶点，让客人在挑高空间与宽敞座席中，感受美食与艺术交融的享受。","keywords":"捷丝旅高雄站前馆, 高雄酒店, 高雄饭店, 高雄商务饭店, 高雄旅店, 高雄住宿, 高雄酒店推荐, 高雄饭店推荐, 高雄旅店推荐, 高雄住宿推荐, 高雄商务饭店推荐,高雄旅游, 台湾旅游, 台湾自由行, 高雄自由行, 台湾自助旅行, 高雄自助旅行, 高雄景点, 高雄美食, 高雄旅游, 台湾文化, 台湾休閒, 台湾景点,  高雄交通便利饭店,高雄订房"},"amenities":{"title":"设施服务 | 捷丝旅 高雄站前馆","description":"无论商务人士或是自助行旅客，都能感受便利且舒适的时光。现代时尚设计的捷丝旅高雄站前馆设交谊厅、健身室、免费上网区及自助洗衣室。","keywords":"捷丝旅高雄站前馆, 高雄酒店, 高雄饭店, 高雄商务饭店, 高雄旅店, 高雄住宿, 高雄酒店推荐, 高雄饭店推荐, 高雄旅店推荐, 高雄住宿推荐, 高雄商务饭店推荐,高雄旅游, 台湾旅游, 台湾自由行, 高雄自由行, 台湾自助旅行, 高雄自助旅行, 高雄景点, 高雄美食, 高雄旅游, 台湾文化, 台湾休閒, 台湾景点,  高雄交通便利饭店,高雄订房"},"activities":{"title":"馆内活动 | 捷丝旅 高雄站前馆","description":"為旅人打造難以忘懷的旅行時光，捷絲旅高雄站前館不定期推出依照季節而改變的活動。「捷絲旅」與「新天鵝堡」之間的合作就是提供給旅客高人氣桌遊。","keywords":"捷丝旅高雄站前馆, 高雄酒店, 高雄饭店, 高雄商务饭店, 高雄旅店, 高雄住宿, 高雄酒店推荐, 高雄饭店推荐, 高雄旅店推荐, 高雄住宿推荐, 高雄商务饭店推荐,高雄旅游, 台湾旅游, 台湾自由行, 高雄自由行, 台湾自助旅行, 高雄自助旅行, 高雄景点, 高雄美食, 高雄旅游, 台湾文化, 台湾休閒, 台湾景点,  高雄交通便利饭店,高雄订房"},"directions":{"title":"交通景点 | 捷丝旅 高雄站前馆","description":"坐落于高雄市中心，可轻松享受购物乐趣及品尝在地美食的好滋味，临近高雄市热闹的六合夜市旁，著名观光景点如光之穹顶及驳二艺术特区位于步行范围内。","keywords":"捷丝旅高雄站前馆, 高雄酒店, 高雄饭店, 高雄商务饭店, 高雄旅店, 高雄住宿, 高雄酒店推荐, 高雄饭店推荐, 高雄旅店推荐, 高雄住宿推荐, 高雄商务饭店推荐,高雄旅游, 台湾旅游, 台湾自由行, 高雄自由行, 台湾自助旅行, 高雄自助旅行, 高雄景点, 高雄美食, 高雄旅游, 台湾文化, 台湾休閒, 台湾景点,  高雄交通便利饭店,高雄订房"},"promotions":{"title":"官网订房保证最低价 | 最新优惠 | 捷丝旅 高雄站前馆","description":"捷丝旅高雄站前馆推出丰富住房优惠，锁定最新消息优惠讯息不漏接！","keywords":"捷丝旅高雄站前馆, 高雄酒店, 高雄饭店, 高雄商务饭店, 高雄旅店, 高雄住宿, 高雄酒店推荐, 高雄饭店推荐, 高雄旅店推荐, 高雄住宿推荐, 高雄商务饭店推荐,高雄旅游, 台湾旅游, 台湾自由行, 高雄自由行, 台湾自助旅行, 高雄自助旅行, 高雄景点, 高雄美食, 高雄旅游, 台湾文化, 台湾休閒, 台湾景点,  高雄交通便利饭店,高雄订房"}},"ja":{"home":{"title":"ご予約は当サイトが最もお得です | ジャストスリープ高雄駅前館","description":"ジャストスリープ高雄駅前館は美しいデザイン美学﹑ユニークともに完全リフレッシュできる空間を作り上げました。高雄駅﹑MRT美麗島駅とバス乗り場から2-5分という快適に最適魅力満載のホテルです。","keywords":"ジャストスリープ高雄駅前館、ジャストスリープ高雄、高雄ビスネスホテル、家族ホテル、ラグジュアリーホテル、ブティックホテル、デザイナーズホテル、ベストホテル、高雄 宿泊、高雄観光、高雄旅行、台湾旅行、台湾おすすめホテル、高雄おすすめホテル、高雄文化、高雄レジャー、高雄観光スポット、高雄の料理、台湾の文化、台湾レジャー、台湾観光スポット、台湾の料理、台湾観光、高雄厳選ホテル、高雄で泊まりたいホテル、高雄の格安ホテル、高雄の人気ホテル、高雄観光に便利なホテル、高雄で駅近のホテル"},"rooms":{"title":"ご予約は当サイトが最もお得です | ジャストスリープ高雄駅前館","description":"ジャストスリープ高雄駅前館の客室は134室、ファッションと文化クリエイティブを兼ね備えています。国際的にWellspring社のマットレスと高級バスルーム設備でごゆっくりとおくつろぎいただけます。","keywords":"ジャストスリープ高雄駅前館、ジャストスリープ高雄、高雄ビスネスホテル、家族ホテル、ラグジュアリーホテル、ブティックホテル、デザイナーズホテル、ベストホテル、高雄 宿泊、高雄観光、高雄旅行、台湾旅行、台湾おすすめホテル、高雄おすすめホテル、高雄文化、高雄レジャー、高雄観光スポット、高雄の料理、台湾の文化、台湾レジャー、台湾観光スポット、台湾の料理、台湾観光、高雄厳選ホテル、高雄で泊まりたいホテル、高雄の格安ホテル、高雄の人気ホテル、高雄観光に便利なホテル、高雄で駅近のホテル"},"diningsandmeetings":{"title":"レストラン、会議 | ジャストスリープ高雄駅前館","description":"ジャストスリープ高雄駅前館は自然、新鮮、健康、革新の経営理念を貫きます。お客様の健康のため、使っている食材は最も新鮮な果物や野菜とユニークな味のしいたけにこだわっています。","keywords":"ジャストスリープ高雄駅前館、ジャストスリープ高雄、高雄ビスネスホテル、家族ホテル、ラグジュアリーホテル、ブティックホテル、デザイナーズホテル、ベストホテル、高雄 宿泊、高雄観光、高雄旅行、台湾旅行、台湾おすすめホテル、高雄おすすめホテル、高雄文化、高雄レジャー、高雄観光スポット、高雄の料理、台湾の文化、台湾レジャー、台湾観光スポット、台湾の料理、台湾観光、高雄厳選ホテル、高雄で泊まりたいホテル、高雄の格安ホテル、高雄の人気ホテル、高雄観光に便利なホテル、高雄で駅近のホテル"},"amenities":{"title":"レジャー施設 | ジャストスリープ高雄駅前館","description":"ジャストスリープ高雄駅前館はロンジ、ジム、パソコンエリアや洗濯室などしており、ほかでは味わえない快適な滞在をご体験していただけます。","keywords":"ジャストスリープ高雄駅前館、ジャストスリープ高雄、高雄ビスネスホテル、家族ホテル、ラグジュアリーホテル、ブティックホテル、デザイナーズホテル、ベストホテル、高雄 宿泊、高雄観光、高雄旅行、台湾旅行、台湾おすすめホテル、高雄おすすめホテル、高雄文化、高雄レジャー、高雄観光スポット、高雄の料理、台湾の文化、台湾レジャー、台湾観光スポット、台湾の料理、台湾観光、高雄厳選ホテル、高雄で泊まりたいホテル、高雄の格安ホテル、高雄の人気ホテル、高雄観光に便利なホテル、高雄で駅近のホテル"},"activities":{"title":"館内イベント | ジャストスリープ高雄駅前館","description":"ジャストスリープ高雄駅前館は客が楽しい旅にするために、不定期的にイベントを開催します。","keywords":"ジャストスリープ高雄駅前館、ジャストスリープ高雄、高雄ビスネスホテル、家族ホテル、ラグジュアリーホテル、ブティックホテル、デザイナーズホテル、ベストホテル、高雄 宿泊、高雄観光、高雄旅行、台湾旅行、台湾おすすめホテル、高雄おすすめホテル、高雄文化、高雄レジャー、高雄観光スポット、高雄の料理、台湾の文化、台湾レジャー、台湾観光スポット、台湾の料理、台湾観光、高雄厳選ホテル、高雄で泊まりたいホテル、高雄の格安ホテル、高雄の人気ホテル、高雄観光に便利なホテル、高雄で駅近のホテル"},"directions":{"title":"交通アクセス | ジャストスリープ高雄駅前館","description":"ジャストスリープ高雄駅前館は高雄の中心に位置し、有名な六合夜市、MRT美麗島の光のドーム、三鳳中街(南北雑貨街)や後驛商圏(服飾問屋街)までは徒歩できる圏内の立地で、お買い物や高雄の名物が楽しめます。","keywords":"ジャストスリープ高雄駅前館、ジャストスリープ高雄、高雄ビスネスホテル、家族ホテル、ラグジュアリーホテル、ブティックホテル、デザイナーズホテル、ベストホテル、高雄 宿泊、高雄観光、高雄旅行、台湾旅行、台湾おすすめホテル、高雄おすすめホテル、高雄文化、高雄レジャー、高雄観光スポット、高雄の料理、台湾の文化、台湾レジャー、台湾観光スポット、台湾の料理、台湾観光、高雄厳選ホテル、高雄で泊まりたいホテル、高雄の格安ホテル、高雄の人気ホテル、高雄観光に便利なホテル、高雄で駅近のホテル"},"promotions":{"title":"ご予約は当サイトが最もお得です | 最新情報 | ジャストスリープ高雄駅前館","description":"ジャストスリープ高雄駅前館は季節のご案内やホテルプロモーション情報などを配信しております。ニュースレターにご登録ください。","keywords":"ジャストスリープ高雄駅前館、ジャストスリープ高雄、高雄ビスネスホテル、家族ホテル、ラグジュアリーホテル、ブティックホテル、デザイナーズホテル、ベストホテル、高雄 宿泊、高雄観光、高雄旅行、台湾旅行、台湾おすすめホテル、高雄おすすめホテル、高雄文化、高雄レジャー、高雄観光スポット、高雄の料理、台湾の文化、台湾レジャー、台湾観光スポット、台湾の料理、台湾観光、高雄厳選ホテル、高雄で泊まりたいホテル、高雄の格安ホテル、高雄の人気ホテル、高雄観光に便利なホテル、高雄で駅近のホテル"}},"ko":{"home":{"title":"공식 사이트에서 예약하는 것이 가장 저렴합니다 | 저스트슬립 가오슝역 점","description":"지하철역과 근접한 저스트슬립 가오슝역 점은 세련되고 모던한 감각의 시각예술 중심적 인테리어로 안락한 숙박을 제공하며, 가오슝 기차역과 유명한 관광명소(세계에서 가장 아름다운 지하철역) 메이리다오역, 류허 야시장과 아주 인접해있으며 다양한 경험을 제공하는 호텔시설은 투숙객의 만족을 보장합니다.","keywords":"#가오슝호텔 #가오슝비즈니스호텔#가오슝숙박#가오슝여행#가오슝자유여행#가오슝호텔추천#가오슝기차역근쳐호텔#가오슝맛집#가오슝호텔예약#가오슝관광#가오슝호텔할인#가정여행#아이들과가기좋은호텔"},"rooms":{"title":"공식 사이트에서 예약하는 것이 가장 저렴합니다 | 저스트슬립 가오슝역 점","description":"저스트슬립 가오슝역 점은 총 134개의 객실이 마련되어 있습니다. 여유로운 공간을 가진모든 객실은 독특하고, 모던한 디자인으로 꾸며져 있습니다. 시각적인 예술로꾸며진 호텔의 객실은 특별한 분위기를 연출해 드립니다. 새로운 고품질의숙박을 위하여 최고급의 Wellspring사의 메트리스를 사용하고 있으며 , 특별한샤워설비는 손님들의 여행에 절대적인 편안함과 안락함을 가져다 줄 것입니다.","keywords":"#가오슝호텔 #가오슝비즈니스호텔#가오슝숙박#가오슝여행#가오슝자유여행#가오슝호텔추천#가오슝기차역근쳐호텔#가오슝맛집#가오슝호텔예약#가오슝관광#가오슝호텔할인#가정여행#아이들과가기좋은호텔"},"diningsandmeetings":{"title":"다이닝 & 연회 회의 | 저스트슬립 가오슝역 점","description":"저스트슬립 가오슝역 점 채식주의 레스토랑' 은 신선한 야채와 버섯류 등의 식재료를 사용하여 무침, 구이, 찌개, 볶음의 이국적인 요리법과 국수, 수제 피자와 파스트 등의 이색 면을 제공하고 있습니다.","keywords":"#가오슝호텔 #가오슝비즈니스호텔#가오슝숙박#가오슝여행#가오슝자유여행#가오슝호텔추천#가오슝기차역근쳐호텔#가오슝맛집#가오슝호텔예약#가오슝관광#가오슝호텔할인#가정여행#아이들과가기좋은호텔"},"amenities":{"title":"테마 | 저스트슬립 가오슝역 점","description":"저스트슬립 가오슝역 점은 라운지,헬스,까페,비즈니스 서비스,셀프 세탁실,뷔페가 갖추고 있으며 대만에 계시는 동안 편안하고 좋은 시간을 보낼 수 있습니다","keywords":"#가오슝호텔 #가오슝비즈니스호텔#가오슝숙박#가오슝여행#가오슝자유여행#가오슝호텔추천#가오슝기차역근쳐호텔#가오슝맛집#가오슝호텔예약#가오슝관광#가오슝호텔할인#가정여행#아이들과가기좋은호텔"},"activities":{"title":"관내활동 | 저스트슬립 가오슝역 점","description":"더 알찬 여행을 위해 이벤트 확인하기","keywords":"#가오슝호텔 #가오슝비즈니스호텔#가오슝숙박#가오슝여행#가오슝자유여행#가오슝호텔추천#가오슝기차역근쳐호텔#가오슝맛집#가오슝호텔예약#가오슝관광#가오슝호텔할인#가정여행#아이들과가기좋은호텔"},"directions":{"title":"시설 | 저스트슬립 가오슝역 점","description":"저스트슬립 가오슝역 점은 까오슝시 중심에 위치하고 있습니다. 호텔 근처에는 까오슝시의번화가인\"류허 야시장(六合夜市)\"을 비롯하여 대만에서 가장아름다운 지하철역으로 불리는 \"메이리다오\", \"싼핑중심거리\", \"후예거리\"를 비롯하여 전자상가 등많은 관광지들이 도보로 가능한 거리 내에 모여 있습니다. 호텔을 방문하시는분들은 부담없는 가격으로 관광과 함께 구매의 기쁨과 행복을 누리고, 대만의맛있는 먹거리를 즐길 수 있습니다.","keywords":"#가오슝호텔 #가오슝비즈니스호텔#가오슝숙박#가오슝여행#가오슝자유여행#가오슝호텔추천#가오슝기차역근쳐호텔#가오슝맛집#가오슝호텔예약#가오슝관광#가오슝호텔할인#가정여행#아이들과가기좋은호텔"},"promotions":{"title":"공식 사이트에서 예약하는 것이 가장 저렴합니다 | 최신소식 | 저스트슬립 가오슝역 점","description":"팔로우해서 스페셜 오퍼 놓치지 않기","keywords":"#가오슝호텔 #가오슝비즈니스호텔#가오슝숙박#가오슝여행#가오슝자유여행#가오슝호텔추천#가오슝기차역근쳐호텔#가오슝맛집#가오슝호텔예약#가오슝관광#가오슝호텔할인#가정여행#아이들과가기좋은호텔"}}}

/***/ }),
/* 584 */
/***/ (function(module, exports) {

module.exports = {"en":{"home":{"title":"Best Rate and Service Guarantee | Book Direct with Just Sleep","description":"Just Sleep is the brand of design hotel under Formasa International Hotels Group. Just Sleep hotels include Taipei Ximending, Sanchong, Just Sleep - NTU, Yilan Jiaoxi, Hualien Zhongzheng, Kaohsiung Station and Kaohsiung Zhongzheng, all of them are in a convenient location and affordable which is definitely the first choice for the travelers who are looking for good value.","keywords":"Just Sleep, Design Hotel in Taiwan, recommended accommodation in Taipei, recommended accommodation in Yilan, accommodation in Zhongshan District, accommodation in Ximending, accommodation in Gongguan, accommodation in Jiaoxi, accommodation in New Taipei City, recommended hotel with affordable price, Taiwan travel, individual travel in Taiwan, tourist attractions in Taiwan, delicacies in Taiwan"}},"zh-TW":{"home":{"title":"官網訂房最低價，另享高鐵訂票75折優惠 | 直接在捷絲旅官網訂房","description":"捷絲旅官網訂房最低價，並享高鐵訂票75折優惠！有台北西門館、三重館、臺大尊賢館、宜蘭礁溪館、花蓮中正館、高雄站前館及中正館，交通便利又平價是出遊最佳選擇。","keywords":"捷絲旅, 台灣設計旅店, 台北住宿推薦, 宜蘭住宿推薦, 林森北路住宿, 西門町住宿, 公館住宿, 礁溪住宿, 三重住宿, 平價旅館推薦, 台灣旅遊, 台灣自助旅行, 台灣景點, 台灣美食"}},"zh-CN":{"home":{"title":"官网订房保证最低价 | 直接在捷丝旅官网订房","description":"捷丝旅官网订房最低价，并享高铁订票75折优惠！有台北西门馆、三重馆、台大尊贤馆、宜兰礁溪馆、花莲中正馆、高雄站前馆及中正馆，交通便利又平价是出游最佳选择。","keywords":"捷丝旅, 台湾设计旅店, 台北住宿推荐, 宜兰住宿推荐, 林森北路住宿, 西门町住宿, 公馆住宿, 礁溪住宿, 三重住宿, 平价旅馆推荐, 台湾旅游, 台湾自助旅行, 台湾景点, 台湾美食"}},"ja":{"home":{"title":"ご予約は当サイトが最もお得です | ジャストスリープ","description":"Just Sleep ジャストスリープはシルクスホテルグループ傘下のデザインホテルブランドです。台北西門館、三重館、台大尊賢館、宜蘭礁渓館、花蓮中正館、高雄駅前館と中正館があり、アクセスの便利さとお手頃価格の優位性など、コストパフォーマンスを重視されるお客様への最良の選択です。","keywords":"ジャストスリープ、台湾のデザインホテル、台北でのおすすめの宿泊先、宜蘭のおすすめの宿泊先、中山区での宿泊、西門町での宿泊、公館での宿泊、礁渓での宿泊、新北での宿泊、手ごろな価格のおすすめホテル、台湾の旅、台湾の自由旅行、台湾の観光スポット、台湾の美食"}},"ko":{"home":{"title":"공식 사이트에서 예약하는 것이 가장 저렴합니다 | 저스트 슬립","description":"저스트 슬립(Just Sleep)은 리젠트 인터내셔널 호텔 그룹(晶华国际酒店集团) 계열의 디자인 호텔 브랜드으로서，타이베이 시먼관(台北西门馆), 싼중관(三重馆), 타이완 대학교 쭌시엔관(台大尊贤馆), 이란 자오시관(宜兰礁溪馆), 화리엔 중정관(花莲中正馆), 까오슝 역전관(高雄站前馆) 및 중정관(中正馆)등이 있으며，편리한 교통과 합리적인 가격으로 가성비를 중시하시는 고객님께 안성맞춤입니다.","keywords":"저스트 슬립(Just Sleep) 트립, 타이완 디자인 호텔, 타이베이 숙박 추천, 이란 숙박 추천, 중산구 숙박, 시먼딩 숙박, 꽁관 숙박, 자오시 숙박, 신베이 숙박, 호텔 추천 평가, 타이완 여행, 타이완 자유 여행, 타이완 여행지, 타이완 맛집"}}}

/***/ }),
/* 585 */
/***/ (function(module, exports) {

module.exports = {"en":{"home":{"title":"Best Rate and Service Guarantee | Book Direct with Just Sleep Taipei NTU","description":"The hotel, next to NTU and Gongguan shopping district, whisks learning passion and leisure thrill to create the best choice for those fulfilling both.","keywords":"Just Sleep Taipei NTU, National Taiwan University, NTU, NTU accommodation, hotels in Gongguan, accommodation in Gongguan, recommended accommodation in Gongguan, MRT Gongguan Station, Taipei travel, Taipei tour, tourist attractions in Taipei, delicacies in Taipei, individual travel in Taipei, NTU hotel"},"rooms":{"title":"Best Hotel Price Guarantee | Book Direct with Just Sleep Taipei NTU","description":"Our guest rooms have classic elegance with a punch of academic quirk taking inspirations from our location and surroundings. Don’t be the last to visit us!","keywords":"Just Sleep Taipei NTU, National Taiwan University, NTU, NTU accommodation, hotels in Gongguan, accommodation in Gongguan, recommended accommodation in Gongguan, MRT Gongguan Station, NTU hotel"},"diningsandmeetings":{"title":"Dinings & Meetings | Just Sleep Taipei NTU","description":"An authentic slice of Italy is served at “Just Italian” through a variety of food choices. Arrangeable small conference venues are also at your dispense.","keywords":"Just Sleep Taipei NTU, National Taiwan University, NTU, NTU accommodation, hotels in Gongguan, accommodation in Gongguan, recommended accommodation in Gongguan, MRT Gongguan Station, Gongguan hotel restaurant "},"amenities":{"title":"Amenities | Just Sleep Taipei NTU","description":"The hotel has a 24-hour service counter and provides free Wi-Fi and self-service laundry facilities to ensure attentive service and accommodated facilities.","keywords":"Just Sleep Taipei NTU, National Taiwan University, NTU, NTU accommodation, hotels in Gongguan, accommodation in Gongguan, recommended accommodation in Gongguan, MRT Gongguan Station, hotel's facilities, free hotel facilities, hotel's Wi-Fi, hotel's self-service laundry, Gongguan hotel facilities"},"activities":{"title":"Activities | Just Sleep Taipei NTU","description":"To feed to the cravings of our guests, “Just Sleep” cooperated with “SWAN PANASIA” exclusively to offer the highest quality of board games.","keywords":"Just Sleep Taipei NTU, National Taiwan University, NTU, NTU accommodation, hotels in Gongguan, accommodation in Gongguan, recommended accommodation in Gongguan, MRT Gongguan Station, hotel's facilities, free hotel's facilities, hotel's Wi-Fi, hotel's self-service laundry, hotel activities, hotel games, Gongguan hotel "},"directions":{"title":"Directions | Just Sleep Taipei NTU","description":"We are located in a food paradise with several surrounding night markets serving locals’ favorite snacks along with other must visit attractions.","keywords":"Just Sleep Taipei NTU, National Taiwan University, NTU, NTU accommodation, hotels in Gongguan, accommodation in Gongguan, recommended accommodation in Gongguan, MRT Gongguan Station, Gongguan shopping district, Shida Night Market "},"promotions":{"title":"Saving Money with Best Rate Guarantee | Book Direct with Just Sleep Taipei NTU","description":"Unbelievable special offers are coming your way from our official website and booking a reservation gets you an even better deal! Why pass it up?","keywords":"Just Sleep Taipei NTU, National Taiwan University, NTU, NTU accommodation, hotels in Gongguan, accommodation in Gongguan, recommended accommodation in Gongguan, MRT Gongguan Station, Special offer for hotels in Gongguan, special offer for accommodation in Taipei Gongguan"}},"zh-TW":{"home":{"title":"官網訂房最低價，另享高鐵訂票75折優惠 | 捷絲旅 臺大尊賢館","description":"位於台灣大學旁，鄰近公館商圈，提供至校園教學、實習、研究、交流、會議及參訪最佳選擇。捷絲旅臺大尊賢館官網訂房最低價，並享高鐵訂票75折優惠！","keywords":"捷絲旅臺大尊賢館, 台灣大學, 台大, 台大住宿, 公館飯店, 公館住宿, 公館住宿推薦, 捷運公館站, 公館商圈, 台北旅遊, 台北旅行, 台北景點, 台北美食, 台北自由行"},"rooms":{"title":"官網訂房最低價，另享高鐵訂票75折優惠 | 捷絲旅 臺大尊賢館","description":"擁有寬敞空間及俏皮學院風設計的客房分為精緻、豪華、及尊賢客房類型任選。捷絲旅臺大尊賢館官網訂房最低價，並享高鐵訂票75折優惠！","keywords":"捷絲旅臺大尊賢館, 台灣大學, 台大, 台大住宿, 公館飯店, 公館住宿, 公館住宿推薦, 捷運公館站, 公館商圈"},"diningsandmeetings":{"title":"餐廳會議 | 捷絲旅 臺大尊賢館","description":"品嚐義大利的一角落，捷絲旅臺大尊賢館2樓餐廳提供吃到飽的特色餐點。另有可依照需求排列的會議室空間，舉行小型會議及活動的最佳選擇。","keywords":"捷絲旅臺大尊賢館, 台灣大學, 台大, 台大住宿, 公館飯店, 公館住宿, 公館住宿推薦, 捷運公館站, 公館商圈"},"amenities":{"title":"設施服務 | 捷絲旅 臺大尊賢館","description":"全館提供免費WiFi與自助式洗衣設備、24小時的服務中心，讓旅人於住宿期間享有體貼細心服務及完整周到住宿設備。","keywords":"捷絲旅臺大尊賢館, 台灣大學, 台大, 台大住宿, 公館飯店, 公館住宿, 公館住宿推薦, 捷運公館站, 公館商圈, 飯店設施, 飯店免費設施, 飯店無線網路, 飯店自助洗衣"},"activities":{"title":"館內活動 | 捷絲旅 臺大尊賢館","description":"為了餵飽旅人的需求，「Just Sleep 捷絲旅」與「SWAN PANASIA 新天鵝堡」獨家合作，給予當下高人氣桌遊。","keywords":"捷絲旅臺大尊賢館, 台灣大學, 台大, 台大住宿, 公館飯店, 公館住宿, 公館住宿推薦, 捷運公館站, 公館商圈, 飯店設施, 飯店免費設施, 飯店無線網路, 飯店自助洗衣"},"directions":{"title":"交通景點 | 捷絲旅 臺大尊賢館","description":"全館位於熱鬧公館商圈，隔壁是國立台灣大學， 2分鐘可達捷運公館站，附近熱門景點如公館夜市、師大夜市及寶藏巖國際藝術村等，可輕鬆體驗台北文化。","keywords":"捷絲旅臺大尊賢館, 台灣大學, 台大, 台大住宿, 公館飯店, 公館住宿, 公館住宿推薦, 捷運公館站, 公館商圈, 師大夜市"},"promotions":{"title":"官網訂房最低價，另享高鐵訂票75折優惠 | 最新優惠 | 捷絲旅 臺大尊賢館","description":"無可置信的好康正往你而去！官網訂房最低價，並享高鐵訂票75折優惠！不定期推出住房專案及優惠訊息，提供給你最優惠的住房價格。","keywords":"捷絲旅臺大尊賢館, 台灣大學, 台大, 台大住宿, 公館飯店, 公館住宿, 公館住宿推薦, 捷運公館站, 公館商圈, 公館飯店優惠, 台北公館住房優惠, 早鳥住房, 官網住房優惠, 官網住房折扣"}},"zh-CN":{"home":{"title":"官网订房保证最低价 | 捷丝旅 台大尊贤馆","description":"捷丝旅台大尊贤馆官网订房最低价，并享高铁订票75折优惠！位于台湾大学旁，邻近公馆商圈，提供至校园教学、实习、研究、交流、会议及参访最佳选择。","keywords":"捷丝旅台大尊贤馆, 台湾大学, 台大, 台大住宿, 公馆饭店, 公馆住宿, 公馆住宿推荐, 捷运公馆站, 公馆商圈, 台北旅游, 台北旅行, 台北景点, 台北美食, 台北自由行"},"rooms":{"title":"官网订房保证最低价 | 捷丝旅 台大尊贤馆","description":"拥有宽敞空间及俏皮学院风设计的客房分为精致、豪华、及尊贤客房类型任选。捷丝旅台大尊贤馆官网订房最低价，并享高铁订票75折优惠！","keywords":"捷丝旅台大尊贤馆, 台湾大学, 台大, 台大住宿, 公馆饭店, 公馆住宿, 公馆住宿推荐, 捷运公馆站, 公馆商圈"},"diningsandmeetings":{"title":"餐厅会议 | 捷丝旅 台大尊贤馆","description":"品尝义大利的一角落，捷丝旅台大尊贤馆2楼餐厅提供吃到饱的特色餐点。另有可依照需求排列的会议室空间，举行小型会议及活动的最佳选择。","keywords":"捷丝旅台大尊贤馆, 台湾大学, 台大, 台大住宿, 公馆饭店, 公馆住宿, 公馆住宿推荐, 捷运公馆站, 公馆商圈"},"amenities":{"title":"设施服务 | 捷丝旅 台大尊贤馆","description":"全館提供免費WiFi與自助式洗衣設備、24小時的服務中心，讓旅人於住宿期間享有體貼細心服務及完整周到住宿設備。","keywords":"捷丝旅台大尊贤馆, 台湾大学, 台大, 台大住宿, 公馆饭店, 公馆住宿, 公馆住宿推荐, 捷运公馆站, 公馆商圈, 饭店设施, 饭店免费设施, 饭店无线网络, 饭店自助洗衣"},"activities":{"title":"馆内活动 | 捷丝旅 台大尊贤馆","description":"为了喂饱旅人的需求，「Just Sleep 捷丝旅」与「SWAN PANASIA 新天鹅堡」独家合作，给予当下高人气桌游。","keywords":"捷丝旅台大尊贤馆, 台湾大学, 台大, 台大住宿, 公馆饭店, 公馆住宿, 公馆住宿推荐, 捷运公馆站, 公馆商圈, 饭店设施, 饭店免费设施, 饭店无线网络, 饭店自助洗衣"},"directions":{"title":"交通景点 | 捷丝旅 台大尊贤馆","description":"全馆位于热闹公馆商圈，隔壁是国立台湾大学， 2分钟可达捷运公馆站，附近热门景点如公馆夜市、师大夜市及宝藏岩国际艺术村等，可轻松体验台北文化。","keywords":"捷丝旅台大尊贤馆, 台湾大学, 台大, 台大住宿, 公馆饭店, 公馆住宿, 公馆住宿推荐, 捷运公馆站, 公馆商圈, 师大夜市"},"promotions":{"title":"官网订房保证最低价 | 最新优惠 | 捷丝旅 台大尊贤馆","description":"无可置信的好康正往你而去！官网订房最低价，并享高铁订票75折优惠！不定期推出住房专案及优惠讯息，提供给你最优惠的住房价格。","keywords":"捷丝旅台大尊贤馆, 台湾大学, 台大, 台大住宿, 公馆饭店, 公馆住宿, 公馆住宿推荐, 捷运公馆站, 公馆商圈, 公馆饭店优惠, 台北公馆住房优惠, 早鸟住房, 官网住房优惠, 官网住房折扣"}},"ja":{"home":{"title":"ご予約は当サイトが最もお得です | ジャストスリープ台大尊賢館","description":"国立台湾大学の鄰に位置しています。付近には賑やかな公館ショッピングエリアがあり、徒歩2分間でMRT公館駅に向かうことができます。校内での教育学習、実習、研究、学術交流、会議と参観者の皆様のご宿泊への最良の選択をご提供しています。","keywords":"ジャストスリープ台大尊賢館、台湾大学、台大、台大での宿泊、公館のホテル、公館での宿泊、公館でおすすめの宿泊先、MRT公館駅、台北での旅、台北旅行、台北の観光スポット、台北での美食、台北での自由旅行"},"rooms":{"title":"ご予約は当サイトが最もお得です | ジャストスリープ台大尊賢館","description":"当ホテルでは10-20坪の客室をご提供しています。広々としたスペースと学院スタイルのデザインを擁し、5種類のルームタイプからお選びいただけます。客室は2-4名様でご宿泊いただけます。公式ウェブサイトからご予約いただくと、最もお得な料金をお楽しみいただけます。","keywords":"ジャストスリープ台大尊賢館、台湾大学、台大、台大での宿泊、公館のホテル、公館での宿泊、公館でおすすめの宿泊先、MRT公館駅"},"diningsandmeetings":{"title":"レストラン、会議 | ジャストスリープ台大尊賢館","description":"レストランはジャストスリープ台大尊賢館の2階に位置しています。豊富でおいしいイタリアンスタイルのビュッフェによるお料理をご提供しています。ピザ、スパゲッティーの食べ放題をお楽しみください。このほか小型の会議スペースが設けられており、20-40名様での会議とイベントの開催に適しています。","keywords":"ジャストスリープ台大尊賢館、台湾大学、台大、台大での宿泊、公館のホテル、公館での宿泊、公館でおすすめの宿泊先、MRT公館駅"},"amenities":{"title":"レジャー施設 | ジャストスリープ台大尊賢館","description":"当ホテルでは24時間でのサービスセンター、無料Wi-Fi、セルフサービスでの無料洗濯機、乾燥機、アイロンなどの設備をご提供し、お客様にご宿泊期間中親切なサービスと完璧な宿泊設備をお楽しみいただきます。","keywords":"ジャストスリープ台大尊賢館、台湾大学、台大、台大での宿泊、公館のホテル、公館での宿泊、公館でおすすめの宿泊先、MRT公館駅、ホテルの施設、ホテルの無料施設、ホテルの無線インターネット、ホテルのセルフサービスのランドリー"},"activities":{"title":"館内イベント | ジャストスリープ台大尊賢館","description":"「Just Sleep ジャストスリープ」と「SWAN PANASIA 新天鵝堡」の独占協力により、お客様に旅の楽しいひと時を創り出すため、AUF ZACK (ささっと！)、FUN FARM(楽しい農場)、WOODMAN(木こりの達人)、RIVER DRAGON (リヴァードラゴン)などの人気テーブルゲームをご提供しています。","keywords":"ジャストスリープ台大尊賢館、台湾大学、台大、台大での宿泊、公館のホテル、公館での宿泊、公館でおすすめの宿泊先、MRT公館駅、ホテルの施設、ホテルの無料施設、ホテルの無線インターネット、ホテルのセルフサービスのランドリー"},"directions":{"title":"交通アクセス | ジャストスリープ台大尊賢館","description":"賑やかな公館ショッピングエリアに位置し、隣はすぐに国立台湾大学となります。徒歩2分でMRT公館駅に向かうことができます。付近の人気観光スポットには公館夜市、師大夜市と宝蔵巌国際芸術村などがあり、手軽に台北のカルチャーを体験いただけます。","keywords":"ジャストスリープ台大尊賢館、台湾大学、台大、台大での宿泊、公館のホテル、公館での宿泊、公館でおすすめの宿泊先、MRT公館駅、公館ショッピングエリア、師大夜市"},"promotions":{"title":"ご予約は当サイトが最もお得です | 最新情報 | ジャストスリープ台大尊賢館","description":"当ホテルでは不定期にご宿泊プランと割引情報をリリースしています。公式ウェブサイトではお客様に最も優れた客室料金をご提供しております。お客様専用の割引情報を入手するためにも、最新情報にご注目ください。","keywords":"ジャストスリープ台大尊賢館、台湾大学、台大、台大での宿泊、公館のホテル、公館での宿泊、公館でおすすめの宿泊先、MRT公館駅、公館のホテルの割引、台北公館での宿泊先の割引"}},"ko":{"home":{"title":"공식 사이트에서 예약하는 것이 가장 저렴합니다 | 저스트슬립 타이완대학교 점","description":"국립 타이완 대학교(国立台湾大学) 옆에 위치하여, 핫플레이스인 공관상권(公馆商圈)에 인접해있고, 전철 공관역(公馆站)까지 도보로 2분이면 이동하실 수 있으며 캠퍼스에서 수학, 실습, 연구, 학술교류, 회의 및 방문을 목적으로 하시는 고객님께 최고의 선택입니다.","keywords":"저스트 슬립 타이완 대학 쭌시엔관, 타이완 대학, 타이대, 타이완 대학 숙박, 공관 호텔, 공관 숙박, 공관 숙박 추천, 공관 전철역, 공관 상권, 사대 야시장"},"rooms":{"title":"공식 사이트에서 예약하는 것이 가장 저렴합니다 | 저스트슬립 타이완대학교 점","description":"호텔은 보다 넓은 공간과 캠퍼스풍 디자인의 10-20평의 객실을 구비하고 있으며, 총 5가지의 객실을 제공합니다. 객실은 2-4인이 입실하실 수 있으며 홈페이지에서 더욱 저렴한 가격으로 만나보세요.","keywords":"저스트 슬립 타이완 대학 쭌시엔관, 타이완 대학, 타이대, 타이완 대학 숙박, 공관 호텔, 공관 숙박, 공관 숙박 추천, 공관 전철역, 공관 상권, 사대 야시장"},"diningsandmeetings":{"title":"다이닝 & 연회 회의 | 저스트슬립 타이완대학교 점","description":"레스토랑은 저스트 슬릭 타이완 대학 쭌시엔관(台大尊贤馆) 2층에 위치해 있으며, 풍성하고 맛있는 이태리식 뷔페를 제공해드리며 피자와 파스타 등을 마음껏 즐기실 수 있습니다. 또한 소형 회의실은 20-40명 규모의 회의 및 행사에 적합합니다.","keywords":"저스트 슬립 타이완 대학 쭌시엔관, 타이완 대학, 타이대, 타이완 대학 숙박, 공관 호텔, 공관 숙박, 공관 숙박 추천, 공관 전철역, 공관 상권, 사대 야시장"},"amenities":{"title":"테마 | 저스트슬립 타이완대학교 점","description":"호텔에서는 24시간 서비스 센터를 운영하며, 무료 Wifi, 및 무료 셀프 세탁기, 건조기, 다리미 등의 편의시설을 통해 고객님께서 호텔에 머무시는 동안 따뜻한 서비스와 완벽한 시설을 누리실 수 있도록 준비하고 있습니다.","keywords":"저스트 슬립 타이완 대학 쭌시엔관, 타이완 대학, 타이대, 타이완 대학 숙박, 공관 호텔, 공관 숙박, 공관 숙박 추천, 공관 전철역, 공관 상권, 사대 야시장"},"activities":{"title":"관내활동 | 저스트슬립 타이완대학교 점","description":"「저스트 슬립(Just Sleep)」과「스완 파나시아(SWAN PANASIA)」가 단독으로 협업하여，AUF ZACK, FUN FARM, WOODMAN, RIVER DRAGON등의 최신 유행의 보드게임을 제공해드립니다. 여행객들에게 행복하고 즐거운 시간을 만들어 드립니다.","keywords":"저스트 슬립 타이완 대학 쭌시엔관, 타이완 대학, 타이대, 타이완 대학 숙박, 공관 호텔, 공관 숙박, 공관 숙박 추천, 공관 전철역, 공관 상권, 사대 야시장"},"directions":{"title":"시설 | 저스트슬립 타이완대학교 점","description":"핫플레이스인 공관상권(公馆商圈)에 위치해 있고, 국립 타이완 대학(国立台湾大学) 바로 옆에 위치해 있습니다. 전철 공관역(公馆站)까지 도보로 2분이면 이동하실 수 있으며 공관 야시장(公馆夜市), 사대 야시장(师大夜市), 바오창옌 국제 예술촌(宝藏巖国际艺术村)등의 여행명소가 호텔 근처에 위치해 있어, 편안하게 타이베이의 문화를 체험하실 수 있습니다.","keywords":"저스트 슬립 타이완 대학 쭌시엔관, 타이완 대학, 타이대, 타이완 대학 숙박, 공관 호텔, 공관 숙박, 공관 숙박 추천, 공관 전철역, 공관 상권, 사대 야시장"},"promotions":{"title":"공식 사이트에서 예약하는 것이 가장 저렴합니다 | 최신소식 | 저스트슬립 타이완대학교 점","description":"호텔에서는 깜짝 이벤트 및 할인혜택에 관한 정보를 제공해 드리며, 홈페이지에서 여행객을 위한 가장 저렴한 가격을 제공해 드립니다. 여행객을 위한 특별 할인에 관한 최신 정보를 놓치지 마세요.","keywords":"저스트 슬립 타이완 대학 쭌시엔관, 타이완 대학, 타이대, 타이완 대학 숙박, 공관 호텔, 공관 숙박, 공관 숙박 추천, 공관 전철역, 공관 상권, 사대 야시장, 공관 호텔 할인, 타이완 대학 공관 숙박 할인"}}}

/***/ }),
/* 586 */
/***/ (function(module, exports) {

module.exports = {"en":{"home":{"title":"Best Rate and Service Guarantee | Book Direct with Just Sleep Taipei Sanchong","description":"The brand-new industrial design and convenient location of Just Sleep Taipei Sanchong ensures an experience of warm and genuine hospitality for you.","keywords":"Just Sleep Taipei Sanchong, Just Sleep, hotels in Taipei, Taiwan family hotels, Taipei family hotels,  Hotels Taipei, luxury hotels Taipei, best hotel Taipei, Taipei hotel recommodation, Taipei travel, Taipei tourism, Taiwan travel, Taiwan tourism, budget travelling Taiwan, budget travelling Taipei, Taipei culture, Taiwan culture, Taipei attractions, Taiwan attractions, Taipei food, Taiwan food, Sanchong hotel, Sanchong recommended"},"rooms":{"title":"Best Hotel Price Guarantee | Book Direct with Just Sleep Taipei Sanchong","description":"Brick walls and a variety of patterns piece together the industrial sleek highlighted in four different types of guest rooms of Just Sleep Taipei Sanchong.","keywords":"Just Sleep Taipei Sanchong, Just Sleep, hotels in Taipei, Taiwan family hotels, Taipei family hotels,  Hotels Taipei, luxury hotels Taipei, best hotel Taipei, Taipei hotel recommodation, Taipei travel, Taipei tourism, Taiwan travel, Taiwan tourism, budget travelling Taiwan, budget travelling Taipei, Taipei culture, Taiwan culture, Taipei attractions, Taiwan attractions, Taipei food, Taiwan food, Sanchong hotel room, hotel room view"},"diningsandmeetings":{"title":"Dinings  | Just Sleep Taipei Sanchong","description":"Just Cafe's gourmet heaven reflects the genius culinary of the chef and serves palate-pleasing delicacies to ensure a day full of energy and vitality.","keywords":"Just Sleep Taipei Sanchong, Just Sleep, hotels in Taipei, Taiwan family hotels, Taipei family hotels,  Hotels Tainan, luxury hotels Taipei, best hotel Taipei, Taipei hotel recommodation, Taipei travel, Taipei tourism, Taiwan travel, Taiwan tourism, budget travelling Taiwan, budget travelling Taipei, Taipei culture, Taiwan culture, Taipei attractions, Taiwan attractions, Taipei food, Taiwan foodTainan cuisine, Taipei snacks, Taiwanese cuisine, Taipei restaurants, Taipei breakfast, Taipei steak, Taipei Lunch, Taipei semi-buffet, Sanchong hotel cafe, hotel restaurant"},"amenities":{"title":"Amenities | Just Sleep Taipei Sanchong","description":"An ideal place for family getaways is at Just Sleep Taipei Sanchong, featuring a fitness center, a self-service laundry room, and a business meeting room.","keywords":"Just Sleep Taipei Sanchong, Just Sleep, hotels in Taipei, Taiwan family hotels, Taipei family hotels, best hotel Taipei, Taipei hotel recommendation, hotel facilities,  gym Taipei, meeting room, Laundry, Taipei family getaway"},"activities":{"title":"","description":"","keywords":""},"directions":{"title":"Directions | Just Sleep Taipei Sanchong","description":"Convenient traffic connections are offered by Just Sleep Taipei Sanchong being steps away from the MRT and favoured attractions, such as Dadaocheng.","keywords":"Just Sleep Taipei Sanchong, Just Sleep, hotels in Taipei, Taipei family hotels, Taipei family hotels, New Taipei City hotels Taipei, best hotel Taipei, Taipei hotel recommodation, accommodation Taipei, how to go to Just Sleep Taipei,  Just Sleep Taipei transportation, transportation Just Sleep Taipei, Taipei attractions, Taipei transportation, Taipei tourism, Taiwan tourism, Taipei cuisine, Taipei snacks, Taiwanese cuisine, Dadaocheng, National Palace Museum，Danshui，New Taipei Industrial Park, convenient Sanchong Taipei hotel"},"promotions":{"title":"Saving Money with Best Rate Guarantee | Book Direct with Just Sleep Taipei Sanchong","description":"Stay tuned for the various room packages, special rates, and activities offered to you on the official website of Just Sleep Taipei Sanchong! Don’t miss out!","keywords":"Just Sleep Taipei Sanchong, Just Sleep, hotels in Taipei, Taiwan family hotels, Taipei family hotels,  Hotels Taipei, luxury hotels Taipei, best hotel Taipei, Taipei hotel recommodation, Taipei travel, Taipei tourism, Taiwan travel, Taiwan tourism, budget travelling Taiwan, budget travelling Taipei,  hotel special offers, hotel discounts, hotel promotions"}},"zh-TW":{"home":{"title":"官網訂房保證最低價 | 捷絲旅 台北三重館","description":"全新輕工業風建築，搭配手工烘培咖啡與台灣原片茶讓旅人在舒適客房休息時，感受溫潤貼心的服務。捷絲旅台北三重館近捷運三和國中站，十分方便。","keywords":"捷絲旅台北三重館, 捷絲旅三重,捷絲旅,台北酒店, 台北飯店, 台北親子飯店, 台北商旅, 台北旅館, 台北精品酒店, 台北精品飯店, 台北豪華酒店, 台北豪華飯店, 台北住宿, 台北酒店推薦, 台北飯店推薦, 台北旅遊, 台灣旅遊, 台灣自由行, 台北自由行, 台灣自助旅行, 台北自助旅行, 台北文化, 台北休閒, 台北景點, 台北美食, 台北旅遊, 台灣文化, 台灣休閒, 台灣景點, 台灣美食, 台灣旅遊,工業風,捷運飯店"},"rooms":{"title":"官網訂房保證最低價 | 捷絲旅 台北三重館","description":"捷絲旅台北三重館擁有時尚的輕工業風格，聰明的客房空間規劃，配有五星級的舒壓床墊及高品質日系家電做為您出差旅遊後休憩的最佳場所。","keywords":"捷絲旅台北三重館, 捷絲旅三重,捷絲旅,台北酒店, 台北飯店, 台北親子飯店, 台北商旅, 台北旅館, 台北精品酒店, 台北精品飯店, 台北豪華酒店, 台北豪華飯店, 台北住宿, 台北酒店推薦, 台北飯店推薦, 台北旅遊, 台灣旅遊, 台灣自由行, 台北自由行, 台灣自助旅行, 台北自助旅行, 台北文化, 台北休閒, 台北景點, 台北美食, 台北旅遊, 台灣文化, 台灣休閒, 台灣景點, 台灣美食, 台灣旅遊,工業風,捷運飯店"},"diningsandmeetings":{"title":"餐廳介紹 | 捷絲旅 台北三重館","description":"Just Café捷食藝由晶華酒店五星主廚親自駐點領導團隊，多樣化的烹調方式與配料，道道幸福料理呈現主廚最真誠的一面美味所在地。","keywords":"捷絲旅台北三重館, 台北酒店, 台北飯店, 台北親子飯店, 台北親子餐廳, 三重飯店, 三重酒店, 三重餐廳, 台北精品酒店, 台北精品飯店, 台北豪華酒店, 台北豪華飯店, 台北豪華餐廳, 台北美食, 台北小吃, 台灣美食, 台北餐廳, 台北高級餐廳, 台北早餐, 台北牛排, 台北午餐 "},"amenities":{"title":"設施服務 | 捷絲旅 台北三重館","description":"捷絲旅台北三重館於二樓公共區域貼心設有健身房讓你舒緩身心、小型會議室舉辦簡單會議或活動，與自助洗衣房洗滌隨身衣物。","keywords":"捷絲旅台北三重館, 台北酒店, 台北飯店,三重酒店, 三重飯店, 台北親子飯店, 台北精品酒店, 台北精品飯店, 台北豪華酒店, 台北豪華飯店, 台北住宿, 台北酒店推薦, 台北捷絲旅'怎麼去, 台北捷絲旅交通, 台北捷絲旅路線, 台北捷絲旅開車, 台北捷絲旅接駁, 台北景點, 台北交通, 台北旅遊, 台灣旅遊, 台灣自由行, 台北自由行, 台灣自助旅行, 台北自助旅行，台北飯店設施,  台北飯店健身房, 台北健身房,  台北小型會議室，台北自助洗衣"},"activities":{"title":"","description":"","keywords":""},"directions":{"title":"交通景點 | 捷絲旅 台北三重館","description":"擁有絕佳的地理位置的捷絲旅台北三重館，無論是大稻埕尋幽、迪化街採買、朝聖嚮往已久的故宮瑰寶、抑或是奔向寬闊的淡水，交通四通八達。","keywords":"捷絲旅台北三重館, 台北酒店, 台北飯店,三重酒店, 三重飯店, 台北親子飯店, 台北精品酒店, 台北精品飯店, 台北豪華酒店, 台北豪華飯店, 台北住宿, 台北酒店推薦, 台北捷絲旅'怎麼去, 台北捷絲旅交通, 台北捷絲旅路線, 台北捷絲旅開車, 台北捷絲旅接駁, 台北景點, 台北交通, 台北旅遊, 台灣旅遊, 台灣自由行, 台北自由行, 台灣自助旅行, 台北自助旅行, 台北美食, 台北小吃, 台灣美食, 台北美食, 台北打卡, 大稻埕,故宮博物院、淡水老街、 桃園機場, 新北市景點, 飯店接駁"},"promotions":{"title":"官網訂房保證最低價 | 最新優惠 | 捷絲旅 台北三重館","description":"千萬不要錯過！捷絲旅台北三重館官網訂房最低價，且不定期推出各類住房專案及優惠訊息，提供給你最優惠的住房價格。","keywords":"捷絲旅台北三重館, 台北酒店, 台北飯店,三重酒店, 三重飯店, 台北親子飯店, 台北精品酒店, 台北精品飯店, 台北豪華酒店, 台北豪華飯店, 台北住宿, 台北酒店推薦, 台北捷絲旅怎麼去, 台北捷絲旅交通, 台北捷絲旅路線, 台北捷絲旅開車, 台北捷絲旅接駁, 台北景點, 台北交通, 台北旅遊, 台灣旅遊, 台灣自由行, 台北自由行, 台灣自助旅行, 台北自助旅行， 台北文化, 台北休閒, 台北景點, 台北美食, 台北旅遊"}},"zh-CN":{"home":{"title":"官网订房保证最低价 | 台北饭店 | 捷丝旅 台北三重馆","description":"全新轻工业风建筑，搭配手工烘培咖啡与台湾原片茶让旅人在舒适客房休息时，感受温润贴心的服务。 捷丝旅台北三重馆近捷运三和国中站，十分方便。","keywords":"捷丝旅台北三重馆, 捷丝旅三重,捷丝旅,台北酒店, 台北饭店, 台北亲子饭店, 台北商旅, 台北旅馆, 台北精品酒店, 台北精品饭店, 台北豪华酒店, 台北豪华饭店, 台北住宿, 台北酒店推荐, 台北饭店推荐, 台北旅游, 台湾旅游, 台湾自由行, 台北自由行, 台湾自助旅行, 台北自助旅行, 台北文化, 台北休闲, 台北景点, 台北美食, 台北旅游, 台湾文化, 台湾休闲, 台湾景点, 台湾美食, 台湾旅游,工业风,早午餐"},"rooms":{"title":"官网订房保证最低价 | 捷丝旅 台北三重馆","description":"捷丝旅台北三重馆拥有时尚的轻工业风格，聪明的客房空间规划，配有五星级的舒压床垫及高品质日系家电做为您出差旅游后休憩的最佳场所。","keywords":"捷丝旅台北三重馆, 台北酒店, 台北饭店, 台北亲子饭店, 台北商旅, 台北旅馆, 台北精品酒店, 台北精品饭店, 台北豪华酒店, 台北豪华饭店, 台北住宿, 台北酒店推荐, 台北饭店推荐, 台北旅游, 台湾旅游, 台湾自由行, 台北自由行, 台湾自助旅行, 台北自助旅行, 台北文化, 台北休闲, 台北景点, 台北美食, 台北旅游, 台湾文化, 台湾休闲, 台湾景点, 台湾美食, 台湾旅游,工业风,早午餐"},"diningsandmeetings":{"title":"餐厅会议 | 捷丝旅 台北三重馆","description":"Just Café捷食艺由晶华酒店五星主厨亲自驻点领导团队，多样化的烹调方式与配料，道道幸福料理呈现主厨最真诚的一面美味所在地。","keywords":"捷丝旅台北三重馆, 台北酒店, 台北饭店, 台北亲子饭店, 台北亲子餐厅, 三重饭店, 三重酒店, 三重餐厅, 台北精品酒店, 台北精品饭店, 台北豪华酒店, 台北豪华饭店, 台北豪华餐厅, 台北美食, 台北小吃, 台湾美食, 台北餐厅, 台北高级餐厅, 台北早餐, 台北牛排, 台北午餐"},"amenities":{"title":"设施服务 | 捷丝旅 台北三重馆","description":"捷丝旅台北三重馆于二楼公共区域贴心设有健身房让你舒缓身心、小型会议室举办简单会议或活动，与自助洗衣房洗涤随身衣物。","keywords":"捷丝旅台北三重馆, 台北酒店, 台北饭店,三重酒店, 三重饭店, 台北亲子饭店, 台北精品酒店, 台北精品饭店, 台北豪华酒店, 台北豪华饭店, 台北住宿, 台北酒店推荐, 台北捷丝旅'怎么去, 台北捷丝旅交通, 台北捷丝旅路线, 台北捷丝旅开车, 台北捷丝旅接驳, 台北景点, 台北交通, 台北旅游, 台湾旅游, 台湾自由行, 台北自由行, 台湾自助旅行, 台北自助旅行，台北饭店设施, 台北饭店健身房, 台北健身房, 台北小型会议室，台北自助洗衣"},"activities":{"title":"","description":"","keywords":""},"directions":{"title":"交通景点 | 捷丝旅 台北三重馆","description":"拥有绝佳的地理位置的捷丝旅台北三重馆，无论是大稻埕寻幽、迪化街采买、朝圣向往已久的故宫瑰宝、抑或是奔向宽阔的淡水，交通四通八达。","keywords":"捷丝旅台北三重馆, 台北酒店, 台北饭店,三重酒店, 三重饭店, 台北亲子饭店, 台北精品酒店, 台北精品饭店, 台北豪华酒店, 台北豪华饭店, 台北住宿, 台北酒店推荐, 台北捷丝旅'怎么去, 台北捷丝旅交通, 台北捷丝旅路线, 台北捷丝旅开车, 台北捷丝旅接驳, 台北景点, 台北交通, 台北旅游, 台湾旅游, 台湾自由行, 台北自由行, 台湾自助旅行, 台北自助旅行, 台北美食, 台北小吃, 台湾美食, 台北美食, 台北打卡, 大稻埕,故宫博物院、淡水老街、 桃园机场, 新北市景点, 饭店接驳"},"promotions":{"title":"官网订房最低价保证 | 最新优惠 | 捷丝旅 台北三重馆","description":"千万不要错过！捷丝旅台北三重馆官网订房最低价，且不定期推出各类住房项目及优惠讯息，提供给你最优惠的住房价格。","keywords":"捷丝旅台北三重馆, 台北酒店, 台北饭店,三重酒店, 三重饭店, 台北亲子饭店, 台北精品酒店, 台北精品饭店, 台北豪华酒店, 台北豪华饭店, 台北住宿, 台北酒店推荐, 台北捷丝旅怎么去, 台北捷丝旅交通, 台北捷丝旅路线, 台北捷丝旅开车, 台北捷丝旅接驳, 台北景点, 台北交通, 台北旅游, 台湾旅游, 台湾自由行, 台北自由行, 台湾自助旅行, 台北自助旅行， 台北文化, 台北休闲, 台北景点, 台北美食, 台北旅游"}},"ja":{"home":{"title":"ご予約は当サイトが最もお得です | ジャストスリープ台北三重館","description":"ジャストスリープ台北三重館は目の前がMRT三和国中駅という絶好の立地条件で、交通の便がよく、ビジネスにも旅行にも大変便利です。斬新なインダストリアルな建築スタイルが特徴で、手作り焙煎のコーヒーと台湾茶をご提供することで、お客様一人ひとりに快適な客室でおくつろぎいただきながら、温かみのあるサービスと雰囲気をお届けしています。","keywords":"ジャストスリープ台北三重館、台北ホテル、台北子連れホテル、家族ホテル、ブティックホテル、デザイナーズホテル、高級ホテル、ベストホテル、台北 宿泊、台北観光、台北旅行、台湾旅行、台湾おすすめホテル、台北おすすめホテル、台北文化、台北レジャー、台北観光スポット、台北の料理、台北の観光、台湾の文化、台湾レジャー、台湾の観光スポット、台湾の料理、台湾観光"},"rooms":{"title":"ご予約は当サイトが最もお得です | ジャストスリープ台北三重館","description":"ジャストスリープ台北三重館の95間客室には今一番人気のインダストリアルデザイン、パナソニック製の家用電器とTOTO製のウォシュレット、浴室設備付き、快適な生活空間を提供しております。","keywords":"ジャストスリープ台北三重館、ジャストスリープ、ジャストスリープ三重、台北ホテル、台北子連れホテル、家族ホテル、ブティックホテル、デザイナーズホテル、高級ホテル、ベストホテル、台北 宿泊、台北観光、台北旅行、台湾旅行、台湾おすすめホテル、台北おすすめホテル、台北文化、台北レジャー、台北観光スポット、台北の料理、台北の観光、台湾の文化、台湾レジャー、台湾の観光スポット、台湾の料理、台湾観光、工業風、MRTホテル"},"diningsandmeetings":{"title":"レストラン、会議 | ジャストスリープ台北三重館","description":"Just Cafe'は地元産の食材で美味しいと幸せな台湾料理を作ります。","keywords":"ジャストスリープ台北三重館、ジャストスリープ、ジャストスリープ三重、台北ホテル、台北子連れホテル、台北ファミリーホテル、ファミリーホテル、台北ファミリーレストラン、ブティックホテル、ブティックホテル、高級ホテル、ラグジュアリーホテル、豪華グルメ、台北グルメ、台北料理、台湾料理、台北レストラン、台北朝食、台北ステーキハウス、台北昼ご飯"},"amenities":{"title":"レジャー施設 | ジャストスリープ台北三重館","description":"ジャストスリープ台北三重館の2階で、シンプルジムとおもてなしのセルフ洗濯機が付いております。ミニミーティングルームで簡単な会議が行えできます。","keywords":"ジャストスリープ台北三重館、ジャストスリープ、ジャストスリープ三重、台北ホテル、台北子連れホテル、家族ホテル、ブティックホテル、デザイナーズホテル、高級ホテル、ベストホテル、台北 宿泊、台北観光、台北旅行、台湾旅行、台湾おすすめホテル、台北おすすめホテル、台北文化、台北レジャー、台北観光スポット、台北の料理、台北の観光、台湾の文化、台湾レジャー、台湾の観光スポット、台湾の料理、台湾観光、工業風、MRTホテル、ラグジュアリーホテル、ジム、セルフサービスランドリー"},"activities":{"title":"","description":"","keywords":""},"directions":{"title":"交通アクセス | ジャストスリープ台北三重館","description":"ジャストスリープ台北三重館はMRTの三和中学校駅2番出口から、すぐホテルの前に着きます。台北有名な迪化街と故宮博物館も近くのアトラクション。","keywords":"ジャストスリープ台北三重館、ジャストスリープ、ジャストスリープ三重、台北ホテル、台北子連れホテル、台北ファミリーホテル、ファミリーホテル、台北ファミリーレストラン、ブティックホテル、ブティックホテル、高級ホテル、ラグジュアリーホテル観光、台北旅行、台湾旅行、台湾おすすめホテル、台北おすすめホテル、台北文化、台北レジャー、台北観光スポット、台北の料理、台北の観光、台湾の文化、台湾レジャー、台湾の観光スポット、台湾の料理、台湾観光、淡水市街、国立故宮博物院、大稲テイ"},"promotions":{"title":"ご予約は当サイトが最もお得です | 最新情報 | ジャストスリープ台北三重館","description":"台北市内より安し， オープンニンプランと一泊二食プランなと提供して、斬新であるホテルでお客様にお待ちいたしております。","keywords":"ジャストスリープ台北三重館、ジャストスリープ、ジャストスリープ三重、台北ホテル、台北子連れホテル、台北ファミリーホテル、ファミリーホテル、台北ファミリーレストラン、ブティックホテル、ブティックホテル、高級ホテル、ラグジュアリーホテル観光、台北旅行、台湾旅行、台湾おすすめホテル、台北おすすめホテル、台北文化、台北レジャー、台北観光スポット、台北の料理、台北の観光、台湾の文化、台湾レジャー、台湾の観光スポット、ホテル スペシャルオファー、ホテル割引、ホテルプロモーション"}},"ko":{"home":{"title":"공식 사이트에서 예약하는 것이 가장 저렴합니다 | 저스트슬립 타이페이 산총점","description":"저스트슬립 타이베이 싼충점은 MRT 싼허중학교역이 호텔 바로 앞에 위치한 최적의 입지조건을 자랑합니다. 사통팔달의 편리한 교통으로 비즈니스 출장은 물론 레저 여행 시에도 매우 편리합니다. 새롭게 단장한 로프트 스타일의 건축물과 수제 로스팅 커피, 타이완산 잎차를 통해 찾아 주신 모든 여행객에게 편안한 객실에서 만끽하는 여유, 정성으로 모시는 세심한 서비스를 선사합니다.","keywords":"저스트슬립 타이페이 싼충점,저스트슬립 싼충,저스트슬립,타이페이 호텔,타이페이 호텔 추천,타이페이 여행,대만 여행,타이페이 문화,타이페이 여유,타이페이 관광지,타이페이 맛집,대만 문화,대만 여유,대만 관광지,대만 맛집,로프트"},"rooms":{"title":"공식 사이트에서 예약하는 것이 가장 저렴합니다 | 저스트슬립 타이페이 산총점","description":"저스트슬립 타이페이 싼충점은 95개 객실이 있습니다. 객실내에 글로벌 품질의 매트리스가 구비되어 있습니다. 여행에 대해서 좋은 선택입니다","keywords":"저스트슬립 타이페이 싼충점,저스트슬립 싼충,저스트슬립,타이페이 호텔,타이페이 호텔 추천,타이페이 여행,대만 여행,타이페이 문화,타이페이 여유,타이페이 관광지,타이페이 맛집,대만 문화,대만 여유,대만 관광지,대만 맛집,로프트"},"diningsandmeetings":{"title":"다이닝 & 연회 회의 | 저스트슬립 타이페이 산총점","description":"저스트 카페는 매일 뷔페 조식을 제공하고 주말에 중식을 제공합니다. 다양한 야채,과일,해물 등등, 제일 맛있는 요리를 제공합니다.","keywords":"저스트슬립 타이페이 싼충점,저스트슬립 싼충,저스트슬립,타이페이 호텔,타이페이 호텔 추천,타이페이 여행,대만 여행,타이페이 문화,타이페이 여유,타이페이 관광지,타이페이 맛집,대만 문화,대만 여유,대만 관광지,대만 맛집,로프트"},"amenities":{"title":"테마 | 저스트슬립 타이페이 산총점","description":"저스트슬립 싼충점은 2층에 피트니스,회의실,셀프 세탁실이 있습니다.","keywords":"저스트슬립 타이페이 싼충점,저스트슬립 싼충,저스트슬립,타이페이 호텔,타이페이 호텔 추천,타이페이 여행,대만 여행,타이페이 문화,타이페이 여유,타이페이 관광지,타이페이 맛집,대만 문화,대만 여유,대만 관광지,대만 맛집,로프트"},"activities":{"title":"","description":"","keywords":""},"directions":{"title":"시설 | 저스트슬립 타이페이 산총점","description":"저스트슬립 싼충점은 제일 좋은 위치에 있습니다. 지하철역이 바로 옆에 있고 2역 타면 바로 타이페이의 번화가입니다. 싼충점은 많이 편한 곳입니다.","keywords":"저스트슬립 타이페이 싼충점,저스트슬립 싼충,저스트슬립,타이페이 호텔,타이페이 호텔 추천,타이페이 여행,대만 여행,타이페이 문화,타이페이 여유,타이페이 관광지,타이페이 맛집,대만 문화,대만 여유,대만 관광지,대만 맛집,로프트"},"promotions":{"title":"공식 사이트에서 예약하는 것이 가장 저렴합니다 | 최신소식 | 저스트슬립 타이페이 산총점","description":"저스트슬립 싼충점은 많은 행사와 할인을 제공합니다. 최신소식과 행사를 놓치지 마십니다.","keywords":"저스트슬립 타이페이 싼충점,저스트슬립 싼충,저스트슬립,타이페이 호텔,타이페이 호텔 추천,타이페이 여행,대만 여행,타이페이 문화,타이페이 여유,타이페이 관광지,타이페이 맛집,대만 문화,대만 여유,대만 관광지,대만 맛집,로프트"}}}

/***/ }),
/* 587 */
/***/ (function(module, exports) {

module.exports = {"en":{"home":{"title":"Best Rate and Service Guarantee | Book Direct with Just Sleep Taipei Ximending","description":"Just Sleep Taipei Ximending, is minutes away from the center of Ximending with personalized five star services at a cheaper price so guests feel at ease in a bustling city.","keywords":"Just Sleep Taipei Ximending, Ximending, hotels in Ximending, accommodation in Ximending, recommended accommodation in Ximending, MRT Ximen Station, Taipei Main Station, accommodation in Taipei Main Station area, Ximending shopping district, Taipei travel, Taipei tour, tourist attractions in Taipei, delicacies in Taipei, individual travel in Taipei, Taipei Ximending hotel, best recommended Ximending hotel"},"rooms":{"title":"Best Hotel Price Guarantee | Book Direct with Just Sleep Taipei Ximending","description":"Be the first to stay in our minimalistic Superior and Deluxe guest rooms accommodating to your needs. Only official website bookings grant you the best deal.","keywords":"Just Sleep Taipei Ximending, Ximending, hotels in Ximending, accommodation in Ximending, recommended accommodation in Ximending, MRT Ximen Station, Taipei Main Station, accommodation in Taipei Main Station area, Ximending shopping district, Ximending hotel rooms"},"diningsandmeetings":{"title":"Dinings & Meetings | Just Sleep Taipei Ximending","description":"Just Cafe serves breakfast buffet using selected fresh local ingredients. The diversified options illustrate pops of color to start you day right.","keywords":"Just Sleep Taipei Ximending, Ximending, hotels in Ximending, accommodation in Ximending, recommended accommodation in Ximending, MRT Ximen Station, Taipei Main Station, accommodation in Taipei Main Station area, Ximending shopping district, ximending hotel breakfast"},"amenities":{"title":"Amenities | Just Sleep Taipei Ximending","description":"Free Wi-Fi, self-service laundry room, the new gym, the service center, and complimentary welcome drinks and local snacks are accessible at the hotel.","keywords":"Just Sleep Taipei Ximending, Ximending, hotels in Ximending, accommodation in Ximending, recommended accommodation in Ximending, MRT Ximen Station, Taipei Main Station, accommodation in Taipei Main Station area, Ximending shopping district, hotel's facilities, free hotel's facilities, hotel's Wi-Fi, hotel's self-service laundry, Ximending hotel facilities"},"activities":{"title":"Activities | Just Sleep Taipei Ximending","description":"“Just Sleep” cooperated with “SWAN PANASIA” exclusively to serve the most popular board games to spice up your stay at Just Sleep Taipei Ximending.","keywords":"Just Sleep Taipei Ximending, Ximending, hotels in Ximending, accommodation in Ximending, recommended accommodation in Ximending, MRT Ximen Station, Taipei Main Station, accommodation in Taipei Main Station area, Ximending shopping district, hotel's facilities, free hotel's facilities, hotel's Wi-Fi, hotel's self-service laundry, Ximending hotel games, taipei hotel activities"},"directions":{"title":"Directions | Just Sleep Taipei Ximending","description":"The hotel is only minutes from vigorous hip and historical spots that everyone has to visit, such as the Red House Theater and Ximending Cinema Street. ","keywords":"Just Sleep Taipei Ximending, Ximending, hotels in Ximending, accommodation in Ximending, recommended accommodation in Ximending, MRT Ximen Station, Taipei Main Station, accommodation in Taipei Main Station area, Ximending shopping district, Red House Theater, Taipei Matsu Temple, Cinema Street, Ximending historical spots"},"promotions":{"title":"Saving Money with Best Rate Guarantee | Book Direct with Just Sleep Taipei Ximending","description":"Only through booking a reservation on our official website will get you the best price. You’ll regret if you miss out on any of our additional special offers!","keywords":"Just Sleep Taipei Ximending, Ximending, hotels in Ximending, accommodation in Ximending, recommended accommodation in Ximending, MRT Ximen Station, Taipei Main Station, accommodation in Taipei Main Station area, Ximending shopping district, special offer for hotels in Ximending, special offer for accommodation in Taipei Ximending"}},"zh-TW":{"home":{"title":"官網訂房最低價，另享高鐵訂票75折優惠 | 捷絲旅 台北西門館","description":"鄰近西門町商圈、捷運西門站、西門町商圈，全新時尚大方空間設計，是旅人最佳選擇。捷絲旅台北西門館官網訂房最低價，並享高鐵訂票75折優惠！","keywords":"捷絲旅台北西門館, 西門町, 西門町飯店, 西門町住宿, 西門住宿推薦, 捷運西門站, 台北車站, 台北車站住宿, 西門町商圈, 台北旅遊, 台北旅行, 台北景點, 台北美食, 台北自由行"},"rooms":{"title":"官網訂房最低價，另享高鐵訂票75折優惠 | 捷絲旅 台北西門館","description":"客房全新整修，搶先入住！輕鬆時尚的精緻房型與舒適寬容的豪華房型，適合情侶、好友及家庭。捷絲旅台北西門館官網訂房最低價，享高鐵訂票75折優惠！","keywords":"捷絲旅台北西門館, 西門町, 台北飯店, 西門町飯店, 西門町住宿, 西門住宿推薦, 台北車站住宿, 捷運西門站, 台北車站, 西門町商圈"},"diningsandmeetings":{"title":"餐廳會議 | 捷絲旅 台北西門館","description":"Just Café 提供自助式早餐，主廚嚴選在地新鮮食材，提供旅人胃口大開、豐富多樣的選擇，讓旅人一大早活力充沛。","keywords":"捷絲旅台北西門館, 西門町, 台北飯店, 西門町飯店, 西門町住宿, 西門住宿推薦, 台北車站住宿, 捷運西門站, 台北車站, 西門町商圈"},"amenities":{"title":"設施服務 | 捷絲旅 台北西門館","description":"全館提供24小時的服務中心、免費WiFi，免費自助洗衣設備，全新落成的健身房，和每日無限量供應旅人飲品與懷舊零食。","keywords":"捷絲旅台北西門館, 西門町, 台北飯店, 西門町飯店, 西門町住宿, 西門住宿推薦, 台北車站住宿, 捷運西門站, 台北車站, 西門町商圈, 飯店設施, 飯店免費設施, 飯店無線網路, 飯店自助洗衣"},"activities":{"title":"館內活動 | 捷絲旅 台北西門館","description":"「Just Sleep 捷絲旅」與「SWAN PANASIA 新天鵝堡」獨家合作，提供熱門桌遊，為旅人打造歡樂旅行回憶。","keywords":"捷絲旅台北西門館, 西門町, 台北飯店, 西門町飯店, 西門町住宿, 西門住宿推薦, 台北車站住宿, 捷運西門站, 台北車站, 西門町商圈, 飯店設施, 飯店免費設施, 飯店無線網路, 飯店自助洗衣"},"directions":{"title":"交通景點 | 捷絲旅 台北西門館","description":"全館鄰近熱鬧西門町商圈，步行3分鐘可達捷運西門站、步行5分鐘至西門町商圈，著名觀光景點如紅樓劇場、西門町電影街等，皆是每個人必去的景點。","keywords":"捷絲旅台北西門館, 西門町, 台北飯店, 西門町飯店, 西門町住宿, 西門住宿推薦, 台北車站住宿, 捷運西門站, 台北車站, 西門町商圈, 紅樓劇場, 台北天后宮, 電影街"},"promotions":{"title":"官網訂房最低價，另享高鐵訂票75折優惠 | 最新優惠 | 捷絲旅 台北西門館","description":"捷絲旅台北西門館官網訂房最低價，並享高鐵訂票75折優惠！不定期推出住房專案及優惠訊息，必敬請鎖定最新消息，掌握旅人專屬最優惠的住房價格。","keywords":"捷絲旅台北西門館, 西門町, 西門町飯店, 西門町住宿, 西門住宿推薦, 捷運西門站, 台北車站, 台北車站住宿, 西門町商圈, 西門町飯店優惠, 台北西門町住房優惠, 早鳥住房, 官網住房優惠, 官網住房折扣"}},"zh-CN":{"home":{"title":"官网订房保证最低价 | 捷丝旅 台北西门馆","description":"捷丝旅台北西门馆官网订房最低价，并享高铁订票75折优惠！邻近西门町商圈、捷运西门站、西门町商圈，全新时尚大方空间设计，是旅人最佳选择。","keywords":"捷丝旅台北西门馆, 西门町, 西门町饭店, 西门町住宿, 西门住宿推荐, 捷运西门站, 台北车站, 台北车站住宿, 西门町商圈, 台北旅游, 台北旅行, 台北景点, 台北美食, 台北自由行"},"rooms":{"title":"官网订房保证最低价 | 捷丝旅 台北西门馆","description":"捷丝旅台北西门馆官网订房最低价，享高铁订票75折优惠！客房全新整修，抢先入住！轻松时尚的精致房型与舒适宽容的豪华房型，适合情侣、好友及家庭。","keywords":"捷丝旅台北西门馆, 西门町, 台北饭店, 西门町饭店, 西门町住宿, 西门住宿推荐, 台北车站住宿, 捷运西门站, 台北车站, 西门町商圈"},"diningsandmeetings":{"title":"餐厅会议 | 捷丝旅 台北西门馆","description":"Just Café 提供自助式早餐，主厨严选在地新鲜食材，提供旅人胃口大开丰富、多样的选择，让旅人一大早活力充沛。","keywords":"捷丝旅台北西门馆, 西门町, 台北饭店, 西门町饭店, 西门町住宿, 西门住宿推荐, 台北车站住宿, 捷运西门站, 台北车站, 西门町商圈"},"amenities":{"title":"设施服务 | 捷丝旅 台北西门馆","description":"全馆提供24小时的服务中心、免费WiFi，以及免费自助洗衣设备，全新落成的健身房，和每日无限量供应旅人饮品与怀旧零食。","keywords":"捷丝旅台北西门馆, 西门町, 台北饭店, 西门町饭店, 西门町住宿, 西门住宿推荐, 台北车站住宿, 捷运西门站, 台北车站, 西门町商圈, 饭店设施, 饭店免费设施, 饭店无线网络, 饭店自助洗衣"},"activities":{"title":"馆内活动 | 捷丝旅 台北西门馆","description":"「Just Sleep 捷丝旅」与「SWAN PANASIA 新天鹅堡」独家合作，提供热门桌游，为旅人打造甜蜜竞争的欢乐旅行回忆。","keywords":"捷丝旅台北西门馆, 西门町, 台北饭店, 西门町饭店, 西门町住宿, 西门住宿推荐, 台北车站住宿, 捷运西门站, 台北车站, 西门町商圈, 饭店设施, 饭店免费设施, 饭店无线网络, 饭店自助洗衣"},"directions":{"title":"交通景点 | 捷丝旅 台北西门馆","description":"全馆邻近热闹西门町商圈，步行3分钟可达捷运西门站、步行5分钟至西门町商圈，著名观光景点如红楼剧场、西门町电影街等，皆是每个人必去的景点。","keywords":"捷丝旅台北西门馆, 西门町, 台北饭店, 西门町饭店, 西门町住宿, 西门住宿推荐, 台北车站住宿, 捷运西门站, 台北车站, 西门町商圈, 红楼剧场, 台北天后宫, 电影街"},"promotions":{"title":"官网订房保证最低价 | 最新优惠 | 捷丝旅 台北西门馆","description":"捷丝旅台北西门馆官网订房最低价，并享高铁订票75折优惠！不定期推出住房专案及优惠讯息，必敬请锁定最新消息，掌握旅人专属最优惠的住房价格。","keywords":"捷丝旅台北西门馆, 西门町, 西门町饭店, 西门町住宿, 西门住宿推荐, 捷运西门站, 台北车站, 台北车站住宿, 西门町商圈, 西门町饭店优惠, 台北西门町住房优惠, 早鸟住房, 官网住房优惠, 官网住房折扣"}},"ja":{"home":{"title":"ご予約は当サイトが最もお得です | ジャストスリープ台北西門館","description":"賑やかな西門町ショッピングエリアに隣接しています。徒歩3分でMRT西門駅、5分で西門町ショッピングエリアに向かうことのできる、全く新たな客室空間です。梱包、代理購入などの親切なサービスもご提供しており、コストパフォーマンスを重視されるお客様への最良の選択です。","keywords":"西門町、西門町のホテル、西門町での宿泊、西門町でのおすすめの宿泊、MRT西門駅、台北駅、台北駅での宿泊、西門町ショッピングエリア、台北での旅、台北旅行、台北の観光スポット、台北での美食、台北での自由旅行、"},"rooms":{"title":"ご予約は当サイトが最もお得です | ジャストスリープ台北西門館","description":"客室を全く新たにリニューアルしました。ぜひご宿泊ください！6-10坪のファッショナブルで快適な客室は、カップル、親しいご友人とご家族でのご旅行に適しています。客室は2-4名様でご宿泊いただけます。公式ウェブサイトからご予約いただくと、最もお得な料金でお楽しみいただけます。","keywords":"西門町、西門町のホテル、西門町での宿泊、西門町でのおすすめの宿泊、MRT西門駅、台北駅、台北駅での宿泊、西門町ショッピングエリア"},"diningsandmeetings":{"title":"レストラン、会議 | ジャストスリープ台北西門館","description":"Just Café ジャストカフェではビュッフェスタイルの朝食をご提供しています。シェフ厳選の地元の新鮮な食材によるサラダから果物、パン、温かいお粥、おかずなど、豊富で多様な朝食の選択をお客様にご提供しています。すばらしい朝をお楽しみください。","keywords":"西門町、西門町のホテル、西門町での宿泊、西門町でのおすすめの宿泊、MRT西門駅、台北駅、台北駅での宿泊、西門町ショッピングエリア"},"amenities":{"title":"レジャー施設 | ジャストスリープ台北西門館","description":"当ホテルでは24時間のサービスセンター、無料Wi-Fi、セルフサービスでの無料洗濯機、乾燥機、アイロンなどの設備、全く新しく完成したフィットネス・スペースをご提供しています。このほか毎日無制限でコーヒー、紅茶、懐かしのおやつなどのウェルカムティーとお茶菓子をご提供しています。","keywords":"西門町、西門町のホテル、西門町での宿泊、西門町でのおすすめの宿泊、MRT西門駅、台北駅、台北駅での宿泊、西門町ショッピングエリア、ホテルの施設、ホテルの無料施設、ホテルの無線インターネット、ホテルのセルフサービスのランドリー"},"activities":{"title":"館内イベント | ジャストスリープ台北西門館","description":"「Just Sleep ジャストスリープ」と「SWAN PANASIA 新天鵝堡」の独占協力により、お客様に旅の楽しいひと時を創り出すため、AUF ZACK (ささっと！)、FUN FARM(楽しい農場)、WOODMAN(木こりの達人)、RIVER DRAGON (リヴァードラゴン)などの人気テーブルゲームをご提供しています。","keywords":"西門町、西門町のホテル、西門町での宿泊、西門町でのおすすめの宿泊、MRT西門駅、台北駅、台北駅での宿泊、西門町ショッピングエリア、ホテルの施設、ホテルの無料施設、ホテルの無線インターネット、ホテルのセルフサービスのランドリー"},"directions":{"title":"交通アクセス | ジャストスリープ台北西門館","description":"当ホテルは賑やかな西門町ショッピングエリアに隣接しています。徒歩約3分でMRT西門駅、5分で西門町ショッピングエリアに向かうことができます。紅楼劇場、西門町の映画町など、どれも国内外の観光客の方々が必ず訪れる有名な観光スポットです。","keywords":"西門町、西門町のホテル、西門町での宿泊、西門町でのおすすめの宿泊、MRT西門駅、台北駅、台北駅での宿泊、西門町ショッピングエリア、紅楼劇場、台北天后宮、映画街"},"promotions":{"title":"ご予約は当サイトが最もお得です | 最新情報 | ジャストスリープ台北西門館","description":"当ホテルでは不定期にご宿泊プランと割引情報をリリースしています。公式ウェブサイトではお客様に最も優れた客室料金をご提供しております。お客様専用の割引情報を入手するためにも、最新情報にご注目ください。","keywords":"西門町、西門町のホテル、西門町での宿泊、西門町でのおすすめの宿泊、MRT西門駅、台北駅、台北駅での宿泊、西門町ショッピングエリア、西門町ホテルの割引、台北西門町での宿泊割引"}},"ko":{"home":{"title":"공식 사이트에서 예약하는 것이 가장 저렴합니다 | 저스트슬립 타이페이 시먼점","description":"유명하고 번화한 시먼딩 상권에 인접해있으며, 시먼 전철역(西门站)까지 도보로 3분, 시먼딩 상권까지 도보로 5분이면 이동이 가능하며, 새로 단장한 객실 공간과 포장 및 구매대행등의 편리하고 친절한 서비스도 제공해드리며, 가성비를 중시하시는 고객님께 안성맞춤입니다.","keywords":"시먼딩, 시먼딩 호텔, 시먼딩 숙박, 시먼딩 숙박 추천, 전철역, 타이베이 버스 터미널, 타이베이 버스 터미널 숙박, 시먼딩 상권, 타이베이 여행, 타이베이 명소, 타이베이 맛집, 타이베이 자유여행"},"rooms":{"title":"공식 사이트에서 예약하는 것이 가장 저렴합니다 | 저스트슬립 타이페이 시먼점","description":"객실이 전부 새롭게 단장하였습니다, 서둘러 예약 하세요! 6－10평의 세련된 인테리어의 편안한 객실로, 연인과 친구 그리고 가족여행에 안성맞춤이며, 객실은 2-4인 입실이 가능합니다. 홈페이지에서 더욱 저렴한 할인혜택으로 만나보세요.","keywords":"시먼딩, 시먼딩 호텔, 시먼딩 숙박, 시먼딩 숙박 추천, 전철역, 타이베이 버스 터미널, 타이베이 버스 터미널 숙박, 시먼딩 상권, 타이베이 여행, 타이베이 명소, 타이베이 맛집, 타이베이 자유여행"},"diningsandmeetings":{"title":"다이닝 & 연회 회의 | 저스트슬립 타이페이 시먼점","description":"Just Café에서는 뷔페식 조식을 제공해드리며, 메인 셰프가 엄선한 신선한 현지의 식재료로 샐러드, 과일, 베이커리, 죽 및 기타 요리 등 여행객에게 더욱 풍성하고 다양한 초이스와 제공해 드리며 아름답고 여유로운 아침시간을 선사해 드립니다.","keywords":"시먼딩, 시먼딩 호텔, 시먼딩 숙박, 시먼딩 숙박 추천, 전철역, 타이베이 버스 터미널, 타이베이 버스 터미널 숙박, 시먼딩 상권, 타이베이 여행, 타이베이 명소, 타이베이 맛집, 타이베이 자유여행"},"amenities":{"title":"테마 | 저스트슬립 타이페이 시먼점","description":"호텔에서는 24시간 서비스 센터를 운영하며, 무료 Wifi, 및 무료 셀프 세탁기, 건조기, 다리미 등의 편의시설을 제공해 드리며, 새로 단장한 헬스장 및 매일마다 무제한으로 제공되는 환영 다과(커피, 홍차 및 추억의 간식) 또한 마음껏 이용해보세요.","keywords":"시먼딩, 시먼딩 호텔, 시먼딩 숙박, 시먼딩 숙박 추천, 전철역, 타이베이 버스 터미널, 타이베이 버스 터미널 숙박, 시먼딩 상권, 타이베이 여행, 타이베이 명소, 타이베이 맛집, 타이베이 자유여행, 호텔 시설, 호텔 무료 시설, 호텔 wifi, 호텔 셀프 세탁"},"activities":{"title":"관내활동 | 저스트슬립 타이페이 시먼점","description":"「저스트 슬립(Just Sleep)」과「스완 파나시아(SWAN PANASIA)」가 단독으로 협업하여，AUF ZACK, FUN FARM, WOODMAN, RIVER DRAGON등의 최신 유행의 보드게임을 제공해드립니다. 여행객들에게 행복하고 즐거운 시간을 만들어 드립니다.","keywords":"시먼딩, 시먼딩 호텔, 시먼딩 숙박, 시먼딩 숙박 추천, 전철역, 타이베이 버스 터미널, 타이베이 버스 터미널 숙박, 시먼딩 상권, 타이베이 여행, 타이베이 명소, 타이베이 맛집, 타이베이 자유여행, 호텔 시설, 호텔 무료 시설, 호텔 wifi, 호텔 셀프 세탁"},"directions":{"title":"시설 | 저스트슬립 타이페이 시먼점","description":"호텔은 유명하고 번화한 시먼딩 상권에 인접해있으며, 시먼 전철역(西门站)까지 도보로 3분, 시먼딩 상권까지 도보로 5분이면 이동이 가능하며, 홍루극장(红楼剧场), 시먼딩 영화거리(西门町电影街)등의 유명한 관광지는 국내외의 여행객이라면 반드시 방문해 보아야할 명소입니다.","keywords":"시먼딩, 시먼딩 호텔, 시먼딩 숙박, 시먼딩 숙박 추천, 전철역, 타이베이 버스 터미널, 타이베이 버스 터미널 숙박, 시먼딩 상권, 타이베이 여행, 타이베이 명소, 타이베이 맛집, 타이베이 자유여행, 홍루극장, 타이베이 티엔호우궁, 영화거리"},"promotions":{"title":"공식 사이트에서 예약하는 것이 가장 저렴합니다 | 최신소식 | 저스트슬립 타이페이 시먼점","description":"호텔에서는 깜짝 이벤트 및 할인혜택에 관한 정보를 제공해 드리며, 홈페이지에서 여행객을 위한 가장 저렴한 가격을 제공해 드립니다. 여행객을 위한 특별 할인에 관한 최신 정보를 놓치지 마세요.","keywords":"시먼딩, 시먼딩 호텔, 시먼딩 숙박, 시먼딩 숙박 추천, 전철역, 타이베이 버스 터미널, 타이베이 버스 터미널 숙박, 시먼딩 상권, 타이베이 여행, 타이베이 명소, 타이베이 맛집, 타이베이 자유여행, 시먼딩 호텔 할인, 타이베이 시먼딩 숙박 할인"}}}

/***/ }),
/* 588 */
/***/ (function(module, exports) {

module.exports = {"en":{"home":{"title":"Best Rate and Service Guarantee | Book Direct with Just Sleep Tainan Hushan","description":"With excellent access to High-Speed Railway Tainan station, it is a brilliant location for Travelers to conveniently enjoy cultural and artistic spots. ","keywords":"Just Sleep Tainan Hushan, Just Sleep, hotels in Tainan, Taiwan family hotels, Tainan family hotels,  Hotels Tainan, luxury hotels Tainan, best hotel Tainan, Tainan hotel recommodation, Tainan travel, Tainan tourism, Taiwan travel, Taiwan tourism, budget travelling Taiwan, budget travelling Tainan, Tainan culture, Taiwan culture, Tainan attractions, Taiwan attractions, Tainan food, Taiwan food, Rende hotel, Rende recommended"},"rooms":{"title":"Best Hotel Price Guarantee | Book Direct with Just Sleep Tainan Hushan","description":"Brick walls and a variety of patterns piece together the industrial sleek highlighted in different types of guest rooms of Just Sleep Tainan Hushan","keywords":"Just Sleep Tainan Hushan, Just Sleep, hotels in Tainan, Taiwan family hotels, Tainan family hotels, Hotels Tainan, luxury hotels Tainan, best hotel Tainan, Tainan hotel recommodation, Tainan travel, Tainan tourism, Taiwan travel, Taiwan tourism, budget travelling Taiwan, budget travelling Tainan, Tainan culture, Taiwan culture, Tainan attractions, Taiwan attractions, Tainan food, Taiwan food, Rende hotel, Rende recommended"},"diningsandmeetings":{"title":"Dinings & Meetings | Just Sleep Tainan Hushan","description":"Just Cafe is an all-day dining restaurant led by a team of 5-star chefs from Silks Place Tainan. The hotel is also equipped with multi-functional banquet hall and meeting rooms that are suitable for business meetings and small banquets.","keywords":"Just Sleep Tainan Hushan, Just Sleep, hotels in Tainan, Taiwan family hotels, Tainan family hotels, Hotels Tainan, luxury hotels Tainan, best hotel Tainan, Tainan hotel recommodation, Tainan travel, Tainan tourism, budget travelling Tainan, Tainan culture, Tainan attractions, Tainan food, Taiwan food, Tainan cuisine, Tainan snacks, Taiwanese cuisine, Tainan restaurants, Tainan Breakfast, Tainan Lunch, Tainan Brunch, Tainan semi-buffet, Rende hotel cafe, Tainan Wedding Venue"},"amenities":{"title":"Amenities | Just Sleep Tainan Hushan","description":"An ideal place for family getaways is at Just Sleep Tainan Hushan, featuring an outdoor pool, a self-service laundry room, a multifunctional meeting room and banquet hall.","keywords":"Just Sleep Tainan Hushan, Just Sleep, hotels in Tainan, Taiwan family hotels, Tainan family hotels, best hotel Tainan, Tainan hotel recommendation, hotel facilities, pool Tainan, meeting room, Laundry, Tainan family getaway, Tainan banquet venue"},"activities":{"title":"","description":"","keywords":""},"directions":{"title":"Directions | Just Sleep Tainan Hushan","description":"With excellent access to High-Speed Railway Tainan station, Tainan Airport and Highways, it is a brilliant location for business activities and family trip.","keywords":"Just Sleep Tainan Hushan, tainan, hotels in Tainan, accommodation in Tainan, recommended accommodation in Tainan, High Speed Rail Tainan Station, Rende, accommodation in Rende area, accommodation near CHIMEI Museum, Ten-Drum Cultural Park, Bao-An Station."},"promotions":{"title":"Saving Money with Best Rate Guarantee | Book Direct with Just Sleep Tainan Hushan","description":"Stay tuned for the various room packages, special rates, and activities offered to you on the official website of Just Sleep Tainan Hushan! Don’t miss out!","keywords":"Just Sleep Tainan Hushan, Just Sleep, hotels in Tainan, Taiwan family hotels, Tainan family hotels,  Hotels Tainan, luxury hotels Taipei, best hotel Tainan, Tainan hotel recommodation, Tainan travel, Tainan tourism, Taiwan travel, Taiwan tourism, budget travelling Taiwan, budget travelling Tainan,  hotel special offers, hotel discounts, hotel promotions"}},"zh-TW":{"home":{"title":"官網訂房最低價 | 捷絲旅 台南虎山館","description":"「捷絲旅 台南虎山館」緊鄰十鼓仁糖文創園區、奇美博物館，讓旅人探索文藝景點享盡地利之便。鄰近高鐵站、機場、高速公路等交通要點，是商務活動及親子度假的飯店首選。","keywords":"捷絲旅台南虎山館, 捷絲旅台南, 捷絲旅, 捷絲旅虎山, 台南酒店, 台南飯店, 台南親子飯店, 台南商旅, 台南旅館, 台南精品酒店, 台南精品飯店, 台南豪華酒店, 台南豪華飯店, 台南住宿, 台南酒店推薦, 台南飯店推薦, 台南旅遊, 台灣旅遊, 台灣自由行, 台南自由行, 台灣自助旅行, 台南自助旅行, 台南文化, 台南休閒, 台南景點, 台南美食, 台南旅遊, 台灣文化, 台灣休閒, 台灣景點, 台灣美食, 台灣旅遊,工業風"},"rooms":{"title":"官網訂房最低價 | 捷絲旅 台南虎山館","description":"捷絲旅台南虎山館輕工業風格，聰明的客房空間規劃，配有五星級床墊及高品質備品做為您出差旅遊休憩或親子同遊的最佳場所。","keywords":"捷絲旅台南虎山館, 捷絲旅台南, 捷絲旅, 捷絲旅虎山, 台南酒店, 台南飯店, 台南親子飯店, 台南商旅, 台南旅館, 台南精品酒店, 台南精品飯店, 台南豪華酒店, 台南豪華飯店, 台南住宿, 台南酒店推薦, 台南飯店推薦, 台南旅遊, 台灣旅遊, 台灣自由行, 台南自由行, 台灣自助旅行, 台南自助旅行, 台南文化, 台南休閒, 台南景點, 台南美食, 台南旅遊, 台灣文化, 台灣休閒, 台灣景點, 台灣美食, 台灣旅遊,工業風"},"diningsandmeetings":{"title":"餐廳會議 | 捷絲旅 台南虎山館","description":"Just Café 捷食藝係由台南晶英酒店五星主廚團隊領軍的全日餐廳，早晨提供自助式早餐，午晚餐則提供主廚特選菜單，滿足老饕的味蕾。館內亦有多功能會議室及宴會廳，適合舉行商務會議及小型宴會。","keywords":"捷絲旅台南虎山館, 台南酒店, 台南飯店, 仁德酒店, 十鼓飯店, 台南親子飯店, 捷食藝, 台南精品飯店, 台南豪華酒店, 台南豪華飯店, 台南住宿, 台南酒店推薦, 台南捷絲旅交通, 台南捷絲旅路線, 台南飯店設施, 台南戶外泳池, 台南小型會議室, 台南小型婚宴, 台南婚宴"},"amenities":{"title":"設施服務 | 捷絲旅 台南虎山館","description":"捷絲旅台南虎山館設有戶外常溫泳池讓你舒緩身心、2F備有交誼廳及自助洗衣間、1F及10F多能會議廳能舉辦小型商務會議、婚宴等活動。","keywords":"捷絲旅台南虎山館, 台南酒店, 台南飯店,仁德酒店, 十鼓飯店, 台南親子飯店, 台南精品酒店, 台南精品飯店, 台南豪華酒店, 台南豪華飯店, 台南住宿, 台南酒店推薦, 台南捷絲旅怎麼去, 台南捷絲旅交通, 台南捷絲旅路線, 台南捷絲旅開車, 台南自助旅行，台南飯店設施,  台南飯店泳池, 台南戶外泳池, 台南小型會議室, 台南小型婚宴, 台南婚宴"},"activities":{"title":"","description":"","keywords":""},"directions":{"title":"交通景點 | 捷絲旅 台南虎山館","description":"鄰近各交通要點的捷絲旅台南虎山館，不論是走訪十鼓文創園區、奇美博物館等文藝行程，或是到黃金海岸散步踏浪，交通四通八達。","keywords":"捷絲旅台南虎山館, 捷絲旅台南, 捷絲旅, 捷絲旅虎山, 台南酒店, 台南飯店, 台南親子飯店, 台南商旅, 台南旅館, 台南精品酒店, 台南精品飯店, 台南住宿, 台南酒店推薦, 台南飯店推薦, 台南旅遊, 台南捷絲旅怎麼去, 台南捷絲旅交通, 台南捷絲旅路線, 台南捷絲旅開車, 台南自助旅行, 台南文化, 台南休閒, 台南景點, 台南美食, 台南旅遊, 台灣文化, 台灣休閒, 台灣景點, 台灣美食, 台灣旅遊,工業風"},"promotions":{"title":"官網訂房最低價 | 最新優惠 | 捷絲旅 台南虎山館","description":"千萬不要錯過！捷絲旅台南虎山館官網訂房最低價，且不定期推出各類住房專案及優惠訊息，提供給你最優惠的住房價格。","keywords":"捷絲旅台南虎山館, 捷絲旅台南, 捷絲旅, 捷絲旅虎山, 台南酒店, 台南飯店, 台南親子飯店, 台南商旅, 台南旅館, 台南精品酒店, 台南精品飯店, 台南豪華酒店, 台南豪華飯店, 台南住宿, 台南酒店推薦, 台南飯店推薦, 台南旅遊, 台灣旅遊, 台灣自由行, 台南自由行, 台灣自助旅行, 台南自助旅行, 台南文化, 台南休閒, 台南景點, 台南美食, 台南旅遊, 台灣文化, 台灣休閒, 台灣景點, 台灣美食, 台灣旅遊,工業風"}},"zh-CN":{"home":{"title":"官网订房最低价 | 捷丝旅 台南虎山馆","description":"「捷丝旅 台南虎山馆」紧邻十鼓仁糖文创园区、奇美博物馆，让旅人探索文艺景点享尽地利之便。邻近高铁站、机场、高速公路等交通要点，是商务活动及亲子度假的饭店首选。","keywords":"捷丝旅台南虎山馆, 捷丝旅台南,捷丝旅, 捷丝旅虎山, 台南酒店, 台南饭店, 台南亲子饭店, 台南商旅, 台南旅馆, 台南精品酒店, 台南精品饭店, 台南豪华酒店, 台南豪华饭店, 台南住宿, 台南酒店推荐, 台南饭店推荐, 台南旅游, 台湾旅游, 台湾自由行, 台南自由行, 台湾自助旅行, 台南自助旅行, 台南文化, 台南休闲, 台南景点, 台南美食, 台南旅游, 台湾文化, 台湾休闲, 台湾景点, 台湾美食, 台湾旅游, 工业风"},"rooms":{"title":"官网订房保证最低价 | 捷丝旅 台南虎山馆","description":"捷丝旅台南虎山馆轻工业风格，聪明的客房空间规划，配有五星级床垫及高品质备品做为您出差旅游休憩或亲子同游的最佳场所。","keywords":"捷丝旅台南虎山馆, 捷丝旅台南, 捷丝旅, 捷丝旅虎山, 台南酒店, 台南饭店, 台南亲子饭店, 台南商旅, 台南旅馆, 台南精品酒店, 台南精品饭店, 台南豪华酒店, 台南豪华饭店, 台南住宿, 台南酒店推荐, 台南饭店推荐, 台南旅游, 台湾旅游, 台湾自由行, 台南自由行, 台湾自助旅行, 台南自助旅行, 台南文化, 台南休闲, 台南景点, 台南美食, 台南旅游, 台湾文化, 台湾休闲, 台湾景点, 台湾美食, 台湾旅游,工业风"},"diningsandmeetings":{"title":"餐厅会议 | 捷丝旅 台南虎山馆","description":"Just Café 捷食艺系由台南晶英酒店五星主厨团队领军的全日餐厅，早晨提供自助式早餐，午晚餐则提供主厨特选菜单，满足老饕的味蕾。馆内亦有多功能会议室及宴会厅，适合举行商务会议及小型宴会。","keywords":"捷丝旅台南虎山馆, 台南酒店, 台南饭店, 仁德酒店, 十鼓饭店, 台南亲子饭店, 捷食艺, 台南精品饭店, 台南豪华酒店, 台南豪华饭店, 台南住宿, 台南酒店推荐, 台南捷丝旅交通, 台南捷丝旅路线, 台南饭店设施, 台南户外泳池, 台南小型会议室, 台南小型婚宴, 台南婚宴"},"amenities":{"title":"设施服务 | 捷丝旅 台南虎山馆","description":"捷丝旅台南虎山馆设有户外常温泳池让你舒缓身心、2F备有交谊厅及自助洗衣间、1F及10F多能会议厅能举办小型商务会议、婚宴等活动。","keywords":"捷丝旅台南虎山馆, 台南酒店, 台南饭店,仁德酒店, 十鼓饭店, 台南亲子饭店, 台南精品酒店, 台南精品饭店, 台南豪华酒店, 台南豪华饭店, 台南住宿, 台南酒店推荐, 台南捷丝旅'怎么去, 台南捷丝旅交通, 台南捷丝旅路线, 台南捷丝旅开车, 台南自助旅行，台南饭店设施,  台南饭店泳池, 台南户外泳池, 台南小型会议室, 台南小型婚宴, 台南婚宴"},"activities":{"title":"","description":"","keywords":""},"directions":{"title":"交通景点 | 捷丝旅 台南虎山馆","description":"邻近各交通要点的捷丝旅台南虎山馆，不论是走访十鼓文创园区、奇美博物馆等文艺行程，或是到黄金海岸散步踏浪，交通四通八达。","keywords":"捷丝旅台南虎山馆, 捷丝旅台南,捷丝旅,捷丝旅虎山,台南酒店, 台南饭店, 台南亲子饭店, 台南商旅, 台南旅馆, 台南精品酒店, 台南精品饭店, 台南住宿, 台南酒店推荐, 台南饭店推荐, 台南旅游, 台南捷丝旅怎么去, 台南捷丝旅交通, 台南捷丝旅路线, 台南捷丝旅开车, 台南自助旅行, 台南文化, 台南休闲, 台南景点, 台南美食, 台南旅游, 台湾文化, 台湾休闲, 台湾景点, 台湾美食, 台湾旅游,工业风"},"promotions":{"title":"官网订房最低价 | 最新优惠 | 捷丝旅 台南虎山馆","description":"千万不要错过！捷丝旅台南虎山馆官网订房最低价，且不定期推出各类住房项目及优惠讯息，提供给你最优惠的住房价格。","keywords":"捷丝旅台南虎山馆, 捷丝旅台南, 捷丝旅, 捷丝旅虎山, 台南酒店, 台南饭店, 台南亲子饭店, 台南商旅, 台南旅馆, 台南精品酒店, 台南精品饭店, 台南豪华酒店, 台南豪华饭店, 台南住宿, 台南酒店推荐, 台南饭店推荐, 台南旅游, 台湾旅游, 台湾自由行, 台南自由行, 台湾自助旅行, 台南自助旅行, 台南文化, 台南休闲, 台南景点, 台南美食, 台南旅游, 台湾文化, 台湾休闲, 台湾景点, 台湾美食, 台湾旅游,工业风"}},"ja":{"home":{"title":"ご予約は当サイトが最もお得です | ジャストスリープ台南虎山館","description":"「ジャストスリープ台南虎山館」は十鼓仁糖文創園区と奇美博物館に隣接し、アートを楽しむ旅人にぴったり。高鉄台南駅や台南空港、高速道路へのアクセスも抜群で、ビジネスやご家族でのご旅行にも大変便利な立地です。","keywords":"ジャストスリープ台南虎山館、台南ホテル、台南子連れホテル、家族ホテル、ブティックホテル、デザイナーズホテル、高級ホテル、ベストホテル、台南 宿泊、台南観光、台南旅行、台湾旅行、台湾おすすめホテル、台南おすすめホテル、台南文化、台南レジャー、台南観光スポット、台南の料理、台南の観光、台湾の文化、台湾レジャー、台湾の観光スポット、台湾の料理、台湾観光"},"rooms":{"title":"ご予約は当サイトが最もお得です | ジャストスリープ台南虎山館","description":"ジャストスリープ台南虎山館の客室には今一番人気のインダストリアルデザイン、浴室設備付き、快適な生活空間を提供しております。","keywords":"ジャストスリープ台南虎山館、台南ホテル、台南子連れホテル、家族ホテル、ブティックホテル、デザイナーズホテル、高級ホテル、ベストホテル、台南 宿泊、台南観光、台南旅行、台湾旅行、台湾おすすめホテル、台南おすすめホテル、台南文化、台南レジャー、台南観光スポット、台南の料理、台南の観光、台湾の文化、台湾レジャー、台湾の観光スポット、台湾の料理、台湾観光"},"diningsandmeetings":{"title":"レストラン、会議 | ジャストスリープ台南虎山館","description":"Just Caféは、シルクスプレイスホテルが誇る一流シェフチーム監修のオールデイダイニングです。ブッフェ形式の朝食では、厳選された新鮮食材を使用したサラダやフルーツ、台南名物グルメの数々が一度に召し上がれます。全てのお客様にご満足いただけるよう、ランチ及びディナータイムには洋食から中華まで幅広いメニューを取り揃えて皆様をお待ちしています。","keywords":"ジャストスリープ台南虎山館、ジャストスリープ、ジャストスリープ虎山、台南ホテル、台南子連れホテル、台南ファミリーホテル、ファミリーホテル、台南ファミリーレストラン、ブティックホテル、ブティックホテル、高級ホテル、ラグジュアリーホテル、豪華グルメ、台南グルメ、台南料理、台湾料理、台南レストラン、台南朝食、台南昼ご飯"},"amenities":{"title":"レジャー施設 | ジャストスリープ台南虎山館","description":"ジャストスリープ台南虎山館で、屋外プールとおもてなしのセルフ洗濯機が付いております。披露宴などのパーティーや、会議、セミナーなどMICEにも幅広く対応します。","keywords":"ジャストスリープ台南虎山館、ジャストスリープ、ジャストスリープ台南、台南ホテル、台南子連れホテル、家族ホテル、ブティックホテル、デザイナーズホテル、高級ホテル、ベストホテル、台南 宿泊、台南観光、台南旅行、台湾旅行、台湾おすすめホテル、台南おすすめホテル、台南文化、台南レジャー、台南観光スポット、台南の料理、台南の観光、台湾の文化、台湾レジャー、台湾の観光スポット、台湾の料理、台湾観光、工業風、ラグジュアリーホテル、屋外プール、セルフサービスランドリー"},"activities":{"title":"","description":"","keywords":""},"directions":{"title":"交通アクセス | ジャストスリープ台南虎山館","description":"ジャストスリープ台南虎山館は十鼓仁糖文創園区と奇美博物館に隣接し、アートを楽しむ旅人にぴったり。","keywords":"ジャストスリープ台南虎山館、ジャストスリープ、ジャストスリープ台南、台南ホテル、台南子連れホテル、台南ファミリーホテル、ファミリーホテル、台南ファミリーレストラン、ブティックホテル、ブティックホテル、高級ホテル、ラグジュアリーホテル観光、台南旅行、台湾旅行、台湾おすすめホテル、台北おすすめホテル、台南文化、台南レジャー、台南観光スポット、台南の料理、台南の観光、台湾の文化、台湾レジャー、台湾の観光スポット、台湾の料理、台湾観光、十鼓仁糖文創園区、奇美博物館、台南都会公園"},"promotions":{"title":"ご予約は当サイトが最もお得です | 最新情報 | ジャストスリープ台南虎山館","description":"公式ウェブサイトで提供されるさまざまな客室パッケージ、特別料金、アクティビティにご期待ください。お見逃しなく！","keywords":"ジャストスリープ台南虎山館、ジャストスリープ、ジャストスリープ台南、台南ホテル、台南子連れホテル、台南ファミリーホテル、ファミリーホテル、台南ファミリーレストラン、ブティックホテル、ブティックホテル、高級ホテル、ラグジュアリーホテル観光、台南旅行、台湾旅行、台湾おすすめホテル、台南おすすめホテル、台南文化、台南レジャー、台南観光スポット、台南の料理、台南の観光、台湾の文化、台湾レジャー、台湾の観光スポット、ホテル スペシャルオファー、ホテル割引、ホテルプロモーション"}},"ko":{"home":{"title":"공식 사이트에서 예약하는 것이 가장 저렴합니다 | 저스트슬립 타이난 후산점","description":"「저스트슬립 타이난 후산점」은 스구 문화마을, 치메이 박물관과 인접해 있어 문화 예술적 명소를 편리하게 즐길 수 있습니다. 고속철도역, 공항, 고속도로 등의 교통 시설과도 가까워 비즈니스 출장 및 가족 휴가를 위한 최고의 선택입니다.","keywords":"저스트슬립 타이난 후산점,저스트슬립 타이난,저스트슬립,타이페이 호텔,타이난 호텔 추천,타이난 여행,대만 여행,타이난 문화,타이난 여유,타이난 관광지,타이난 맛집,대만 문화,대만 여유,대만 관광지,대만 맛집,로프트"},"rooms":{"title":"공식 사이트에서 예약하는 것이 가장 저렴합니다 | 저스트슬립 타이난 후산점","description":"저스트슬립 타이페이 싼충점은 129개 객실이 있습니다. 객실내에 글로벌 품질의 매트리스가 구비되어 있습니다. 여행에 대해서 좋은 선택입니다","keywords":"저스트슬립 타이난 후산점,저스트슬립 타이난,저스트슬립,타이페이 호텔,타이난 호텔 추천,타이난 여행,대만 여행,타이난 문화,타이난 여유,타이난 관광지,타이난 맛집,대만 문화,대만 여유,대만 관광지,대만 맛집,로프트"},"diningsandmeetings":{"title":"다이닝 & 연회 회의 | 저스트슬립 타이난 후산점","description":"Just Café 미식이 있는 저스트 카페는 타이난 스카이팰리스 호텔의 5성급 셰프팀이 직접 이끄는 올 데이 다이닝 레스토랑입니다. 아침에는 샐러드, 과일, 빵, 타이난의 이색 길거리 음식 등 엄선한 신선한 재료로 구성된 뷔페 스타일의 조식으로 활력 넘치는 하루를 열고, 런치와 디너 시간대에는 간단한 양식류 및 중식 메뉴가 포함된 셰프 특선 메뉴를 즐길 수 있습니다.","keywords":"저스트슬립 타이난 후산점,저스트슬립 타이난,저스트슬립,타이난 호텔,타이난 호텔 추천,타이난 여행,대만 여행,타이난 문화,타이난 여유,타이난 관광지,타이난 맛집,대만 문화,대만 여유,대만 관광지,대만 맛집,타이난 레스토랑, 타이난 조식, 타이난 점심, 타이난 저녁 식사, 타이난 브런치"},"amenities":{"title":"테마 | 저스트슬립 타이난 후산점","description":"저스트슬립 타이난 후산점 야외 수영장과 환대의 셀프 세탁기가 붙어 있습니다. 피로연 파티 나 회의, 세미나 등 MICE에도 폭넓게 대응합니다.","keywords":"저스트슬립 타이난 후산점,저스트슬립 타이난,저스트슬립,타이난 호텔,타이난 호텔 추천,타이난 여행,대만 여행,타이난 문화,타이난 여유,타이난 관광지,타이난 맛집,대만 문화,대만 여유,대만 관광지, 타이난 수영장"},"activities":{"title":"","description":"","keywords":""},"directions":{"title":"시설 | 저스트슬립 타이난 후산점","description":"저스트슬립 타이난 후산점 은 스구 문화마을, 치메이 박물관과 인접해 있어 문화 예술적 명소를 편리하게 즐길 수 있습니다. ","keywords":"저스트슬립 타이난 후산점,저스트슬립 타이난,저스트슬립,타이난 호텔,타이난 호텔 추천,타이난 여행,대만 여행,타이난 문화,타이난 여유,타이난 관광지,타이난 맛집,대만 문화,대만 여유,대만 관광지,대만 맛집,로프트"},"promotions":{"title":"공식 사이트에서 예약하는 것이 가장 저렴합니다 | 최신소식 | 저스트슬립 타이난 후산점","description":"공식 웹 사이트에서 제공되는 다양한 객실 패키지, 특별 요금 및 활동을 계속 지켜봐주십시오! 놓치지 마세요!","keywords":"저스트슬립 타이난 후산점,저스트슬립 타이난,저스트슬립,타이페이 호텔,타이난 호텔 추천,타이난 여행,대만 여행,타이난 문화,타이난 여유,타이난 관광지,타이난 맛집,대만 문화,대만 여유,대만 관광지,대만 맛집,로프트"}}}

/***/ }),
/* 589 */
/***/ (function(module, exports) {

module.exports = {"en":{"home":{"title":"Best Rate and Service Guarantee | Book Direct with Just Sleep Taipei Zhongshan","description":"Book the best rates at Just Sleep Taipei Zhongshan! Located near the MRT, we offer cozy rooms, high-speed Internet Service, and great hospitality for your stay.","keywords":"Just Sleep, Taipei Zhongshan, Taipei hotel, Zhongshan accommodation, best rates, official website"},"rooms":{"title":"Rooms | Just Sleep Taipei Zhongshan","description":"Discover diverse room types at Just Sleep Taipei Zhongshan, from Single to Balcony Rooms. Enjoy comfortable beds, modern bathrooms, and Internet Service.","keywords":"Taipei Zhongshan rooms, Taipei accommodation, Superior Room, Deluxe Room, business hotel"},"diningsandmeetings":{"title":"Dinings & Meetings | Just Sleep Taipei Zhongshan","description":"Visit our cozy Just Café at Just Sleep Taipei Zhongshan. Enjoy a rich buffet breakfast in the morning and a relaxing lounge space for the rest of your day.","keywords":"Just Café, Taipei Zhongshan dining, hotel breakfast, buffet breakfast, lounge"},"amenities":{"title":"Amenities | Just Sleep Taipei Zhongshan","description":"Enjoy thoughtful facilities at Just Sleep Taipei Zhongshan, including self-service Laundry, whole-hotel Internet Service, and our engaging \"Just Fun\" activities.","keywords":"hotel facilities, self-service Laundry, Internet Service, Just Fun, activities"},"activities":{"title":"","description":"","keywords":""},"directions":{"title":"Directions | Just Sleep Taipei Zhongshan","description":"Conveniently located near MRT Zhongshan Station, our hotel offers easy access to Chifeng Street, shopping districts, and popular Taipei attractions.","keywords":"MRT Zhongshan Station, Zhongshan district, Taipei attractions, Chifeng Street"},"promotions":{"title":"Saving Money with Best Rate Guarantee | Book Direct with Just Sleep Taipei Zhongshan","description":"Discover the latest Special Offers at Just Sleep Taipei Zhongshan. Book our exclusive packages and early bird discounts for an unforgettable stay in Taipei.","keywords":"special offers, hotel promotions, Taipei hotel deals, exclusive packages"}},"zh-TW":{"home":{"title":"官網訂房最低價 | 捷絲旅 台北中山館","description":"捷絲旅台北中山館官網訂房享最低價保證！飯店座落中山商圈，鄰近捷運站，交通極為便捷。提供質感客房、高速Wi-Fi與貼心服務，是您商務出差或休閒旅遊的台北住宿首選。","keywords":"捷絲旅, 台北中山館, 台北飯店, 中山區住宿, 官網訂房, 最低價保證, Just Sleep"},"rooms":{"title":"房型介紹 | 捷絲旅 台北中山館","description":"捷絲旅台北中山館提供多樣化房型選擇，包含精緻單人房至雅緻陽台客房，滿足商務與旅遊需求。客房皆具備舒適床墊、現代衛浴及Wi-Fi，打造放鬆的休憩空間。","keywords":"捷絲旅台北中山館提供多樣化房型選擇，包含精緻單人房至雅緻陽台客房，滿足商務與旅遊需求。客房皆具備舒適床墊、現代衛浴及Wi-Fi，打造放鬆的休憩空間。"},"diningsandmeetings":{"title":"餐廳會議 | 捷絲旅 台北中山館","description":"捷絲旅台北中山館設有溫馨舒適的 Just Café。每日早晨提供豐盛多元的自助式早餐，為您的台北之旅注入滿滿活力；非用餐時段則化身為愜意的交誼空間，讓您盡情放鬆休息。","keywords":"台北中山館餐廳, Just Café, 飯店早餐, 自助早餐, 交誼空間"},"amenities":{"title":"設施服務 | 捷絲旅 台北中山館","description":"捷絲旅台北中山館提供完善設施與服務，包含自助洗衣Laundry、全館Wi-Fi及「Just 好玩」館內活動。貼心的規劃為您的住宿時光增添無憂便捷與歡樂回憶。","keywords":"飯店設施, 自助洗衣, 免費WiFi, 館內活動, 台北中山館"},"activities":{"title":"","description":"","keywords":""},"directions":{"title":"交通景點 | 捷絲旅 台北中山館","description":"捷絲旅台北中山館擁有極佳地理位置，鄰近捷運中山站，交通四通八達。周邊匯集百貨商圈、赤峰街與眾多美食，讓您輕鬆探索台北熱門景點與在地文化，享受精彩豐富的旅程。","keywords":"捷運中山站住宿, 中山商圈飯店, 台北景點推薦, 赤峰街, 交通資訊"},"promotions":{"title":"最新優惠 | 捷絲旅 台北中山館","description":"掌握捷絲旅台北中山館最新優惠！我們不定期推出官網獨家住房專案、早鳥折扣及季節限定特惠。立即查看當期活動，用划算的價格預訂優質客房，享受超值且難忘的台北住宿體驗。","keywords":"最新優惠, 住房專案, 台北飯店優惠, 官網限定折扣, 捷絲旅優惠"}},"zh-CN":{"home":{"title":"官网订房最低价 | 捷丝旅 台北中山馆","description":"捷丝旅台北中山馆官网订房享最低价保证！饭店座落中山商圈，邻近捷运站，交通极为便捷。提供质感客房、高速Wi-Fi与贴心服务，是您商务出差或休闲旅游的台北住宿首选。","keywords":"捷丝旅, 台北中山馆, 台北饭店, 中山区住宿, 官网订房, 最低价保证, Just Sleep"},"rooms":{"title":"房型介绍 | 捷丝旅 台北中山馆","description":"捷丝旅台北中山馆提供多样化房型选择，包含精致单人房至雅致阳台客房，满足商务与旅游需求。客房皆具备舒适床垫、现代卫浴及Wi-Fi，打造放松的休憩空间。","keywords":"台北中山馆房型, 台北住宿推荐, 精致客房, 雅致客房, 商务旅馆"},"diningsandmeetings":{"title":"餐厅会议 | 捷丝旅 台北中山馆","description":"捷丝旅台北中山馆设有温馨舒适的 Just Café。每日早晨提供丰盛的自助式早餐，为您台北之旅注入满满活力；非用餐时段则化身为惬意的交谊空间，让您尽情放松休息。","keywords":"台北中山馆餐厅, Just Café, 饭店早餐, 自助早餐, 交谊空间"},"amenities":{"title":"飯店設施, 自助洗衣, 免費WiFi, 館內活動, 台北中山館","description":"捷丝旅台北中山馆提供完善设施与服务，包含自助洗衣Laundry、全馆Wi-Fi及「Just 好玩」馆内活动。贴心的规划为您的住宿时光增添无忧便捷与欢乐回忆。","keywords":"饭店设施, 自助洗衣, 免费WiFi, 馆内活动, 台北中山馆"},"activities":{"title":"","description":"","keywords":""},"directions":{"title":"交通景点 | 捷丝旅 台北中山馆","description":"捷丝旅台北中山馆拥有极佳地理位置，邻近捷运中山站，交通四通八达。周边汇集百货商圈、赤峰街与众多美食，让您轻松探索台北热门景点与在地文化，享受精彩丰富的旅程。","keywords":"捷运中山站住宿, 中山商圈饭店, 台北景点推荐, 赤峰街, 交通资讯"},"promotions":{"title":"最新优惠 | 捷丝旅 台北中山馆","description":"掌握捷丝旅台北中山馆最新优惠！不定期推出官网独家住房专案、早鸟折扣及季节特惠。立即查看当期活动，用划算的价格预订优质客房，享受超值且难忘的台北住宿体验。","keywords":"最新优惠, 住房专案, 台北饭店优惠, 官网限定折扣, 捷丝旅优惠"}},"ja":{"home":{"title":"ご予約は当サイトが最もお得です | ジャストスリープ台北中山館","description":"ジャストスリープ台北中山館は公式サイトからのご予約が一番お得！中山商圏やMRT駅に近く、アクセス抜群。上質な客室と高速Internet Serviceで、ビジネスや観光に最適な滞在を提供します。","keywords":"ジャストスリープ, 台北中山館, 台北ホテル, 中山エリア宿泊, 最低価格保証"},"rooms":{"title":"客室紹介 | ジャストスリープ台北中山館","description":"シングルからバルコニー付きまで、多様なニーズに応える客室をご用意。全室に快適なベッド、モダンなバスルーム、Internet Serviceを完備し、リラックスできる空間を提供します。","keywords":"台北中山館 客室, 台北宿泊おすすめ, スーペリアルーム, デラックスルーム, ビジネスホテル"},"diningsandmeetings":{"title":"レストラン、会議 | ジャストスリープ台北中山館","description":"館内には温かみのあるJust Caféをご用意。朝は種類豊富なビュッフェ朝食で一日の活力をチャージ。それ以外の時間は、リラックスできるラウンジスペースとしておくつろぎいただけます。","keywords":"台北中山館 レストラン, Just Café, ホテル朝食, ビュッフェ朝食, ラウンジ"},"amenities":{"title":"レジャー施設 | ジャストスリープ台北中山館","description":"便利なセルフ式のLaundry、館内全域でのInternet Service、館内アクティビティ「Just Fun」など、充実した施設とサービスをご用意。お客様の快適で思い出に残る滞在をサポートします。","keywords":"ホテル施設, セルフランドリー, Internet Service, Just Fun, 台北中山館"},"activities":{"title":"","description":"","keywords":""},"directions":{"title":"交通アクセス | ジャストスリープ台北中山館","description":"MRT中山駅から近く、交通アクセス抜群。周辺にはデパート、赤峰街、多くの人気グルメが集まり、台北の最新スポットやローカル文化の探索を存分にお楽しみいただけます。","keywords":"MRT中山駅 宿泊, 中山エリア ホテル, 台北観光おすすめ, 赤峰街, アクセス情報"},"promotions":{"title":"最新情報 | ジャストスリープ台北中山館","description":"ジャストスリープ台北中山館の最新キャンペーン情報をチェック！公式サイト限定のお得な宿泊プランや早割をご用意しています。最適なプランを予約して、台北での素晴らしい滞在をお楽しみください。","keywords":"最新オファー, 宿泊プラン, 台北ホテル割引, 公式サイト限定, ジャストスリープ割引"}},"ko":{"home":{"title":"공식 사이트에서 예약하는 것이 가장 저렴합니다 | 저스트슬립 타이베이 중산","description":"저스트 슬립 타이베이 중산 공식 웹사이트에서 예약하시고 최저가 보장 혜택을 누리세요! 중산 상권 및 지하철역과 가까워 교통이 매우 편리합니다. 편안한 객실, 고속 Internet Service, 세심한 서비스를 제공합니다.","keywords":"저스트 슬립, 타이베이 중산관, 타이베이 호텔, 중산구 숙소, 최저가 보장"},"rooms":{"title":"객실 | 저스트슬립 타이베이 중산","description":"싱글룸부터 발코니룸까지 다양한 객실을 제공하여 비즈니스 및 여행 목적에 모두 적합합니다. 편안한 침대, 모던한 욕실, Internet Service를 갖추고 있어 편안한 휴식을 취하실 수 있습니다.","keywords":"타이베이 중산관 객실, 타이베이 숙소 추천, 수페리어룸, 디럭스룸, 비즈니스 호텔"},"diningsandmeetings":{"title":"다이닝 & 연회 회의 | 저스트슬립 타이베이 중산","description":"저스트 슬립 타이베이 중산에는 아늑한 Just Café가 마련되어 있습니다. 매일 아침 풍성하고 다양한 뷔페식 조식을 제공하며, 식사 시간 외에는 편안한 휴식 공간으로 이용하실 수 있습니다.","keywords":"타이베이 중산관 레스토랑, Just Café, 호텔 조식, 조식 뷔페, 라운지"},"amenities":{"title":"테마 | 저스트슬립 타이베이 중산","description":"셀프 세탁 Laundry, 호텔 전 구역 Internet Service, 그리고 호텔 내 액티비티인 'Just Fun' 등 완벽한 부대시설과 서비스를 제공합니다. 세심한 배려로 더욱 편리하고 즐거운 숙박을 만들어 드립니다.","keywords":"호텔 부대시설, 셀프 세탁, Internet Service, Just Fun, 타이베이 중산관"},"activities":{"title":"","description":"","keywords":""},"directions":{"title":"시설 | 저스트슬립 타이베이 중산","description":"저스트 슬립 타이베이 중산은 지하철 중산역과 가까워 교통이 매우 편리합니다. 주변에 백화점 상권, 츠펑제, 다양한 맛집이 모여 있어 타이베이의 인기 명소와 지역 문화를 쉽게 탐방할 수 있습니다.","keywords":"지하철 중산역 숙소, 중산 상권 호텔, 타이베이 명소 추천, 츠펑제, 교통 정보"},"promotions":{"title":"최신소식 | 저스트슬립 타이베이 중산","description":"저스트 슬립 타이베이 중산의 최신 프로모션 정보를 확인하세요! 공식 웹사이트 단독 숙박 패키지, 얼리버드 할인, 시즌 특가를 수시로 진행합니다. 지금 바로 확인하고 합리적인 가격에 예약하세요.","keywords":"최신 프로모션, 숙박 패키지, 타이베이 호텔 할인, 공식 웹사이트 한정, 저스트 슬립 할인"}}}

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "./assets/img_ximen_grey__630cc511948b71ec1ffe5c53f485ece6.jpg";

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "./assets/img_ximen_color__63c8ac811331c714a65de8f5056c354b.jpg";

/***/ }),
/* 592 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "./assets/img_ntu_grey__537782bf23f77af31b985e93be3baed2.jpg";

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "./assets/img_ntu_color__eb6665179227a4ce2a6a893653ed5e0c.jpg";

/***/ }),
/* 595 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "./assets/img_kao_grey__f8840d52df661ba31d7801d45be3f480.jpg";

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "./assets/img_kao_color__896c86f6951593d238def6f26f566113.jpg";

/***/ }),
/* 598 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "./assets/img_kaostation_grey__12098552e704a5ba8cf019200c58e4ad.jpg";

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "./assets/img_kaostation_color__0664fceb475af7f55b24ed922bd728cc.jpg";

/***/ }),
/* 601 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "./assets/img_hualien_grey__38ba312992dff9f56b892247328af6fc.jpg";

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "./assets/img_hualien_color__b967199dc79af5c06a8c96666339ad42.jpg";

/***/ }),
/* 604 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "./assets/img_jiaoxi_grey__02b1c94f4ccbc5ea0167304e5a6426e9.jpg";

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "./assets/img_jiaoxi_color__b8ff81c724e2c151fb7d930dcf8037b9.jpg";

/***/ }),
/* 607 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "./assets/img_ximen_grey@2x__43b86b23964dd36f8f5470d2c8957e2a.jpg";

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "./assets/img_ximen_color@2x__2ccb1fd35840c3ad895f49c29d6cd4c1.jpg";

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "./assets/img_ntu_grey@2x__f0a6979be8c87beace45103e96446004.jpg";

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "./assets/img_ntu_color@2x__493eac8ad8ef25542332220931369c4b.jpg";

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "./assets/img_kao_grey@2x__21fb8a657d20a84c92010ed7bd82ad39.jpg";

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "./assets/img_kao_color@2x__4e5b3bdf59decb34106e7fffb174800d.jpg";

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "./assets/img_kaostation_grey@2x__cea32984d843efb4ee3727a24b1f0277.jpg";

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "./assets/img_kaostation_color@2x__1b8b47e6a2657ee0646303fa8d2b064c.jpg";

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "./assets/img_hualien_grey@2x__135b251c3cf3cea1fe76d5290a6e6bf3.jpg";

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "./assets/img_hualien_color@2x__3ddcf39fd3e3c044767a0f0085df1b20.jpg";

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "./assets/img_jiaoxi_grey@2x__fd26a112c751618f57e5d5db68326c32.jpg";

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "./assets/img_jiaoxi_color@2x__cac8a703b4ab46a14c642b7a6a05be99.jpg";

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "./assets/img_sanchong_color__0aa89781103e1af16abf41ccce301838.jpg";

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "./assets/img_sanchong_color@2x__f359d77821a08637013eb98490e1e92b.jpg";

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "./assets/img_sanchong_grey__4854326f82b4867e3afb6f2af7befbeb.jpg";

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "./assets/img_sanchong_grey@2x__4ac71f81db053ed11a471d5f5fc73389.jpg";

/***/ }),
/* 624 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "./assets/img_hushan_color__958027fd59456647fa16d015d744ea49.jpg";

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "./assets/img_hushan_color@2x__40c15c44f567c1cdc6ef20b6cd53410d.jpg";

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "./assets/img_hushan_grey__116bfd0ea16a8753e407fd6dfcdb93a5.jpg";

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "./assets/img_hushan_grey@2x__1f87b918239f5803ef8596e9a38012f4.jpg";

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "./assets/img_hushan_grey@2x__6f2d64bd15595c63e00263f6c224a64a.jpg";

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "./assets/img_osakaShinsaibashi_color__5f666a67c6de83fce4d2d09ba80c7283.jpg";

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "./assets/img_osakaShinsaibashi_color@2x__6f5e05b9785b77e5248aea5e0a3b3975.jpg";

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "./assets/img_osakaShinsaibashi_grey__76c62f7d2537fcefdc6f27acc2ce63d9.jpg";

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "./assets/img_osakaShinsaibashi_grey@2x__aaade82b3acf7585b445ebdffe8e04e4.jpg";

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "./assets/img_osakaShinsaibashi_grey@2x__aaade82b3acf7585b445ebdffe8e04e4.jpg";

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "./assets/img_zhongshan_color__100fdf4ca5ef8a4a0cc3db6367e904e6.jpg";

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "./assets/img_zhongshan_color@2x__6f50f5840bdb4fbdb0d323f1ad3322d4.jpg";

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "./assets/img_zhongshan_grey__62db3173ea48fa4d09aaed6c0ca4e88c.jpg";

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "./assets/img_zhongshan_grey@2x__cefe1f2120d996caa0bdff1e9935a690.jpg";

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "./assets/img_zhongshan_grey@2x__cefe1f2120d996caa0bdff1e9935a690.jpg";

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
/* eslint-disable */

exports.default = {
	common: {
		'1': 'January',
		'2': 'February',
		'3': 'March',
		'4': 'April',
		'5': 'May',
		'6': 'June',
		'7': 'July',
		'8': 'August',
		'9': 'September',
		'10': 'October',
		'11': 'November',
		'12': 'December',
		adults: 'Adults',
		children: 'Children',
		bookNow: 'BOOK NOW',
		prev: 'Prev',
		backToHome: 'Back To Home',
		next: 'Next',
		detail: 'Detail',
		selectDate: 'Select Date',
		selectHotel: 'Select Hotel',
		onlineTravelFair: '線上旅展',
		bookNowBtn: 'BOOK NOW'
	},
	pageTitle: {
		brandName: 'Just Sleep',
		main: 'Brand',
		news: 'Promotions',
		privacy: 'Privacy and Cookies Policy',
		accommodation: 'Rooms',
		facility: 'Amenities',
		restaurant: 'Dinings & Meetings',
		location: 'Directions',
		activity: 'Activities'
	},
	header: {
		main: 'BRAND',
		news: 'PROMOTIONS',
		index: 'HOME',
		accommodation: 'ROOMS',
		facility: 'AMENITIES',
		restaurant: 'DININGS & MEETINGS',
		location: 'DIRECTIONS',
		activity: 'ACTIVITIES',
		bookNow: 'BOOK NOW',
		taiwan: 'TAIWAN',
		japan: 'JAPAN',
		onlineTravelFair: '線上旅展',
		bookNowBtn: 'BOOK NOW'
	},
	footer: {
		registrationNumber: 'Hotel Registration Number',
		privacy: 'Privacy and Cookies Policy'
	},
	cookieBar: {
		attention: '<p>We value and respect your privacy.</p>\n<p>The Silks Hotel Group uses its own and selected third-party cookies on this site to improve performance, for analytics and for advertising. By browsing this site, you are agreeing to this. We encourage you to review our full {{privacyLink}} for more information.</p>',
		privacy: 'Privacy and Cookies Policy',
		accept: 'CONTINUE TO SITE'
	},
	homePage: {
		title: 'Comprehensive Luxury for Smart Travelers',
		about: 'About',
		aboutJustsleep: 'About Just Sleep',
		toHotelSite: 'Discover',
		more: 'Read More',
		justNews: 'Just News',
		justComfortTitle: 'Just Sleep',
		justComfortBackTitle: 'Just Sleep',
		justComfortContent: 'The hotel offers you the different choice of the pillows. It makes every tourists live in Just Sleep can get the comfortable sleep quality.',
		justGoTitle: 'Just Play',
		justGoBackTitle: 'Just Play',
		justGoContent: 'We offer the tourism information service according to every tourist’s requirement to recommend the spot, shopping stores and traffic information in hotel.',
		justEquipTitle: 'Just Spares',
		justEquipBackTitle: 'Just Spares',
		justEquipContent: 'We offer the special spares such as selfie stick, mobile phone charger, mobile power pack, lamp and so on(only for Ximen and NTU hotel).',
		justBuyTitle: 'Just Buy',
		justBuyBackTitle: 'Just Buy',
		justBuyContent: 'We offer the service about purchasing special souvenir in Taiwan to save tourists time and travel easily.',
		justPackTitle: 'Just Pack',
		justPackBackTitle: 'Just Pack',
		justPackContent: 'We offer the service about weighting your baggage and choosing the box for each size. The bearer will help you pack for free to make you return easily.',
		justRelax: 'Just Convenience',
		justSight: 'Just Sight',
		justGo: 'Just Go',
		justExplore: 'Just Explore',
		justService: 'Just Service'
	},
	accommodationPage: {
		rooms: 'ROOMS',
		roomFacilityTitle: 'In-room Amenities',
		lookupRoomType: 'Check Room Type',
		have: '',
		roomType: 'Room Type',
		am: 'AM',
		pm: 'PM',
		checkInTime: 'Check-in',
		checkOutTime: 'Check-out',
		detail: 'Detail',
		bookNow: 'BOOK NOW'
	},
	locationPage: {
		location: 'DIRECTIONS',
		trainInfo: 'By Train / High Speed Rail',
		busInfo: 'By Bus',
		driveInfo: 'By Driving',
		parkInfo: 'Parking',
		hotelInfo: 'Transport Service',
		airplaneInfo: 'From Airport'
	},
	newsHomePage: {
		all: 'All',
		news: 'PROMOTIONS',
		selectType: 'Select Type',
		more: 'Read More'
	},
	newsPage: {
		projectTime: 'Project Time',
		projectDetail: 'Project Detail',
		note: 'Remark'
	},
	restaurantPage: {
		restaurantsAndMeetings: 'DININGS & MEETINGS',
		restaurant: 'Dinings',
		meeting: 'Meetings'
	},
	activityPage: {
		activity: 'ACTIVITIES',
		attractionsNearby: 'Attractions',
		more: 'Read More',
		lookupSchedule: 'Read More',
		join: 'Read More'
	},
	facilityPage: {
		facility: 'AMENITIES',
		lookup: 'Read More'
	},
	justFunSection: {
		justFunTitle: 'Just Fun',
		justFun: 'Ten Features'
	},
	hotelMain: {
		name: 'Brand',
		longName: 'Brand',
		title: '',
		bannerText: 'Just Sleep',
		contactUs: 'Customer Service',
		address: 'No. 83, Section 4, Roosevelt Rd, Da’an District, Taipei City, 106',
		intro: '"Just Sleep" is a boutique design hotel brand under Silks Hotel Group. Upholding the brand spirit of "style, comfort, and attention to detail," Just Sleep provides travelers with high-quality services comparable to five-star hotels at affordable prices.\n'
	},
	hotelXimen: {
		name: 'Taipei Ximending',
		title: 'Hotel Near MRT Ximen Station',
		contactUs: 'Customer Service',
		address: '5F, No. 41, Sec. 1, Zhonghua Rd., Taipei 10042, Taiwan (Please enter from No.144, Sec. 1, Hankou St entrance.)',
		intro: 'Just Sleep Taipei Ximending is close to the bustling and lively Ximen shopping district. The tourists can travel to the historic spot in Taipei and experience not only the new culture, but also the local food.'
	},
	hotelNTU: {
		name: 'Taipei NTU',
		title: '',
		contactUs: 'Customer Service',
		address: 'No. 83, Sec. 4, Roosevelt Rd., Taipei 10673, Taiwan',
		intro: 'Just Sleep Taipei NTU is located beside the National Taiwan University. It offers a comfortable accommodation choice for those people who go teaching, interning, researching, academic communication, meeting and touring. The hotel mixes the design of free college style to create an atmosphere of mutual prosperity with the campus.'
	},
	hotelZhongshan: {
		name: 'Taipei Zhongshan',
		title: '',
		contactUs: 'Customer Service',
		address: 'No. 39, Ln. 135, Sec. 1, Zhongshan N. Rd., Zhongshan Dist., Taipei 10441, Taiwan',
		intro: 'Located in the vibrant Zhongshan District—where rich history meets modern energy—Just Sleep Taipei Zhongshan offers unparalleled convenience just steps from MRT Zhongshan Station. Guests can easily explore the bustling Tiaotong and Zhongshan shopping districts, experiencing a perfect blend of old-town charm and contemporary Taipei.'
	},
	hotelKaohsiung: {
		name: 'Kaohsiung Zhongzheng',
		title: '',
		contactUs: 'Customer Service',
		address: 'No. 134, Zhongzheng 1st Rd., Kaohsiung 80284, Taiwan',
		intro: '\"Just Sleep Kaohsiung Zhongzheng\" is designed with a music theme and offers both trendy style and practical functionality. It\'s close to Kaohsiung MRT Lingya Sports Park Station, Weiwuying National Kaohsiung Center for the Arts, and Wumiao Night Market, providing travelers with a unique stay experience.\n'
	},
	hotelKaohsiungStation: {
		name: 'Kaohsiung Station',
		title: '',
		contactUs: 'Customer Service',
		address: 'No.280, Zhongshan 1st Rd., Xinxing Dist., Kaohsiung City 800, Taiwan ',
		intro: "Just Sleep Kaohsiung Station's unique design includes exquisite original art works and custom-made designer furnishings. It is conveniently close to the Kaohsiung transition , Formosa Boulevard Station and Liuohe Tourist Night Market."
	},
	hotelHualien: {
		name: 'Hualien Zhongzheng',
		title: '',
		contactUs: 'Customer Service',
		address: 'No. 396, Zhongzheng Rd., Hualien 97041, Taiwan',
		intro: 'Just Sleep Hualien Zhongzheng is centrally located in Hualien City, a quiet place amidst the bustling area. Enter the hotel and immediately feel lighthearted and relaxed.'
	},
	hotelJiaoxi: {
		name: 'Yilan Jiaoxi',
		title: 'Yilan hot spring hotel',
		contactUs: 'Customer Service',
		address: 'No. 8, Ln. 24, Deyang Rd., Jiaoxi Township, Yilan, Taiwan',
		intro: 'Just Sleep Yilan Jiaoxi is close to the lively Jiaoxi shopping district. The hotel offers sodium bicarbonate hot spring. The design hotel is a new sign in Jiaoxi district. The tourists can go to the famous sightseeing spot such as Wufongci Designated Scenic Area, Tangwei Brook Park and so on by walking.'
	},
	hotelSanchong: {
		name: 'Taipei Sanchong',
		title: '',
		contactUs: 'Customer Service',
		address: 'No.107-1,Sec.4,Sanhe Rd.,Sanchong Dist.,New Taipei City 24152,Taiwan',
		intro: 'Just Sleep Taipei Sanchong is ideally located in front of MRT Sanhe Junior High School Station and offers convenient traffic connections. It is an excellent choice for both business travelers and tourists. The soft loft industrial design coupled with hand-roasted coffee and Taiwan whole leaf tea ensures maximum comfort and coziness and an experience of warm and genuine hospitality for each traveler.'
	},
	hotelHushan: {
		name: 'Tainan Hushan',
		title: '',
		contactUs: 'Customer Service',
		address: 'No. 300, Sec. 2, Wenhua Rd., Rende Dist., Tainan City 717015 Taiwan',
		intro: 'Just Sleep Tainan Hushan is located right next to Ten-Drum Cultural Village and CHIMEI Museum, so travelers can conveniently enjoy cultural and artistic spots. With excellent access to High-Speed Railway Tainan station, Tainan Airport and Highways, it is a brilliant location for business activities and family trip.'
	},
	hotelOsakaShinsaibashi: {
		name: 'Osaka Shinsaibashi',
		title: '',
		contactUs: 'Customer Service',
		address: '2-chōme-9-15 Minamisemba, Chuo Ward, Osaka, 542-0081',
		intro: "Just Sleep Osaka Shinsaibashi is the first Just Sleep brand hotel in Japan, and the hotel's location is close to the bustling Shinsaibashi shopping district, lined with gourmet shops, and within walking distance to a place where you can experience local fashionable culture and hospitality.\nTransportation is very convenient with easy access to four major subway stations: Shinsaibashi Station, Hommachi Station, Sakaisuji Hommachi Station and Nagahoribashi Station. It is a very convenient hotel for going out, so it will be the best hotel for individul traveler in Osaka.",
		tel: 'Tel : +81-06-6251-3666',
		fax: 'Fax : +81-06-6251-3889'
	}
};

/* eslint-enable */

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
/* eslint-disable */

exports.default = {
	common: {
		'1': '1月',
		'2': '2月',
		'3': '3月',
		'4': '4月',
		'5': '5月',
		'6': '6月',
		'7': '7月',
		'8': '8月',
		'9': '9月',
		'10': '10月',
		'11': '11月',
		'12': '12月',
		adults: '大人',
		children: '子供',
		bookNow: '今すぐ予約',
		prev: '前の',
		backToHome: '戻る',
		next: '次へ',
		detail: '詳細',
		selectDate: 'チェックイン日',
		selectHotel: 'ホテル一覧',
		onlineTravelFair: '線上旅展',
		bookNowBtn: '今すぐ予約'
	},
	pageTitle: {
		brandName: 'Just Sleep ジャストスリープ',
		main: 'ブランド',
		news: '最新情報',
		privacy: 'プライバシーポリシー',
		accommodation: '客室紹介',
		facility: '施設・サービス',
		restaurant: 'レストラン・会議',
		location: '交通アクセス',
		activity: '館内イベント'
	},
	header: {
		main: 'ブランド',
		news: '最新情報',
		index: 'ホーム',
		accommodation: '客室紹介',
		facility: '施設・サービス',
		restaurant: 'レストラン・会議',
		location: '交通アクセス',
		activity: '館内イベント',
		bookNow: '今すぐ予約',
		taiwan: '台湾',
		japan: '日本',
		onlineTravelFair: '線上旅展',
		bookNowBtn: '今すぐ予約'
	},
	footer: {
		registrationNumber: '旅館業許可番号',
		privacy: 'プライバシーポリシー'
	},
	cookieBar: {
		attention: '<p>シルクスホテルグループは､お客様により快適にご利用いただくため､Cookieを使用しております｡</p>\n<p>ご利用いただく際には､この外部Cookieの使用に同意いただいたものとみなします｡詳細は{{privacyLink}}ご覧ください｡</p>',
		privacy: 'プライバシー及びクッキーに関するポリシーを',
		accept: '同意する'
	},
	homePage: {
		title: '満足のご滯在お届けする、ジャスとスリープ',
		about: 'について',
		aboutJustsleep: 'ジャストスリープについて',
		toHotelSite: '公式サイトに行く',
		more: 'もっと見る',
		justNews: '最新情報',
		justComfortTitle: ' ',
		justComfortBackTitle: 'Just Sleep',
		justComfortContent: 'ジャストスリープでは\n異なるタイプの枕を\nお選びいただけます｡\nジャストスリープに\nご宿泊される全ての\nお客様に快適な睡眠\nの質をお届けしており\nます｡',
		justGoTitle: ' ',
		justGoBackTitle: 'Just Play',
		justGoContent: 'ジャストスリープでは\n旅のコンサルティング\nサービスをご提供して\nおります｡お客様の\nニーズに応じた観光\nスポット､アクセス\n情報､ショッピングの\nスポット等をご提供\n致します｡',
		justEquipTitle: ' ',
		justEquipBackTitle: 'Just Spares',
		justEquipContent: '自撮り棒､モバイル\nバッテリー､充電器､\nスタンドライト等の\nアメニティをご用意\nしています｡(一部\nホテルにて提供)',
		justBuyTitle: ' ',
		justBuyBackTitle: 'Just Buy',
		justBuyContent: '手軽に旅をお楽しみ\nいただけますよう､\n土産代行サービスを\nご提供しています｡\n(一部ホテルにて提供)',
		justPackTitle: ' ',
		justPackBackTitle: 'Just Pack',
		justPackContent: 'お荷物の計量､各種\nサイズの段ボール､\n無料のパッキング\nサービスをご提供\nしております｡(一部\nホテルにて提供)\n',
		justRelax: '施設・サービス',
		justSight: 'おすすめ観光情報',
		justGo: '館内イベント',
		justExplore: '探索',
		justService: 'サービス'
	},
	accommodationPage: {
		rooms: '客室紹介',
		roomFacilityTitle: '客室',
		lookupRoomType: '客室のご案内',
		have: '',
		roomType: 'タイプ',
		am: '午前',
		pm: '午後',
		checkInTime: 'チェックイン',
		checkOutTime: 'チェックアウト',
		detail: '詳細',
		bookNow: '今すぐ予約'
	},
	locationPage: {
		location: '交通アクセス',
		trainInfo: '鉄道 / 新幹線（高速鉄道）利用',
		busInfo: 'バス利用',
		driveInfo: '自家用車利用',
		parkInfo: '駐車場',
		hotelInfo: '送迎サービス',
		airplaneInfo: '飛行機'
	},
	newsHomePage: {
		all: '全部',
		news: '最新情報',
		selectType: '',
		more: 'もっと見る'
	},
	newsPage: {
		projectTime: '時間',
		projectDetail: '情報',
		note: '備考欄'
	},
	restaurantPage: {
		restaurantsAndMeetings: 'レストラン・会議',
		restaurant: 'レストラン',
		meeting: '会議'
	},
	activityPage: {
		activity: '館内イベント',
		attractionsNearby: 'おすすめ観光情報',
		more: 'もっと見る',
		lookupSchedule: 'もっと見る',
		join: 'もっと見る'
	},
	facilityPage: {
		facility: '施設・サービス',
		lookup: 'もっと見る'
	},
	justFunSection: {
		justFun: '西門の十の楽しみ'
	},
	hotelMain: {
		name: 'ブランド',
		title: '',
		longName: 'ブランド',
		bannerText: 'ジャストスリープ ',
		contactUs: 'カスタマーサポート',
		address: '台北市大安区羅斯福路四段83号',
		intro: 'Just Sleepジャストスリープは､シルクスホテルグループ傘下のデザインホテルブランドです｡\n「ご満足いただけるご宿泊をおとどけする ジャストスリープ」をブランド精神にこだわり､',
		intro2: '親しみやすく手頃な料金にて､5つ星ホテルの美しく優れたサービスをお楽しみいただけます｡'
	},
	hotelXimen: {
		name: '台北西門',
		title: '',
		contactUs: 'カスタマーサポート',
		address: '台北市中正区中華路一段41号5階（入口は漢口街一段144号にあります。）',
		intro: '「ジャストスリープ台北西門」は賑やかで活気に満ちた西門町ショッピングエリアに隣接しています。お客様が手軽にのんびりと台北市を遊ぶことのできる、最も歴史と物語のある観光スポットがあり、台湾スタイルの新たな流行と文化を体験できるほか、本場の美食も味わえます。'
	},
	hotelNTU: {
		name: '台大尊賢',
		title: '台湾大学周辺のホテル',
		contactUs: 'カスタマーサポート',
		address: '台北市大安区羅斯福路四段83号',
		intro: '「ジャストスリープ台大尊賢」は国立台湾大学のとなりに位置し、学内での教育、実習、研究、学術交流、会議及び訪問者の皆様に快適なご宿泊への選択肢をご提供しています。気ままなカレッジスタイルをデザインに融合した館内は、大学との共栄の雰囲気を創り出しています。'
	},
	hotelZhongshan: {
		name: '台北中山',
		title: '',
		contactUs: 'カスタマーサポート',
		address: '台北市中山区中山北路一段135巷39号',
		intro: '「ジャストスリープ台北中山」は、歴史の面影とモダンな活気が交差する中山区に位置し、MRT中山駅からも近くアクセスの良いホテルです。旅行者は賑やかな「条通（ティアオトン）」や中山ショッピングエリアを気軽に散策でき、台北のレトロな文化と最新のトレンドを同時に体感できます。国内外の旅行者が台北を深く楽しむための理想的な滞在先です。'
	},
	hotelKaohsiung: {
		name: '高雄中正',
		title: '',
		contactUs: 'カスタマーサポート',
		address: '高雄市苓雅区中正一路134号',
		intro: 'ジャストスリープ高雄中正は、現代的な建物で、おしゃれかつ実用的な内装デザインなど、他では味わえない空間でのご滞在を提供しています。高雄市中正路に位置し、MRT苓雅運動園區駅（以前の名称は技撃館駅）の真向かいにあり、非常に便利なロケーションです。'
	},
	hotelKaohsiungStation: {
		name: '高雄駅前',
		title: '',
		contactUs: 'カスタマーサポート',
		address: '高雄市新興区中山一路280号',
		intro: 'ジャストスリープ高雄駅前ホテルは寝るだけのところではなく﹑美しいデザイン美学﹑ユニークともに完全リフレッシュできる空間を作り上げました。高雄駅﹑MRT美麗島駅とバス乗り場から2-5分という快適に最適魅力満載のホテルです。'
	},
	hotelHualien: {
		name: '花蓮中正',
		title: '',
		contactUs: 'カスタマーサポート',
		address: '花蓮市中正路396号',
		intro: 'ファイブスター系列ホテルの設計によるジャストスリープ花蓮はリーズナブルな料金とハイクオリティなサービスが特徴です。高い天井をデザインしたレストランや図書館も完備しており、ほかでは味わえない快適な滞在をご体験していただけます。'
	},
	hotelJiaoxi: {
		name: '宜蘭礁溪',
		title: '宜蘭温泉ホテル',
		contactUs: 'カスタマーサポート',
		address: '宜蘭県礁渓郷徳陽路24巷8号',
		intro: '「ジャストスリープ宜蘭礁溪」は賑やかな礁渓ショッピングエリアに隣接しています。全館で炭酸塩化ナトリウム温泉をお楽しみいただける、礁渓地区のデザインホテルの全く新しい指標です。お客様は徒歩で、五峰旗風景区、湯圍溝温泉講演などの有名な観光スポットに向かうことができます。'
	},
	hotelSanchong: {
		name: '台北三重',
		title: '',
		contactUs: 'カスタマーサポート',
		address: '新北市三重区三和路四段107-1号（MRT三和國中駅2番出口から1分です。）',
		intro: '「ジャストスリープ台北三重」は目の前がMRT三和国中駅という絶好の立地条件で、交通の便がよく、ビジネスにも旅行にも大変便利です。斬新なインダストリアルな建築スタイルが特徴で、手作り焙煎のコーヒーと台湾茶をご提供することで、お客様一人ひとりに快適な客室でおくつろぎいただきながら、温かみのあるサービスと雰囲気をお届けしています。'
	},
	hotelHushan: {
		name: '台南虎山',
		title: '',
		contactUs: 'カスタマーサポート',
		address: '台南市仁徳区文華路二段300号',
		intro: '「ジャストスリープ台南虎山」は十鼓仁糖文創園区と奇美博物館に隣接し、アートを楽しむ旅人にぴったり。高鉄台南駅や台南空港、高速道路へのアクセスも抜群で、ビジネスやご家族でのご旅行にも大変便利な立地です。'
	},
	hotelOsakaShinsaibashi: {
		name: '大阪心斎橋',
		title: '',
		contactUs: 'カスタマーサポート',
		address: '〒542-0081 大阪市中央区南船場2丁目9-15',
		intro: 'ジャストスリープ大阪心斎橋は､グルメショップが立ち並ぶ賑やかな心斎橋筋商店街に近く､ファッショナブルな文化が味わえるアメリカ村にも徒歩圏内です｡また心斎橋駅､本町駅､堺筋本町駅､長堀橋駅の４つの地下鉄駅から徒歩7～8分とアクセスも便利で､大阪市中心エリアの観光に最適なホテルです｡',
		tel: 'Tel : 06-6251-3666',
		fax: 'Fax : 06-6251-3889'
	}
};

/* eslint-enable */

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
/* eslint-disable */

exports.default = {
	common: {
		'1': '일월',
		'2': '이월',
		'3': '삼월',
		'4': '사월',
		'5': '오월',
		'6': '육월',
		'7': '칠월',
		'8': '팔월',
		'9': '구월',
		'10': '십월',
		'11': '십일월',
		'12': '십이월',
		adults: '성인수',
		children: '아동수',
		bookNow: '확인',
		prev: '이전',
		backToHome: '돌아 가기',
		next: '다음',
		detail: '세부 묘사',
		selectDate: '도착 날짜',
		selectHotel: '가지 선택',
		onlineTravelFair: '線上旅展',
		bookNowBtn: '확인'
	},
	pageTitle: {
		brandName: 'Just Sleep 저스트 슬립',
		main: '브랜드',
		news: '최신소식',
		privacy: '개인정보 정책 및 자세한 쿠키 정책 을',
		accommodation: '객실',
		facility: '테마',
		restaurant: '다이닝 & 연회 회의',
		location: '시설',
		activity: '관내활동'
	},
	header: {
		main: '브랜드',
		news: '최신소식',
		index: '홈',
		accommodation: '객실',
		facility: '테마',
		restaurant: '다이닝 & 연회 회의',
		location: '시설',
		activity: '관내활동',
		bookNow: '확인',
		taiwan: '대만',
		japan: '일본',
		onlineTravelFair: '線上旅展',
		bookNowBtn: '확인'
	},
	footer: {
		registrationNumber: '관광숙박업 등록번호',
		privacy: '개인정보 정책 및 자세한 쿠키 정책 을'
	},
	cookieBar: {
		attention: '<p>우리는 귀하의프라이버시를를 존중합니다.</p>\n<p>실크하우스그룹은 좀 더 나은 서비스 및 컨텐츠 개선을 위해 자체 혹은 선택 된 제3자 쿠키를 이용하고있습니다. 본 사이트 사용을 위해서 동의를 부탁드립니다. 실크하우스그룹은모든{{privacyLink}}검토 후, 동의해주시길 권장 드립니다.</p>',
		privacy: '개인정보 정책 및 자세한 쿠키 정책 을',
		accept: '동의하기'
	},
	homePage: {
		title: '품격있는 객실 친절한 서비스',
		about: '에 대하여',
		aboutJustsleep: '저스트슬립 은',
		toHotelSite: '세부사항',
		more: '세부사항',
		justNews: '최신소식',
		justComfortTitle: 'Just 편안한 수면',
		justComfortBackTitle: 'Just 편안한 수면',
		justComfortContent: '호텔에서는 다양한 베개를 제공해드리고 있으며, 저스트 슬립에 오시는 모든 고객님 한분 한분에게 최고의 수면을 선사해드립니다.',
		justGoTitle: 'Just 즐거운 여행',
		justGoBackTitle: 'Just 즐거운 여행',
		justGoContent: '호텔에서는 각 여행지의 관광안내 서비스를 제공해드리고 있습니다. 저스트 슬립의 고객 한분 한분께서 원하시는 관광지와 쇼핑 그리고 교통정보에 대한 안내를 제공해드립니다.\n',
		justEquipTitle: 'Just특별한 아이템',
		justEquipBackTitle: 'Just특별한 아이템',
		justEquipContent: '셀카봉, 휴대용 충전 배터리, 여행용 배터리, 손전등 등의 특별 아이템들을 제공해드립니다.（시먼관(西门馆). 및 타이완대학 쭌시엔관(臺大尊賢館) 한정）',
		justBuyTitle: 'Just쇼핑',
		justBuyBackTitle: 'Just쇼핑',
		justBuyContent: '타이완의 특별한 기념품 대리 구매 서비스를 제공해 드립니다. 기념품 구매 시간을 절약하시고 더욱 여유로운 여행을 즐기세요.',
		justPackTitle: 'Just포장',
		justPackBackTitle: 'Just포장',
		justPackContent: '짐 무게 측정 및 각 사이즈 별 종이박스 판매 서비스를 제공해 드립니다. 무료 전문 포장 서비스와 함께 여유롭게 귀가하세요.',
		justRelax: '편리한 시설',
		justSight: '주차장 안내',
		justGo: '관내활동',
		justExplore: '탐색',
		justService: '친밀한 서비스'
	},
	accommodationPage: {
		rooms: '객실',
		roomFacilityTitle: '어메니티',
		lookupRoomType: '정보 더 보기',
		have: '',
		roomType: '객실 타입',
		am: '아침',
		pm: '오후',
		checkInTime: '체크인 시간',
		checkOutTime: '체크아웃 시간',
		detail: '세부사항',
		bookNow: '확인'
	},
	locationPage: {
		location: '시설',
		trainInfo: '철도 / 고속철도 ',
		busInfo: '고속버스',
		driveInfo: '자가용',
		parkInfo: '주차장',
		hotelInfo: '호텔 셔틀',
		airplaneInfo: '공항에서 호텔까지 오는 법'
	},
	newsHomePage: {
		all: '모두',
		news: '최신소식',
		selectType: '',
		more: '세부사항'
	},
	newsPage: {
		projectTime: '시간',
		projectDetail: '세부 정보',
		note: '비고'
	},
	restaurantPage: {
		restaurantsAndMeetings: '다이닝 & 연회 회의',
		restaurant: '식당',
		meeting: '회의'
	},
	activityPage: {
		activity: '관내활동',
		attractionsNearby: '주차장 안내',
		more: '세부사항',
		lookupSchedule: '세부사항',
		join: '세부사항'
	},
	facilityPage: {
		facility: '테마',
		lookup: '세부사항'
	},
	justFunSection: {
		justFun: '시먼딩 10 곳 저스트 플레이'
	},
	hotelMain: {
		name: '브랜드',
		title: '',
		longName: '브랜드',
		bannerText: '저스트 슬립',
		contactUs: '고객 서비스',
		address: '타이베이시 뤄쓰푸로 4단 83호',
		intro: '저스트슬립 은 리젠트 인터내셔널 호텔 그룹(晶華國際酒店集團) 계열의 디자인 호텔 브랜드이며, 「대중적인 가격, 우수한 서비스」를 철학으로 하며, 「우수한 품격，더욱 세심한 정성」의 브랜드 정신으로, 고객님께서 더욱 저렴한 가격으로 5성급 호텔의 최고의 서비스를 누리실 수 있도록 최선을 다하고 있습니다.\n'
	},
	hotelXimen: {
		name: '타이페이 시먼점',
		title: '',
		contactUs: '고객 서비스',
		address: '타이베이시 중정구 중화로 1 단 41호 5 층',
		intro: '「저스트슬립 타이페이 시먼점」은 번화가의 중심지인 시먼딩(西門町) 상권 근처에 위치해 있어 타이베이 시내의 역사명소들을 보다 편리하고 편안하게 여행하실 수 있으며, 타이베이 젊음의 문화와 함께 현지의 맛있는 음식도 체험하실 수 있습니다.'
	},
	hotelNTU: {
		name: '타이완대학교 점',
		title: '',
		contactUs: '고객 서비스',
		address: '타이베이시 뤄쓰푸로 4단 83호',
		intro: '「저스트슬립 타이환대학교 점」은 국립 타이완 대학 옆에 위치해 있으며, 캠퍼스의 교육, 실습, 연구, 학술교류, 회의, 세미나 및 행사 참석자들을 위한 편안한 휴식의 장소를 제공해드리고 있습니다. 자유로운 캠퍼스의 이미지를 본 관의 디자인에 융합하여 캠퍼스와의 공존 및 공영의 분위기를 만들어 내고 있습니다.'
	},
	hotelZhongshan: {
		name: '타이베이 중산',
		title: '',
		contactUs: '고객 서비스',
		address: '타이베이시 중산구 중산베이루 1단 135샹 39하오',
		intro: "저스트 슬립 타이베이 중산(Just Sleep Taipei Zhongshan)'은 깊은 역사와 현대적인 활기가 어우러진 타이베이 중산구에 위치해 있으며, 지하철(MRT) 중산역과 가까워 뛰어난 교통 접근성을 자랑합니다. 번화한 탸오퉁(條通)과 중산 상권을 여유롭게 산책하며 타이베이의 옛 정취와 최신 트렌드를 동시에 경험할 수 있어, 대만 타이베이를 여행하는 국내외 관광객들에게 완벽한 숙소입니다."
	},
	hotelKaohsiung: {
		name: '가오슝 종정점',
		title: '',
		contactUs: '고객 서비스',
		address: '가오슝시 영아구 중정1로 134호',
		intro: 'Just Sleep 가오슝 중정관은 문화와 예술 중심의 융합된 감각적인 디자인으로 넓은 공간을 제공하며, 우먀오(武廟) 야시장과 웨이우잉(衛武營) 예술문화센터, 그리고 지하철역과 인접합니다. 해당 지하철역은 위안극관역(예전 명칭: 기격관역)입니다. 투숙객은 다양한 현지 문화를 체험할 수 있습니다.\n'
	},
	hotelKaohsiungStation: {
		name: '가오슝역 점',
		title: '',
		contactUs: '고객 서비스',
		address: '가오슝시 신싱취 쫑산1루 280하오 ',
		intro: '지하철역과 근접한 Just sleep 호텔은 세련되고 모던한 감각의 시각예술 중심적 인테리어로 안락한 숙박을 제공하며, 가오슝 기차역과 유명한 관광명소(세계에서 가장 아름다운 지하철역) 메이리다오역, 류허 야시장과 아주 인접해있으며 다양한 경험을 제공하는 호텔시설은 투숙객의 만족을 보장합니다.'
	},
	hotelHualien: {
		name: '화롄 종정점',
		title: '',
		contactUs: '고객 서비스',
		address: '화롄시 중정로 396호',
		intro: '본 호텔은 다양한 현지 음식을 체험할 수 있는 화롄 시내에 자리하고 있습니다. 또한 난빈[東大門] 해안에서 아름다운 바다 풍경을 감상할 수 있으며 문화창작단지에서 창의적 역량을 경험할 수 있습니다.본 호텔은 다양한 현지 음식을 체험할 수 있는 화롄 시내에 자리하고 있습니다. 또한 난빈[東大門] 해안에서 아름다운 바다 풍경을 감상할 수 있으며 문화창작단지에서 창의적 역량을 경험할 수 있습니다.'
	},
	hotelJiaoxi: {
		name: '이란 자오시점',
		title: '이란 온천 호텔',
		contactUs: '고객 서비스',
		address: '이란현 초계향 덕양로 24항8호',
		intro: '「저스트슬립 이란 자오시점」은 번화한 자오시(礁溪) 상권 근처에 위치해 있으며, 전 관에서 탄산수소나트륨 온천을 제공하며, 자오시 지역내 디자인 호텔의 새로운 모델로 자리매김 하였습니다.  또한 도보로 우펑치 풍경구(五峰旗風景區), 탕웨이거우 온천공원(湯圍溝溫泉公園)등의 유명 관광명소로 바로 이동하실 수 있습니다.'
	},
	hotelSanchong: {
		name: '타이페이 산총점',
		title: '',
		contactUs: '고객 서비스',
		address: '대만 신베이시 산충구 싼허로 4단 107-1호',
		intro: '「저스트슬립 타이페이 산총점」은 MRT 싼허중학교역이 호텔 바로 앞에 위치한 최적의 입지조건을 자랑합니다. 사통팔달의 편리한 교통으로 비즈니스 출장은 물론 레저 여행 시에도 매우 편리합니다. 새롭게 단장한 로프트 스타일의 건축물과 수제 로스팅 커피, 타이완산 잎차를 통해 찾아 주신 모든 여행객에게 편안한 객실에서 만끽하는 여유, 정성으로 모시는 세심한 서비스를 선사합니다.'
	},
	hotelHushan: {
		name: '타이난 후산점',
		title: '',
		contactUs: '고객 서비스',
		address: '타이난시 런더구 원화로 2단 300호',
		intro: '「저스트슬립 타이난 후산점」은 스구 문화마을, 치메이 박물관과 인접해 있어 문화 예술적 명소를 편리하게 즐길실 수 있습니다. 고속철도역, 공항, 고속도로 등의 교통 시설과도 가까워 비즈니스 출장 및 가족 휴가를 위한 최고의 선택입니다.'
	},
	hotelOsakaShinsaibashi: {
		name: '오사카 신사이바시는',
		title: '',
		contactUs: '고객 서비스',
		address: '542-0081 오사카시 주오구 미나미시파 2초메 9-15',
		intro: '저스트 슬립 오사카 신사이바시는 저스트 슬립 브랜드의 일본 진출 첫 거점입니다. 우리 호텔은 번화가인 산사이바시 비즈니스 지구에 가까이 위치해 있습니다. 비즈니스 지구에 위치한 여러 레스토랑에서 최신 현지 문화를 경험하고 친절한 서비스를 받을 수 있습니다.\n호텔은 신사이바시 역, 혼마치 역, 사카이수지 혼마치 역, 나가호리바시 역 등 주요 지하철역과도 가깝습니다. 이를 통해 다른 관광지로도 쉽게 이동할 수 있기에 저스트 슬립 오카사 신사이바시는 오사카 자유 여행에 있어 최적의 숙소라고 할 수 있습니다.',
		tel: 'Tel : 006-6251-3666',
		fax: 'Fax : +81-06-6251-3889'
	}
};

/* eslint-enable */

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
/* eslint-disable */

exports.default = {
	common: {
		'1': '一月',
		'2': '二月',
		'3': '三月',
		'4': '四月',
		'5': '五月',
		'6': '六月',
		'7': '七月',
		'8': '八月',
		'9': '九月',
		'10': '十月',
		'11': '十一月',
		'12': '十二月',
		adults: '大人',
		children: '小孩',
		bookNow: '立即订房',
		prev: '上一则',
		backToHome: '回列表页',
		next: '下一则',
		detail: '详细资讯',
		selectDate: '选择日期',
		selectHotel: '选择分馆',
		onlineTravelFair: '線上旅展',
		bookNowBtn: '立即订房'
	},
	pageTitle: {
		brandName: 'Just Sleep 捷丝旅',
		main: '品牌首页',
		news: '最新优惠 ',
		privacy: '隐私声明与 Cookie 政策',
		accommodation: '房型介绍',
		facility: '设施服务',
		restaurant: '餐厅会议',
		location: '交通景点',
		activity: '馆内活动'
	},
	header: {
		main: '品牌首页',
		news: '最新优惠 ',
		index: '分馆首页',
		accommodation: '房型介绍',
		facility: '设施服务',
		restaurant: '餐厅会议',
		location: '交通景点',
		activity: '馆内活动',
		bookNow: '立即订房',
		taiwan: '台湾',
		japan: '日本',
		onlineTravelFair: '線上旅展',
		bookNowBtn: '立即订房'
	},
	footer: {
		registrationNumber: '旅馆业登记证编号',
		privacy: '隐私声明与 Cookie 政策'
	},
	cookieBar: {
		attention: '<p>我们重视且尊重您的隐私。</p> \n<p>晶华国际酒店集团的全球官方网站是使用独立的第三方Cookie来提升网站的表现、分析数据以及达到更精准的投放广告。若您浏览此网站，即代表您同意我们使用第三方Cookie。若欲了解更多相关信息，建议您可前往我们的{{privacyLink}}进行查看。</p>',
		privacy: '"隐私声明与Cookie政策网页" ',
		accept: '同意，并浏览网站'
	},
	homePage: {
		title: '风格优旅 心细如缕',
		about: '关于',
		aboutJustsleep: '关于捷丝旅',
		toHotelSite: '前往官网',
		more: '了解更多',
		justNews: '最新消息',
		justComfortTitle: 'Just 好眠',
		justComfortBackTitle: 'Just 好眠',
		justComfortContent: '饭店内提供不同的枕头选择，使毎一位下榻捷丝旅的旅人，皆可获得舒适的睡眠品质。',
		justGoTitle: 'Just 好游',
		justGoBackTitle: 'Just 好游',
		justGoContent: '饭店内提供旅游咨询服务，依据每一位旅人的需求推荐景点、购物好店及交通信息。',
		justEquipTitle: 'Just 备品',
		justEquipBackTitle: 'Just 备品',
		justEquipContent: '提供自拍神器、手机充电器、行动电源、台灯等特殊备品（限台北西门馆、及台大尊贤馆）。',
		justBuyTitle: 'Just 好买',
		justBuyBackTitle: 'Just 好买',
		justBuyContent: '提供代购台湾特色伴手礼之服务，为旅人省下时间、轻松旅游。',
		justPackTitle: 'Just 打包',
		justPackBackTitle: 'Just 打包',
		justPackContent: '提供行李秤重及各尺寸纸箱选购之服务，由专人帮您免费打包、轻松返程。',
		justRelax: '便捷设施',
		justSight: '景點介绍',
		justGo: 'Just 好游',
		justExplore: '捷丝旅·探索',
		justService: '贴心服务'
	},
	accommodationPage: {
		rooms: '房型介绍',
		roomFacilityTitle: '客房设施 • 备品',
		lookupRoomType: '查看客房类型',
		have: '共有',
		roomType: '房型',
		am: '上午',
		pm: '下午',
		checkInTime: '入住时间',
		checkOutTime: '退房时间',
		detail: '详细资讯',
		bookNow: '立即订房'
	},
	locationPage: {
		location: '交通景点',
		trainInfo: '台铁/高鐵资讯',
		busInfo: '客运资讯',
		driveInfo: '开车资讯',
		parkInfo: '停车资讯',
		hotelInfo: '饭店接驳',
		airplaneInfo: '机场资讯'
	},
	newsHomePage: {
		all: '全部',
		news: '最新优惠 ',
		selectType: '选择类型',
		more: '了解更多'
	},
	newsPage: {
		projectTime: '专案期间',
		projectDetail: '专案内容',
		note: '备注'
	},
	restaurantPage: {
		restaurantsAndMeetings: '餐厅会议',
		restaurant: '餐厅',
		meeting: '会议'
	},
	activityPage: {
		activity: '馆内活动',
		attractionsNearby: '推荐景点',
		more: '了解更多',
		lookupSchedule: '查看行程',
		join: '立刻報名'
	},
	facilityPage: {
		facility: '设施服务',
		lookup: '查看簡介'
	},
	justFunSection: {
		justFun: '西门十趣'
	},
	hotelMain: {
		name: '品牌首頁',
		title: '',
		longName: '品牌首頁',
		bannerText: '捷丝旅',
		contactUs: '客服信箱',
		address: '台北市罗斯福路四段83号',
		intro: '「Just Sleep 捷丝旅」为晶华国际酒店集团旗下之设计型旅馆品牌，秉持「风格优旅，心细如缕」的品牌精神，使旅人可以亲民、实惠的价格，享受媲美五星饭店的优质服务。\n'
	},
	hotelXimen: {
		name: '台北西门馆',
		title: '',
		contactUs: '客服信箱',
		address: '台北市中正区中华路一段41号5楼（请由汉口街一段144号出入）',
		intro: '「捷丝旅台北西门馆」邻近繁华、热闹的西门町商圈，旅人可轻松畅游台北市最具历史故事的景点，体验台味新潮文化之余，亦可品尝地道美食。\n'
	},
	hotelNTU: {
		name: '台大尊贤馆',
		title: '',
		contactUs: '客服信箱',
		address: '台北市大安区罗斯福路四段83号',
		intro: '「捷丝旅台大尊贤馆」位于国立台湾大学旁，提供至校园教学、实习、研究、学术交流、会议及参访人员舒适旅宿的选择，馆内将自在的学院风格融入设计中，营造与校园共荣的氛围。\n'
	},
	hotelZhongshan: {
		name: '台北中山馆',
		title: '',
		contactUs: '客服信箱',
		address: '台北市中山区中山北路一段135巷39号',
		intro: '捷丝旅台北中山馆位于融合了历史底蕴与现代活力的中山区，临近台北地铁（捷运）中山站，交通极为便利。旅客可轻松步行探索繁华的条通及中山商圈，感受老城区的复古情调与现代时尚的交织。这里是海内外旅客深度体验台北“Citywalk”和轻旅行的理想下榻之选。'
	},
	hotelKaohsiung: {
		name: '高雄中正馆',
		title: '',
		contactUs: '客服信箱',
		address: '高雄市苓雅区中正一路134号',
		intro: '「捷丝旅高雄中正馆」以音乐风格为设计主轴，内部空间设计兼具时尚音乐风格与实用功能。本馆临近高雄捷运苓雅运动园区站(旧名:技击馆站)、卫武营国家艺术文化中心及武庙夜市，将提供旅人不同凡响的旅宿体验。\n'
	},
	hotelKaohsiungStation: {
		name: '高雄站前馆',
		title: '',
		contactUs: '客服信箱',
		address: '高雄市新兴区中山一路280号',
		intro: '「捷丝旅高雄站前馆」以视觉艺术为主轴，将美学融入饭店设计中，兼具精品魅力及文创的时尚气息。临近高雄火车站、捷运美丽岛站及六合夜市，都能便利前往不同的景点，为旅客休憩的首选。'
	},
	hotelHualien: {
		name: '花莲中正馆',
		title: '',
		contactUs: '客服信箱',
		address: '花莲市中正路396号',
		intro: '拥有五星级饭店血统的设计旅店捷丝旅，以平实的价格提供顾客超乎想象的优质服务，馆内设有儿童游戏室以及图书馆，让旅客在其中能够得到放松，并补给心灵的能量，提供与众不同的住宿新享受。'
	},
	hotelJiaoxi: {
		name: '宜兰礁溪馆',
		title: '',
		contactUs: '客服信箱',
		address: '宜兰县礁溪乡德阳路24巷8号',
		intro: '「捷丝旅宜兰礁溪馆」邻近热闹的礁溪商圈，全馆提供碳酸氢钠温泉，是礁溪地区设计旅店的全新指标，旅人步行即可至著名观光景点如五峰旗风景区、汤围沟温泉公园等。\n'
	},
	hotelSanchong: {
		name: '台北三重馆',
		title: '',
		contactUs: '客服信箱',
		address: '新北市三重区三和路四段107-1号（捷运三和国中站2号出口往后走1分钟）',
		intro: '「捷丝旅台北三重馆」拥有绝佳的地理位置，捷运三和国中站就在门口，交通四通八达；商务住宿或是旅游休憩均十分方便。全新的轻工业风建筑，透过手工烘培的咖啡与台湾原片茶，传达给每一位旅人在舒适的客房休息之余，还有温润贴心的服务与感受。'
	},
	hotelHushan: {
		name: '台南虎山馆',
		title: '',
		contactUs: '客服信箱',
		address: '台南市仁德区文华路二段300号',
		intro: '「捷丝旅台南虎山馆」紧邻十鼓仁糖文创园区、奇美博物馆，让旅人探索文艺景点享尽地利之便。邻近高铁站、机场、高速公路等交通要点，是商务活动及亲子度假的饭店首选。'
	},
	hotelOsakaShinsaibashi: {
		name: '大阪心斋桥馆',
		title: '',
		contactUs: '客服信箱',
		address: '542-0081大阪市中央区南船场二丁目9-15',
		intro: '「捷丝旅大阪心斋桥馆」是捷丝旅品牌进军日本的首家据点，饭店位置紧邻热闹繁华的心斋桥商圈，商圈内美食店铺林立，房客步行即可沉浸式的体验在地潮流文化与热情好客的风土民情。\n饭店对外交通四通八达，心斋桥站、本町站、堺筋本町及长堀桥站等四大地铁车站近在咫尺，出行时便利性十足，绝对是旅人规划大阪自由行时的住宿首选。',
		tel: 'Tel : +81-06-6251-3666',
		fax: 'Fax : +81-06-6251-3889'
	}
};

/* eslint-enable */

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
/* eslint-disable */

exports.default = {
	common: {
		'1': '一月',
		'2': '二月',
		'3': '三月',
		'4': '四月',
		'5': '五月',
		'6': '六月',
		'7': '七月',
		'8': '八月',
		'9': '九月',
		'10': '十月',
		'11': '十一月',
		'12': '十二月',
		adults: '大人',
		children: '小孩',
		bookNow: '立即訂房',
		prev: '上一則',
		backToHome: '回列表頁',
		next: '下一則',
		detail: '詳細資訊',
		selectDate: '選擇日期',
		selectHotel: '選擇分館',
		onlineTravelFair: '線上旅展',
		bookNowBtn: '立即預訂'
	},
	pageTitle: {
		brandName: 'Just Sleep 捷絲旅',
		main: '品牌首頁',
		news: '最新優惠',
		privacy: '隱私權聲明與 Cookie 政策',
		accommodation: '房型介紹',
		facility: '設施服務',
		restaurant: '餐廳會議',
		location: '交通景點',
		activity: '館內活動'
	},
	header: {
		main: '品牌首頁',
		news: '最新優惠',
		index: '分館首頁',
		accommodation: '房型介紹',
		facility: '設施服務',
		restaurant: '餐廳會議',
		location: '交通景點',
		activity: '館內活動',
		bookNow: '立即訂房',
		taiwan: '台灣',
		japan: '日本',
		onlineTravelFair: '線上旅展',
		bookNowBtn: '立即預訂'
	},
	footer: {
		registrationNumber: '旅館業登記證編號',
		privacy: '隱私權聲明與 Cookie 政策'
	},
	cookieBar: {
		attention: '<p>我們重視且尊重您的隱私。</p>\n<p>晶華國際酒店集團的全球官方網站是使用獨立的第三方Cookie來提升網站的表現、分析數據以及達到更精準的投放廣告。若您瀏覽此網站，即代表您同意我們使用第三方Cookie。若欲了解更多相關資訊，建議您可前往我們的{{privacyLink}}網頁進行查看。</p>',
		privacy: '隱私權聲明與 Cookie 政策',
		accept: '同意，並瀏覽網站'
	},
	homePage: {
		title: '風格優旅 心細如縷',
		about: '關於',
		aboutJustsleep: '關於捷絲旅',
		toHotelSite: '前往官網',
		more: '暸解更多',
		justNews: '最新消息',
		justComfortTitle: 'Just 好眠',
		justComfortBackTitle: 'Just 好眠',
		justComfortContent: '飯店內提供不同的枕頭選擇，使毎一位下榻捷絲旅的旅人，皆可獲得舒適的睡眠品質。',
		justGoTitle: 'Just 好遊',
		justGoBackTitle: 'Just 好遊',
		justGoContent: '飯店內提供旅遊諮詢服務，依據每一位旅人的需求推薦景點、購物好店及交通資訊。',
		justEquipTitle: 'Just 備品',
		justEquipBackTitle: 'Just 備品',
		justEquipContent: '提供自拍神器、手機充電器、行動電源、檯燈等特殊備品（限台北西門館、及臺大尊賢館）。',
		justBuyTitle: 'Just 好買',
		justBuyBackTitle: 'Just 好買',
		justBuyContent: '提供代購台灣特色伴手禮之服務，為旅人省下時間、輕鬆旅遊。',
		justPackTitle: 'Just 打包',
		justPackBackTitle: 'Just 打包',
		justPackContent: '提供行李秤重及各尺寸紙箱選購之服務，由專人幫您免費打包、輕鬆返程。',
		justRelax: '便捷設施',
		justSight: '景點介紹',
		justGo: 'Just 好遊',
		justExplore: '捷絲旅·探索',
		justService: '貼心服務'
	},
	accommodationPage: {
		rooms: '房型介紹',
		roomFacilityTitle: '客房設施 • 備品',
		lookupRoomType: '查看客房類型',
		have: '共有',
		roomType: '房型',
		am: '上午',
		pm: '下午',
		checkInTime: '入住時間',
		checkOutTime: '退房時間',
		detail: '詳細資訊',
		bookNow: '立即訂房'
	},
	locationPage: {
		location: '交通景點',
		trainInfo: '臺鐵/高鐵資訊',
		busInfo: '客運資訊',
		driveInfo: '開車資訊',
		parkInfo: '停車資訊',
		hotelInfo: '飯店接駁',
		airplaneInfo: '機場資訊'
	},
	newsHomePage: {
		all: '全部',
		news: '最新優惠',
		selectType: '選擇類型',
		more: '暸解更多'
	},
	newsPage: {
		projectTime: '專案期間',
		projectDetail: '專案內容',
		note: '備註'
	},
	restaurantPage: {
		restaurantsAndMeetings: '餐廳會議',
		restaurant: '餐廳',
		meeting: '會議'
	},
	activityPage: {
		activity: '館內活動',
		attractionsNearby: '推薦景點',
		more: '暸解更多',
		lookupSchedule: '查看行程',
		join: '立刻報名'
	},
	facilityPage: {
		facility: '設施服務',
		lookup: '查看簡介'
	},
	justFunSection: {
		justFun: '西門十趣'
	},
	hotelMain: {
		name: '品牌首頁',
		title: '',
		longName: '品牌首頁',
		bannerText: '捷絲旅',
		contactUs: '客服信箱',
		address: '台北市羅斯福路四段83號',
		intro: '「Just Sleep 捷絲旅」為晶華國際酒店集團旗下之設計型旅館品牌，秉持「風格優旅，心細如縷」的品牌精神，使旅人可以親民、實惠的價格，享受媲美五星飯店的優質服務。'
	},
	hotelXimen: {
		name: '台北西門館',
		title: '',
		contactUs: '客服信箱',
		address: '台北市中正區中華路一段41號5樓（請由漢口街一段144號出入）',
		intro: '「捷絲旅台北西門館」鄰近繁華、熱鬧的西門町商圈，旅人可輕鬆暢遊台北市最具歷史故事的景點，體驗台味新潮文化之餘，亦可品嘗道地美食。\n'
	},
	hotelNTU: {
		name: '臺大尊賢館',
		title: '',
		contactUs: '客服信箱',
		address: '台北市大安區羅斯福路四段83號',
		intro: '「捷絲旅臺大尊賢館」位於國立台灣大學旁，提供至校園教學、實習、研究、學術交流、會議及參訪人員舒適旅宿的選擇，館內將自在的學院風格融入設計中，營造與校園共榮的氛圍。'
	},
	hotelZhongshan: {
		name: '台北中山館',
		title: '',
		contactUs: '客服信箱',
		address: '台北市中山區中山北路一段135巷39號',
		intro: '「捷絲旅台北中山館」座落於揉合歷史底蘊與現代活力的中山區，鄰近捷運中山站，交通便利性極佳。旅人可輕鬆漫步探索繁華的條通及中山商圈，感受舊城文化與新潮時尚的交織，是海內外旅人深度體驗台北輕旅行的理想下榻首選。'
	},
	hotelKaohsiung: {
		name: '高雄中正館',
		title: '',
		contactUs: '客服信箱',
		address: '高雄市苓雅區中正一路134號',
		intro: '「捷絲旅高雄中正館」以音樂風格為設計主軸，內部空間設計兼具時尚音樂風格與實用功能。本館臨近高雄捷運苓雅運動園區站(舊名:技擊館站)、衛武營國家藝術文化中心及武廟夜市，將提供旅人不同凡響的旅宿體驗。\n'
	},
	hotelKaohsiungStation: {
		name: '高雄站前館',
		title: '',
		contactUs: '客服信箱',
		address: '高雄市新興區中山一路280號',
		intro: '「捷絲旅高雄站前館」以視覺藝術為主軸，將美學融入飯店設計中，兼具精品魅力及文創的時尚氣息。本館臨近高雄火車站、捷運美麗島站及六合夜市，能便利前往不同的景點，為旅客休憩的首選。'
	},
	hotelHualien: {
		name: '花蓮中正館',
		title: '',
		contactUs: '客服信箱',
		address: '花蓮市中正路396號',
		intro: '「捷絲旅花蓮中正館」以文學為主軸，設有圖書館、兒童遊戲室，使旅人休憩其中並獲得放鬆，坐落於市中心，臨近知名美食店家、著名的東大門夜市，亦可輕鬆品嚐在地特色小吃。\n'
	},
	hotelJiaoxi: {
		name: '宜蘭礁溪館',
		title: '',
		contactUs: '客服信箱',
		address: '宜蘭縣礁溪鄉德陽路24巷8號',
		intro: '「捷絲旅宜蘭礁溪館」鄰近熱鬧的礁溪商圈，全館提供碳酸氫鈉溫泉，是礁溪地區設計旅店的全新指標，旅人步行即可至著名觀光景點如五峰旗風景區、湯圍溝溫泉公園等。\n'
	},
	hotelSanchong: {
		name: '台北三重館',
		title: '',
		contactUs: '客服信箱',
		address: '新北市三重區三和路四段107-1號（捷運三和國中站2號出口往後走1分鐘）',
		intro: '「捷絲旅台北三重館」擁有絕佳的地理位置，捷運三和國中站就在門口，交通四通八達；商務住宿或是旅遊休憩均十分方便。全新的輕工業風建築，透過手工烘培的咖啡與台灣原片茶，傳達給每一位旅人在舒適的客房休息之餘，還有溫潤貼心的服務與感受。'
	},
	hotelHushan: {
		name: '台南虎山館',
		title: '',
		contactUs: '客服信箱',
		address: '台南市仁德區文華路二段300號',
		intro: '「捷絲旅台南虎山館」緊鄰十鼓仁糖文創園區、奇美博物館，讓旅人輕鬆探索文藝景點享盡地利之便。鄰近高鐵站、機場、高速公路等交通要點，是商務活動及親子度假的飯店首選。'
	},
	hotelOsakaShinsaibashi: {
		name: '大阪心齋橋館',
		title: '',
		contactUs: '客服信箱',
		address: '542-0081大阪市中央區南船場二丁目9-15',
		intro: '「捷絲旅大阪心齋橋館」是捷絲旅品牌進軍日本的首家據點，飯店位置緊鄰熱鬧繁華的心齋橋商圈，商圈內美食店舖林立，房客步行即可沉浸式的體驗在地潮流文化與熱情好客的風土民情。\n飯店對外交通四通八達，心齋橋站、本町站、堺筋本町及長堀橋站等四大地鐵車站近在咫尺，出行時便利性十足，絕對是旅人規劃大阪自由行時的住宿首選。',
		tel: 'Tel : +81-06-6251-3666',
		fax: 'Fax : +81-06-6251-3889'
	}
};

/* eslint-enable */

/***/ }),
/* 645 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 646 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = configureStore;

var _redux = __webpack_require__(103);

var _reduxPromiseMiddleware = __webpack_require__(234);

var _reduxPromiseMiddleware2 = _interopRequireDefault(_reduxPromiseMiddleware);

var _reduxThunkFsa = __webpack_require__(235);

var _reduxThunkFsa2 = _interopRequireDefault(_reduxThunkFsa);

var _reactRouter = __webpack_require__(36);

var _reactRouterRedux = __webpack_require__(51);

var _reducers = __webpack_require__(660);

var _reducers2 = _interopRequireDefault(_reducers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import { createEpicMiddleware } from 'redux-observable';
// import { rootEpic } from 'actions/epics';

// const epicMiddleware = createEpicMiddleware(rootEpic);

var reduxRouterMiddleware = (0, _reactRouterRedux.routerMiddleware)(_reactRouter.browserHistory);

var middlewares = [reduxRouterMiddleware, _reduxThunkFsa2.default, (0, _reduxPromiseMiddleware2.default)()];
var composeEnhancers = _redux.compose;

if (false) {
	composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || _redux.compose;
}

function configureStore(preState) {
	var store = (0, _redux.createStore)(_reducers2.default, preState, composeEnhancers(_redux.applyMiddleware.apply(undefined, middlewares)));

	if (false) {
		module.hot.accept('../reducers', function () {
			var nextReducers = require('../reducers').default; // eslint-disable-line global-require
			store.replaceReducer(nextReducers);
		});
	}

	return store;
}

/***/ }),
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _redux = __webpack_require__(103);

var _reactRouterRedux = __webpack_require__(51);

var _global = __webpack_require__(661);

var _global2 = _interopRequireDefault(_global);

var _hotel = __webpack_require__(662);

var _hotel2 = _interopRequireDefault(_hotel);

var _justExplore = __webpack_require__(663);

var _justExplore2 = _interopRequireDefault(_justExplore);

var _location = __webpack_require__(664);

var _location2 = _interopRequireDefault(_location);

var _facility = __webpack_require__(665);

var _facility2 = _interopRequireDefault(_facility);

var _activity = __webpack_require__(666);

var _activity2 = _interopRequireDefault(_activity);

var _restaurant = __webpack_require__(667);

var _restaurant2 = _interopRequireDefault(_restaurant);

var _news = __webpack_require__(668);

var _news2 = _interopRequireDefault(_news);

var _accommodation = __webpack_require__(669);

var _accommodation2 = _interopRequireDefault(_accommodation);

var _banner = __webpack_require__(670);

var _banner2 = _interopRequireDefault(_banner);

var _attraction = __webpack_require__(671);

var _attraction2 = _interopRequireDefault(_attraction);

var _popup = __webpack_require__(672);

var _popup2 = _interopRequireDefault(_popup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reducers = (0, _redux.combineReducers)({
	routing: _reactRouterRedux.routerReducer,
	global: _global2.default,
	hotel: _hotel2.default,
	justExplore: _justExplore2.default,
	location: _location2.default,
	facility: _facility2.default,
	activity: _activity2.default,
	restaurant: _restaurant2.default,
	news: _news2.default,
	accommodation: _accommodation2.default,
	banner: _banner2.default,
	attraction: _attraction2.default,
	popup: _popup2.default
});

exports.default = reducers;

/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(6);

var _i18n = __webpack_require__(22);

exports.default = (0, _reduxActions.handleActions)({
	CHANGE_LANGUAGE: function CHANGE_LANGUAGE(state, action) {
		return _extends({}, state, {
			lan: action.payload.lan
		});
	},

	MATCH_MEDIA: function MATCH_MEDIA(state, action) {
		return _extends({}, state, {
			window: _extends({}, state.window, {
				media: action.payload.media
			})
		});
	},

	SCROLL_WINDOW: function SCROLL_WINDOW(state, action) {
		return _extends({}, state, {
			window: _extends({}, state.window, {
				pageYOffset: action.payload.pageYOffset
			})
		});
	},

	STORE_PAGE: function STORE_PAGE(state, action) {
		return _extends({}, state, {
			page: action.payload.page
		});
	},

	GET_COOKIES: function GET_COOKIES(state, action) {
		return _extends({}, state, {
			cookies: action.payload.cookies
		});
	},

	ACCEPT_COOKIES: function ACCEPT_COOKIES(state, action) {
		return _extends({}, state, {
			cookies: _extends({}, state.cookies, action.payload.cookies)
		});
	}
}, {
	lan: 'zh-TW',
	lanList: _i18n.lanList.filter(function (lan) {
		return _i18n.lanData[lan];
	}),
	lanData: _i18n.lanData,
	window: {
		media: '',
		pageYOffset: 0
	},
	page: 'main',
	cookies: {}
});

/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(6);

var _hotel = __webpack_require__(157);

exports.default = (0, _reduxActions.handleActions)({
	CHANGE_HOTEL: function CHANGE_HOTEL(state, action) {
		return _extends({}, state, {
			hotel: action.payload.hotel
		});
	},

	FETCH_HOTEL_LIST_FULFILLED: function FETCH_HOTEL_LIST_FULFILLED(state, action) {
		return _extends({}, state, {
			hotelList: action.payload.hotelList
		});
	},

	GET_ALL_HOTEL_DATA_FULFILLED: function GET_ALL_HOTEL_DATA_FULFILLED(state, action) {
		return _extends({}, state, {
			hotelData: action.payload.hotelData
		});
	},
	GET_HOTEL_META_FULFILLED: function GET_HOTEL_META_FULFILLED(state, action) {
		return _extends({}, state, {
			hotelMeta: action.payload.data
		});
	},
	GET_MAIN_PAGE_META_FULFILLED: function GET_MAIN_PAGE_META_FULFILLED(state, action) {
		return _extends({}, state, {
			mainPageMeta: action.payload.data
		});
	}
}, {
	hotel: 'main',
	hotelList: _hotel.defaultHotelList,
	hotelData: _hotel.defaultHotelData,
	hotelMeta: _hotel.defaultHotelMeta
});

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(6);

exports.default = (0, _reduxActions.handleActions)({
	GHANGE_ACTIVE_HOTEL: function GHANGE_ACTIVE_HOTEL(state, action) {
		return _extends({}, state, {
			activeId: action.payload.activeId === state.activeId ? -1 : action.payload.activeId
		});
	}
}, {
	activeId: -1
});

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(6);

exports.default = (0, _reduxActions.handleActions)({
	FETCH_LOCATION_DATA_FULFILLED: function FETCH_LOCATION_DATA_FULFILLED(state, action) {
		return _extends({}, state, action.payload);
	}
}, {
	intro: '',
	train: '',
	bus: '',
	drive: '',
	park: '',
	hotel: '',
	airplane: ''
});

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(6);

exports.default = (0, _reduxActions.handleActions)({
	FETCH_FACILITIES_FULFILLED: function FETCH_FACILITIES_FULFILLED(state, action) {
		return _extends({}, state, {
			facilityList: action.payload.facilityList,
			facilityData: action.payload.facilityData
		});
	}
}, {
	facilityList: [],
	facilityData: {}
});

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(6);

exports.default = (0, _reduxActions.handleActions)({
	FETCH_ACTIVITIES_FULFILLED: function FETCH_ACTIVITIES_FULFILLED(state, action) {
		return _extends({}, state, {
			activities: action.payload.activities
		});
	}
}, {
	activities: []
});

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(6);

exports.default = (0, _reduxActions.handleActions)({
	FETCH_RESTAURANT_DATA_FULFILLED: function FETCH_RESTAURANT_DATA_FULFILLED(state, action) {
		return _extends({}, state, {
			data: action.payload.data
		});
	}
}, {
	data: []
});

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(6);

var _lodash = __webpack_require__(85);

var defaultCategoryData = {
	'-100': {
		id: -1,
		date: '2018-07-20 00:00:00',
		title: '',
		content: '',
		intro: '',
		image: '',
		tags: []
	}
};

var defaultNews = {
	id: -1,
	title: 'test',
	subtitle: 'test',
	content: '',
	date: '2018-07-20 00:00:00',
	bannerImage: '',
	tag: '住房優惠'
};

exports.default = (0, _reduxActions.handleActions)({
	FETCH_HOTEL_NEWS_CATEGORY_FULFILLED: function FETCH_HOTEL_NEWS_CATEGORY_FULFILLED(state, action) {
		return _extends({}, state, {
			categoryList: action.payload.categoryList,
			categoryData: action.payload.categoryData
		});
	},

	FETCH_HOTEL_NEWS_LIST_FULFILLED: function FETCH_HOTEL_NEWS_LIST_FULFILLED(state, action) {
		return _extends({}, state, {
			newsList: action.payload.newsList,
			totalPage: action.payload.totalPage,
			currentPage: action.payload.currentPage
		});
	},

	FETCH_MORE_HOTEL_NEWS_LIST_FULFILLED: function FETCH_MORE_HOTEL_NEWS_LIST_FULFILLED(state, action) {
		return _extends({}, state, {
			newsList: action.payload.newsList,
			totalPage: action.payload.totalPage,
			currentPage: action.payload.currentPage
		});
	},

	FETCH_HOME_NEWS_LIST_FULFILLED: function FETCH_HOME_NEWS_LIST_FULFILLED(state, action) {
		return _extends({}, state, {
			newsList: action.payload.newsList,
			totalPage: action.payload.totalPage,
			currentPage: action.payload.currentPage
		});
	},

	FETCH_MORE_HOME_NEWS_LIST_FULFILLED: function FETCH_MORE_HOME_NEWS_LIST_FULFILLED(state, action) {
		return _extends({}, state, {
			newsList: action.payload.newsList,
			totalPage: action.payload.totalPage,
			currentPage: action.payload.currentPage
		});
	},

	FETCH_HOTEL_NEWS_FULFILLED: function FETCH_HOTEL_NEWS_FULFILLED(state, action) {
		return _extends({}, state, {
			news: action.payload.news
		});
	},

	FETCH_HOME_NEWS_FULFILLED: function FETCH_HOME_NEWS_FULFILLED(state, action) {
		if ((0, _lodash.isNil)((0, _lodash.get)(action, 'payload', null))) {
			return _extends({}, state);
		}

		return _extends({}, state, {
			news: action.payload.news
		});
	}
}, {
	categoryList: [],
	categoryData: defaultCategoryData,
	newsList: [],
	news: defaultNews,
	totalPage: 0,
	currentPage: 0
});

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(6);

exports.default = (0, _reduxActions.handleActions)({
	FETCH_ACCOMMODATION_DATA_FULFILLED: function FETCH_ACCOMMODATION_DATA_FULFILLED(state, action) {
		return _extends({}, state, {
			checkInTime: action.payload.checkInTime,
			checkOutTime: action.payload.checkOutTime,
			features: action.payload.features,
			categoryList: action.payload.categoryList,
			categoryData: action.payload.categoryData,
			roomList: action.payload.roomList,
			roomData: action.payload.roomData
		});
	}
}, {
	checkInTime: {
		ampm: 'pm',
		time: '3:00'
	},
	checkOutTime: {
		ampm: 'pm',
		time: '3:00'
	},
	features: [],
	categoryList: [],
	categoryData: {},
	roomList: [],
	roomData: {}
});

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(6);

exports.default = (0, _reduxActions.handleActions)({
	FETCH_BANNER_FULFILLED: function FETCH_BANNER_FULFILLED(state, action) {
		return _extends({}, state, {
			image: action.payload.image,
			thumbnail: action.payload.thumbnail
		});
	}
}, {
	image: '',
	thumbnail: ''
});

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(6);

exports.default = (0, _reduxActions.handleActions)({
	FETCH_ATTRACTIONS_PENDING: function FETCH_ATTRACTIONS_PENDING(state) {
		return _extends({}, state, {
			loading: _extends({}, state.loading, {
				attraction: true
			})
		});
	},

	FETCH_ATTRACTIONS_FULFILLED: function FETCH_ATTRACTIONS_FULFILLED(state, action) {
		return _extends({}, state, {
			attractionList: action.payload.attractionList,
			attractionData: action.payload.attractionData,
			loading: _extends({}, state.loading, {
				attraction: false
			})
		});
	},

	FETCH_EACH_HOTEL_ATTRACTIONS_PENDING: function FETCH_EACH_HOTEL_ATTRACTIONS_PENDING(state) {
		return _extends({}, state, state, {
			loading: _extends({}, state.loading, {
				allHotelAttraction: true
			})
		});
	},

	FETCH_EACH_HOTEL_ATTRACTIONS_FULFILLED: function FETCH_EACH_HOTEL_ATTRACTIONS_FULFILLED(state, action) {
		return _extends({}, state, {
			hotelAttraction: action.payload.hotelAttraction,
			loading: _extends({}, state.loading, {
				attraction: true
			})
		});
	}
}, {
	attractionList: [],
	attractionData: {},
	hotelAttraction: {},
	loading: {
		attraction: false,
		allHotelAttraction: false
	}
});

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(6);

exports.default = (0, _reduxActions.handleActions)({
	FETCH_POPUPS_PENDING: function FETCH_POPUPS_PENDING(state) {
		return _extends({}, state, {
			loading: _extends({}, state.loading, {
				popups: true
			})
		});
	},
	FETCH_POPUPS_FULFILLED: function FETCH_POPUPS_FULFILLED(state, action) {
		return _extends({}, state, {
			popups: action.payload.popups,
			loading: _extends({}, state.loading, {
				popups: false
			})
		});
	},
	FETCH_POPUP_INDEX_PENDING: function FETCH_POPUP_INDEX_PENDING(state) {
		return _extends({}, state, {
			loading: _extends({}, state.loading, {
				popupIndex: true
			})
		});
	},
	FETCH_POPUP_INDEX_FULFILLED: function FETCH_POPUP_INDEX_FULFILLED(state, action) {
		return _extends({}, state, {
			popupIndex: action.payload.popupIndex,
			loading: _extends({}, state.loading, {
				popupIndex: false
			})
		});
	},
	CLOSE_POPUP: function CLOSE_POPUP(state) {
		return _extends({}, state, {
			active: false
		});
	}
}, {
	active: true,
	popups: [],
	popupIndex: [],
	loading: {
		popups: false,
		popupIndex: false
	}
});

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(17);

var _reactRouter = __webpack_require__(36);

var _global = __webpack_require__(151);

var _hotel = __webpack_require__(15);

var _news = __webpack_require__(52);

var _attraction = __webpack_require__(104);

var _popup = __webpack_require__(38);

var _event = __webpack_require__(230);

var _i18n = __webpack_require__(22);

var _analytics = __webpack_require__(694);

var _container = __webpack_require__(706);

var _container2 = _interopRequireDefault(_container);

var _Main = __webpack_require__(756);

var _Main2 = _interopRequireDefault(_Main);

var _Hotel = __webpack_require__(757);

var _Hotel2 = _interopRequireDefault(_Hotel);

var _News = __webpack_require__(769);

var _News2 = _interopRequireDefault(_News);

var _Privacy = __webpack_require__(771);

var _Privacy2 = _interopRequireDefault(_Privacy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createRoutes = function createRoutes(store) {
	var scroll = (0, _event.createScroller)(store);

	return {
		path: '/',
		component: _container2.default,
		onEnter: function onEnter(_ref) {
			var _ref$location = _ref.location,
			    pathname = _ref$location.pathname,
			    search = _ref$location.search;

			scroll.addListener();
			(0, _analytics.initGA)();
			(0, _analytics.sendPageView)(pathname + search);
			store.dispatch((0, _hotel.getAllHotelData)());
			store.dispatch((0, _global.getCookies)());
		},
		onChange: function onChange(pre, _ref2) {
			var _ref2$location = _ref2.location,
			    pathname = _ref2$location.pathname,
			    search = _ref2$location.search;

			(0, _analytics.sendPageView)(pathname + search);
		},
		onLeave: function onLeave() {
			scroll.removeListener();
		},
		indexRoute: {
			getComponent: function getComponent(nextState, cb) {
				return __webpack_require__.e/* require.ensure */(0/* duplicate */).then((function (require) {
					var component = __webpack_require__(159).default;
					cb(null, component);
				}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
			},
			onEnter: function onEnter() {
				var _store$getState = store.getState(),
				    lan = _store$getState.global.lan,
				    hotel = _store$getState.hotel.hotel;

				if (hotel !== 'main') {
					store.dispatch((0, _hotel.changeHotel)('main'));
				}

				store.dispatch((0, _news.getHomeNewsList)((0, _i18n.lanMapRoute)(lan), {}));
				store.dispatch((0, _popup.getPopupIndex)((0, _i18n.lanMapRoute)(lan), {}));
				store.dispatch((0, _attraction.getEachHotelAttractions)((0, _i18n.lanMapRoute)(lan)));
				store.dispatch((0, _hotel.getMainPageMeta)('tw'));
			}
		},
		childRoutes: [(0, _Main2.default)(store), (0, _News2.default)(store), (0, _Privacy2.default)(store), (0, _Hotel2.default)(store)]
	};
};

var Routes = function Routes(_ref3) {
	var store = _ref3.store,
	    history = _ref3.history;
	return _react2.default.createElement(
		_reactRedux.Provider,
		{ store: store },
		_react2.default.createElement(_reactRouter.Router, {
			key: Math.random(),
			onUpdate: function onUpdate() {
				return window.scrollTo(0, 0);
			},
			history: history,
			routes: createRoutes(store)
		})
	);
};

exports.default = Routes;

/***/ }),
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.sendPageView = exports.initGA = undefined;

var _reactGa = __webpack_require__(695);

var _reactGa2 = _interopRequireDefault(_reactGa);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GOOGLE_ANALYTICS_ID_MAP = {
	dev: 'UA-199274286-2',
	develop: 'UA-199274286-2',
	production: 'UA-124370350-10'
};

var GOOGLE_ANALYTICS_ID = GOOGLE_ANALYTICS_ID_MAP["production"];

var initGA = exports.initGA = function initGA() {
	if (!window.GA_INITIALIZED) {
		console.log('GA init');
		_reactGa2.default.initialize(GOOGLE_ANALYTICS_ID, { debug: true });
		window.GA_INITIALIZED = true;
	};
};

var sendPageView = exports.sendPageView = function sendPageView(pathname) {
	console.log('Logging pageview for ' + pathname);
	_reactGa2.default.set({ page: pathname });
	_reactGa2.default.pageview(pathname);
};

/***/ }),
/* 695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "initialize", function() { return initialize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addTrackers", function() { return addTrackers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ga", function() { return ga; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "set", function() { return set; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "send", function() { return send; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pageview", function() { return pageview; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "modalview", function() { return modalview; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "timing", function() { return timing; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "event", function() { return event; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exception", function() { return exception; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "plugin", function() { return plugin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "outboundLink", function() { return outboundLink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "testModeAPI", function() { return testModeAPI; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OutboundLink", function() { return OutboundLink; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_OutboundLink__ = __webpack_require__(696);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core__ = __webpack_require__(697);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var initialize = __WEBPACK_IMPORTED_MODULE_1__core__["initialize"];

var addTrackers = __WEBPACK_IMPORTED_MODULE_1__core__["addTrackers"];

var ga = __WEBPACK_IMPORTED_MODULE_1__core__["ga"];

var set = __WEBPACK_IMPORTED_MODULE_1__core__["set"];

var send = __WEBPACK_IMPORTED_MODULE_1__core__["send"];

var pageview = __WEBPACK_IMPORTED_MODULE_1__core__["pageview"];

var modalview = __WEBPACK_IMPORTED_MODULE_1__core__["modalview"];

var timing = __WEBPACK_IMPORTED_MODULE_1__core__["timing"];

var event = __WEBPACK_IMPORTED_MODULE_1__core__["event"];

var exception = __WEBPACK_IMPORTED_MODULE_1__core__["exception"];

var plugin = __WEBPACK_IMPORTED_MODULE_1__core__["plugin"];

var outboundLink = __WEBPACK_IMPORTED_MODULE_1__core__["outboundLink"];

var testModeAPI = __WEBPACK_IMPORTED_MODULE_1__core__["testModeAPI"];

__WEBPACK_IMPORTED_MODULE_0__components_OutboundLink__["a" /* default */].origTrackLink = __WEBPACK_IMPORTED_MODULE_0__components_OutboundLink__["a" /* default */].trackLink;
__WEBPACK_IMPORTED_MODULE_0__components_OutboundLink__["a" /* default */].trackLink = __WEBPACK_IMPORTED_MODULE_1__core__["outboundLink"];
var OutboundLink = __WEBPACK_IMPORTED_MODULE_0__components_OutboundLink__["a" /* default */];
/* harmony default export */ __webpack_exports__["default"] = (_objectSpread(_objectSpread({}, __WEBPACK_IMPORTED_MODULE_1__core__), {}, {
  OutboundLink: OutboundLink
}));

/***/ }),
/* 696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OutboundLink; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_console_warn__ = __webpack_require__(153);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var NEWTAB = '_blank';
var MIDDLECLICK = 1;

var OutboundLink = /*#__PURE__*/function (_Component) {
  _inherits(OutboundLink, _Component);

  var _super = _createSuper(OutboundLink);

  function OutboundLink() {
    var _this;

    _classCallCheck(this, OutboundLink);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleClick", function (event) {
      var _this$props = _this.props,
          target = _this$props.target,
          eventLabel = _this$props.eventLabel,
          to = _this$props.to,
          onClick = _this$props.onClick,
          trackerNames = _this$props.trackerNames;
      var eventMeta = {
        label: eventLabel
      };
      var sameTarget = target !== NEWTAB;
      var normalClick = !(event.ctrlKey || event.shiftKey || event.metaKey || event.button === MIDDLECLICK);

      if (sameTarget && normalClick) {
        event.preventDefault();
        OutboundLink.trackLink(eventMeta, function () {
          window.location.href = to;
        }, trackerNames);
      } else {
        OutboundLink.trackLink(eventMeta, function () {}, trackerNames);
      }

      if (onClick) {
        onClick(event);
      }
    });

    return _this;
  }

  _createClass(OutboundLink, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          href = _this$props2.to,
          target = _this$props2.target,
          oldProps = _objectWithoutProperties(_this$props2, ["to", "target"]);

      var props = _objectSpread(_objectSpread({}, oldProps), {}, {
        target: target,
        href: href,
        onClick: this.handleClick
      });

      if (target === NEWTAB) {
        props.rel = "".concat(props.rel ? props.rel : '', " noopener noreferrer").trim();
      }

      delete props.eventLabel;
      delete props.trackerNames;
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', props);
    }
  }]);

  return OutboundLink;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(OutboundLink, "trackLink", function () {
  Object(__WEBPACK_IMPORTED_MODULE_2__utils_console_warn__["a" /* default */])('ga tracking not enabled');
});


OutboundLink.propTypes = {
  eventLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  trackerNames: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string)
};
OutboundLink.defaultProps = {
  target: null,
  to: null,
  onClick: null,
  trackerNames: null
};

/***/ }),
/* 697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["addTrackers"] = addTrackers;
/* harmony export (immutable) */ __webpack_exports__["initialize"] = initialize;
/* harmony export (immutable) */ __webpack_exports__["ga"] = ga;
/* harmony export (immutable) */ __webpack_exports__["set"] = set;
/* harmony export (immutable) */ __webpack_exports__["send"] = send;
/* harmony export (immutable) */ __webpack_exports__["pageview"] = pageview;
/* harmony export (immutable) */ __webpack_exports__["modalview"] = modalview;
/* harmony export (immutable) */ __webpack_exports__["timing"] = timing;
/* harmony export (immutable) */ __webpack_exports__["event"] = event;
/* harmony export (immutable) */ __webpack_exports__["exception"] = exception;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "plugin", function() { return plugin; });
/* harmony export (immutable) */ __webpack_exports__["outboundLink"] = outboundLink;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "testModeAPI", function() { return testModeAPI; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_format__ = __webpack_require__(698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_removeLeadingSlash__ = __webpack_require__(702);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_trim__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_loadGA__ = __webpack_require__(703);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_console_warn__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_console_log__ = __webpack_require__(704);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_testModeAPI__ = __webpack_require__(705);
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * React Google Analytics Module
 *
 * @package react-ga
 * @author  Adam Lofting <adam@mozillafoundation.org>
 *          Atul Varma <atul@mozillafoundation.org>
 */

/**
 * Utilities
 */








var _isNotBrowser = typeof window === 'undefined' || typeof document === 'undefined';

var _debug = false;
var _titleCase = true;
var _testMode = false;
var _alwaysSendToDefaultTracker = true;
var _redactEmail = true;

var internalGa = function internalGa() {
  var _window;

  if (_testMode) return __WEBPACK_IMPORTED_MODULE_6__utils_testModeAPI__["a" /* default */].ga.apply(__WEBPACK_IMPORTED_MODULE_6__utils_testModeAPI__["a" /* default */], arguments);
  if (_isNotBrowser) return false;
  if (!window.ga) return Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('ReactGA.initialize must be called first or GoogleAnalytics should be loaded manually');
  return (_window = window).ga.apply(_window, arguments);
};

function _format(s) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_format__["a" /* default */])(s, _titleCase, _redactEmail);
}

function _gaCommand(trackerNames) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  var command = args[0];

  if (typeof internalGa === 'function') {
    if (typeof command !== 'string') {
      Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('ga command must be a string');
      return;
    }

    if (_alwaysSendToDefaultTracker || !Array.isArray(trackerNames)) internalGa.apply(void 0, args);

    if (Array.isArray(trackerNames)) {
      trackerNames.forEach(function (name) {
        internalGa.apply(void 0, _toConsumableArray(["".concat(name, ".").concat(command)].concat(args.slice(1))));
      });
    }
  }
}

function _initialize(gaTrackingID, options) {
  if (!gaTrackingID) {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('gaTrackingID is required in initialize()');
    return;
  }

  if (options) {
    if (options.debug && options.debug === true) {
      _debug = true;
    }

    if (options.titleCase === false) {
      _titleCase = false;
    }

    if (options.redactEmail === false) {
      _redactEmail = false;
    }

    if (options.useExistingGa) {
      return;
    }
  }

  if (options && options.gaOptions) {
    internalGa('create', gaTrackingID, options.gaOptions);
  } else {
    internalGa('create', gaTrackingID, 'auto');
  }
}

function addTrackers(configsOrTrackingId, options) {
  if (Array.isArray(configsOrTrackingId)) {
    configsOrTrackingId.forEach(function (config) {
      if (_typeof(config) !== 'object') {
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('All configs must be an object');
        return;
      }

      _initialize(config.trackingId, config);
    });
  } else {
    _initialize(configsOrTrackingId, options);
  }

  return true;
}
function initialize(configsOrTrackingId, options) {
  if (options && options.testMode === true) {
    _testMode = true;
  } else {
    if (_isNotBrowser) {
      return;
    }

    if (!options || options.standardImplementation !== true) Object(__WEBPACK_IMPORTED_MODULE_3__utils_loadGA__["a" /* default */])(options);
  }

  _alwaysSendToDefaultTracker = options && typeof options.alwaysSendToDefaultTracker === 'boolean' ? options.alwaysSendToDefaultTracker : true;
  addTrackers(configsOrTrackingId, options);
}
/**
 * ga:
 * Returns the original GA object.
 */

function ga() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  if (args.length > 0) {
    internalGa.apply(void 0, args);

    if (_debug) {
      Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("called ga('arguments');");
      Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("with arguments: ".concat(JSON.stringify(args)));
    }
  }

  return window.ga;
}
/**
 * set:
 * GA tracker set method
 * @param {Object} fieldsObject - a field/value pair or a group of field/value pairs on the tracker
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function set(fieldsObject, trackerNames) {
  if (!fieldsObject) {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('`fieldsObject` is required in .set()');
    return;
  }

  if (_typeof(fieldsObject) !== 'object') {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('Expected `fieldsObject` arg to be an Object');
    return;
  }

  if (Object.keys(fieldsObject).length === 0) {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('empty `fieldsObject` given to .set()');
  }

  _gaCommand(trackerNames, 'set', fieldsObject);

  if (_debug) {
    Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("called ga('set', fieldsObject);");
    Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("with fieldsObject: ".concat(JSON.stringify(fieldsObject)));
  }
}
/**
 * send:
 * Clone of the low level `ga.send` method
 * WARNING: No validations will be applied to this
 * @param  {Object} fieldObject - field object for tracking different analytics
 * @param  {Array} trackerNames - trackers to send the command to
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function send(fieldObject, trackerNames) {
  _gaCommand(trackerNames, 'send', fieldObject);

  if (_debug) {
    Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("called ga('send', fieldObject);");
    Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("with fieldObject: ".concat(JSON.stringify(fieldObject)));
    Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("with trackers: ".concat(JSON.stringify(trackerNames)));
  }
}
/**
 * pageview:
 * Basic GA pageview tracking
 * @param  {String} path - the current page page e.g. '/about'
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 * @param {String} title - (optional) the page title e. g. 'My Website'
 */

function pageview(rawPath, trackerNames, title) {
  if (!rawPath) {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('path is required in .pageview()');
    return;
  }

  var path = Object(__WEBPACK_IMPORTED_MODULE_2__utils_trim__["a" /* default */])(rawPath);

  if (path === '') {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('path cannot be an empty string in .pageview()');
    return;
  }

  var extraFields = {};

  if (title) {
    extraFields.title = title;
  }

  if (typeof ga === 'function') {
    _gaCommand(trackerNames, 'send', _objectSpread({
      hitType: 'pageview',
      page: path
    }, extraFields));

    if (_debug) {
      Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("called ga('send', 'pageview', path);");
      var extraLog = '';

      if (title) {
        extraLog = " and title: ".concat(title);
      }

      Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("with path: ".concat(path).concat(extraLog));
    }
  }
}
/**
 * modalview:
 * a proxy to basic GA pageview tracking to consistently track
 * modal views that are an equivalent UX to a traditional pageview
 * @param  {String} modalName e.g. 'add-or-edit-club'
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function modalview(rawModalName, trackerNames) {
  if (!rawModalName) {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('modalName is required in .modalview(modalName)');
    return;
  }

  var modalName = Object(__WEBPACK_IMPORTED_MODULE_1__utils_removeLeadingSlash__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__utils_trim__["a" /* default */])(rawModalName));

  if (modalName === '') {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('modalName cannot be an empty string or a single / in .modalview()');
    return;
  }

  if (typeof ga === 'function') {
    var path = "/modal/".concat(modalName);

    _gaCommand(trackerNames, 'send', 'pageview', path);

    if (_debug) {
      Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("called ga('send', 'pageview', path);");
      Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("with path: ".concat(path));
    }
  }
}
/**
 * timing:
 * GA timing
 * @param args.category {String} required
 * @param args.variable {String} required
 * @param args.value  {Int}  required
 * @param args.label  {String} required
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function timing() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      category = _ref.category,
      variable = _ref.variable,
      value = _ref.value,
      label = _ref.label;

  var trackerNames = arguments.length > 1 ? arguments[1] : undefined;

  if (typeof ga === 'function') {
    if (!category || !variable || typeof value !== 'number') {
      Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('args.category, args.variable ' + 'AND args.value are required in timing() ' + 'AND args.value has to be a number');
      return;
    } // Required Fields


    var fieldObject = {
      hitType: 'timing',
      timingCategory: _format(category),
      timingVar: _format(variable),
      timingValue: value
    };

    if (label) {
      fieldObject.timingLabel = _format(label);
    }

    send(fieldObject, trackerNames);
  }
}
/**
 * event:
 * GA event tracking
 * @param args.category {String} required
 * @param args.action {String} required
 * @param args.label {String} optional
 * @param args.value {Int} optional
 * @param args.nonInteraction {boolean} optional
 * @param args.transport {string} optional
 * @param {{action: string, category: string}} trackerNames - (optional) a list of extra trackers to run the command on
 */

function event() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      category = _ref2.category,
      action = _ref2.action,
      label = _ref2.label,
      value = _ref2.value,
      nonInteraction = _ref2.nonInteraction,
      transport = _ref2.transport,
      args = _objectWithoutProperties(_ref2, ["category", "action", "label", "value", "nonInteraction", "transport"]);

  var trackerNames = arguments.length > 1 ? arguments[1] : undefined;

  if (typeof ga === 'function') {
    // Simple Validation
    if (!category || !action) {
      Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('args.category AND args.action are required in event()');
      return;
    } // Required Fields


    var fieldObject = {
      hitType: 'event',
      eventCategory: _format(category),
      eventAction: _format(action)
    }; // Optional Fields

    if (label) {
      fieldObject.eventLabel = _format(label);
    }

    if (typeof value !== 'undefined') {
      if (typeof value !== 'number') {
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('Expected `args.value` arg to be a Number.');
      } else {
        fieldObject.eventValue = value;
      }
    }

    if (typeof nonInteraction !== 'undefined') {
      if (typeof nonInteraction !== 'boolean') {
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('`args.nonInteraction` must be a boolean.');
      } else {
        fieldObject.nonInteraction = nonInteraction;
      }
    }

    if (typeof transport !== 'undefined') {
      if (typeof transport !== 'string') {
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('`args.transport` must be a string.');
      } else {
        if (['beacon', 'xhr', 'image'].indexOf(transport) === -1) {
          Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('`args.transport` must be either one of these values: `beacon`, `xhr` or `image`');
        }

        fieldObject.transport = transport;
      }
    }

    Object.keys(args).filter(function (key) {
      return key.substr(0, 'dimension'.length) === 'dimension';
    }).forEach(function (key) {
      fieldObject[key] = args[key];
    });
    Object.keys(args).filter(function (key) {
      return key.substr(0, 'metric'.length) === 'metric';
    }).forEach(function (key) {
      fieldObject[key] = args[key];
    }); // Send to GA

    send(fieldObject, trackerNames);
  }
}
/**
 * exception:
 * GA exception tracking
 * @param args.description {String} optional
 * @param args.fatal {boolean} optional
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function exception(_ref3, trackerNames) {
  var description = _ref3.description,
      fatal = _ref3.fatal;

  if (typeof ga === 'function') {
    // Required Fields
    var fieldObject = {
      hitType: 'exception'
    }; // Optional Fields

    if (description) {
      fieldObject.exDescription = _format(description);
    }

    if (typeof fatal !== 'undefined') {
      if (typeof fatal !== 'boolean') {
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('`args.fatal` must be a boolean.');
      } else {
        fieldObject.exFatal = fatal;
      }
    } // Send to GA


    send(fieldObject, trackerNames);
  }
}
var plugin = {
  /**
   * require:
   * GA requires a plugin
   * @param name {String} e.g. 'ecommerce' or 'myplugin'
   * @param options {Object} optional e.g {path: '/log', debug: true}
   * @param trackerName {String} optional e.g 'trackerName'
   */
  require: function require(rawName, options, trackerName) {
    if (typeof ga === 'function') {
      // Required Fields
      if (!rawName) {
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('`name` is required in .require()');
        return;
      }

      var name = Object(__WEBPACK_IMPORTED_MODULE_2__utils_trim__["a" /* default */])(rawName);

      if (name === '') {
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('`name` cannot be an empty string in .require()');
        return;
      }

      var requireString = trackerName ? "".concat(trackerName, ".require") : 'require'; // Optional Fields

      if (options) {
        if (_typeof(options) !== 'object') {
          Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('Expected `options` arg to be an Object');
          return;
        }

        if (Object.keys(options).length === 0) {
          Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('Empty `options` given to .require()');
        }

        ga(requireString, name, options);

        if (_debug) {
          Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("called ga('require', '".concat(name, "', ").concat(JSON.stringify(options)));
        }
      } else {
        ga(requireString, name);

        if (_debug) {
          Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("called ga('require', '".concat(name, "');"));
        }
      }
    }
  },

  /**
   * execute:
   * GA execute action for plugin
   * Takes variable number of arguments
   * @param pluginName {String} e.g. 'ecommerce' or 'myplugin'
   * @param action {String} e.g. 'addItem' or 'myCustomAction'
   * @param actionType {String} optional e.g. 'detail'
   * @param payload {Object} optional e.g { id: '1x5e', name : 'My product to track' }
   */
  execute: function execute(pluginName, action) {
    var payload;
    var actionType;

    for (var _len3 = arguments.length, args = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
      args[_key3 - 2] = arguments[_key3];
    }

    if (args.length === 1) {
      payload = args[0];
    } else {
      actionType = args[0];
      payload = args[1];
    }

    if (typeof ga === 'function') {
      if (typeof pluginName !== 'string') {
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('Expected `pluginName` arg to be a String.');
      } else if (typeof action !== 'string') {
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('Expected `action` arg to be a String.');
      } else {
        var command = "".concat(pluginName, ":").concat(action);
        payload = payload || null;

        if (actionType && payload) {
          ga(command, actionType, payload);

          if (_debug) {
            Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("called ga('".concat(command, "');"));
            Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("actionType: \"".concat(actionType, "\" with payload: ").concat(JSON.stringify(payload)));
          }
        } else if (payload) {
          ga(command, payload);

          if (_debug) {
            Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("called ga('".concat(command, "');"));
            Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("with payload: ".concat(JSON.stringify(payload)));
          }
        } else {
          ga(command);

          if (_debug) {
            Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("called ga('".concat(command, "');"));
          }
        }
      }
    }
  }
};
/**
 * outboundLink:
 * GA outboundLink tracking
 * @param args.label {String} e.g. url, or 'Create an Account'
 * @param {function} hitCallback - Called after processing a hit.
 */

function outboundLink(args, hitCallback, trackerNames) {
  if (typeof hitCallback !== 'function') {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('hitCallback function is required');
    return;
  }

  if (typeof ga === 'function') {
    // Simple Validation
    if (!args || !args.label) {
      Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('args.label is required in outboundLink()');
      return;
    } // Required Fields


    var fieldObject = {
      hitType: 'event',
      eventCategory: 'Outbound',
      eventAction: 'Click',
      eventLabel: _format(args.label)
    };
    var safetyCallbackCalled = false;

    var safetyCallback = function safetyCallback() {
      // This prevents a delayed response from GA
      // causing hitCallback from being fired twice
      safetyCallbackCalled = true;
      hitCallback();
    }; // Using a timeout to ensure the execution of critical application code
    // in the case when the GA server might be down
    // or an ad blocker prevents sending the data
    // register safety net timeout:


    var t = setTimeout(safetyCallback, 250);

    var clearableCallbackForGA = function clearableCallbackForGA() {
      clearTimeout(t);

      if (!safetyCallbackCalled) {
        hitCallback();
      }
    };

    fieldObject.hitCallback = clearableCallbackForGA; // Send to GA

    send(fieldObject, trackerNames);
  } else {
    // if ga is not defined, return the callback so the application
    // continues to work as expected
    setTimeout(hitCallback, 0);
  }
}
var testModeAPI = __WEBPACK_IMPORTED_MODULE_6__utils_testModeAPI__["a" /* default */];
/* harmony default export */ __webpack_exports__["default"] = ({
  initialize: initialize,
  ga: ga,
  set: set,
  send: send,
  pageview: pageview,
  modalview: modalview,
  timing: timing,
  event: event,
  exception: exception,
  plugin: plugin,
  outboundLink: outboundLink,
  testModeAPI: __WEBPACK_IMPORTED_MODULE_6__utils_testModeAPI__["a" /* default */]
});

/***/ }),
/* 698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = format;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__redactEmail__ = __webpack_require__(699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toTitleCase__ = __webpack_require__(701);


function format() {
  var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var titleCase = arguments.length > 1 ? arguments[1] : undefined;
  var redactingEmail = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  var _str = s || '';

  if (titleCase) {
    _str = Object(__WEBPACK_IMPORTED_MODULE_1__toTitleCase__["a" /* default */])(s);
  }

  if (redactingEmail) {
    _str = Object(__WEBPACK_IMPORTED_MODULE_0__redactEmail__["a" /* default */])(_str);
  }

  return _str;
}

/***/ }),
/* 699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = redactEmail;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__console_warn__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mightBeEmail__ = __webpack_require__(700);


var redacted = 'REDACTED (Potential Email Address)';
function redactEmail(string) {
  if (Object(__WEBPACK_IMPORTED_MODULE_1__mightBeEmail__["a" /* default */])(string)) {
    Object(__WEBPACK_IMPORTED_MODULE_0__console_warn__["a" /* default */])('This arg looks like an email address, redacting.');
    return redacted;
  }

  return string;
}

/***/ }),
/* 700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = mightBeEmail;
// See if s could be an email address. We don't want to send personal data like email.
// https://support.google.com/analytics/answer/2795983?hl=en
function mightBeEmail(s) {
  // There's no point trying to validate rfc822 fully, just look for ...@...
  return typeof s === 'string' && s.indexOf('@') !== -1;
}

/***/ }),
/* 701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = toTitleCase;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__trim__ = __webpack_require__(243);
/**
 * To Title Case 2.1 - http://individed.com/code/to-title-case/
 * Copyright 2008-2013 David Gouch. Licensed under the MIT License.
 * https://github.com/gouch/to-title-case
 */

var smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i; // test

function toTitleCase(string) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__trim__["a" /* default */])(string).replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, function (match, index, title) {
    if (index > 0 && index + match.length !== title.length && match.search(smallWords) > -1 && title.charAt(index - 2) !== ':' && (title.charAt(index + match.length) !== '-' || title.charAt(index - 1) === '-') && title.charAt(index - 1).search(/[^\s-]/) < 0) {
      return match.toLowerCase();
    }

    if (match.substr(1).search(/[A-Z]|\../) > -1) {
      return match;
    }

    return match.charAt(0).toUpperCase() + match.substr(1);
  });
}

/***/ }),
/* 702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = removeLeadingSlash;
function removeLeadingSlash(string) {
  if (string.substring(0, 1) === '/') {
    return string.substring(1);
  }

  return string;
}

/***/ }),
/* 703 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isLoaded = false;
/* harmony default export */ __webpack_exports__["a"] = (function (options) {
  if (isLoaded) return;
  isLoaded = true;
  var gaAddress = 'https://www.google-analytics.com/analytics.js';

  if (options && options.gaAddress) {
    gaAddress = options.gaAddress;
  } else if (options && options.debug) {
    gaAddress = 'https://www.google-analytics.com/analytics_debug.js';
  }

  var onerror = options && options.onerror; // https://developers.google.com/analytics/devguides/collection/analyticsjs/

  /* eslint-disable */

  (function (i, s, o, g, r, a, m) {
    i['GoogleAnalyticsObject'] = r;
    i[r] = i[r] || function () {
      (i[r].q = i[r].q || []).push(arguments);
    }, i[r].l = 1 * new Date();
    a = s.createElement(o), m = s.getElementsByTagName(o)[0];
    a.async = 1;
    a.src = g;
    a.onerror = onerror;
    m.parentNode.insertBefore(a, m);
  })(window, document, 'script', gaAddress, 'ga');
  /* eslint-enable */

});

/***/ }),
/* 704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = log;
function log(s) {
  console.info('[react-ga]', s);
}

/***/ }),
/* 705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export gaCalls */
var gaCalls = [];
/* harmony default export */ __webpack_exports__["a"] = ({
  calls: gaCalls,
  ga: function ga() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    gaCalls.push([].concat(args));
  },
  resetCalls: function resetCalls() {
    gaCalls.length = 0;
  }
});

/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reactContainerHelper = __webpack_require__(49);

var _reactRedux = __webpack_require__(17);

var _path = __webpack_require__(105);

var _component = __webpack_require__(707);

var _component2 = _interopRequireDefault(_component);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var initState = function initState() {};

var mapSetStateToProps = function mapSetStateToProps(_, _ref) {
	var props = _objectWithoutProperties(_ref, []);

	return _extends({}, props, {

		// disable hover effect on mobile device
		handleTouchStart: function handleTouchStart() {
			document.body.style.cursor = 'pointer';
		}
	});
};

var container = (0, _reactContainerHelper.contain)(initState, mapSetStateToProps)(_component2.default);

var gaPath = '';
var mapStateToProps = function mapStateToProps(_ref2) {
	var _ref2$routing$locatio = _ref2.routing.locationBeforeTransitions,
	    pathname = _ref2$routing$locatio.pathname,
	    search = _ref2$routing$locatio.search,
	    cookies = _ref2.global.cookies;

	var pathnames = (0, _path.normalizePathname)(pathname);
	var path = pathname + search;

	if ("production" === 'production' && window.ga) {
		if (path && gaPath !== path) {
			console.log('send', gaPath);
			gaPath = path;
			window.ga('set', 'page', gaPath);
			window.ga('send', 'pageview');
		}
	}

	return {
		page: pathnames[1] === '' || pathnames[1] === 'promotions' || pathnames[1] === 'main' || pathnames[1] === 'privacy' ? 'home' : pathnames[1],
		cookiesAccepted: cookies.acceptCookies === 'y'
	};
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(container);

/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _App = __webpack_require__(708);

var _App2 = _interopRequireDefault(_App);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var App = (0, _App2.default)();

exports.default = App;

/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _HeaderHome = __webpack_require__(709);

var _HeaderHome2 = _interopRequireDefault(_HeaderHome);

var _HeaderHotel = __webpack_require__(725);

var _HeaderHotel2 = _interopRequireDefault(_HeaderHotel);

var _Footer = __webpack_require__(734);

var _Footer2 = _interopRequireDefault(_Footer);

var _CookieBar = __webpack_require__(746);

var _CookieBar2 = _interopRequireDefault(_CookieBar);

var _ChatbotWidget = __webpack_require__(750);

var _ChatbotWidget2 = _interopRequireDefault(_ChatbotWidget);

var _index = __webpack_require__(256);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(755);

var _index4 = _interopRequireDefault(_index3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var App = function App(_ref) {
	var page = _ref.page,
	    children = _ref.children,
	    handleTouchStart = _ref.handleTouchStart,
	    cookiesAccepted = _ref.cookiesAccepted;

	var cookieBarRef = (0, _react.useRef)(null);

	var _useState = (0, _react.useState)(0),
	    cookieOffset = _useState[0],
	    setCookieOffset = _useState[1];

	var _useState2 = (0, _react.useState)(0),
	    popupOffset = _useState2[0],
	    setPopupOffset = _useState2[1];

	(0, _react.useEffect)(function () {
		var timer = void 0;
		if (!cookiesAccepted) {
			// CookieBar is position:fixed so wrapper div height is 0.
			// Use firstElementChild to measure the actual CookieBar height.
			// Wait for the 3s animate-in to complete before measuring.
			timer = setTimeout(function () {
				var el = cookieBarRef.current && cookieBarRef.current.firstElementChild;
				if (el) setCookieOffset(el.offsetHeight);
			}, 3200);
		} else {
			setCookieOffset(0);
		}
		return function () {
			return clearTimeout(timer);
		};
	}, [cookiesAccepted]);

	// The ad Popup is rendered deep inside page layouts (CSSTransition), so App
	// can't hold a ref to it. It mounts up to 3s before it fades into view and
	// unmounts several seconds after it fades out, so watching mount/unmount lags
	// the visual by seconds. Sync to the fade animation instead: the offset changes
	// exactly when the ad's fade-in/fade-out starts, and the widget's own 1s ease-in
	// transition (see ChatbotWidget/index.css) makes it rise/sink in step with the ad.
	(0, _react.useEffect)(function () {
		var isPopup = function isPopup(el) {
			return el && el.classList && el.classList.contains(_index2.default.popup);
		};
		var handleStart = function handleStart(e) {
			if (!isPopup(e.target)) return;
			// popup-exit-active is the leaving state (ad fading out); otherwise it's appearing.
			if (e.target.classList.contains('popup-exit-active')) {
				setPopupOffset(0);
			} else {
				setPopupOffset(e.target.offsetHeight);
			}
		};
		document.addEventListener('animationstart', handleStart);
		return function () {
			return document.removeEventListener('animationstart', handleStart);
		};
	}, []);

	// CookieBar and Popup are both position:fixed bottom:0, so they overlap rather
	// than stack; float the widget above whichever is taller.
	var bottomOffset = Math.max(cookieOffset, popupOffset);

	return _react2.default.createElement(
		'div',
		{ onTouchStart: handleTouchStart },
		page === 'home' ? _react2.default.createElement(_HeaderHome2.default, { page: page }) : _react2.default.createElement(_HeaderHotel2.default, null),
		children,
		_react2.default.createElement(_Footer2.default, null),
		_react2.default.createElement(
			'div',
			{ ref: cookieBarRef },
			_react2.default.createElement(_CookieBar2.default, { className: _index4.default.cookieBar })
		),
		page !== 'home' && _react2.default.createElement(_ChatbotWidget2.default, { bottomOffset: bottomOffset })
	);
};

var AppLayout = function AppLayout() {
	return App;
};

exports.default = AppLayout;

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _reactContainerHelper = __webpack_require__(49);

var _reactRedux = __webpack_require__(17);

var _path = __webpack_require__(105);

var _component = __webpack_require__(710);

var _component2 = _interopRequireDefault(_component);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initState = function initState() {
	return {
		isSideNaviOpened: false
	};
};

var mapSetStateToProps = function mapSetStateToProps(_ref, _ref2, setState) {
	var isSideNaviOpened = _ref.isSideNaviOpened;
	var page = _ref2.page;
	return {
		isSideNaviOpened: isSideNaviOpened,
		page: page,
		toggleNavi: function toggleNavi() {
			setState({ isSideNaviOpened: !isSideNaviOpened });
		},
		closeNavi: function closeNavi() {
			setState({ isSideNaviOpened: false });
		},
		onClickOutside: function onClickOutside(e) {
			// prevent close navi when clicking hambuger
			if (e.clientY > 60) {
				setState({ isSideNaviOpened: false });
			}
		}
	};
};

var componentContainer = (0, _reactContainerHelper.contain)(initState, mapSetStateToProps)(_component2.default);

var getPage = function getPage(pathname) {
	var pathnames = (0, _path.normalizePathname)(pathname);

	return pathnames[1] === '' ? 'main' : pathnames[1];
};

var mapStateToProps = function mapStateToProps(_ref3) {
	var pathname = _ref3.routing.locationBeforeTransitions.pathname;
	return {
		page: getPage(pathname)
	};
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(componentContainer);

/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(36);

var _Navigation = __webpack_require__(244);

var _Navigation2 = _interopRequireDefault(_Navigation);

var _logoJustsleepShort = __webpack_require__(246);

var _logoJustsleepShort2 = _interopRequireDefault(_logoJustsleepShort);

var _index = __webpack_require__(724);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HeaderHome = function HeaderHome(_ref) {
	var page = _ref.page;
	return _react2.default.createElement(
		'header',
		{ className: _index2.default.headerHome },
		_react2.default.createElement(
			'div',
			{ className: _index2.default.left },
			_react2.default.createElement(_Navigation2.default, { type: 'home' })
		),
		page !== 'main' && _react2.default.createElement(
			_reactRouter.Link,
			{ to: '/', className: _index2.default.logo },
			_react2.default.createElement(_logoJustsleepShort2.default, { viewBox: '0 0 289 60', width: '100%', height: '50px' })
		)
	);
};

exports.default = HeaderHome;

/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames7 = __webpack_require__(16);

var _classnames8 = _interopRequireDefault(_classnames7);

var _reactDeviceDetect = __webpack_require__(37);

var _HotelSelector = __webpack_require__(259);

var _HotelSelector2 = _interopRequireDefault(_HotelSelector);

var _LanguageSelector = __webpack_require__(721);

var _LanguageSelector2 = _interopRequireDefault(_LanguageSelector);

var _index = __webpack_require__(723);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Navigator = function Navigator(_ref) {
	var _classnames, _classnames2, _classnames3, _classnames4, _classnames5, _classnames6;

	var className = _ref.className,
	    type = _ref.type,
	    language = _ref.language,
	    hotel = _ref.hotel,
	    onLangSelect = _ref.onLangSelect,
	    onHotelSelect = _ref.onHotelSelect;
	return _react2.default.createElement(
		'nav',
		{
			className: (0, _classnames8.default)(_index2.default.navigator, className, (_classnames = {}, _classnames[_index2.default.reverse] = type === 'hotel', _classnames[_index2.default.home] = type === 'home', _classnames[_index2.default.hotel] = type === 'hotel', _classnames))
		},
		_react2.default.createElement(
			'span',
			{ className: _index2.default.languageSelector },
			_react2.default.createElement(_LanguageSelector2.default, {
				selectedLanguage: language,
				onSelect: onLangSelect,
				selectBoxConfig: type === 'home' ? {
					class: (0, _classnames8.default)(_index2.default.homeSelectBox, _index2.default.language, (_classnames2 = {}, _classnames2[_index2.default.isBrowser] = _reactDeviceDetect.isBrowser, _classnames2)),
					activeClass: _index2.default.homeSelectBoxActive,
					triangleColor: 'white',
					triangleBorderWidth: 2
				} : {
					class: _index2.default.hotelSelectBox,
					activeClass: _index2.default.hotelSelectBoxActive,
					triangle: true,
					triangleColor: 'white',
					triangleBorderWidth: 2
				},
				optionConfig: {
					border: false,
					optionClass: (0, _classnames8.default)(_index2.default.options, _index2.default[language], (_classnames3 = {}, _classnames3[_index2.default.hotelOptions] = type === 'hotel', _classnames3))
				}
			})
		),
		_react2.default.createElement(
			'span',
			{ className: _index2.default.hotelSelector },
			_react2.default.createElement(_HotelSelector2.default, {
				isHeaderSelect: true // isHeaderSelect is used to determine if the hotel selector is a header select issue-#175
				, withHomeSelection: type === 'hotel',
				selectedHotel: hotel,
				onSelect: onHotelSelect,
				selectBoxConfig: {
					class: (0, _classnames8.default)(_index2.default.hotel, _index2.default[language], (_classnames4 = {}, _classnames4[_index2.default.homeSelectBox] = type === 'home', _classnames4[_index2.default.hotelSelectBox] = type === 'hotel', _classnames4)),
					activeClass: (0, _classnames8.default)((_classnames5 = {}, _classnames5[_index2.default.homeSelectBoxActive] = type === 'home', _classnames5[_index2.default.hotelSelectBoxActive] = type === 'hotel', _classnames5)),
					triangleDown: type === 'home',
					triangleColor: 'white',
					triangleBorderWidth: 2
				},
				optionConfig: {
					border: false,
					optionClass: (0, _classnames8.default)(_index2.default.options, _index2.default[language], (_classnames6 = {}, _classnames6[_index2.default.hotelOptions] = type === 'hotel', _classnames6))
				}
			})
		)
	);
};

exports.default = Navigator;

/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactI18next = __webpack_require__(42);

var _lodash = __webpack_require__(85);

var _Select = __webpack_require__(158);

var _Select2 = _interopRequireDefault(_Select);

var _HeaderSelect = __webpack_require__(719);

var _HeaderSelect2 = _interopRequireDefault(_HeaderSelect);

var _train = __webpack_require__(260);

var _train2 = _interopRequireDefault(_train);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HotelSelector = function HotelSelector(_ref) {
	var t = _ref.t,
	    hotelList = _ref.hotelList,
	    hotelData = _ref.hotelData,
	    selectedHotel = _ref.selectedHotel,
	    disabled = _ref.disabled,
	    onSelect = _ref.onSelect,
	    selectBoxConfig = _ref.selectBoxConfig,
	    optionConfig = _ref.optionConfig,
	    withIcon = _ref.withIcon,
	    _ref$isHeaderSelect = _ref.isHeaderSelect,
	    isHeaderSelect = _ref$isHeaderSelect === undefined ? false : _ref$isHeaderSelect;
	return _react2.default.createElement(
		'div',
		null,
		!isHeaderSelect ? _react2.default.createElement(_Select2.default, {
			options: hotelList.map(function (hotelKey) {
				return {
					id: (0, _lodash.get)(hotelData[hotelKey], 'id', null),
					label: (0, _lodash.get)(hotelData[hotelKey], 'name', null),
					value: hotelKey
				};
			}),
			selected: selectedHotel ? {
				id: hotelData[selectedHotel].id,
				label: hotelData[selectedHotel].name,
				value: selectedHotel
			} : undefined,
			placeholder: t('selectHotel'),
			PlaceholderIcon: withIcon && _train2.default,
			selectBoxConfig: selectBoxConfig,
			onSelect: onSelect,
			disabled: disabled,
			optionConfig: optionConfig,
			moreWeight: true
		}) : _react2.default.createElement(_HeaderSelect2.default, {
			options: hotelList.map(function (hotelKey) {
				return {
					id: (0, _lodash.get)(hotelData[hotelKey], 'id', null),
					label: (0, _lodash.get)(hotelData[hotelKey], 'name', null),
					value: hotelKey
				};
			}),
			selected: selectedHotel ? {
				id: hotelData[selectedHotel].id,
				label: hotelData[selectedHotel].name,
				value: selectedHotel
			} : undefined,
			placeholder: t('selectHotel'),
			PlaceholderIcon: withIcon && _train2.default,
			selectBoxConfig: selectBoxConfig,
			onSelect: onSelect,
			disabled: disabled,
			optionConfig: optionConfig,
			moreWeight: true
		})
	);
};

exports.default = (0, _reactI18next.translate)('common')(HotelSelector);

/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(16);

var _classnames2 = _interopRequireDefault(_classnames);

var _Option = __webpack_require__(714);

var _Option2 = _interopRequireDefault(_Option);

var _index = __webpack_require__(716);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Options = function Options(_ref) {
	var selected = _ref.selected,
	    options = _ref.options,
	    reverse = _ref.reverse,
	    border = _ref.border,
	    select = _ref.select,
	    optionClass = _ref.optionClass,
	    moreWeight = _ref.moreWeight;
	return _react2.default.createElement(
		'div',
		{ className: _index2.default.options },
		options.map(function (option) {
			return _react2.default.createElement(
				_Option2.default,
				{
					key: option.id,
					className: (0, _classnames2.default)(_index2.default.option, optionClass),
					border: border,
					reverse: reverse,
					active: option.id === selected.id,
					onSelect: function onSelect() {
						select(option);
					},
					moreWeight: moreWeight
				},
				option.label
			);
		})
	);
};

exports.default = Options;

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames2 = __webpack_require__(16);

var _classnames3 = _interopRequireDefault(_classnames2);

var _reactDeviceDetect = __webpack_require__(37);

var _index = __webpack_require__(715);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Option = function Option(_ref) {
	var _classnames;

	var className = _ref.className,
	    children = _ref.children,
	    active = _ref.active,
	    reverse = _ref.reverse,
	    border = _ref.border,
	    onSelect = _ref.onSelect,
	    moreWeight = _ref.moreWeight;
	return _react2.default.createElement(
		'div',
		{
			className: (0, _classnames3.default)(_index2.default.option, className, (_classnames = {}, _classnames[_index2.default.reverse] = reverse, _classnames[_index2.default.border] = border, _classnames[_index2.default.active] = active, _classnames[_index2.default.isBrowser] = _reactDeviceDetect.isBrowser, _classnames[_index2.default.isMoreWeight] = moreWeight, _classnames)),
			role: 'button',
			tabIndex: '0',
			onClick: onSelect,
			onKeyPress: function onKeyPress() {}
		},
		children
	);
};

exports.default = Option;

/***/ }),
/* 715 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"option":"index__option___2fge9","reverse":"index__reverse___2aPiH","border":"index__border___3uKSr","is-browser":"index__is-browser___3fig_","isBrowser":"index__is-browser___3fig_","active":"index__active___2ZvmW","is-more-weight":"index__is-more-weight___1NFDZ","isMoreWeight":"index__is-more-weight___1NFDZ"};

/***/ }),
/* 716 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"options":"index__options___337ec","option":"index__option___1eDxE"};

/***/ }),
/* 717 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"triangle":"index__triangle___2H9DB","left":"index__left___2VmW1","right":"index__right___MB6fz","up":"index__up___1aUAQ","down":"index__down___1hPc4"};

/***/ }),
/* 718 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"select":"index__select___1I-ge","disabled":"index__disabled___3reSL","select-box":"index__select-box___3RVgq","selectBox":"index__select-box___3RVgq","mask":"index__mask___3LrwS","animation":"index__animation___1fOco","is-browser":"index__is-browser___3iSPJ","isBrowser":"index__is-browser___3iSPJ","active":"index__active___3K7F6","options":"index__options___3kV_D","default-select-box":"index__default-select-box___6PCUJ","defaultSelectBox":"index__default-select-box___6PCUJ","container":"index__container___3JPgM","placeholder":"index__placeholder___cGqVk","icon":"index__icon___157YC","triangle":"index__triangle____D1rT"};

/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames3 = __webpack_require__(16);

var _classnames4 = _interopRequireDefault(_classnames3);

var _reactClickOutside = __webpack_require__(107);

var _reactClickOutside2 = _interopRequireDefault(_reactClickOutside);

var _reactDeviceDetect = __webpack_require__(37);

var _reactI18next = __webpack_require__(42);

var _Options = __webpack_require__(245);

var _Options2 = _interopRequireDefault(_Options);

var _Triangle = __webpack_require__(155);

var _Triangle2 = _interopRequireDefault(_Triangle);

var _index = __webpack_require__(720);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HeaderSelect = function (_React$Component) {
	_inherits(HeaderSelect, _React$Component);

	function HeaderSelect(props) {
		_classCallCheck(this, HeaderSelect);

		var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

		_this.state = {
			optionsOpen: false,
			hoveredRegion: null
		};
		_this.handleClickOutside = _this.handleClickOutside.bind(_this);
		_this.onSelect = _this.onSelect.bind(_this);
		_this.toggleSelectBox = _this.toggleSelectBox.bind(_this);
		return _this;
	}

	HeaderSelect.prototype.onSelect = function onSelect(option) {
		this.setState({ optionsOpen: false });
		this.props.onSelect(option);
	};

	HeaderSelect.prototype.handleClickOutside = function handleClickOutside() {
		this.setState({ optionsOpen: false });
	};

	HeaderSelect.prototype.toggleSelectBox = function toggleSelectBox() {
		if (!this.props.disabled) {
			this.setState({ optionsOpen: !this.state.optionsOpen });
		}
	};

	HeaderSelect.prototype.render = function render() {
		var _classnames,
		    _classnames2,
		    _this2 = this;

		var _props = this.props,
		    className = _props.className,
		    options = _props.options,
		    _props$placeholder = _props.placeholder,
		    placeholder = _props$placeholder === undefined ? 'select...' : _props$placeholder,
		    PlaceholderIcon = _props.PlaceholderIcon,
		    _props$selected = _props.selected,
		    selected = _props$selected === undefined ? {
			id: -1,
			label: '',
			value: ''
		} : _props$selected,
		    disabled = _props.disabled,
		    selectBoxConfigProp = _props.selectBoxConfig,
		    optionConfigProp = _props.optionConfig,
		    moreWeight = _props.moreWeight,
		    t = _props.t;

		// 將 options 分成台灣和日本的選項 (作為 #175 的 workaround 解決方案 只在這邊簡單作陣列區分而非更改整個 redux 資料邏輯)
		// src/util/hotel.js 的 options 陣列最後一個元素是日本選項，所以需要分開處理

		var mainOption = options.length && options[0].value === 'main' ? [options[0]] : [];
		var lastOption = options.length ? [options[options.length - 1]] : [];
		var taiwanOptions = options.length ? options.slice(0, -1) : []; // 除了最後一個元素的陣列
		var japanOptions = [].concat(mainOption, lastOption); // 包含第一個 main 選項和最後一個日本選項

		// console.log('options:', options);
		// console.log('Japan Options:', japanOptions);
		// console.log('Taiwan Options:', taiwanOptions);

		var selectBoxConfig = _extends({
			class: _index2.default.defaultSelectBox,
			activeClass: _index2.default.activeSelectBox,
			triangle: true,
			triangleDown: false,
			triangleSize: 10,
			triangleColor: '#2D2926',
			triangleBorderWidth: 1,
			animation: false
		}, selectBoxConfigProp);

		var optionConfig = _extends({ border: true }, optionConfigProp);

		var optionsOpen = this.state.optionsOpen;


		return _react2.default.createElement(
			'div',
			{
				className: (0, _classnames4.default)(_index2.default.select, className, (_classnames = {}, _classnames[_index2.default.disabled] = disabled, _classnames))
			},
			_react2.default.createElement(
				'div',
				{
					className: (0, _classnames4.default)(_index2.default.selectBox, selectBoxConfig.class, (_classnames2 = {}, _classnames2[_index2.default.active] = optionsOpen, _classnames2[selectBoxConfig.activeClass] = optionsOpen, _classnames2[_index2.default.animation] = selectBoxConfig.animation, _classnames2[_index2.default.isBrowser] = _reactDeviceDetect.isBrowser, _classnames2)),
					role: 'button',
					tabIndex: '0',
					onClick: this.toggleSelectBox,
					onKeyPress: function onKeyPress() {}
				},
				_react2.default.createElement('div', { className: _index2.default.mask }),
				_react2.default.createElement(
					'div',
					{ className: _index2.default.container },
					selected.id === -1 ? _react2.default.createElement(
						'div',
						{ className: _index2.default.placeholder },
						PlaceholderIcon && _react2.default.createElement(
							'div',
							{ className: _index2.default.icon },
							_react2.default.createElement(PlaceholderIcon, null)
						),
						_react2.default.createElement(
							'div',
							{ className: _index2.default.text },
							placeholder
						)
					) : selected.label,
					selectBoxConfig.triangle && _react2.default.createElement(_Triangle2.default, {
						direction: selectBoxConfig.triangleDown || optionsOpen ? 'down' : 'right',
						className: _index2.default.triangle,
						size: selectBoxConfig.triangleSize,
						color: selectBoxConfig.triangleColor,
						borderWidth: selectBoxConfig.triangleBorderWidth
					})
				)
			),
			_react2.default.createElement(
				'div',
				{
					className: (0, _classnames4.default)(_index2.default.options),
					style: { height: optionsOpen ? options.length * 60 + 'px' : 0 }
				},
				_react2.default.createElement(
					'div',
					{
						className: _index2.default.regionOptions,
						onMouseEnter: function onMouseEnter() {
							return _this2.setState({ hoveredRegion: 'taiwan' });
						},
						onMouseLeave: function onMouseLeave() {
							return _this2.setState({ hoveredRegion: null });
						}
					},
					_react2.default.createElement(
						'div',
						{ className: _index2.default.regionTitle },
						t('taiwan')
					),
					this.state.hoveredRegion === 'taiwan' && _react2.default.createElement(_Options2.default, _extends({
						options: taiwanOptions,
						selected: selected,
						onSelect: this.onSelect,
						moreWeight: moreWeight
					}, optionConfig))
				),
				_react2.default.createElement(
					'div',
					{
						className: _index2.default.regionOptions,
						onMouseEnter: function onMouseEnter() {
							return _this2.setState({ hoveredRegion: 'japan' });
						},
						onMouseLeave: function onMouseLeave() {
							return _this2.setState({ hoveredRegion: null });
						}
					},
					_react2.default.createElement(
						'div',
						{ className: _index2.default.regionTitle },
						t('japan')
					),
					this.state.hoveredRegion === 'japan' && _react2.default.createElement(_Options2.default, _extends({
						options: japanOptions,
						selected: selected,
						onSelect: this.onSelect,
						moreWeight: moreWeight
					}, optionConfig))
				)
			)
		);
	};

	return HeaderSelect;
}(_react2.default.Component);

exports.default = (0, _reactI18next.translate)('header')((0, _reactClickOutside2.default)(HeaderSelect));

/***/ }),
/* 720 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"select":"index__select___271jL","disabled":"index__disabled___2atPj","select-box":"index__select-box___2aJUQ","selectBox":"index__select-box___2aJUQ","mask":"index__mask___26Q-Y","animation":"index__animation___1pJYp","is-browser":"index__is-browser___3fMl0","isBrowser":"index__is-browser___3fMl0","active":"index__active___Mxcc_","options":"index__options___eoG4v","region-options":"index__region-options___FJfOp","regionOptions":"index__region-options___FJfOp","region-title":"index__region-title___WMUVV","regionTitle":"index__region-title___WMUVV","default-select-box":"index__default-select-box___1fOyp","defaultSelectBox":"index__default-select-box___1fOyp","container":"index__container___3w7Jf","placeholder":"index__placeholder___PHcin","icon":"index__icon___1Ycmk","triangle":"index__triangle___ih7sJ"};

/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _reactRedux = __webpack_require__(17);

var _component = __webpack_require__(722);

var _component2 = _interopRequireDefault(_component);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(_ref) {
	var _ref$global = _ref.global,
	    lanData = _ref$global.lanData,
	    lanList = _ref$global.lanList;
	return {
		lanData: lanData,
		lanList: lanList
	};
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_component2.default);

/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Select = __webpack_require__(158);

var _Select2 = _interopRequireDefault(_Select);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LanguageSelector = function LanguageSelector(_ref) {
	var lanData = _ref.lanData,
	    lanList = _ref.lanList,
	    _ref$selectedLanguage = _ref.selectedLanguage,
	    selectedLanguage = _ref$selectedLanguage === undefined ? 'zh-TW' : _ref$selectedLanguage,
	    onSelect = _ref.onSelect,
	    selectBoxConfig = _ref.selectBoxConfig,
	    optionConfig = _ref.optionConfig;
	return _react2.default.createElement(
		'div',
		null,
		_react2.default.createElement(_Select2.default, {
			options: lanList.map(function (lang) {
				return lanData[lang];
			}),
			selected: lanData[selectedLanguage],
			selectBoxConfig: _extends({
				triangle: false
			}, selectBoxConfig),
			optionConfig: optionConfig,
			onSelect: onSelect
		})
	);
};

exports.default = LanguageSelector;

/***/ }),
/* 723 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"navigator":"index__navigator___36pnK","reverse":"index__reverse___1MYoK","home":"index__home___vF_m_","home-select-box":"index__home-select-box___13y8h","homeSelectBox":"index__home-select-box___13y8h","is-browser":"index__is-browser___3Yc--","isBrowser":"index__is-browser___3Yc--","hotel":"index__hotel___1Qoh9","ko":"index__ko___410F3","en":"index__en___17i0N","home-select-box-active":"index__home-select-box-active___17hFz","homeSelectBoxActive":"index__home-select-box-active___17hFz","options":"index__options___K9Hsr","hotel-select-box":"index__hotel-select-box___34wVg","hotelSelectBox":"index__hotel-select-box___34wVg","hotel-select-box-active":"index__hotel-select-box-active___3kf6a","hotelSelectBoxActive":"index__hotel-select-box-active___3kf6a","hotel-options":"index__hotel-options___3qFCV","hotelOptions":"index__hotel-options___3qFCV"};

/***/ }),
/* 724 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"header-home":"index__header-home___1gFbZ","headerHome":"index__header-home___1gFbZ","navi-side":"index__navi-side___R0gkp","naviSide":"index__navi-side___R0gkp","active":"index__active___39aEc","left":"index__left___2ejZn","hamburger":"index__hamburger___1NGOr","logo":"index__logo___4ZK_i"};

/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reactContainerHelper = __webpack_require__(49);

var _reactRedux = __webpack_require__(17);

var _path = __webpack_require__(105);

var _component = __webpack_require__(726);

var _component2 = _interopRequireDefault(_component);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /* eslint-disable indent */


var initState = function initState() {
	return {
		isSideNaviOpened: false,
		fixNav: false,
		imageHeight: 0
	};
};

var mapSetStateToProps = function mapSetStateToProps(_ref2, _ref, setState) {
	var isSideNaviOpened = _ref2.isSideNaviOpened,
	    fixNav = _ref2.fixNav,
	    imageHeight = _ref2.imageHeight;

	var lan = _ref.lan,
	    hotel = _ref.hotel,
	    hotelData = _ref.hotelData,
	    props = _objectWithoutProperties(_ref, ['lan', 'hotel', 'hotelData']);

	return _extends({
		// states
		isSideNaviOpened: isSideNaviOpened,
		fixNav: fixNav,
		lan: lan,
		hotel: hotel,
		bannerText: hotelData[hotel].name

	}, props, {

		// actions
		toggleNavi: function toggleNavi() {
			setState({ isSideNaviOpened: !isSideNaviOpened });
		},
		closeNavi: function closeNavi() {
			setState({ isSideNaviOpened: false });
		},
		onClickOutside: function onClickOutside(e) {
			// prevent close navi when clicking hambuger
			if (e.clientY > 80 || e.clientX > 45) {
				setState({ isSideNaviOpened: false });
			}
		},
		getImageHeight: function getImageHeight(height) {
			if (imageHeight !== height) {
				setState({ imageHeight: height });
			}
		},
		bookHotel: function bookHotel() {
			var bookingLink = '';
			if (hotel === 'osakaShinsaibashi') {
				bookingLink = 'https://member.silkshotelgroup.com/' + lan + '/JSOKS';
				// const curr = langStr => {
				//	const str = {
				//		'zh-TW': 'TWD',
				//		'zh-CN': 'CNY',
				//		'ja': 'JPY',
				//		'ko': 'KRW',
				//		'en': 'USD'
				//	}
				//	return str[langStr];
				// };

				// bookingLink = `https://book-directonline.com/properties/jsosdirect?locale=
				// ${lan}&currency=${curr(lan)}`;
			} else {
				var lang = function lang(langStr) {
					var str = '';
					switch (langStr) {
						case 'zh-TW':
							str = null;
							break;
						case 'zh-CN':
							str = 'zh-CN';
							break;
						case 'ja':
							str = 'ja';
							break;
						case 'ko':
							str = 'ko';
							break;
						default:
							str = 'en';
							break;
					}
					return str ? str + '/' : '';
				};
				bookingLink = 'https://member.silkshotelgroup.com/' + lang(lan) + hotelData[hotel].bookingCode;
			}
			window.open(bookingLink, '_blank');
		}
	});
};

var setLifecycle = function setLifecycle() {
	return {
		componentWillReceiveProps: function componentWillReceiveProps(_ref3, _ref4) {
			var pageYOffset = _ref3.pageYOffset;
			var getState = _ref4.getState,
			    getProps = _ref4.getProps,
			    setState = _ref4.setState;

			var _getState = getState(),
			    imageHeight = _getState.imageHeight;

			var _getProps = getProps(),
			    previousPageYOffset = _getProps.pageYOffset;

			if (pageYOffset !== previousPageYOffset) {
				setState({ previousPageYOffset: pageYOffset });

				if (pageYOffset > imageHeight - 80) {
					setState({ fixNav: true });
				} else {
					setState({ fixNav: false });
				}
			}
		}
	};
};

var componentContainer = (0, _reactContainerHelper.contain)(initState, mapSetStateToProps, setLifecycle)(_component2.default);

var getPage = function getPage(pathname) {
	var pathnames = (0, _path.normalizePathname)(pathname);

	return pathnames.length <= 3 || !pathnames[3] ? '' : pathnames[3];
};

var mapStateToProps = function mapStateToProps(_ref5) {
	var _ref5$global = _ref5.global,
	    _ref5$global$window = _ref5$global.window,
	    media = _ref5$global$window.media,
	    pageYOffset = _ref5$global$window.pageYOffset,
	    lan = _ref5$global.lan,
	    pathname = _ref5.routing.locationBeforeTransitions.pathname,
	    _ref5$hotel = _ref5.hotel,
	    hotel = _ref5$hotel.hotel,
	    hotelData = _ref5$hotel.hotelData,
	    _ref5$banner = _ref5.banner,
	    image = _ref5$banner.image,
	    thumbnail = _ref5$banner.thumbnail;
	return {
		media: media,
		hotel: hotel,
		hotelData: hotelData,
		lan: lan,
		page: getPage(pathname),
		pageYOffset: pageYOffset,
		bannerImage: image,
		bannerThumbnail: thumbnail
	};
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(componentContainer);

/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames15 = __webpack_require__(16);

var _classnames16 = _interopRequireDefault(_classnames15);

var _reactRouter = __webpack_require__(36);

var _reactI18next = __webpack_require__(42);

var _reactDeviceDetect = __webpack_require__(37);

var _reactProgressiveImage = __webpack_require__(253);

var _reactProgressiveImage2 = _interopRequireDefault(_reactProgressiveImage);

var _Navigation = __webpack_require__(244);

var _Navigation2 = _interopRequireDefault(_Navigation);

var _Hamburger = __webpack_require__(727);

var _Hamburger2 = _interopRequireDefault(_Hamburger);

var _NavigationSide = __webpack_require__(729);

var _NavigationSide2 = _interopRequireDefault(_NavigationSide);

var _NavExtraItem = __webpack_require__(247);

var _NavExtraItem2 = _interopRequireDefault(_NavExtraItem);

var _NavSustainabilityItem = __webpack_require__(248);

var _NavSustainabilityItem2 = _interopRequireDefault(_NavSustainabilityItem);

var _i18n = __webpack_require__(22);

var _navi = __webpack_require__(249);

var _constants = __webpack_require__(732);

var _index = __webpack_require__(733);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BookBtn = function BookBtn(_ref) {
	var _classnames;

	var className = _ref.className,
	    onClick = _ref.onClick,
	    children = _ref.children;
	return _react2.default.createElement(
		'span',
		{
			className: (0, _classnames16.default)(_index2.default.bookBtn, className, (_classnames = {}, _classnames[_index2.default.mobileDevice] = _reactDeviceDetect.isMobile, _classnames[_index2.default.isBrowser] = _reactDeviceDetect.isBrowser, _classnames)),
			role: 'button',
			tabIndex: '0',
			onClick: onClick,
			onKeyPress: function onKeyPress() {}
		},
		children
	);
};

var HeaderHotel = function HeaderHotel(_ref2) {
	var _classnames2, _classnames3, _classnames4, _classnames5, _classnames6, _classnames8, _classnames9, _classnames10, _classnames11, _classnames12;

	var t = _ref2.t,
	    hotel = _ref2.hotel,
	    lan = _ref2.lan,
	    media = _ref2.media,
	    page = _ref2.page,
	    bannerImage = _ref2.bannerImage,
	    bannerThumbnail = _ref2.bannerThumbnail,
	    bannerText = _ref2.bannerText,
	    isSideNaviOpened = _ref2.isSideNaviOpened,
	    fixNav = _ref2.fixNav,
	    toggleNavi = _ref2.toggleNavi,
	    closeNavi = _ref2.closeNavi,
	    onClickOutside = _ref2.onClickOutside,
	    getImageHeight = _ref2.getImageHeight,
	    bookHotel = _ref2.bookHotel;

	var _useState = (0, _react.useState)(false),
	    isOpen = _useState[0],
	    setIsOpen = _useState[1];

	var dropdownRef = (0, _react.useRef)(null);
	var isTraditionalChinese = lan === 'zh-TW';
	var isTaiwanHotel = _constants.TAIWAN_HOTEL_LIST.includes(hotel);

	(0, _react.useEffect)(function () {
		var handleClickOutside = function handleClickOutside(event) {
			if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
				setIsOpen(false);
			}
		};

		if (isOpen) {
			document.addEventListener('mousedown', handleClickOutside);
		}

		return function () {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, [isOpen]);

	var onClick = function onClick() {
		if (isTraditionalChinese && isTaiwanHotel) {
			setIsOpen(!isOpen);
		} else {
			bookHotel();
		}
	};

	var onClickHref = function onClickHref() {
		window.open('https://twanga.mohist.com.tw/LIKEGO/index.php?GetStore=SLK', '_blank');
	};

	return _react2.default.createElement(
		'header',
		{ className: _index2.default.headerHotel },
		_react2.default.createElement(
			'div',
			{
				className: (0, _classnames16.default)(_index2.default.naviSide, (_classnames2 = {}, _classnames2[_index2.default.mediaNormal] = lan !== 'en', _classnames2[_index2.default.mediaEn] = lan === 'en', _classnames2[_index2.default.active] = isSideNaviOpened, _classnames2[_index2.default.home] = page === '', _classnames2[_index2.default.headerFix] = fixNav, _classnames2))
			},
			_react2.default.createElement(_NavigationSide2.default, {
				type: 'hotel',
				closeNavi: closeNavi,
				onClickOutside: onClickOutside,
				extraComponent: media === 'phone' && BookBtn,
				extraComponentProps: { t: t, bookHotel: bookHotel, className: _index2.default.naviSideBookBtn }
			})
		),
		_react2.default.createElement(
			'nav',
			{
				className: (0, _classnames16.default)((_classnames3 = {}, _classnames3[_index2.default.mediaNormal] = lan !== 'en', _classnames3[_index2.default.mediaEn] = lan === 'en', _classnames3[_index2.default.home] = page === '', _classnames3[_index2.default.fix] = fixNav, _classnames3))
			},
			_react2.default.createElement(
				'div',
				{
					className: (0, _classnames16.default)(_index2.default.hamburger, (_classnames4 = {}, _classnames4[_index2.default.mediaNormal] = lan !== 'en', _classnames4[_index2.default.mediaEn] = lan === 'en', _classnames4)),
					role: 'button',
					tabIndex: '0',
					onClick: toggleNavi,
					onKeyPress: function onKeyPress() {}
				},
				_react2.default.createElement(_Hamburger2.default, { open: isSideNaviOpened })
			),
			_react2.default.createElement(_Navigation2.default, {
				className: (0, _classnames16.default)(_index2.default.navigation, (_classnames5 = {}, _classnames5[_index2.default.mediaNormal] = lan !== 'en', _classnames5[_index2.default.mediaEn] = lan === 'en', _classnames5)),
				type: 'hotel'
			}),
			_react2.default.createElement(
				'div',
				{
					className: (0, _classnames16.default)(_index2.default.pageGuide, (_classnames6 = {}, _classnames6[_index2.default.mediaNormal] = lan !== 'en', _classnames6[_index2.default.mediaEn] = lan === 'en', _classnames6))
				},
				_navi.hotelPages.map(function (hotelPage) {
					var _classnames7;

					return _react2.default.createElement(
						_reactRouter.Link,
						{ key: hotelPage.route, to: '/' + hotel + '/' + (0, _i18n.lanMapRoute)(lan) + '/' + hotelPage.route },
						_react2.default.createElement(
							'span',
							{
								className: (0, _classnames16.default)(_index2.default.navItem, _index2.default[lan], (_classnames7 = {}, _classnames7[_index2.default.mediaNormal] = lan !== 'en', _classnames7[_index2.default.mediaEn] = lan === 'en', _classnames7[_index2.default.active] = page === hotelPage.route, _classnames7[_index2.default.isBrowser] = _reactDeviceDetect.isBrowser, _classnames7))
							},
							t(hotelPage.label)
						)
					);
				}),
				_react2.default.createElement(_NavExtraItem2.default, {
					className: (0, _classnames16.default)(_index2.default.navItem, (_classnames8 = {}, _classnames8[_index2.default.mediaNormal] = lan !== 'en', _classnames8[_index2.default.mediaEn] = lan === 'en', _classnames8[_index2.default.isBrowser] = _reactDeviceDetect.isBrowser, _classnames8)),
					hotel: hotel,
					lan: lan
				}),
				_react2.default.createElement(_NavSustainabilityItem2.default, {
					className: (0, _classnames16.default)(_index2.default.navItem, (_classnames9 = {}, _classnames9[_index2.default.mediaNormal] = lan !== 'en', _classnames9[_index2.default.mediaEn] = lan === 'en', _classnames9[_index2.default.isBrowser] = _reactDeviceDetect.isBrowser, _classnames9)),
					hotel: hotel,
					lan: lan
				})
			),
			_react2.default.createElement(
				'div',
				{ ref: dropdownRef },
				_react2.default.createElement(
					BookBtn,
					{
						className: (0, _classnames16.default)(_index2.default.bookBtn, _index2.default[lan], (_classnames10 = {}, _classnames10[_index2.default.mediaNormal] = lan !== 'en', _classnames10[_index2.default.mediaEn] = lan === 'en', _classnames10)),
						onClick: onClick
					},
					t('bookNowBtn')
				),
				isOpen && _react2.default.createElement(
					'div',
					{ className: _index2.default.fixedPosition },
					_react2.default.createElement(
						BookBtn,
						{
							className: (0, _classnames16.default)(_index2.default.bookBtn, _index2.default.bookBtnItem, _index2.default[lan], (_classnames11 = {}, _classnames11[_index2.default.mediaNormal] = lan !== 'en', _classnames11[_index2.default.mediaEn] = lan === 'en', _classnames11)),
							onClick: function onClick() {
								bookHotel();
								setIsOpen(false);
							}
						},
						t('bookNow')
					),
					_react2.default.createElement(
						BookBtn,
						{
							className: (0, _classnames16.default)(_index2.default.bookBtn, _index2.default.bookBtnItem, _index2.default[lan], (_classnames12 = {}, _classnames12[_index2.default.mediaNormal] = lan !== 'en', _classnames12[_index2.default.mediaEn] = lan === 'en', _classnames12)),
							onClick: function onClick() {
								onClickHref();
								setIsOpen(false);
							}
						},
						t('onlineTravelFair')
					)
				)
			)
		),
		page === '' && _react2.default.createElement(
			_reactProgressiveImage2.default,
			{ src: bannerImage, placeholder: '' },
			function (src, loading) {
				var _classnames13, _classnames14;

				return _react2.default.createElement(
					'div',
					{
						className: (0, _classnames16.default)(_index2.default.banner, (_classnames13 = {}, _classnames13[_index2.default.mediaNormal] = lan !== 'en', _classnames13[_index2.default.mediaEn] = lan === 'en', _classnames13)),
						style: {
							backgroundImage: 'url(' + (loading ? bannerThumbnail : src) + ')',
							opacity: loading ? 0.5 : 1
						},
						ref: function ref(node) {
							if (node) {
								getImageHeight(node.getBoundingClientRect().height);
							}
						}
					},
					_react2.default.createElement(
						'div',
						{
							className: (0, _classnames16.default)(_index2.default.container, (_classnames14 = {}, _classnames14[_index2.default.mediaNormal] = lan !== 'en', _classnames14[_index2.default.mediaEn] = lan === 'en', _classnames14))
						},
						bannerText
					)
				);
			}
		)
	);
};

exports.default = (0, _reactI18next.translate)('header')(HeaderHotel);

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames2 = __webpack_require__(16);

var _classnames3 = _interopRequireDefault(_classnames2);

var _index = __webpack_require__(728);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Hamburger = function Hamburger(_ref) {
	var _classnames;

	var open = _ref.open;
	return _react2.default.createElement(
		'div',
		{
			className: (0, _classnames3.default)(_index2.default.hamburger, (_classnames = {}, _classnames[_index2.default.open] = open, _classnames))
		},
		_react2.default.createElement('span', { className: _index2.default.line }),
		_react2.default.createElement('span', { className: _index2.default.line }),
		_react2.default.createElement('span', { className: _index2.default.line })
	);
};

exports.default = Hamburger;

/***/ }),
/* 728 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"hamburger":"index__hamburger___2Bi99","line":"index__line___2OK-H","open":"index__open___28k8W"};

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _reactRedux = __webpack_require__(17);

var _path = __webpack_require__(105);

var _component = __webpack_require__(730);

var _component2 = _interopRequireDefault(_component);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getPage = function getPage(hotel, pathname) {
	var pathnames = (0, _path.normalizePathname)(pathname);

	if (hotel) {
		return pathnames.length >= 4 ? pathnames[3] : '';
	}

	return pathnames[1] === '' ? 'main' : pathnames[1];
};

var mapStateToProps = function mapStateToProps(_ref) {
	var lan = _ref.global.lan,
	    pathname = _ref.routing.locationBeforeTransitions.pathname,
	    hotel = _ref.hotel.hotel;
	return {
		lan: lan,
		hotel: hotel,
		page: getPage(hotel, pathname)
	};
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_component2.default);

/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(36);

var _reactI18next = __webpack_require__(42);

var _classnames2 = __webpack_require__(16);

var _classnames3 = _interopRequireDefault(_classnames2);

var _reactClickOutside = __webpack_require__(107);

var _reactClickOutside2 = _interopRequireDefault(_reactClickOutside);

var _reactDeviceDetect = __webpack_require__(37);

var _NavExtraItem = __webpack_require__(247);

var _NavExtraItem2 = _interopRequireDefault(_NavExtraItem);

var _NavSustainabilityItem = __webpack_require__(248);

var _NavSustainabilityItem2 = _interopRequireDefault(_NavSustainabilityItem);

var _i18n = __webpack_require__(22);

var _navi = __webpack_require__(249);

var _index = __webpack_require__(731);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NavigationSide = function (_React$Component) {
	_inherits(NavigationSide, _React$Component);

	function NavigationSide(props) {
		_classCallCheck(this, NavigationSide);

		var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

		_this.handleClickOutside = _this.handleClickOutside.bind(_this);
		return _this;
	}

	NavigationSide.prototype.handleClickOutside = function handleClickOutside(e) {
		if (this.props.onClickOutside) {
			this.props.onClickOutside(e);
		}
	};

	NavigationSide.prototype.render = function render() {
		var _props = this.props,
		    t = _props.t,
		    lan = _props.lan,
		    page = _props.page,
		    hotel = _props.hotel,
		    closeNavi = _props.closeNavi,
		    extraComponent = _props.extraComponent,
		    extraComponentProps = _props.extraComponentProps;


		return _react2.default.createElement(
			'div',
			{ className: _index2.default.navigationHomeSide },
			extraComponent && extraComponent(extraComponentProps),
			_react2.default.createElement(
				'div',
				{ className: _index2.default.pageWrapper },
				_navi.hotelPages.map(function (p) {
					var _classnames;

					return _react2.default.createElement(
						'div',
						{ key: p.id, className: _index2.default.page },
						_react2.default.createElement(
							_reactRouter.Link,
							{
								className: (0, _classnames3.default)(_index2.default.link, (_classnames = {}, _classnames[_index2.default.active] = p.route === page, _classnames[_index2.default.mobileDevice] = _reactDeviceDetect.isMobile, _classnames[_index2.default.isBrowser] = _reactDeviceDetect.isBrowser, _classnames)),
								to: '/' + hotel + '/' + (0, _i18n.lanMapRoute)(lan) + '/' + p.route,
								role: 'button',
								tabIndex: '0',
								onClick: closeNavi,
								onKeyPress: function onKeyPress() {}
							},
							t(p.label)
						)
					);
				}),
				_react2.default.createElement(_NavExtraItem2.default, {
					className: (0, _classnames3.default)(_index2.default.extraItem, _index2.default.link),
					hotel: hotel,
					lan: lan
				}),
				_react2.default.createElement(_NavSustainabilityItem2.default, { className: (0, _classnames3.default)(_index2.default.extraItem, _index2.default.link), lan: lan })
			)
		);
	};

	return NavigationSide;
}(_react2.default.Component);

exports.default = (0, _reactI18next.translate)('header')((0, _reactClickOutside2.default)(NavigationSide));

/***/ }),
/* 731 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"navigation-home-side":"index__navigation-home-side___2Xo-l","navigationHomeSide":"index__navigation-home-side___2Xo-l","logo":"index__logo___3KBs3","page-wrapper":"index__page-wrapper___1221q","pageWrapper":"index__page-wrapper___1221q","link":"index__link___3CZk8","active":"index__active___26D8c","is-browser":"index__is-browser___ltUDO","isBrowser":"index__is-browser___ltUDO","mobile-device":"index__mobile-device___19Dy5","mobileDevice":"index__mobile-device___19Dy5","page":"index__page___nxA-0","extra-item":"index__extra-item___wEZFX","extraItem":"index__extra-item___wEZFX"};

/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var TAIWAN_HOTEL_LIST = exports.TAIWAN_HOTEL_LIST = ['ximending', 'NTU', 'zhongshan', 'kaohsiung', 'kaohsiungStation', 'hualien', 'jiaoxi', 'sanchong', 'hushan'];

/***/ }),
/* 733 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"header-hotel":"index__header-hotel___3mL9t","headerHotel":"index__header-hotel___3mL9t","navi-side":"index__navi-side___2gL68","naviSide":"index__navi-side___2gL68","media-normal":"index__media-normal___1ZUYO","mediaNormal":"index__media-normal___1ZUYO","media-en":"index__media-en___1thhp","mediaEn":"index__media-en___1thhp","home":"index__home___1f9V4","header-fix":"index__header-fix___HfiWh","headerFix":"index__header-fix___HfiWh","active":"index__active___1CSms","fix":"index__fix___2cZZ-","hamburger":"index__hamburger___34GCo","navigation":"index__navigation___T8Dbv","book-btn":"index__book-btn___vTpUK","bookBtn":"index__book-btn___vTpUK","page-guide":"index__page-guide___vV5yD","pageGuide":"index__page-guide___vV5yD","nav-item":"index__nav-item___2TsKq","navItem":"index__nav-item___2TsKq","en":"index__en___3GAHK","is-browser":"index__is-browser___3uGFs","isBrowser":"index__is-browser___3uGFs","banner":"index__banner___2nHPg","container":"index__container___197Qo","ko":"index__ko___26ei2","book-btn-item":"index__book-btn-item___3ufsu","bookBtnItem":"index__book-btn-item___3ufsu","mobile-device":"index__mobile-device___8Edx4","mobileDevice":"index__mobile-device___8Edx4","navi-side-book-btn":"index__navi-side-book-btn___2D-sj","naviSideBookBtn":"index__navi-side-book-btn___2D-sj","fixed-position":"index__fixed-position___3OsYi","fixedPosition":"index__fixed-position___3OsYi"};

/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _reactRedux = __webpack_require__(17);

var _i18n = __webpack_require__(22);

var _component = __webpack_require__(735);

var _component2 = _interopRequireDefault(_component);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(_ref) {
	var _ref$global = _ref.global,
	    lan = _ref$global.lan,
	    window = _ref$global.window,
	    _ref$hotel = _ref.hotel,
	    hotel = _ref$hotel.hotel,
	    hotelList = _ref$hotel.hotelList,
	    hotelData = _ref$hotel.hotelData;
	return {
		lan: lan,
		hotel: hotel,
		hotelList: hotelList,
		hotelData: hotelData,
		lanRoute: (0, _i18n.lanMapRoute)(lan),
		address: hotelData[hotel].address,
		tel: hotelData[hotel].tel,
		fax: hotelData[hotel].fax,
		registrationNumber: hotelData[hotel].registrationNumber,
		mapLink: hotelData[hotel].mapLink,
		media: window.media,
		contactUs: hotelData[hotel].contactUs,
		bookingCode: hotelData[hotel].bookingCode
	};
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_component2.default);

/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(36);

var _reactI18next = __webpack_require__(42);

var _classnames3 = __webpack_require__(16);

var _classnames4 = _interopRequireDefault(_classnames3);

var _reactDeviceDetect = __webpack_require__(37);

var _lodash = __webpack_require__(85);

var _SocialGroup = __webpack_require__(736);

var _SocialGroup2 = _interopRequireDefault(_SocialGroup);

var _logoJustsleepShort = __webpack_require__(246);

var _logoJustsleepShort2 = _interopRequireDefault(_logoJustsleepShort);

var _index = __webpack_require__(745);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Footer = function Footer(_ref) {
	var _classnames;

	var t = _ref.t,
	    tel = _ref.tel,
	    fax = _ref.fax,
	    address = _ref.address,
	    contactUs = _ref.contactUs,
	    bookingCode = _ref.bookingCode,
	    mapLink = _ref.mapLink,
	    hotelList = _ref.hotelList,
	    hotelData = _ref.hotelData,
	    hotel = _ref.hotel,
	    lanRoute = _ref.lanRoute,
	    registrationNumber = _ref.registrationNumber;

	var currentYear = new Date().getFullYear();

	var contactLan = function contactLan(lan) {
		switch (lan) {
			case 'tw':
				return 'zh-tw';
			case 'cn':
				return 'zh-cn';
			case 'kr':
				return 'ko';
			case 'jp':
				return 'ja';
			default:
				return lan;
		}
	};

	return _react2.default.createElement(
		'footer',
		{ className: _index2.default.footer },
		_react2.default.createElement(
			'div',
			{ className: _index2.default.top },
			_react2.default.createElement(_SocialGroup2.default, { className: _index2.default.socialGroup }),
			_react2.default.createElement(
				'div',
				{ className: _index2.default.info },
				_react2.default.createElement(
					'div',
					{ className: _index2.default.contact },
					_react2.default.createElement(
						'a',
						{
							href: 'https://event.silkshotelgroup.com/ContactUs/' + contactLan(lanRoute) + '/' + bookingCode,
							target: '_blank'
						},
						contactUs
					),
					_react2.default.createElement(
						'a',
						{ href: 'tel:' + tel.replace(/ /g, ''), className: _index2.default.tel },
						tel
					),
					_react2.default.createElement(
						'a',
						{ href: '/' },
						fax
					),
					_react2.default.createElement(
						'a',
						{ href: mapLink, target: '_blank', className: _index2.default.address },
						address
					)
				),
				registrationNumber && _react2.default.createElement(
					'p',
					{ className: _index2.default.registrationNumber },
					t('registrationNumber'),
					'\uFF1A',
					registrationNumber
				)
			)
		),
		_react2.default.createElement(
			'div',
			{ className: _index2.default.middle },
			_react2.default.createElement(
				'div',
				{ className: (0, _classnames4.default)(_index2.default.hotels, (_classnames = {}, _classnames[_index2.default.en] = lanRoute === 'en', _classnames)) },
				hotelList.map(function (hotelKey) {
					var _classnames2;

					return _react2.default.createElement(
						'span',
						{
							key: hotelKey,
							className: (0, _classnames4.default)((_classnames2 = {}, _classnames2[_index2.default.isBrowser] = _reactDeviceDetect.isBrowser, _classnames2))
						},
						_react2.default.createElement(
							_reactRouter.Link,
							{ to: '/' + hotelKey },
							(0, _lodash.get)(hotelData[hotelKey], 'name', 'default-hotel')
						)
					);
				})
			),
			_react2.default.createElement(
				'div',
				{ className: _index2.default.info },
				_react2.default.createElement(
					'div',
					{ className: _index2.default.contact },
					_react2.default.createElement(
						'a',
						{
							href: 'https://event.silkshotelgroup.com/ContactUs/' + contactLan(lanRoute) + '/' + bookingCode,
							target: '_blank'
						},
						contactUs
					),
					_react2.default.createElement(
						'a',
						{ href: 'tel:' + tel.replace(/ /g, ''), className: _index2.default.tel },
						tel
					),
					_react2.default.createElement(
						'a',
						{ href: '/' },
						fax
					),
					_react2.default.createElement(
						'a',
						{ href: mapLink, target: '_blank', className: _index2.default.address },
						address
					)
				),
				registrationNumber && _react2.default.createElement(
					'p',
					{ className: _index2.default.registrationNumber },
					t('registrationNumber'),
					'\uFF1A',
					registrationNumber
				)
			)
		),
		_react2.default.createElement(
			'div',
			{ className: _index2.default.bottom },
			_react2.default.createElement(
				'div',
				{ className: _index2.default.logo },
				_react2.default.createElement(_logoJustsleepShort2.default, { viewBox: '0 0 289 60', width: '100%', height: '25px' })
			),
			_react2.default.createElement(
				'div',
				{ className: _index2.default.text },
				_react2.default.createElement(
					'div',
					{ className: _index2.default.copyright },
					_react2.default.createElement(
						'span',
						null,
						'Copyright'
					),
					_react2.default.createElement(
						'span',
						{ role: 'img', 'aria-label': 'copyright' },
						'\xA9'
					),
					_react2.default.createElement(
						'a',
						{
							href: 'https://www.silkshotelgroup.com/' + (lanRoute === 'kr' ? 'en' : lanRoute) + '/',
							target: '_blank'
						},
						currentYear,
						' Silks Hotel Group'
					)
				),
				_react2.default.createElement(
					_reactRouter.Link,
					{
						to: hotel === 'main' ? '/privacy' : '/' + hotel + '/' + lanRoute + '/privacy',
						className: _index2.default.privacy
					},
					t('privacy')
				)
			)
		)
	);
};

exports.default = (0, _reactI18next.translate)('footer')(Footer);

/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _reactRedux = __webpack_require__(17);

var _component = __webpack_require__(737);

var _component2 = _interopRequireDefault(_component);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(_ref) {
	var _ref$hotel = _ref.hotel,
	    hotel = _ref$hotel.hotel,
	    hotelData = _ref$hotel.hotelData;
	return {
		lineLink: hotelData[hotel].socialLinks.line,
		tripadvisorLink: hotelData[hotel].socialLinks.tripAdvisor,
		fbLink: hotelData[hotel].socialLinks.fb,
		igLink: hotelData[hotel].socialLinks.ig,
		weiboLink: hotelData[hotel].socialLinks.weibo,
		youtubeLink: hotelData[hotel].socialLinks.youtube
	};
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_component2.default);

/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames2 = __webpack_require__(16);

var _classnames3 = _interopRequireDefault(_classnames2);

var _reactDeviceDetect = __webpack_require__(37);

var _socialFb = __webpack_require__(738);

var _socialFb2 = _interopRequireDefault(_socialFb);

var _socialLine = __webpack_require__(739);

var _socialLine2 = _interopRequireDefault(_socialLine);

var _socialIg = __webpack_require__(740);

var _socialIg2 = _interopRequireDefault(_socialIg);

var _socialTripadvisor = __webpack_require__(741);

var _socialTripadvisor2 = _interopRequireDefault(_socialTripadvisor);

var _socialWeibo = __webpack_require__(742);

var _socialWeibo2 = _interopRequireDefault(_socialWeibo);

var _socialYoutube = __webpack_require__(743);

var _socialYoutube2 = _interopRequireDefault(_socialYoutube);

var _index = __webpack_require__(744);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SocialGroup = function SocialGroup(_ref) {
	var _classnames;

	var className = _ref.className,
	    lineLink = _ref.lineLink,
	    tripadvisorLink = _ref.tripadvisorLink,
	    fbLink = _ref.fbLink,
	    igLink = _ref.igLink,
	    weiboLink = _ref.weiboLink,
	    youtubeLink = _ref.youtubeLink;
	return _react2.default.createElement(
		'div',
		{
			className: (0, _classnames3.default)(_index2.default.socialGroup, className, (_classnames = {}, _classnames[_index2.default.isBrowser] = _reactDeviceDetect.isBrowser, _classnames))
		},
		fbLink && _react2.default.createElement(
			'a',
			{ href: fbLink, target: '_blank', rel: 'noopener noreferrer' },
			_react2.default.createElement(
				'span',
				null,
				_react2.default.createElement(_socialFb2.default, null)
			)
		),
		lineLink && _react2.default.createElement(
			'a',
			{ href: lineLink, target: '_blank', rel: 'noopener noreferrer' },
			_react2.default.createElement(
				'span',
				null,
				_react2.default.createElement(_socialLine2.default, null)
			)
		),
		igLink && _react2.default.createElement(
			'a',
			{ href: igLink, target: '_blank', rel: 'noopener noreferrer' },
			_react2.default.createElement(
				'span',
				null,
				_react2.default.createElement(_socialIg2.default, null)
			)
		),
		tripadvisorLink && _react2.default.createElement(
			'a',
			{ href: tripadvisorLink, target: '_blank', rel: 'noopener noreferrer' },
			_react2.default.createElement(
				'span',
				null,
				_react2.default.createElement(_socialTripadvisor2.default, null)
			)
		),
		weiboLink && _react2.default.createElement(
			'a',
			{ href: weiboLink, target: '_blank', rel: 'noopener noreferrer' },
			_react2.default.createElement(
				'span',
				null,
				_react2.default.createElement(_socialWeibo2.default, null)
			)
		),
		youtubeLink && _react2.default.createElement(
			'a',
			{ href: youtubeLink, target: '_blank', rel: 'noopener noreferrer' },
			_react2.default.createElement(
				'span',
				null,
				_react2.default.createElement(_socialYoutube2.default, null)
			)
		)
	);
};

exports.default = SocialGroup;

/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(1);

function SocialFb(props) {
    return React.createElement("svg", props, React.createElement("g", { "fill": "none", "fillRule": "evenodd" }, [React.createElement("path", { "d": "M0 0h16v16H0z", "key": 0 }), React.createElement("path", { "fill": "#FEFEFE", "d": "M7.228 12.057c0 1.056-.006 2.112.005 3.168.002.235-.074.307-.304.303a68.417 68.417 0 0 0-2.2 0c-.226.005-.288-.076-.287-.292.006-2.12 0-4.24.01-6.36 0-.213-.066-.258-.258-.255-.597.009-1.193-.005-1.79.006-.212.005-.278-.07-.275-.28.011-.71.011-1.419 0-2.128-.004-.216.072-.274.28-.269.58.014 1.16-.004 1.74.01.227.005.303-.055.304-.297.002-.796.006-1.595.061-2.39.093-1.298 1.037-2.42 2.304-2.69C7.375.465 7.964.472 8.539.457c.401-.011.803.04 1.206.06.156.008.222.064.22.238-.011.645-.01 1.289-.001 1.934.002.168-.044.219-.217.221-.554.008-1.11.013-1.661.067-.522.049-.812.332-.85 1.047-.03.562 0 1.128-.013 1.692-.005.203.079.245.256.243.717-.006 1.434.004 2.151-.008.188-.002.24.053.214.234-.102.757-.198 1.515-.294 2.275-.021.178-.149.163-.268.164-.596.002-1.193.01-1.79-.003-.209-.004-.272.051-.27.27.012 1.055.006 2.111.006 3.167", "key": 1 })]));
}

SocialFb.displayName = "SocialFb";

SocialFb.defaultProps = { "width": "16", "height": "16" };

module.exports = SocialFb;

SocialFb.default = SocialFb;

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(1);

function SocialLine(props) {
    return React.createElement("svg", props, React.createElement("g", { "fill": "none", "fillRule": "evenodd" }, [React.createElement("path", { "fill": "#FEFEFE", "d": "M8.443 2.25c-1.067.009-2 .177-2.89.552-1.19.503-2.171 1.257-2.803 2.403-.618 1.12-.711 2.295-.26 3.495.461 1.222 1.342 2.073 2.466 2.692.737.405 1.533.627 2.359.768.562.096.687.299.593.86-.035.21-.077.42-.107.632-.031.217.072.327.285.289.128-.024.259-.067.374-.128 1.07-.558 2.057-1.242 3.011-1.98.823-.634 1.6-1.316 2.206-2.173.619-.876.904-1.848.771-2.914-.163-1.306-.844-2.321-1.87-3.111-1.246-.962-2.681-1.365-4.136-1.384M8.356.57c1.528 0 3.057.004 4.586 0 .71-.003 1.348.19 1.886.661.634.555.936 1.264.937 2.102 0 3.106.006 6.21-.002 9.316-.004 1.338-.813 2.37-2.082 2.682-.233.057-.48.076-.722.077-3.075.005-6.15.005-9.224.003-1.367-.002-2.417-.804-2.729-2.093a3.102 3.102 0 0 1-.074-.722c-.005-3.07-.005-6.14-.003-9.21C.93 2.017 1.725.968 3.013.652c.244-.06.504-.076.756-.077C5.298.568 6.827.57 8.356.57", "key": 0 }), React.createElement("path", { "fill": "#FEFEFE", "d": "M8.207 6.993v.627c0 .272.004.544-.001.816a.284.284 0 0 1-.282.294c-.165.007-.282-.088-.31-.259a1.083 1.083 0 0 1-.013-.173V6.214c0-.069.003-.14.02-.206a.29.29 0 0 1 .484-.153c.05.045.096.1.137.156.316.434.632.87.95 1.304.036.049.075.097.146.187V6.73c0-.198-.005-.395.002-.592.008-.229.13-.37.306-.37.184 0 .327.155.328.376.005.747.001 1.493.002 2.24 0 .164-.069.28-.227.33-.157.048-.28-.01-.376-.142-.343-.473-.69-.943-1.034-1.415-.032-.043-.069-.085-.132-.164m3.124-.043c.292 0 .57-.002.847 0 .215.002.359.12.365.293.007.181-.154.328-.37.33-.277.003-.554.001-.844.001v.527h.816c.155 0 .287.048.361.193.099.194-.017.41-.248.427-.276.023-.555.015-.833.017-.144 0-.29.003-.433-.01-.198-.019-.308-.13-.31-.328-.005-.76-.006-1.517 0-2.276.002-.232.145-.354.381-.355.37-.003.741-.003 1.112 0 .21 0 .362.133.367.314.006.178-.143.307-.365.309-.277.002-.555 0-.846 0v.557zM4.555 8.1h.83c.158 0 .286.056.345.211.078.202-.035.405-.255.413-.427.016-.854.014-1.281 0-.204-.007-.293-.132-.294-.352v-2.22c0-.232.12-.376.312-.384.195-.006.34.146.341.38.004.577.002 1.155.002 1.733v.22zm2.315-.833c0 .364.003.728-.002 1.092-.004.254-.133.385-.353.368-.164-.012-.27-.095-.292-.264a1.414 1.414 0 0 1-.012-.19V6.245c0-.04-.002-.082.002-.12.017-.218.144-.355.326-.356.184 0 .321.135.327.354.008.381.002.762.002 1.144h.001z", "key": 1 }), React.createElement("path", { "d": "M0 0h16v16H0z", "key": 2 })]));
}

SocialLine.displayName = "SocialLine";

SocialLine.defaultProps = { "width": "16", "height": "16" };

module.exports = SocialLine;

SocialLine.default = SocialLine;

/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(1);

function SocialIg(props) {
    return React.createElement("svg", props, React.createElement("g", { "fill": "none", "fillRule": "evenodd" }, [React.createElement("path", { "d": "M0 0h16v16H0z", "key": 0 }), React.createElement("path", { "fill": "#FEFEFE", "d": "M2.19 8.352c.039.848.057 2.062.16 3.269.08.924.569 1.632 1.421 2.051.63.31 1.318.351 1.999.363 1.479.025 2.959.023 4.437.011a14.017 14.017 0 0 0 1.66-.106c1.091-.14 1.898-.7 2.223-1.774.16-.531.213-1.107.228-1.665.035-1.351.033-2.703.02-4.054a20.475 20.475 0 0 0-.112-2.07c-.102-.933-.566-1.65-1.428-2.077-.63-.311-1.32-.348-1.999-.362a153.168 153.168 0 0 0-4.31-.01 17.91 17.91 0 0 0-1.763.102c-.749.08-1.386.393-1.86 1.005-.4.516-.55 1.12-.58 1.746-.05 1.067-.06 2.136-.095 3.57zm13.442-.367c0 .982.025 1.966-.007 2.947-.032.946-.213 1.863-.764 2.67-.647.95-1.574 1.447-2.68 1.62-.513.08-1.037.103-1.556.115-1.247.026-2.495.051-3.742.037-.817-.01-1.64-.047-2.45-.148-1.794-.223-3.093-1.478-3.364-3.26-.12-.782-.152-1.58-.165-2.372-.022-1.36-.016-2.72.01-4.079.016-.81.082-1.622.392-2.388.49-1.212 1.387-1.972 2.646-2.278A7.124 7.124 0 0 1 5.444.652C6.913.615 8.383.592 9.853.612c.884.013 1.777-.026 2.65.194 1.647.416 2.676 1.449 2.974 3.118.148.827.15 1.68.194 2.522.026.512.005 1.026.005 1.539h-.044z", "key": 1 }), React.createElement("path", { "fill": "#FEFEFE", "d": "M10.75 7.984a2.47 2.47 0 0 0-2.468-2.457 2.458 2.458 0 0 0-2.458 2.435 2.468 2.468 0 0 0 2.462 2.49 2.48 2.48 0 0 0 2.463-2.468m-2.476 3.795c-2.114-.036-3.769-1.674-3.771-3.792-.004-2.12 1.662-3.79 3.795-3.785a3.752 3.752 0 0 1 3.77 3.785c-.003 2.128-1.692 3.775-3.794 3.792m3.088-7.753a.865.865 0 0 1 .87-.854c.48.004.884.411.88.883-.005.453-.426.863-.883.86a.877.877 0 0 1-.867-.889", "key": 2 })]));
}

SocialIg.displayName = "SocialIg";

SocialIg.defaultProps = { "width": "16", "height": "16" };

module.exports = SocialIg;

SocialIg.default = SocialIg;

/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(1);

function SocialTripadvisor(props) {
    return React.createElement("svg", props, React.createElement("g", { "fill": "none", "fillRule": "evenodd" }, [React.createElement("path", { "d": "M0 0h16v16H0z", "key": 0 }), React.createElement("path", { "fill": "#FEFEFE", "d": "M8.22 8.394c.318-2.054 1.512-3.219 3.575-3.509-2.413-.941-4.823-.918-7.23.005A3.786 3.786 0 0 1 8.22 8.394M4.479 5.648c-1.682.017-3.024 1.369-3.005 3.03.018 1.678 1.376 3.024 3.035 3.008 1.692-.015 3.007-1.377 2.994-3.1-.012-1.611-1.394-2.955-3.024-2.938m7.516 0C10.353 5.6 8.991 7.03 8.962 8.598c-.031 1.642 1.333 3.1 3.028 3.09A3.022 3.022 0 0 0 15 8.656a3 3 0 0 0-3.005-3.009m-2.93 5.376l-.822 1.144-.81-1.124c-.296.25-.553.5-.843.709-1.18.85-2.909.873-4.115.066C1.267 11.008.687 9.87.75 8.418a3.373 3.373 0 0 1 .603-1.791.407.407 0 0 0 .056-.388 3.908 3.908 0 0 0-.62-1.18c-.016-.02-.03-.044-.067-.094h.21c.674 0 1.348.002 2.022-.004a.515.515 0 0 0 .258-.072c1.026-.642 2.151-1.002 3.338-1.182 1.45-.221 2.89-.173 4.314.204a7.842 7.842 0 0 1 2.183.928.79.79 0 0 0 .457.129c.673-.008 1.347-.003 2.021-.003h.207c-.14.221-.28.416-.39.629-.113.22-.198.455-.291.685-.045.115-.024.213.049.322a3.714 3.714 0 0 1-1.021 5.158 3.721 3.721 0 0 1-4.859-.573l-.156-.163", "key": 1 }), React.createElement("path", { "fill": "#FEFEFE", "d": "M11.976 9.908a1.273 1.273 0 0 0 1.266-1.26 1.27 1.27 0 0 0-1.257-1.266 1.271 1.271 0 0 0-1.267 1.257 1.27 1.27 0 0 0 1.258 1.269m1.819-1.263a1.799 1.799 0 0 1-1.827 1.814c-.995 0-1.81-.822-1.805-1.823.003-1.01.812-1.8 1.84-1.799 1.005 0 1.792.796 1.792 1.808m-8.094.013a1.253 1.253 0 0 0-1.25-1.266 1.25 1.25 0 0 0-1.266 1.25A1.252 1.252 0 0 0 4.438 9.91c.702.002 1.26-.55 1.263-1.251M4.432 10.47a1.811 1.811 0 0 1-1.808-1.823c0-1.01.82-1.818 1.837-1.81A1.8 1.8 0 0 1 6.257 8.65a1.8 1.8 0 0 1-1.825 1.82", "key": 2 }), React.createElement("path", { "fill": "#FEFEFE", "d": "M12.496 8.639a.596.596 0 0 1-.597.611.614.614 0 0 1-.626-.605.62.62 0 0 1 .612-.61.61.61 0 0 1 .611.604m-8.15-.59a.612.612 0 0 1 .615.6.613.613 0 0 1-.607.61.602.602 0 0 1-.61-.601.601.601 0 0 1 .602-.609", "key": 3 })]));
}

SocialTripadvisor.displayName = "SocialTripadvisor";

SocialTripadvisor.defaultProps = { "width": "16", "height": "16" };

module.exports = SocialTripadvisor;

SocialTripadvisor.default = SocialTripadvisor;

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(1);

function SocialWeibo(props) {
    return React.createElement("svg", props, React.createElement("g", { "fill": "none", "fillRule": "evenodd" }, [React.createElement("path", { "d": "M0 0h16v16H0z", "key": 0 }), React.createElement("path", { "fill": "#FEFEFE", "d": "M6.329 13.227a6.793 6.793 0 0 0 2.33-.429c.815-.312 1.528-.774 2.067-1.476a2.14 2.14 0 0 0-.177-2.847c-.467-.474-1.033-.776-1.662-.966-1.343-.405-2.682-.354-4.006.082-.887.292-1.666.765-2.24 1.518-.49.641-.628 1.357-.334 2.122.23.599.683 1.008 1.225 1.32.848.489 1.776.659 2.797.676m.772.854c-1.679-.011-3.18-.343-4.566-1.127-.659-.373-1.189-.884-1.55-1.556-.375-.702-.41-1.441-.215-2.2.194-.76.566-1.434 1.028-2.06.778-1.056 1.705-1.964 2.816-2.668.638-.405 1.313-.727 2.07-.837.34-.048.672-.018.969.173.323.21.463.521.486.894.02.331-.06.647-.137.965-.017.07-.024.18.016.217.042.04.152.035.221.013.391-.123.775-.272 1.17-.381.511-.142 1.035-.194 1.563-.074.666.151 1.018.678.884 1.348-.045.222-.12.438-.173.658-.042.176-.013.22.16.286.22.085.444.164.658.262.422.192.755.49.994.889.304.503.326 1.04.159 1.59-.232.763-.728 1.34-1.33 1.84-1.009.839-2.177 1.331-3.456 1.579a9.024 9.024 0 0 1-.834.131c-.341.034-.687.043-.933.058m4.501-12.178c2.09.015 3.584 1.396 3.968 3.065.16.701.154 1.399-.072 2.088-.111.343-.403.518-.72.424-.315-.094-.483-.421-.378-.762.216-.708.175-1.402-.151-2.06-.458-.92-1.203-1.472-2.239-1.575-.298-.028-.606.004-.905.04-.314.038-.614-.14-.682-.443a.568.568 0 0 1 .421-.68.91.91 0 0 1 .118-.023l.64-.075", "key": 1 }), React.createElement("path", { "fill": "#FEFEFE", "d": "M13.658 5.89c-.037.187-.062.378-.115.56a.496.496 0 0 1-.604.356c-.254-.072-.4-.338-.341-.618.018-.09.044-.182.048-.274a.94.94 0 0 0-1.106-.964c-.216.038-.413 0-.545-.194a.477.477 0 0 1-.02-.531.452.452 0 0 1 .3-.229c1.076-.263 2.205.52 2.338 1.623l.028.265.017.005m-6.872 4.517c.19 0 .362-.157.359-.326-.004-.142-.121-.243-.282-.243-.186.002-.352.161-.352.336 0 .132.12.233.275.233m-1.018-.22c-.442 0-.807.25-.943.61a.636.636 0 0 0 .266.78c.368.225.888.103 1.177-.276.18-.233.22-.49.09-.753a.644.644 0 0 0-.59-.36m.511 2.429c-.714-.021-1.272-.17-1.725-.586-.679-.623-.788-1.61-.242-2.401.585-.85 1.424-1.215 2.443-1.168.488.024.94.175 1.318.496.68.577.85 1.427.46 2.228-.336.688-.898 1.097-1.615 1.306-.242.07-.496.098-.639.125", "key": 2 })]));
}

SocialWeibo.displayName = "SocialWeibo";

SocialWeibo.defaultProps = { "width": "16", "height": "16" };

module.exports = SocialWeibo;

SocialWeibo.default = SocialWeibo;

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(1);

function SocialYoutube(props) {
    return React.createElement("svg", props, React.createElement("g", { "fill": "none", "fillRule": "evenodd" }, [React.createElement("path", { "d": "M0 0h16v16H0z", "key": 0 }), React.createElement("path", { "fill": "#FEFEFE", "d": "M10.568 7.832L6.59 5.749v4.133l3.978-2.05M8.22 13.189c-1.89-.053-3.199-.078-4.506-.133-.472-.019-.954-.063-1.41-.18-.89-.229-1.25-.934-1.384-1.765a13.763 13.763 0 0 1-.165-1.745C.708 7.853.69 6.34.916 4.835c.064-.422.2-.825.466-1.167.41-.526.986-.7 1.621-.736a94.734 94.734 0 0 1 9.408-.04c.5.02 1.008.062 1.496.17.52.116.9.457 1.129.957.239.522.309 1.077.358 1.639.12 1.365.116 2.732.038 4.098-.038.654-.067 1.313-.297 1.942-.29.794-.857 1.236-1.687 1.277-1.935.096-3.87.16-5.227.214", "key": 1 })]));
}

SocialYoutube.displayName = "SocialYoutube";

SocialYoutube.defaultProps = { "width": "16", "height": "16" };

module.exports = SocialYoutube;

SocialYoutube.default = SocialYoutube;

/***/ }),
/* 744 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"social-group":"index__social-group___3DJ_O","socialGroup":"index__social-group___3DJ_O","is-browser":"index__is-browser___UKZbT","isBrowser":"index__is-browser___UKZbT"};

/***/ }),
/* 745 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"footer":"index__footer___3G6lz","top":"index__top___3KedE","social-group":"index__social-group___Lo6ps","socialGroup":"index__social-group___Lo6ps","info":"index__info___3x46v","contact":"index__contact___39fB0","registration-number":"index__registration-number___3mhbx","registrationNumber":"index__registration-number___3mhbx","middle":"index__middle____HHD5","hotels":"index__hotels___1bPiz","is-browser":"index__is-browser___2hVyf","isBrowser":"index__is-browser___2hVyf","en-hotels":"index__en-hotels___8x5uZ","enHotels":"index__en-hotels___8x5uZ","group-hotel":"index__group-hotel___WPp4L","groupHotel":"index__group-hotel___WPp4L","en":"index__en___bjUW-","bottom":"index__bottom___3vkHu","logo":"index__logo___15ADa","text":"index__text___2fK1x","copyright":"index__copyright___g1mej","privacy":"index__privacy___15ZMT"};

/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _reactRedux = __webpack_require__(17);

var _global = __webpack_require__(151);

var _component = __webpack_require__(747);

var _component2 = _interopRequireDefault(_component);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(_ref) {
	var acceptCookies = _ref.global.cookies.acceptCookies;
	return {
		active: !acceptCookies
	};
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	return {
		onConfirm: function onConfirm() {
			dispatch((0, _global.acceptCookies)());
		}
	};
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_component2.default);

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactI18next = __webpack_require__(42);

var _reactRouter = __webpack_require__(36);

var _classnames2 = __webpack_require__(16);

var _classnames3 = _interopRequireDefault(_classnames2);

var _Button = __webpack_require__(255);

var _Button2 = _interopRequireDefault(_Button);

var _index = __webpack_require__(749);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CookieBar = function CookieBar(_ref) {
	var _classnames;

	var t = _ref.t,
	    className = _ref.className,
	    active = _ref.active,
	    onConfirm = _ref.onConfirm;
	return _react2.default.createElement(
		'div',
		{ className: (0, _classnames3.default)(_index2.default.cookieBar, className, (_classnames = {}, _classnames[_index2.default.active] = active, _classnames)) },
		_react2.default.createElement(
			'div',
			{ className: _index2.default.container },
			_react2.default.createElement(
				'div',
				{ className: _index2.default.confirmText },
				_react2.default.createElement(_reactI18next.Interpolate, {
					i18nKey: 'attention',
					useDangerouslySetInnerHTML: 'true',
					privacyLink: _react2.default.createElement(
						_reactRouter.Link,
						{ to: '/privacy' },
						t('privacy')
					)
				})
			),
			_react2.default.createElement(
				_Button2.default,
				{
					className: _index2.default.button,
					contentClassName: _index2.default.buttonContent,
					animation: false,
					reverse: true,
					onClick: onConfirm
				},
				t('accept')
			)
		)
	);
};

exports.default = (0, _reactI18next.translate)('cookieBar')(CookieBar);

/***/ }),
/* 748 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"button":"index__button___eMuHc","animation-mask":"index__animation-mask___HAWFc","animationMask":"index__animation-mask___HAWFc","content":"index__content___1F-Mz","arrow":"index__arrow___1uzmS","is-browser":"index__is-browser___2I3sm","isBrowser":"index__is-browser___2I3sm","animation":"index__animation___3d-QI","reverse":"index__reverse___aN-1I"};

/***/ }),
/* 749 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"cookie-bar":"index__cookie-bar___2sPLb","cookieBar":"index__cookie-bar___2sPLb","active":"index__active___1DE-7","moveIn":"index__moveIn___2VH5S","container":"index__container___2jZw7","confirm-text":"index__confirm-text___2X6Vi","confirmText":"index__confirm-text___2X6Vi","button":"index__button___18pM5","button-content":"index__button-content___2otOo","buttonContent":"index__button-content___2otOo"};

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _reactRedux = __webpack_require__(17);

var _component = __webpack_require__(751);

var _component2 = _interopRequireDefault(_component);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(_ref) {
	var lan = _ref.global.lan,
	    hotel = _ref.hotel.hotel;
	return {
		lan: lan,
		hotel: hotel
	};
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_component2.default);

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _chatbotJustsleep = __webpack_require__(752);

var _chatbotJustsleep2 = _interopRequireDefault(_chatbotJustsleep);

var _config = __webpack_require__(753);

var _index = __webpack_require__(754);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChatbotWidget = function ChatbotWidget(_ref) {
	var hotel = _ref.hotel,
	    lan = _ref.lan,
	    _ref$bottomOffset = _ref.bottomOffset,
	    bottomOffset = _ref$bottomOffset === undefined ? 0 : _ref$bottomOffset;

	var _useState = (0, _react.useState)(true),
	    showBubble = _useState[0],
	    setShowBubble = _useState[1];

	var config = (0, _config.getChatbotConfig)(hotel, lan);

	if (!config) return null;

	var url = config.url,
	    text = config.text;

	var widgetStyle = { bottom: 16 + bottomOffset + 'px' };

	var openChatbot = function openChatbot() {
		window.open(url, '_blank', 'noopener,noreferrer');
	};

	return _react2.default.createElement(
		'div',
		{ className: _index2.default.widget, style: widgetStyle },
		_react2.default.createElement(
			'button',
			{
				className: _index2.default.iconBtn,
				type: 'button',
				'aria-label': 'Open Chatbot',
				onClick: openChatbot
			},
			_react2.default.createElement('img', { className: _index2.default.icon, src: _chatbotJustsleep2.default, alt: '' })
		),
		showBubble && _react2.default.createElement(
			'div',
			{ className: _index2.default.bubble, onClick: openChatbot, role: 'button', tabIndex: '0', onKeyPress: function onKeyPress() {} },
			text,
			_react2.default.createElement(
				'div',
				{
					role: 'button',
					tabIndex: '0',
					className: _index2.default.closeBtn,
					'aria-label': 'Close',
					onClick: function onClick(e) {
						e.stopPropagation();
						setShowBubble(false);
					},
					onKeyPress: function onKeyPress() {}
				},
				_react2.default.createElement(
					'svg',
					{ xmlns: 'http://www.w3.org/2000/svg', width: '10', height: '10', viewBox: '0 0 12 13' },
					_react2.default.createElement('path', { fill: 'none', fillRule: 'evenodd', stroke: '#FFF', strokeLinecap: 'square', d: 'M.305 11.695L11.695.305.305 11.695zm0-11.39l11.39 11.39' })
				)
			)
		)
	);
};

exports.default = ChatbotWidget;

/***/ }),
/* 752 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var LANG_PARAM = {
	'zh-TW': '',
	'zh-CN': '&ch=lang_cn',
	en: '&ch=lang_en',
	ja: '&ch=lang_ja',
	ko: '&ch=lang_ko'
};

var BASE_URLS = {
	ximending: 'https://reg01l200101.southeastasia.cloudapp.azure.com/wise/webchat/default/?t=%2BZBuJE8oPaveaNMQjdEoOQ%3D%3D',
	NTU: 'https://reg01l200101.southeastasia.cloudapp.azure.com/wise/webchat/default/?t=71Kryn8tkuHd5xfqhen9aw%3D%3D',
	jiaoxi: 'https://reg01l200101.southeastasia.cloudapp.azure.com/wise/webchat/default/?t=oC56ls9rDQCvE6pSN%2B9i0w%3D%3D',
	osakaShinsaibashi: 'https://reg01l200101.southeastasia.cloudapp.azure.com/wise/webchat/default/?t=%2BqBC9BCrmLROSWts0rsUXg%3D%3D',
	zhongshan: 'https://reg01l200101.southeastasia.cloudapp.azure.com/wise/webchat/default/?t=KiJw8%2BHC9sYC%2BQ7%2FSDTLjw%3D%3D'
};

var TEXT = {
	'zh-TW': '您好，歡迎在此提出問題，捷絲旅小管家很樂意為您解答。',
	'zh-CN': '您好，欢迎在此提出问题，捷丝旅小管家很乐意为您解答。',
	en: 'Hello! Please feel free to leave your questions here. We will be happy to assist you.',
	ja: 'こんにちは！どのようなことでも、お気軽にご相談ください。',
	ko: '안녕하세요. 문의사항이 있으시면 언제든지 말씀해 주세요. 친절하게 안내해 드리겠습니다.'
};

var TEXT_OSAKA_JA = 'こんにちは。ご不明な点がございましたら、こちらでお気軽にご質問ください。ホテルがご案内いたします。';

// Wave 1 (6/22): ximending, NTU, jiaoxi, osakaShinsaibashi
// Wave 2 (7/1): add 'zhongshan'
var CHATBOT_HOTELS = exports.CHATBOT_HOTELS = ['ximending', 'NTU', 'jiaoxi', 'osakaShinsaibashi'];

var getChatbotConfig = exports.getChatbotConfig = function getChatbotConfig(hotel, lan) {
	if (!CHATBOT_HOTELS.includes(hotel)) return null;
	var baseUrl = BASE_URLS[hotel];
	var url = baseUrl + (LANG_PARAM[lan] || '');
	var text = hotel === 'osakaShinsaibashi' && lan === 'ja' ? TEXT_OSAKA_JA : TEXT[lan] || TEXT['zh-TW'];
	return { url: url, text: text };
};

/***/ }),
/* 754 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"widget":"index__widget___1u3vM","iconBtn":"index__iconBtn___1V9Cn","icon":"index__icon___1oDwZ","bubble":"index__bubble___19Usn","closeBtn":"index__closeBtn___jP6Wn"};

/***/ }),
/* 755 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"cookie-bar":"index__cookie-bar___Gb5bi","cookieBar":"index__cookie-bar___Gb5bi"};

/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _hotel = __webpack_require__(15);

var _news = __webpack_require__(52);

var _popup = __webpack_require__(38);

var _attraction = __webpack_require__(104);

var _i18n = __webpack_require__(22);

exports.default = function (store) {
	return {
		path: 'main',
		onEnter: function onEnter() {
			var _store$getState = store.getState(),
			    hotel = _store$getState.hotel.hotel;

			if (hotel !== 'main') {
				store.dispatch((0, _hotel.changeHotel)('main'));
			}
		},
		indexRoute: {
			getComponent: function getComponent(nextState, cb) {
				return __webpack_require__.e/* require.ensure */(0/* duplicate */).then((function (require) {
					var component = __webpack_require__(159).default;
					cb(null, component);
				}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
			},
			onEnter: function onEnter() {
				var _store$getState2 = store.getState(),
				    lan = _store$getState2.global.lan;

				store.dispatch((0, _news.getHomeNewsList)((0, _i18n.lanMapRoute)(lan), {}));
				store.dispatch((0, _attraction.getEachHotelAttractions)((0, _i18n.lanMapRoute)(lan)));
			}
		},
		childRoutes: [{
			path: ':lang',
			onEnter: function onEnter(_ref, replace) {
				var lang = _ref.params.lang;

				var _store$getState3 = store.getState(),
				    _store$getState3$glob = _store$getState3.global,
				    lan = _store$getState3$glob.lan,
				    lanList = _store$getState3$glob.lanList,
				    lanData = _store$getState3$glob.lanData;

				if (!lanList.map(function (l) {
					return lanData[l].value;
				}).includes(lang)) {
					replace('/');
					return;
				}

				if ((0, _i18n.lanMapRoute)(lan) !== lang) {
					(0, _i18n.changeLng)(lang);
				}
			},
			indexRoute: {
				getComponent: function getComponent(nextState, cb) {
					return __webpack_require__.e/* require.ensure */(0/* duplicate */).then((function (require) {
						var component = __webpack_require__(159).default;
						cb(null, component);
					}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
				},
				onEnter: function onEnter(_ref2) {
					var lang = _ref2.params.lang;

					store.dispatch((0, _news.getHomeNewsList)(lang, {}));
					store.dispatch((0, _attraction.getEachHotelAttractions)(lang));
					store.dispatch((0, _hotel.getMainPageMeta)(lang));
					store.dispatch((0, _popup.getPopupIndex)(lang));
				}
			}
		}]
	};
};

/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _hotel = __webpack_require__(15);

var _news = __webpack_require__(52);

var _activity = __webpack_require__(250);

var _attraction = __webpack_require__(104);

var _location = __webpack_require__(251);

var _facility = __webpack_require__(252);

var _popup = __webpack_require__(38);

var _banner = __webpack_require__(66);

var _i18n = __webpack_require__(22);

var _News = __webpack_require__(758);

var _News2 = _interopRequireDefault(_News);

var _Restaurant = __webpack_require__(760);

var _Restaurant2 = _interopRequireDefault(_Restaurant);

var _Accommodation = __webpack_require__(762);

var _Accommodation2 = _interopRequireDefault(_Accommodation);

var _Location = __webpack_require__(764);

var _Location2 = _interopRequireDefault(_Location);

var _Activity = __webpack_require__(765);

var _Activity2 = _interopRequireDefault(_Activity);

var _Facility = __webpack_require__(766);

var _Facility2 = _interopRequireDefault(_Facility);

var _Privacy = __webpack_require__(767);

var _Privacy2 = _interopRequireDefault(_Privacy);

var _NotFound = __webpack_require__(768);

var _NotFound2 = _interopRequireDefault(_NotFound);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (store) {
	return {
		path: ':hotel',
		onEnter: function onEnter(_ref, replace) {
			var hotel = _ref.params.hotel;

			var _store$getState = store.getState(),
			    hotelList = _store$getState.hotel.hotelList;

			if (!hotelList.includes(hotel)) {
				replace('/');
			}
		},
		indexRoute: {
			onEnter: function onEnter(_ref2, replace) {
				var hotel = _ref2.params.hotel;

				var _store$getState2 = store.getState(),
				    lan = _store$getState2.global.lan;

				replace('/' + hotel + '/' + (0, _i18n.lanMapRoute)(lan));
			}
		},
		childRoutes: [{
			path: ':lang',
			onEnter: function onEnter(_ref3, replace) {
				var _ref3$params = _ref3.params,
				    lang = _ref3$params.lang,
				    hotel = _ref3$params.hotel;

				var _store$getState3 = store.getState(),
				    _store$getState3$glob = _store$getState3.global,
				    lan = _store$getState3$glob.lan,
				    lanList = _store$getState3$glob.lanList,
				    lanData = _store$getState3$glob.lanData,
				    storedhotel = _store$getState3.hotel.hotel;

				if (!lanList.map(function (l) {
					return lanData[l].value;
				}).includes(lang)) {
					replace('/');
					return;
				}

				if ((0, _i18n.lanMapRoute)(lan) !== lang) {
					(0, _i18n.changeLng)(lang);
				}

				if (storedhotel !== hotel) {
					store.dispatch((0, _hotel.changeHotel)(hotel));
				}
			},
			indexRoute: {
				getComponent: function getComponent(nextState, cb) {
					return __webpack_require__.e/* require.ensure */(4).then((function (require) {
						var component = __webpack_require__(781).default;
						cb(null, component);
					}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
				},
				onEnter: function onEnter(_ref4) {
					var _ref4$params = _ref4.params,
					    lang = _ref4$params.lang,
					    hotel = _ref4$params.hotel;

					store.dispatch((0, _news.getHotelNewsList)(lang, hotel, {}));
					store.dispatch((0, _attraction.getAttractions)(lang, hotel));
					store.dispatch((0, _facility.getFacilities)(lang, hotel));
					store.dispatch((0, _activity.getActivities)(lang, hotel));
					store.dispatch((0, _location.getLocationData)(lang, hotel));
					store.dispatch((0, _attraction.getAttractions)(lang, hotel));
					store.dispatch((0, _popup.getPopups)(lang, hotel));
					store.dispatch((0, _popup.getPopupIndex)(lang));
					store.dispatch((0, _banner.getBanner)(lang, hotel, 'main'));
					store.dispatch((0, _hotel.getHotelMeta)(lang, hotel, 'index'));
				}
			},
			childRoutes: [(0, _News2.default)(store), (0, _Restaurant2.default)(store), (0, _Accommodation2.default)(store), (0, _Location2.default)(store), (0, _Activity2.default)(store), (0, _Facility2.default)(store), (0, _Privacy2.default)(store), (0, _NotFound2.default)(store)]
		}]
	};
};

/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _news = __webpack_require__(52);

var _banner = __webpack_require__(66);

var _popup = __webpack_require__(38);

var _hotel = __webpack_require__(15);

var _News = __webpack_require__(759);

var _News2 = _interopRequireDefault(_News);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (store) {
	return {
		path: 'promotions',
		indexRoute: {
			getComponent: function getComponent(nextState, cb) {
				return __webpack_require__.e/* require.ensure */(6).then((function (require) {
					var component = __webpack_require__(774).default;
					cb(null, component);
				}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
			},
			onEnter: function onEnter(_ref) {
				var _ref$params = _ref.params,
				    lang = _ref$params.lang,
				    hotel = _ref$params.hotel,
				    _ref$location$query = _ref.location.query,
				    category = _ref$location$query.category,
				    page = _ref$location$query.page;

				store.dispatch((0, _news.getHotelNewsCategory)(lang, hotel));
				store.dispatch((0, _news.getHotelNewsList)(lang, hotel, { category: category, page: page }));
				store.dispatch((0, _banner.getBanner)(lang, hotel, 'news'));
				store.dispatch((0, _popup.getPopups)(lang, hotel));
				store.dispatch((0, _hotel.getHotelMeta)(lang, hotel, 'promotions'));
			},
			onChange: function onChange(_, _ref2) {
				var _ref2$params = _ref2.params,
				    lang = _ref2$params.lang,
				    hotel = _ref2$params.hotel,
				    _ref2$location$query = _ref2.location.query,
				    category = _ref2$location$query.category,
				    page = _ref2$location$query.page;

				store.dispatch((0, _news.getHotelNewsList)(lang, hotel, { category: category, page: page }));
			}
		},
		childRoutes: [(0, _News2.default)(store)]
	};
};

/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _news = __webpack_require__(52);

var _hotel = __webpack_require__(15);

exports.default = function (store) {
	return {
		path: ':id',
		indexRoute: {
			getComponent: function getComponent(nextState, cb) {
				return __webpack_require__.e/* require.ensure */(3).then((function (require) {
					var component = __webpack_require__(773).default;
					cb(null, component);
				}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
			},
			onEnter: function onEnter(_ref) {
				var _ref$params = _ref.params,
				    lang = _ref$params.lang,
				    hotel = _ref$params.hotel,
				    id = _ref$params.id;

				store.dispatch((0, _news.getHotelNews)(lang, hotel, id));
				store.dispatch((0, _hotel.getHotelMeta)(lang, hotel, 'promotions'));
			}
		}
	};
};

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _restaurant = __webpack_require__(761);

var _banner = __webpack_require__(66);

var _popup = __webpack_require__(38);

var _hotel = __webpack_require__(15);

exports.default = function (store) {
	return {
		path: 'diningsandmeetings',
		indexRoute: {
			getComponent: function getComponent(nextState, cb) {
				return __webpack_require__.e/* require.ensure */(9).then((function (require) {
					var component = __webpack_require__(775).default;
					cb(null, component);
				}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
			},
			onEnter: function onEnter(_ref) {
				var _ref$params = _ref.params,
				    lang = _ref$params.lang,
				    hotel = _ref$params.hotel;

				store.dispatch((0, _restaurant.getRestautantData)(lang, hotel));
				store.dispatch((0, _banner.getBanner)(lang, hotel, 'restaurant'));
				store.dispatch((0, _popup.getPopups)(lang, hotel));
				store.dispatch((0, _hotel.getHotelMeta)(lang, hotel, 'diningsandmeetings'));
			},
			onChange: function onChange(_, _ref2) {
				var _ref2$params = _ref2.params,
				    lang = _ref2$params.lang,
				    hotel = _ref2$params.hotel;

				store.dispatch((0, _restaurant.getRestautantData)(lang, hotel));
			}
		}
	};
};

/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getRestautantData = undefined;

var _reduxActions = __webpack_require__(6);

var _endpoint = __webpack_require__(35);

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var getRestautantData = exports.getRestautantData = (0, _reduxActions.createAction)('FETCH_RESTAURANT_DATA', function () {
	var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(lan, hotel) {
		var _ref2, status, message, data, reconstructedData;

		return regeneratorRuntime.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						_context.next = 2;
						return (0, _endpoint.wrapFetch)('api/v1/web/' + lan + '/' + hotel + '/restaurant', {
							method: 'GET'
						});

					case 2:
						_ref2 = _context.sent;
						status = _ref2.status;
						message = _ref2.message;
						data = _ref2.data;

						if (!(status !== 200)) {
							_context.next = 8;
							break;
						}

						throw new Error(message);

					case 8:
						reconstructedData = data.map(function (initData) {
							return {
								id: initData.id,
								title: initData.title,
								category: initData.category.name,
								content: initData.intro,
								detail: {
									sections: initData.meta.map(function (meta) {
										return {
											id: meta.id,
											title: meta.title,
											contents: meta.content.split('\n').map(function (content, index) {
												return {
													id: index,
													item: content
												};
											})
										};
									})
								},
								images: initData.photos.map(function (photo) {
									return photo.url;
								}),
								thumbnail: initData.photos.map(function (photo) {
									return photo.thumb_url;
								})
							};
						});
						return _context.abrupt('return', { data: reconstructedData });

					case 10:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, undefined);
	}));

	return function (_x, _x2) {
		return _ref.apply(this, arguments);
	};
}());

/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _accommodation = __webpack_require__(763);

var _banner = __webpack_require__(66);

var _popup = __webpack_require__(38);

var _hotel = __webpack_require__(15);

exports.default = function (store) {
	return {
		path: 'rooms',
		indexRoute: {
			getComponent: function getComponent(nextState, cb) {
				return __webpack_require__.e/* require.ensure */(7).then((function (require) {
					var component = __webpack_require__(776).default;
					cb(null, component);
				}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
			},
			onEnter: function onEnter(_ref) {
				var _ref$params = _ref.params,
				    lang = _ref$params.lang,
				    hotel = _ref$params.hotel;

				store.dispatch((0, _accommodation.getAccommodationData)(lang, hotel));
				store.dispatch((0, _banner.getBanner)(lang, hotel, 'accommodation'));
				store.dispatch((0, _popup.getPopups)(lang, hotel));
				store.dispatch((0, _hotel.getHotelMeta)(lang, hotel, 'rooms'));
			}
		}
	};
};

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getAccommodationData = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(6);

var _helper = __webpack_require__(154);

var _endpoint = __webpack_require__(35);

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var getAccommodationData = exports.getAccommodationData = (0, _reduxActions.createAction)('FETCH_ACCOMMODATION_DATA', function () {
	var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(lan, hotel) {
		var _ref2, status, message, _ref2$data, commonData, rooms, category, convertTime, common, checkInTime, checkOutTime, features, categoryData, categoryList, roomData, roomList;

		return regeneratorRuntime.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						_context.next = 2;
						return (0, _endpoint.wrapFetch)('api/v1/web/' + lan + '/' + hotel + '/room', {
							method: 'GET'
						});

					case 2:
						_ref2 = _context.sent;
						status = _ref2.status;
						message = _ref2.message;
						_ref2$data = _ref2.data;
						commonData = _ref2$data.common;
						rooms = _ref2$data.rooms;
						category = _ref2$data.category;

						if (!(status !== 200)) {
							_context.next = 11;
							break;
						}

						throw new Error(message);

					case 11:
						convertTime = function convertTime(time) {
							var hour = parseInt(time.split(':')[0], 10);
							var minute = time.split(':')[1];

							var ampm = 'am';
							var convertedHour = hour;
							if (hour > 12) {
								ampm = 'pm';
								convertedHour = hour - 12;
							}

							return {
								ampm: ampm,
								time: convertedHour + ':' + minute
							};
						};

						common = (0, _helper.keyTransform)(commonData[0]);
						checkInTime = convertTime(common.checkinTime);
						checkOutTime = convertTime(common.checkoutTime);
						features = common.features.map(function (feature) {
							var label = feature.title;
							var note = '';

							if (feature.title.indexOf('/') !== -1) {
								var _feature$title$split = feature.title.split('/');

								label = _feature$title$split[0];
								note = _feature$title$split[1];
							}

							if (feature.title.indexOf('／') !== -1) {
								var _feature$title$split2 = feature.title.split('／');

								label = _feature$title$split2[0];
								note = _feature$title$split2[1];
							}

							return {
								id: feature.id,
								label: label,
								icon: feature.url,
								note: note
							};
						});
						categoryData = {};
						categoryList = category.map(function (c) {
							categoryData[c.id] = _extends({}, c, { rooms: [] });
							return c.id;
						});
						roomData = {};
						roomList = rooms.map(function (r, index) {
							roomData[index] = {
								id: index,
								roomName: r.title,
								roomSize: r.area,
								bedType: r.bed,
								detail: r.equip,
								images: r.photos.map(function (img) {
									return img.url;
								}),
								thumbnail: r.photos.map(function (img) {
									return img.thumb_url;
								})
							};
							categoryData[r.category.id].rooms.push(index);
							return index;
						});
						return _context.abrupt('return', {
							checkInTime: checkInTime,
							checkOutTime: checkOutTime,
							features: features,
							categoryList: categoryList,
							categoryData: categoryData,
							roomList: roomList,
							roomData: roomData
						});

					case 21:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, undefined);
	}));

	return function (_x, _x2) {
		return _ref.apply(this, arguments);
	};
}());

/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _location = __webpack_require__(251);

var _attraction = __webpack_require__(104);

var _banner = __webpack_require__(66);

var _popup = __webpack_require__(38);

var _hotel = __webpack_require__(15);

exports.default = function (store) {
	return {
		path: 'directions',
		indexRoute: {
			getComponent: function getComponent(nextState, cb) {
				return __webpack_require__.e/* require.ensure */(5).then((function (require) {
					var component = __webpack_require__(777).default;
					cb(null, component);
				}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
			},
			onEnter: function onEnter(_ref) {
				var _ref$params = _ref.params,
				    lang = _ref$params.lang,
				    hotel = _ref$params.hotel;

				store.dispatch((0, _location.getLocationData)(lang, hotel));
				store.dispatch((0, _attraction.getAttractions)(lang, hotel));
				store.dispatch((0, _banner.getBanner)(lang, hotel, 'location'));
				store.dispatch((0, _popup.getPopups)(lang, hotel));
				store.dispatch((0, _hotel.getHotelMeta)(lang, hotel, 'directions'));
			}
		}
	};
};

/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _activity = __webpack_require__(250);

var _banner = __webpack_require__(66);

var _popup = __webpack_require__(38);

var _hotel = __webpack_require__(15);

exports.default = function (store) {
	return {
		path: 'activities',
		indexRoute: {
			getComponent: function getComponent(nextState, cb) {
				return __webpack_require__.e/* require.ensure */(10).then((function (require) {
					var component = __webpack_require__(778).default;
					cb(null, component);
				}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
			},
			onEnter: function onEnter(_ref) {
				var _ref$params = _ref.params,
				    lang = _ref$params.lang,
				    hotel = _ref$params.hotel;

				store.dispatch((0, _activity.getActivities)(lang, hotel));
				store.dispatch((0, _banner.getBanner)(lang, hotel, 'activity'));
				store.dispatch((0, _popup.getPopups)(lang, hotel));
				store.dispatch((0, _hotel.getHotelMeta)(lang, hotel, 'activities'));
			}
		}
	};
};

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _facility = __webpack_require__(252);

var _banner = __webpack_require__(66);

var _popup = __webpack_require__(38);

var _hotel = __webpack_require__(15);

exports.default = function (store) {
	return {
		path: 'amenities',
		indexRoute: {
			getComponent: function getComponent(nextState, cb) {
				return __webpack_require__.e/* require.ensure */(8).then((function (require) {
					var component = __webpack_require__(779).default;
					cb(null, component);
				}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
			},
			onEnter: function onEnter(_ref) {
				var _ref$params = _ref.params,
				    lang = _ref$params.lang,
				    hotel = _ref$params.hotel;

				store.dispatch((0, _facility.getFacilities)(lang, hotel));
				store.dispatch((0, _banner.getBanner)(lang, hotel, 'facility'));
				store.dispatch((0, _popup.getPopups)(lang, hotel));
				store.dispatch((0, _hotel.getHotelMeta)(lang, hotel, 'amenities'));
			}
		}
	};
};

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function () {
	return {
		path: 'privacy',
		indexRoute: {
			getComponent: function getComponent(nextState, cb) {
				return __webpack_require__.e/* require.ensure */(1).then((function (require) {
					var component = __webpack_require__(780).default;
					cb(null, component);
				}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
			}
		}
	};
};

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function () {
	return {
		path: '*',
		onEnter: function onEnter(_, replace) {
			replace({ pathname: '/' });
		}
	};
};

/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _hotel = __webpack_require__(15);

var _news = __webpack_require__(52);

var _i18n = __webpack_require__(22);

var _News = __webpack_require__(770);

var _News2 = _interopRequireDefault(_News);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (store) {
	return {
		path: 'promotions',
		onEnter: function onEnter() {
			var _store$getState = store.getState(),
			    hotel = _store$getState.hotel.hotel;

			if (hotel !== 'main') {
				store.dispatch((0, _hotel.changeHotel)('main'));
			}
		},
		indexRoute: {
			getComponent: function getComponent(nextState, cb) {
				return __webpack_require__.e/* require.ensure */(2).then((function (require) {
					var component = __webpack_require__(261).default;
					cb(null, component);
				}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
			},
			onEnter: function onEnter(_ref) {
				var page = _ref.location.query.page;

				var _store$getState2 = store.getState(),
				    lan = _store$getState2.global.lan;

				console.log('onEnter');
				store.dispatch((0, _news.getHomeNewsList)((0, _i18n.lanMapRoute)(lan), { page: page }));
			},
			onChange: function onChange(_, _ref2) {
				var page = _ref2.location.query.page;

				var _store$getState3 = store.getState(),
				    lan = _store$getState3.global.lan;

				console.log('onChange');
				store.dispatch((0, _news.getHomeNewsList)((0, _i18n.lanMapRoute)(lan), { page: page }));
			}
		},
		childRoutes: [{
			path: ':lang',
			indexRoute: {
				getComponent: function getComponent(nextState, cb) {
					return __webpack_require__.e/* require.ensure */(2).then((function (require) {
						var component = __webpack_require__(261).default;
						cb(null, component);
					}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
				},
				onEnter: function onEnter(_ref3) {
					var lang = _ref3.params.lang,
					    page = _ref3.location.query.page;

					store.dispatch((0, _news.getHomeNewsList)((0, _i18n.lanMapRoute)(lang), { page: page }));
				},
				onChange: function onChange(_, _ref4) {
					var lang = _ref4.params.lang,
					    page = _ref4.location.query.page;

					store.dispatch((0, _news.getHomeNewsList)((0, _i18n.lanMapRoute)(lang), { page: page }));
				}
			},
			onEnter: function onEnter(_ref5) {
				var lang = _ref5.params.lang;

				var _store$getState4 = store.getState(),
				    lan = _store$getState4.global.lan;

				if ((0, _i18n.lanMapRoute)(lan) !== lang) {
					(0, _i18n.changeLng)(lang);
				}
			},
			childRoutes: [(0, _News2.default)(store)]
		}]
	};
};

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _news = __webpack_require__(52);

exports.default = function (store) {
	return {
		path: ':id',
		indexRoute: {
			getComponent: function getComponent(nextState, cb) {
				return __webpack_require__.e/* require.ensure */(3).then((function (require) {
					var component = __webpack_require__(782).default;
					cb(null, component);
				}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
			},
			onEnter: function onEnter(_ref) {
				var _ref$params = _ref.params,
				    lang = _ref$params.lang,
				    id = _ref$params.id;

				store.dispatch((0, _news.getHomeNews)(lang, id));
			}
		}
	};
};

/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _hotel = __webpack_require__(15);

var _i18n = __webpack_require__(22);

exports.default = function (store) {
	return {
		path: 'privacy',
		onEnter: function onEnter() {
			var _store$getState = store.getState(),
			    hotel = _store$getState.hotel.hotel;

			if (hotel !== 'main') {
				store.dispatch((0, _hotel.changeHotel)('main'));
			}
		},
		indexRoute: {
			getComponent: function getComponent(nextState, cb) {
				return __webpack_require__.e/* require.ensure */(1).then((function (require) {
					var component = __webpack_require__(262).default;
					cb(null, component);
				}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
			}
		},
		childRoutes: [{
			path: ':lang',
			indexRoute: {
				getComponent: function getComponent(nextState, cb) {
					return __webpack_require__.e/* require.ensure */(1).then((function (require) {
						var component = __webpack_require__(262).default;
						cb(null, component);
					}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
				}
			},
			onEnter: function onEnter(_ref) {
				var lang = _ref.params.lang;

				var _store$getState2 = store.getState(),
				    lan = _store$getState2.global.lan;

				if ((0, _i18n.lanMapRoute)(lan) !== lang) {
					(0, _i18n.changeLng)(lang);
				}
			}
		}]
	};
};

/***/ })
],[263]);


// WEBPACK FOOTER //
// app.218b9f5fcdae20afd430.js